window.theme = window.theme || {};
window.slate = window.slate || {};

/* ================ VENDORS ================ */
/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function (a) {
	a.fn.equalHeights = function () {
		var b = 0, c = a(this);
		return c.each(function () {
			var c = a(this).innerHeight();
			c > b && (b = c);
		}), c.css("height", b);
	}, a("[data-equal]").each(function () {
		var b = a(this), c = b.data("equal");
		b.find(c).equalHeights();
	});
}(jQuery);

/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
!function (a, b, c) {
	var d = window.matchMedia;
	"undefined" != typeof module && module.exports ? module.exports = c(d) : "function" == typeof define && define.amd ? define(function () {return b[a] = c(d);}) : b[a] = c(d);
}("enquire", this, function (a) {
	"use strict";

	function b(a, b) {
		var c, d = 0, e = a.length;
		for (d; e > d && (c = b(a[d], d), c !== !1); d++) ;
	}

	function c(a) {return "[object Array]" === Object.prototype.toString.apply(a);}

	function d(a) {return "function" == typeof a;}

	function e(a) {this.options = a, !a.deferSetup && this.setup();}

	function f(b, c) {
		this.query = b, this.isUnconditional = c, this.handlers = [], this.mql = a(b);
		var d = this;
		this.listener = function (a) {d.mql = a, d.assess();}, this.mql.addListener(this.listener);
	}

	function g() {
		if (!a) throw new Error("matchMedia not present, legacy browsers require a polyfill");
		this.queries = {}, this.browserIsIncapable = !a("only all").matches;
	}

	return e.prototype = {
		setup: function () {this.options.setup && this.options.setup(), this.initialised = !0;},
		on: function () {!this.initialised && this.setup(), this.options.match && this.options.match();},
		off: function () {this.options.unmatch && this.options.unmatch();},
		destroy: function () {this.options.destroy ? this.options.destroy() : this.off();},
		equals: function (a) {return this.options === a || this.options.match === a;}
	}, f.prototype = {
		addHandler: function (a) {
			var b = new e(a);
			this.handlers.push(b), this.matches() && b.on();
		},
		removeHandler: function (a) {
			var c = this.handlers;
			b(c, function (b, d) {return b.equals(a) ? (b.destroy(), !c.splice(d, 1)) : void 0;});
		},
		matches: function () {return this.mql.matches || this.isUnconditional;},
		clear: function () {b(this.handlers, function (a) {a.destroy();}), this.mql.removeListener(this.listener), this.handlers.length = 0;},
		assess: function () {
			var a = this.matches() ? "on" : "off";
			b(this.handlers, function (b) {b[a]();});
		}
	}, g.prototype = {
		register: function (a, e, g) {
			var h = this.queries, i = g && this.browserIsIncapable;
			return h[a] || (h[a] = new f(a, i)), d(e) && (e = {match: e}), c(e) || (e = [e]), b(e, function (b) {d(b) && (b = {match: b}), h[a].addHandler(b);}), this;
		}, unregister: function (a, b) {
			var c = this.queries[a];
			return c && (b ? c.removeHandler(b) : (c.clear(), delete this.queries[a])), this;
		}
	}, new g;
});

/*! Magnific Popup - v1.0.0 - 2015-03-30
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2015 Dmitry Semenov; */
!function (a) {"function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto);}(function (a) {
	var b, c, d, e, f, g, h = "Close", i = "BeforeClose", j = "AfterClose", k = "BeforeAppend", l = "MarkupParse",
		m = "Open", n = "Change", o = "mfp", p = "." + o, q = "mfp-ready", r = "mfp-removing", s = "mfp-prevent-close",
		t = function () {}, u = !!window.jQuery, v = a(window), w = function (a, c) {b.ev.on(o + a + p, c);},
		x = function (b, c, d, e) {
			var f = document.createElement("div");
			return f.className = "mfp-" + b, d && (f.innerHTML = d), e ? c && c.appendChild(f) : (f = a(f), c && f.appendTo(c)), f;
		},
		y = function (c, d) {b.ev.triggerHandler(o + c, d), b.st.callbacks && (c = c.charAt(0).toLowerCase() + c.slice(1), b.st.callbacks[c] && b.st.callbacks[c].apply(b, a.isArray(d) ? d : [d]));},
		z = function (c) {return c === g && b.currTemplate.closeBtn || (b.currTemplate.closeBtn = a(b.st.closeMarkup.replace("%title%", b.st.tClose)), g = c), b.currTemplate.closeBtn;},
		A = function () {a.magnificPopup.instance || (b = new t, b.init(), a.magnificPopup.instance = b);}, B = function () {
			var a = document.createElement("p").style, b = ["ms", "O", "Moz", "Webkit"];
			if (void 0 !== a.transition) return !0;
			for (; b.length;) if (b.pop() + "Transition" in a) return !0;
			return !1;
		};
	t.prototype = {
		constructor: t,
		init: function () {
			var c = navigator.appVersion;
			b.isIE7 = -1 !== c.indexOf("MSIE 7."), b.isIE8 = -1 !== c.indexOf("MSIE 8."), b.isLowIE = b.isIE7 || b.isIE8, b.isAndroid = /android/gi.test(c), b.isIOS = /iphone|ipad|ipod/gi.test(c), b.supportsTransition = B(), b.probablyMobile = b.isAndroid || b.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), d = a(document), b.popupsCache = {};
		},
		open: function (c) {
			var e;
			if (c.isObj === !1) {
				b.items = c.items.toArray(), b.index = 0;
				var g, h = c.items;
				for (e = 0; e < h.length; e++) if (g = h[e], g.parsed && (g = g.el[0]), g === c.el[0]) {
					b.index = e;
					break;
				}
			} else b.items = a.isArray(c.items) ? c.items : [c.items], b.index = c.index || 0;
			if (b.isOpen) return void b.updateItemHTML();
			b.types = [], f = "", b.ev = c.mainEl && c.mainEl.length ? c.mainEl.eq(0) : d, c.key ? (b.popupsCache[c.key] || (b.popupsCache[c.key] = {}), b.currTemplate = b.popupsCache[c.key]) : b.currTemplate = {}, b.st = a.extend(!0, {}, a.magnificPopup.defaults, c), b.fixedContentPos = "auto" === b.st.fixedContentPos ? !b.probablyMobile : b.st.fixedContentPos, b.st.modal && (b.st.closeOnContentClick = !1, b.st.closeOnBgClick = !1, b.st.showCloseBtn = !1, b.st.enableEscapeKey = !1), b.bgOverlay || (b.bgOverlay = x("bg").on("click" + p, function () {b.close();}), b.wrap = x("wrap").attr("tabindex", -1).on("click" + p, function (a) {b._checkIfClose(a.target) && b.close();}), b.container = x("container", b.wrap)), b.contentContainer = x("content"), b.st.preloader && (b.preloader = x("preloader", b.container, b.st.tLoading));
			var i = a.magnificPopup.modules;
			for (e = 0; e < i.length; e++) {
				var j = i[e];
				j = j.charAt(0).toUpperCase() + j.slice(1), b["init" + j].call(b);
			}
			y("BeforeOpen"), b.st.showCloseBtn && (b.st.closeBtnInside ? (w(l, function (a, b, c, d) {c.close_replaceWith = z(d.type);}), f += " mfp-close-btn-in") : b.wrap.append(z())), b.st.alignTop && (f += " mfp-align-top"), b.wrap.css(b.fixedContentPos ? {
				overflow: b.st.overflowY,
				overflowX: "hidden",
				overflowY: b.st.overflowY
			} : {
				top: v.scrollTop(),
				position: "absolute"
			}), (b.st.fixedBgPos === !1 || "auto" === b.st.fixedBgPos && !b.fixedContentPos) && b.bgOverlay.css({
				height: d.height(),
				position: "absolute"
			}), b.st.enableEscapeKey && d.on("keyup" + p, function (a) {27 === a.keyCode && b.close();}), v.on("resize" + p, function () {b.updateSize();}), b.st.closeOnContentClick || (f += " mfp-auto-cursor"), f && b.wrap.addClass(f);
			var k = b.wH = v.height(), n = {};
			if (b.fixedContentPos && b._hasScrollBar(k)) {
				var o = b._getScrollbarSize();
				o && (n.marginRight = o);
			}
			b.fixedContentPos && (b.isIE7 ? a("body, html").css("overflow", "hidden") : n.overflow = "hidden");
			var r = b.st.mainClass;
			return b.isIE7 && (r += " mfp-ie7"), r && b._addClassToMFP(r), b.updateItemHTML(), y("BuildControls"), a("html").css(n), b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || a(document.body)), b._lastFocusedEl = document.activeElement, setTimeout(function () {b.content ? (b._addClassToMFP(q), b._setFocus()) : b.bgOverlay.addClass(q), d.on("focusin" + p, b._onFocusIn);}, 16), b.isOpen = !0, b.updateSize(k), y(m), c;
		},
		close: function () {b.isOpen && (y(i), b.isOpen = !1, b.st.removalDelay && !b.isLowIE && b.supportsTransition ? (b._addClassToMFP(r), setTimeout(function () {b._close();}, b.st.removalDelay)) : b._close());},
		_close: function () {
			y(h);
			var c = r + " " + q + " ";
			if (b.bgOverlay.detach(), b.wrap.detach(), b.container.empty(), b.st.mainClass && (c += b.st.mainClass + " "), b._removeClassFromMFP(c), b.fixedContentPos) {
				var e = {marginRight: ""};
				b.isIE7 ? a("body, html").css("overflow", "") : e.overflow = "", a("html").css(e);
			}
			d.off("keyup" + p + " focusin" + p), b.ev.off(p), b.wrap.attr("class", "mfp-wrap").removeAttr("style"), b.bgOverlay.attr("class", "mfp-bg"), b.container.attr("class", "mfp-container"), !b.st.showCloseBtn || b.st.closeBtnInside && b.currTemplate[b.currItem.type] !== !0 || b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach(), b._lastFocusedEl && a(b._lastFocusedEl).focus(), b.currItem = null, b.content = null, b.currTemplate = null, b.prevHeight = 0, y(j);
		},
		updateSize: function (a) {
			if (b.isIOS) {
				var c = document.documentElement.clientWidth / window.innerWidth, d = window.innerHeight * c;
				b.wrap.css("height", d), b.wH = d;
			} else b.wH = a || v.height();
			b.fixedContentPos || b.wrap.css("height", b.wH), y("Resize");
		},
		updateItemHTML: function () {
			var c = b.items[b.index];
			b.contentContainer.detach(), b.content && b.content.detach(), c.parsed || (c = b.parseEl(b.index));
			var d = c.type;
			if (y("BeforeChange", [b.currItem ? b.currItem.type : "", d]), b.currItem = c, !b.currTemplate[d]) {
				var f = b.st[d] ? b.st[d].markup : !1;
				y("FirstMarkupParse", f), b.currTemplate[d] = f ? a(f) : !0;
			}
			e && e !== c.type && b.container.removeClass("mfp-" + e + "-holder");
			var g = b["get" + d.charAt(0).toUpperCase() + d.slice(1)](c, b.currTemplate[d]);
			b.appendContent(g, d), c.preloaded = !0, y(n, c), e = c.type, b.container.prepend(b.contentContainer), y("AfterChange");
		},
		appendContent: function (a, c) {b.content = a, a ? b.st.showCloseBtn && b.st.closeBtnInside && b.currTemplate[c] === !0 ? b.content.find(".mfp-close").length || b.content.append(z()) : b.content = a : b.content = "", y(k), b.container.addClass("mfp-" + c + "-holder"), b.contentContainer.append(b.content);},
		parseEl: function (c) {
			var d, e = b.items[c];
			if (e.tagName ? e = {el: a(e)} : (d = e.type, e = {data: e, src: e.src}), e.el) {
				for (var f = b.types, g = 0; g < f.length; g++) if (e.el.hasClass("mfp-" + f[g])) {
					d = f[g];
					break;
				}
				e.src = e.el.attr("data-mfp-src"), e.src || (e.src = e.el.attr("href"));
			}
			return e.type = d || b.st.type || "inline", e.index = c, e.parsed = !0, b.items[c] = e, y("ElementParse", e), b.items[c];
		},
		addGroup: function (a, c) {
			var d = function (d) {d.mfpEl = this, b._openClick(d, a, c);};
			c || (c = {});
			var e = "click.magnificPopup";
			c.mainEl = a, c.items ? (c.isObj = !0, a.off(e).on(e, d)) : (c.isObj = !1, c.delegate ? a.off(e).on(e, c.delegate, d) : (c.items = a, a.off(e).on(e, d)));
		},
		_openClick: function (c, d, e) {
			var f = void 0 !== e.midClick ? e.midClick : a.magnificPopup.defaults.midClick;
			if (f || 2 !== c.which && !c.ctrlKey && !c.metaKey) {
				var g = void 0 !== e.disableOn ? e.disableOn : a.magnificPopup.defaults.disableOn;
				if (g) if (a.isFunction(g)) {
					if (!g.call(b)) return !0;
				} else if (v.width() < g) return !0;
				c.type && (c.preventDefault(), b.isOpen && c.stopPropagation()), e.el = a(c.mfpEl), e.delegate && (e.items = d.find(e.delegate)), b.open(e);
			}
		},
		updateStatus: function (a, d) {
			if (b.preloader) {
				c !== a && b.container.removeClass("mfp-s-" + c), d || "loading" !== a || (d = b.st.tLoading);
				var e = {status: a, text: d};
				y("UpdateStatus", e), a = e.status, d = e.text, b.preloader.html(d), b.preloader.find("a").on("click", function (a) {a.stopImmediatePropagation();}), b.container.addClass("mfp-s-" + a), c = a;
			}
		},
		_checkIfClose: function (c) {
			if (!a(c).hasClass(s)) {
				var d = b.st.closeOnContentClick, e = b.st.closeOnBgClick;
				if (d && e) return !0;
				if (!b.content || a(c).hasClass("mfp-close") || b.preloader && c === b.preloader[0]) return !0;
				if (c === b.content[0] || a.contains(b.content[0], c)) {
					if (d) return !0;
				} else if (e && a.contains(document, c)) return !0;
				return !1;
			}
		},
		_addClassToMFP: function (a) {b.bgOverlay.addClass(a), b.wrap.addClass(a);},
		_removeClassFromMFP: function (a) {this.bgOverlay.removeClass(a), b.wrap.removeClass(a);},
		_hasScrollBar: function (a) {return (b.isIE7 ? d.height() : document.body.scrollHeight) > (a || v.height());},
		_setFocus: function () {(b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus();},
		_onFocusIn: function (c) {return c.target === b.wrap[0] || a.contains(b.wrap[0], c.target) ? void 0 : (b._setFocus(), !1);},
		_parseMarkup: function (b, c, d) {
			var e;
			d.data && (c = a.extend(d.data, c)), y(l, [b, c, d]), a.each(c, function (a, c) {
				if (void 0 === c || c === !1) return !0;
				if (e = a.split("_"), e.length > 1) {
					var d = b.find(p + "-" + e[0]);
					if (d.length > 0) {
						var f = e[1];
						"replaceWith" === f ? d[0] !== c[0] && d.replaceWith(c) : "img" === f ? d.is("img") ? d.attr("src", c) : d.replaceWith('<img src="' + c + '" class="' + d.attr("class") + '" />') : d.attr(e[1], c);
					}
				} else b.find(p + "-" + a).html(c);
			});
		},
		_getScrollbarSize: function () {
			if (void 0 === b.scrollbarSize) {
				var a = document.createElement("div");
				a.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(a), b.scrollbarSize = a.offsetWidth - a.clientWidth, document.body.removeChild(a);
			}
			return b.scrollbarSize;
		}
	}, a.magnificPopup = {
		instance: null,
		proto: t.prototype,
		modules: [],
		open: function (b, c) {return A(), b = b ? a.extend(!0, {}, b) : {}, b.isObj = !0, b.index = c || 0, this.instance.open(b);},
		close: function () {return a.magnificPopup.instance && a.magnificPopup.instance.close();},
		registerModule: function (b, c) {c.options && (a.magnificPopup.defaults[b] = c.options), a.extend(this.proto, c.proto), this.modules.push(b);},
		defaults: {
			disableOn: 0,
			key: null,
			midClick: !1,
			mainClass: "",
			preloader: !0,
			focus: "",
			closeOnContentClick: !1,
			closeOnBgClick: !0,
			closeBtnInside: !0,
			showCloseBtn: !0,
			enableEscapeKey: !0,
			modal: !1,
			alignTop: !1,
			removalDelay: 0,
			prependTo: null,
			fixedContentPos: "auto",
			fixedBgPos: "auto",
			overflowY: "auto",
			closeMarkup: '<button title="%title%" type="button" class="mfp-close">&times;</button>',
			tClose: "Close (Esc)",
			tLoading: "Loading..."
		}
	}, a.fn.magnificPopup = function (c) {
		A();
		var d = a(this);
		if ("string" == typeof c) if ("open" === c) {
			var e, f = u ? d.data("magnificPopup") : d[0].magnificPopup, g = parseInt(arguments[1], 10) || 0;
			f.items ? e = f.items[g] : (e = d, f.delegate && (e = e.find(f.delegate)), e = e.eq(g)), b._openClick({mfpEl: e}, d, f);
		} else b.isOpen && b[c].apply(b, Array.prototype.slice.call(arguments, 1)); else c = a.extend(!0, {}, c), u ? d.data("magnificPopup", c) : d[0].magnificPopup = c, b.addGroup(d, c);
		return d;
	};
	var C, D, E, F = "inline", G = function () {E && (D.after(E.addClass(C)).detach(), E = null);};
	a.magnificPopup.registerModule(F, {
		options: {hiddenClass: "hide", markup: "", tNotFound: "Content not found"},
		proto: {
			initInline: function () {b.types.push(F), w(h + "." + F, function () {G();});},
			getInline: function (c, d) {
				if (G(), c.src) {
					var e = b.st.inline, f = a(c.src);
					if (f.length) {
						var g = f[0].parentNode;
						g && g.tagName && (D || (C = e.hiddenClass, D = x(C), C = "mfp-" + C), E = f.after(D).detach().removeClass(C)), b.updateStatus("ready");
					} else b.updateStatus("error", e.tNotFound), f = a("<div>");
					return c.inlineElement = f, f;
				}
				return b.updateStatus("ready"), b._parseMarkup(d, {}, c), d;
			}
		}
	});
	var H, I = "ajax", J = function () {H && a(document.body).removeClass(H);},
		K = function () {J(), b.req && b.req.abort();};
	a.magnificPopup.registerModule(I, {
		options: {
			settings: null,
			cursor: "mfp-ajax-cur",
			tError: '<a href="%url%">The content</a> could not be loaded.'
		},
		proto: {
			initAjax: function () {b.types.push(I), H = b.st.ajax.cursor, w(h + "." + I, K), w("BeforeChange." + I, K);},
			getAjax: function (c) {
				H && a(document.body).addClass(H), b.updateStatus("loading");
				var d = a.extend({
					url: c.src,
					success: function (d, e, f) {
						var g = {data: d, xhr: f};
						y("ParseAjax", g), b.appendContent(a(g.data), I), c.finished = !0, J(), b._setFocus(), setTimeout(function () {b.wrap.addClass(q);}, 16), b.updateStatus("ready"), y("AjaxContentAdded");
					},
					error: function () {J(), c.finished = c.loadError = !0, b.updateStatus("error", b.st.ajax.tError.replace("%url%", c.src));}
				}, b.st.ajax.settings);
				return b.req = a.ajax(d), "";
			}
		}
	});
	var L, M = function (c) {
		if (c.data && void 0 !== c.data.title) return c.data.title;
		var d = b.st.image.titleSrc;
		if (d) {
			if (a.isFunction(d)) return d.call(b, c);
			if (c.el) return c.el.attr(d) || "";
		}
		return "";
	};
	a.magnificPopup.registerModule("image", {
		options: {
			markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
			cursor: "mfp-zoom-out-cur",
			titleSrc: "title",
			verticalFit: !0,
			tError: '<a href="%url%">The image</a> could not be loaded.'
		}, proto: {
			initImage: function () {
				var c = b.st.image, d = ".image";
				b.types.push("image"), w(m + d, function () {"image" === b.currItem.type && c.cursor && a(document.body).addClass(c.cursor);}), w(h + d, function () {c.cursor && a(document.body).removeClass(c.cursor), v.off("resize" + p);}), w("Resize" + d, b.resizeImage), b.isLowIE && w("AfterChange", b.resizeImage);
			},
			resizeImage: function () {
				var a = b.currItem;
				if (a && a.img && b.st.image.verticalFit) {
					var c = 0;
					b.isLowIE && (c = parseInt(a.img.css("padding-top"), 10) + parseInt(a.img.css("padding-bottom"), 10)), a.img.css("max-height", b.wH - c);
				}
			},
			_onImageHasSize: function (a) {a.img && (a.hasSize = !0, L && clearInterval(L), a.isCheckingImgSize = !1, y("ImageHasSize", a), a.imgHidden && (b.content && b.content.removeClass("mfp-loading"), a.imgHidden = !1));},
			findImageSize: function (a) {
				var c = 0, d = a.img[0],
					e = function (f) {L && clearInterval(L), L = setInterval(function () {return d.naturalWidth > 0 ? void b._onImageHasSize(a) : (c > 200 && clearInterval(L), c++, void (3 === c ? e(10) : 40 === c ? e(50) : 100 === c && e(500)));}, f);};
				e(1);
			},
			getImage: function (c, d) {
				var e = 0,
					f = function () {c && (c.img[0].complete ? (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("ready")), c.hasSize = !0, c.loaded = !0, y("ImageLoadComplete")) : (e++, 200 > e ? setTimeout(f, 100) : g()));},
					g = function () {c && (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("error", h.tError.replace("%url%", c.src))), c.hasSize = !0, c.loaded = !0, c.loadError = !0);},
					h = b.st.image, i = d.find(".mfp-img");
				if (i.length) {
					var j = document.createElement("img");
					j.className = "mfp-img", c.el && c.el.find("img").length && (j.alt = c.el.find("img").attr("alt")), c.img = a(j).on("load.mfploader", f).on("error.mfploader", g), j.src = c.src, i.is("img") && (c.img = c.img.clone()), j = c.img[0], j.naturalWidth > 0 ? c.hasSize = !0 : j.width || (c.hasSize = !1);
				}
				return b._parseMarkup(d, {
					title: M(c),
					img_replaceWith: c.img
				}, c), b.resizeImage(), c.hasSize ? (L && clearInterval(L), c.loadError ? (d.addClass("mfp-loading"), b.updateStatus("error", h.tError.replace("%url%", c.src))) : (d.removeClass("mfp-loading"), b.updateStatus("ready")), d) : (b.updateStatus("loading"), c.loading = !0, c.hasSize || (c.imgHidden = !0, d.addClass("mfp-loading"), b.findImageSize(c)), d);
			}
		}
	});
	var N, O = function () {return void 0 === N && (N = void 0 !== document.createElement("p").style.MozTransform), N;};
	a.magnificPopup.registerModule("zoom", {
		options: {
			enabled: !1,
			easing: "ease-in-out",
			duration: 300,
			opener: function (a) {return a.is("img") ? a : a.find("img");}
		}, proto: {
			initZoom: function () {
				var a, c = b.st.zoom, d = ".zoom";
				if (c.enabled && b.supportsTransition) {
					var e, f, g = c.duration, j = function (a) {
						var b = a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
							d = "all " + c.duration / 1e3 + "s " + c.easing,
							e = {position: "fixed", zIndex: 9999, left: 0, top: 0, "-webkit-backface-visibility": "hidden"},
							f = "transition";
						return e["-webkit-" + f] = e["-moz-" + f] = e["-o-" + f] = e[f] = d, b.css(e), b;
					}, k = function () {b.content.css("visibility", "visible");};
					w("BuildControls" + d, function () {
						if (b._allowZoom()) {
							if (clearTimeout(e), b.content.css("visibility", "hidden"), a = b._getItemToZoom(), !a) return void k();
							f = j(a), f.css(b._getOffset()), b.wrap.append(f), e = setTimeout(function () {f.css(b._getOffset(!0)), e = setTimeout(function () {k(), setTimeout(function () {f.remove(), a = f = null, y("ZoomAnimationEnded");}, 16);}, g);}, 16);
						}
					}), w(i + d, function () {
						if (b._allowZoom()) {
							if (clearTimeout(e), b.st.removalDelay = g, !a) {
								if (a = b._getItemToZoom(), !a) return;
								f = j(a);
							}
							f.css(b._getOffset(!0)), b.wrap.append(f), b.content.css("visibility", "hidden"), setTimeout(function () {f.css(b._getOffset());}, 16);
						}
					}), w(h + d, function () {b._allowZoom() && (k(), f && f.remove(), a = null);});
				}
			},
			_allowZoom: function () {return "image" === b.currItem.type;},
			_getItemToZoom: function () {return b.currItem.hasSize ? b.currItem.img : !1;},
			_getOffset: function (c) {
				var d;
				d = c ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem);
				var e = d.offset(), f = parseInt(d.css("padding-top"), 10), g = parseInt(d.css("padding-bottom"), 10);
				e.top -= a(window).scrollTop() - f;
				var h = {width: d.width(), height: (u ? d.innerHeight() : d[0].offsetHeight) - g - f};
				return O() ? h["-moz-transform"] = h.transform = "translate(" + e.left + "px," + e.top + "px)" : (h.left = e.left, h.top = e.top), h;
			}
		}
	});
	var P = "iframe", Q = "//about:blank", R = function (a) {
		if (b.currTemplate[P]) {
			var c = b.currTemplate[P].find("iframe");
			c.length && (a || (c[0].src = Q), b.isIE8 && c.css("display", a ? "block" : "none"));
		}
	};
	a.magnificPopup.registerModule(P, {
		options: {
			markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
			srcAction: "iframe_src",
			patterns: {
				youtube: {index: "youtube.com", id: "v=", src: "//www.youtube.com/embed/%id%?autoplay=1"},
				vimeo: {index: "vimeo.com/", id: "/", src: "//player.vimeo.com/video/%id%?autoplay=1"},
				gmaps: {index: "//maps.google.", src: "%id%&output=embed"}
			}
		},
		proto: {
			initIframe: function () {b.types.push(P), w("BeforeChange", function (a, b, c) {b !== c && (b === P ? R() : c === P && R(!0));}), w(h + "." + P, function () {R();});},
			getIframe: function (c, d) {
				var e = c.src, f = b.st.iframe;
				a.each(f.patterns, function () {return e.indexOf(this.index) > -1 ? (this.id && (e = "string" == typeof this.id ? e.substr(e.lastIndexOf(this.id) + this.id.length, e.length) : this.id.call(this, e)), e = this.src.replace("%id%", e), !1) : void 0;});
				var g = {};
				return f.srcAction && (g[f.srcAction] = e), b._parseMarkup(d, g, c), b.updateStatus("ready"), d;
			}
		}
	});
	var S = function (a) {
		var c = b.items.length;
		return a > c - 1 ? a - c : 0 > a ? c + a : a;
	}, T = function (a, b, c) {return a.replace(/%curr%/gi, b + 1).replace(/%total%/gi, c);};
	a.magnificPopup.registerModule("gallery", {
		options: {
			enabled: !1,
			arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
			preload: [0, 2],
			navigateByImgClick: !0,
			arrows: !0,
			tPrev: "Previous (Left arrow key)",
			tNext: "Next (Right arrow key)",
			tCounter: "%curr% of %total%"
		}, proto: {
			initGallery: function () {
				var c = b.st.gallery, e = ".mfp-gallery", g = Boolean(a.fn.mfpFastClick);
				return b.direction = !0, c && c.enabled ? (f += " mfp-gallery", w(m + e, function () {c.navigateByImgClick && b.wrap.on("click" + e, ".mfp-img", function () {return b.items.length > 1 ? (b.next(), !1) : void 0;}), d.on("keydown" + e, function (a) {37 === a.keyCode ? b.prev() : 39 === a.keyCode && b.next();});}), w("UpdateStatus" + e, function (a, c) {c.text && (c.text = T(c.text, b.currItem.index, b.items.length));}), w(l + e, function (a, d, e, f) {
					var g = b.items.length;
					e.counter = g > 1 ? T(c.tCounter, f.index, g) : "";
				}), w("BuildControls" + e, function () {
					if (b.items.length > 1 && c.arrows && !b.arrowLeft) {
						var d = c.arrowMarkup,
							e = b.arrowLeft = a(d.replace(/%title%/gi, c.tPrev).replace(/%dir%/gi, "left")).addClass(s),
							f = b.arrowRight = a(d.replace(/%title%/gi, c.tNext).replace(/%dir%/gi, "right")).addClass(s),
							h = g ? "mfpFastClick" : "click";
						e[h](function () {b.prev();}), f[h](function () {b.next();}), b.isIE7 && (x("b", e[0], !1, !0), x("a", e[0], !1, !0), x("b", f[0], !1, !0), x("a", f[0], !1, !0)), b.container.append(e.add(f));
					}
				}), w(n + e, function () {b._preloadTimeout && clearTimeout(b._preloadTimeout), b._preloadTimeout = setTimeout(function () {b.preloadNearbyImages(), b._preloadTimeout = null;}, 16);}), void w(h + e, function () {d.off(e), b.wrap.off("click" + e), b.arrowLeft && g && b.arrowLeft.add(b.arrowRight).destroyMfpFastClick(), b.arrowRight = b.arrowLeft = null;})) : !1;
			},
			next: function () {b.direction = !0, b.index = S(b.index + 1), b.updateItemHTML();},
			prev: function () {b.direction = !1, b.index = S(b.index - 1), b.updateItemHTML();},
			goTo: function (a) {b.direction = a >= b.index, b.index = a, b.updateItemHTML();},
			preloadNearbyImages: function () {
				var a, c = b.st.gallery.preload, d = Math.min(c[0], b.items.length), e = Math.min(c[1], b.items.length);
				for (a = 1; a <= (b.direction ? e : d); a++) b._preloadItem(b.index + a);
				for (a = 1; a <= (b.direction ? d : e); a++) b._preloadItem(b.index - a);
			},
			_preloadItem: function (c) {
				if (c = S(c), !b.items[c].preloaded) {
					var d = b.items[c];
					d.parsed || (d = b.parseEl(c)), y("LazyLoad", d), "image" === d.type && (d.img = a('<img class="mfp-img" />').on("load.mfploader", function () {d.hasSize = !0;}).on("error.mfploader", function () {d.hasSize = !0, d.loadError = !0, y("LazyLoadError", d);}).attr("src", d.src)), d.preloaded = !0;
				}
			}
		}
	});
	var U = "retina";
	a.magnificPopup.registerModule(U, {
		options: {
			replaceSrc: function (a) {return a.src.replace(/\.\w+$/, function (a) {return "@2x" + a;});},
			ratio: 1
		}, proto: {
			initRetina: function () {
				if (window.devicePixelRatio > 1) {
					var a = b.st.retina, c = a.ratio;
					c = isNaN(c) ? c() : c, c > 1 && (w("ImageHasSize." + U, function (a, b) {
						b.img.css({
							"max-width": b.img[0].naturalWidth / c,
							width: "100%"
						});
					}), w("ElementParse." + U, function (b, d) {d.src = a.replaceSrc(d, c);}));
				}
			}
		}
	}), function () {
		var b = 1e3, c = "ontouchstart" in window, d = function () {v.off("touchmove" + f + " touchend" + f);},
			e = "mfpFastClick", f = "." + e;
		a.fn.mfpFastClick = function (e) {
			return a(this).each(function () {
				var g, h = a(this);
				if (c) {
					var i, j, k, l, m, n;
					h.on("touchstart" + f, function (a) {l = !1, n = 1, m = a.originalEvent ? a.originalEvent.touches[0] : a.touches[0], j = m.clientX, k = m.clientY, v.on("touchmove" + f, function (a) {m = a.originalEvent ? a.originalEvent.touches : a.touches, n = m.length, m = m[0], (Math.abs(m.clientX - j) > 10 || Math.abs(m.clientY - k) > 10) && (l = !0, d());}).on("touchend" + f, function (a) {d(), l || n > 1 || (g = !0, a.preventDefault(), clearTimeout(i), i = setTimeout(function () {g = !1;}, b), e());});});
				}
				h.on("click" + f, function () {g || e();});
			});
		}, a.fn.destroyMfpFastClick = function () {a(this).off("touchstart" + f + " click" + f), c && v.off("touchmove" + f + " touchend" + f);};
	}(), A();
});
/*
 * ScrollToFixed
 * https://github.com/bigspotteddog/ScrollToFixed
 *
 * Copyright (c) 2011 Joseph Cava-Lynch
 * MIT license
 */
/*
(function (a) {
	a.isScrollToFixed = function (b) {return !!a(b).data("ScrollToFixed");};
	a.ScrollToFixed = function (d, i) {
		var l = this;
		l.$el = a(d);
		l.el = d;
		l.$el.data("ScrollToFixed", l);
		var c = false;
		var G = l.$el;
		var H;
		var E;
		var e;
		var y;
		var D = 0;
		var q = 0;
		var j = -1;
		var f = -1;
		var t = null;
		var z;
		var g;

		function u() {
			G.trigger("preUnfixed.ScrollToFixed");
			k();
			G.trigger("unfixed.ScrollToFixed");
			f = -1;
			D = G.offset().top;
			q = G.offset().left;
			if (l.options.offsets) {
				q += (G.offset().left - G.position().left);
			}
			if (j == -1) {
				j = q;
			}
			H = G.css("position");
			c = true;
			if (l.options.bottom != -1) {
				G.trigger("preFixed.ScrollToFixed");
				w();
				G.trigger("fixed.ScrollToFixed");
			}
		}

		function n() {
			var I = l.options.limit;
			if (!I) {
				return 0;
			}
			if (typeof (I) === "function") {
				return I.apply(G);
			}
			return I;
		}

		function p() {return H === "fixed";}

		function x() {return H === "absolute";}

		function h() {return !(p() || x());}

		function w() {
			if (!p()) {
				t.css({
					display: G.css("display"),
					width: G.outerWidth(true),
					height: G.outerHeight(true),
					"float": G.css("float")
				});
				cssOptions = {
					"z-index": l.options.zIndex,
					position: "fixed",
					top: l.options.bottom == -1 ? s() : "",
					bottom: l.options.bottom == -1 ? "" : l.options.bottom,
					"margin-left": "0px"
				};
				if (!l.options.dontSetWidth) {
					cssOptions.width = G.width();
				}
				G.css(cssOptions);
				G.addClass(l.options.baseClassName);
				if (l.options.className) {
					G.addClass(l.options.className);
				}
				H = "fixed";
			}
		}

		function b() {
			var J = n();
			var I = q;
			if (l.options.removeOffsets) {
				I = "";
				J = J - D;
			}
			cssOptions = {position: "absolute", top: J, left: I, "margin-left": "0px", bottom: ""};
			if (!l.options.dontSetWidth) {
				cssOptions.width = G.width();
			}
			G.css(cssOptions);
			H = "absolute";
		}

		function k() {
			if (!h()) {
				f = -1;
				t.css("display", "none");
				G.css({"z-index": y, width: "", position: E, left: "", top: e, "margin-left": ""});
				G.removeClass("scroll-to-fixed-fixed");
				if (l.options.className) {
					G.removeClass(l.options.className);
				}
				H = null;
			}
		}

		function v(I) {
			if (I != f) {
				G.css("left", q - I);
				f = I;
			}
		}

		function s() {
			var I = l.options.marginTop;
			if (!I) {
				return 0;
			}
			if (typeof (I) === "function") {
				return I.apply(G);
			}
			return I;
		}

		function A() {
			if (!a.isScrollToFixed(G)) {
				return;
			}
			var K = c;
			if (!c) {
				u();
			} else {
				if (h()) {
					D = G.offset().top;
					q = G.offset().left;
				}
			}
			var I = a(window).scrollLeft();
			var L = a(window).scrollTop();
			var J = n();
			if (l.options.minWidth && a(window).width() < l.options.minWidth) {
				if (!h() || !K) {
					o();
					G.trigger("preUnfixed.ScrollToFixed");
					k();
					G.trigger("unfixed.ScrollToFixed");
				}
			} else {
				if (l.options.maxWidth && a(window).width() > l.options.maxWidth) {
					if (!h() || !K) {
						o();
						G.trigger("preUnfixed.ScrollToFixed");
						k();
						G.trigger("unfixed.ScrollToFixed");
					}
				} else {
					if (l.options.bottom == -1) {
						if (J > 0 && L >= J - s()) {
							if (!x() || !K) {
								o();
								G.trigger("preAbsolute.ScrollToFixed");
								b();
								G.trigger("unfixed.ScrollToFixed");
							}
						} else {
							if (L >= D - s()) {
								if (!p() || !K) {
									o();
									G.trigger("preFixed.ScrollToFixed");
									w();
									f = -1;
									G.trigger("fixed.ScrollToFixed");
								}
								v(I);
							} else {
								if (!h() || !K) {
									o();
									G.trigger("preUnfixed.ScrollToFixed");
									k();
									G.trigger("unfixed.ScrollToFixed");
								}
							}
						}
					} else {
						if (J > 0) {
							if (L + a(window).height() - G.outerHeight(true) >= J - (s() || -m())) {
								if (p()) {
									o();
									G.trigger("preUnfixed.ScrollToFixed");
									if (E === "absolute") {
										b();
									} else {
										k();
									}
									G.trigger("unfixed.ScrollToFixed");
								}
							} else {
								if (!p()) {
									o();
									G.trigger("preFixed.ScrollToFixed");
									w();
								}
								v(I);
								G.trigger("fixed.ScrollToFixed");
							}
						} else {
							v(I);
						}
					}
				}
			}
		}

		function m() {
			if (!l.options.bottom) {
				return 0;
			}
			return l.options.bottom;
		}

		function o() {
			var I = G.css("position");
			if (I == "absolute") {
				G.trigger("postAbsolute.ScrollToFixed");
			} else {
				if (I == "fixed") {
					G.trigger("postFixed.ScrollToFixed");
				} else {
					G.trigger("postUnfixed.ScrollToFixed");
				}
			}
		}

		var C = function (I) {
			if (G.is(":visible")) {
				c = false;
				A();
			}
		};
		var F = function (I) {(!!window.requestAnimationFrame) ? requestAnimationFrame(A) : A();};
		var B = function () {
			var J = document.body;
			if (document.createElement && J && J.appendChild && J.removeChild) {
				var L = document.createElement("div");
				if (!L.getBoundingClientRect) {
					return null;
				}
				L.innerHTML = "x";
				L.style.cssText = "position:fixed;top:100px;";
				J.appendChild(L);
				var M = J.style.height, N = J.scrollTop;
				J.style.height = "3000px";
				J.scrollTop = 500;
				var I = L.getBoundingClientRect().top;
				J.style.height = M;
				var K = (I === 100);
				J.removeChild(L);
				J.scrollTop = N;
				return K;
			}
			return null;
		};
		var r = function (I) {
			I = I || window.event;
			if (I.preventDefault) {
				I.preventDefault();
			}
			I.returnValue = false;
		};
		l.init = function () {
			l.options = a.extend({}, a.ScrollToFixed.defaultOptions, i);
			y = G.css("z-index");
			l.$el.css("z-index", l.options.zIndex);
			t = a("<div />");
			H = G.css("position");
			E = G.css("position");
			e = G.css("top");
			if (h()) {
				l.$el.after(t);
			}
			a(window).bind("resize.ScrollToFixed", C);
			a(window).bind("scroll.ScrollToFixed", F);
			if ("ontouchmove" in window) {
				a(window).bind("touchmove.ScrollToFixed", A);
			}
			if (l.options.preFixed) {
				G.bind("preFixed.ScrollToFixed", l.options.preFixed);
			}
			if (l.options.postFixed) {
				G.bind("postFixed.ScrollToFixed", l.options.postFixed);
			}
			if (l.options.preUnfixed) {
				G.bind("preUnfixed.ScrollToFixed", l.options.preUnfixed);
			}
			if (l.options.postUnfixed) {
				G.bind("postUnfixed.ScrollToFixed", l.options.postUnfixed);
			}
			if (l.options.preAbsolute) {
				G.bind("preAbsolute.ScrollToFixed", l.options.preAbsolute);
			}
			if (l.options.postAbsolute) {
				G.bind("postAbsolute.ScrollToFixed", l.options.postAbsolute);
			}
			if (l.options.fixed) {
				G.bind("fixed.ScrollToFixed", l.options.fixed);
			}
			if (l.options.unfixed) {
				G.bind("unfixed.ScrollToFixed", l.options.unfixed);
			}
			if (l.options.spacerClass) {
				t.addClass(l.options.spacerClass);
			}
			G.bind("resize.ScrollToFixed", function () {t.height(G.height());});
			G.bind("scroll.ScrollToFixed", function () {
				G.trigger("preUnfixed.ScrollToFixed");
				k();
				G.trigger("unfixed.ScrollToFixed");
				A();
			});
			G.bind("detach.ScrollToFixed", function (I) {
				r(I);
				G.trigger("preUnfixed.ScrollToFixed");
				k();
				G.trigger("unfixed.ScrollToFixed");
				a(window).unbind("resize.ScrollToFixed", C);
				a(window).unbind("scroll.ScrollToFixed", F);
				G.unbind(".ScrollToFixed");
				t.remove();
				l.$el.removeData("ScrollToFixed");
			});
			C();
		};
		l.init();
	};
	a.ScrollToFixed.defaultOptions = {
		marginTop: 0,
		limit: 0,
		bottom: -1,
		zIndex: 1000,
		baseClassName: "scroll-to-fixed-fixed"
	};
	a.fn.scrollToFixed = function (b) {return this.each(function () {(new a.ScrollToFixed(this, b));});};
})(jQuery);
*/

/*
 * ScrollToFixed
 * https://github.com/bigspotteddog/ScrollToFixed
 *
 * Copyright (c) 2011 Joseph Cava-Lynch
 * MIT license
 */
(function($) {
    $.isScrollToFixed = function(el) {
        return !!$(el).data('ScrollToFixed');
    };

    $.ScrollToFixed = function(el, options) {
        // To avoid scope issues, use 'base' instead of 'this' to reference this
        // class from internal events and functions.
        var base = this;

        // Access to jQuery and DOM versions of element.
        base.$el = $(el);
        base.el = el;

        // Add a reverse reference to the DOM object.
        base.$el.data('ScrollToFixed', base);

        // A flag so we know if the scroll has been reset.
        var isReset = false;

        // The element that was given to us to fix if scrolled above the top of
        // the page.
        var target = base.$el;

        var position;
        var originalPosition;
        var originalFloat;
        var originalOffsetTop;
        var originalZIndex;

        // The offset top of the element when resetScroll was called. This is
        // used to determine if we have scrolled past the top of the element.
        var offsetTop = 0;

        // The offset left of the element when resetScroll was called. This is
        // used to move the element left or right relative to the horizontal
        // scroll.
        var offsetLeft = 0;
        var originalOffsetLeft = -1;

        // This last offset used to move the element horizontally. This is used
        // to determine if we need to move the element because we would not want
        // to do that for no reason.
        var lastOffsetLeft = -1;

        // This is the element used to fill the void left by the target element
        // when it goes fixed; otherwise, everything below it moves up the page.
        var spacer = null;

        var spacerClass;

        var className;

        // Capture the original offsets for the target element. This needs to be
        // called whenever the page size changes or when the page is first
        // scrolled. For some reason, calling this before the page is first
        // scrolled causes the element to become fixed too late.
        function resetScroll() {
            // Set the element to it original positioning.
            target.trigger('preUnfixed.ScrollToFixed');
            setUnfixed();
            target.trigger('unfixed.ScrollToFixed');

            // Reset the last offset used to determine if the page has moved
            // horizontally.
            lastOffsetLeft = -1;

            // Capture the offset top of the target element.
            offsetTop = target.offset().top;

            // Capture the offset left of the target element.
            offsetLeft = target.offset().left;

            // If the offsets option is on, alter the left offset.
            if (base.options.offsets) {
                offsetLeft += (target.offset().left - target.position().left);
            }

            if (originalOffsetLeft == -1) {
                originalOffsetLeft = offsetLeft;
            }

            position = target.css('position');

            // Set that this has been called at least once.
            isReset = true;

            if (base.options.bottom != -1) {
                target.trigger('preFixed.ScrollToFixed');
                setFixed();
                target.trigger('fixed.ScrollToFixed');
            }
        }

        function getLimit() {
            var limit = base.options.limit;
            if (!limit) return 0;

            if (typeof(limit) === 'function') {
                return limit.apply(target);
            }
            return limit;
        }

        // Returns whether the target element is fixed or not.
        function isFixed() {
            return position === 'fixed';
        }

        // Returns whether the target element is absolute or not.
        function isAbsolute() {
            return position === 'absolute';
        }

        function isUnfixed() {
            return !(isFixed() || isAbsolute());
        }

        // Sets the target element to fixed. Also, sets the spacer to fill the
        // void left by the target element.
        function setFixed() {
            // Only fix the target element and the spacer if we need to.
            if (!isFixed()) {
                //get REAL dimensions (decimal fix)
                //Ref. http://stackoverflow.com/questions/3603065/how-to-make-jquery-to-not-round-value-returned-by-width
                var dimensions = target[0].getBoundingClientRect();

                // Set the spacer to fill the height and width of the target
                // element, then display it.
                spacer.css({
                    'display' : target.css('display'),
                    'width' : dimensions.width,
                    'height' : dimensions.height,
                    'float' : target.css('float')
                });

                // Set the target element to fixed and set its width so it does
                // not fill the rest of the page horizontally. Also, set its top
                // to the margin top specified in the options.

                cssOptions={
                    'z-index' : base.options.zIndex,
                    'position' : 'fixed',
                    'top' : base.options.bottom == -1?getMarginTop():'',
                    'bottom' : base.options.bottom == -1?'':base.options.bottom,
                    'margin-left' : '0px'
                }
                if (!base.options.dontSetWidth){ cssOptions['width']=target.css('width'); };

                target.css(cssOptions);

                target.addClass(base.options.baseClassName);

                if (base.options.className) {
                    target.addClass(base.options.className);
                }

                position = 'fixed';
            }
        }

        function setAbsolute() {

            var top = getLimit();
            var left = offsetLeft;

            if (base.options.removeOffsets) {
                left = '';
                top = top - offsetTop;
            }

            cssOptions={
              'position' : 'absolute',
              'top' : top,
              'left' : left,
              'margin-left' : '0px',
              'bottom' : ''
            }
            if (!base.options.dontSetWidth){ cssOptions['width']=target.css('width'); };

            target.css(cssOptions);

            position = 'absolute';
        }

        // Sets the target element back to unfixed. Also, hides the spacer.
        function setUnfixed() {
            // Only unfix the target element and the spacer if we need to.
            if (!isUnfixed()) {
                lastOffsetLeft = -1;

                // Hide the spacer now that the target element will fill the
                // space.
                spacer.css('display', 'none');

                // Remove the style attributes that were added to the target.
                // This will reverse the target back to the its original style.
                target.css({
                    'z-index' : originalZIndex,
                    'width' : '',
                    'position' : originalPosition,
                    'left' : '',
                    'top' : originalOffsetTop,
                    'margin-left' : ''
                });

                target.removeClass('scroll-to-fixed-fixed');

                if (base.options.className) {
                    target.removeClass(base.options.className);
                }

                position = null;
            }
        }

        // Moves the target element left or right relative to the horizontal
        // scroll position.
        function setLeft(x) {
            // Only if the scroll is not what it was last time we did this.
            if (x != lastOffsetLeft) {
                // Move the target element horizontally relative to its original
                // horizontal position.
                target.css('left', offsetLeft - x);

                // Hold the last horizontal position set.
                lastOffsetLeft = x;
            }
        }

        function getMarginTop() {
            var marginTop = base.options.marginTop;
            if (!marginTop) return 0;

            if (typeof(marginTop) === 'function') {
                return marginTop.apply(target);
            }
            return marginTop;
        }

        // Checks to see if we need to do something based on new scroll position
        // of the page.
        function checkScroll() {
            if (!$.isScrollToFixed(target) || target.is(':hidden')) return;
            var wasReset = isReset;
            var wasUnfixed = isUnfixed();

            // If resetScroll has not yet been called, call it. This only
            // happens once.
            if (!isReset) {
                resetScroll();
            } else if (isUnfixed()) {
                // if the offset has changed since the last scroll,
                // we need to get it again.

                // Capture the offset top of the target element.
                offsetTop = target.offset().top;

                // Capture the offset left of the target element.
                offsetLeft = target.offset().left;
            }

            // Grab the current horizontal scroll position.
            var x = $(window).scrollLeft();

            // Grab the current vertical scroll position.
            var y = $(window).scrollTop();

            // Get the limit, if there is one.
            var limit = getLimit();

            // If the vertical scroll position, plus the optional margin, would
            // put the target element at the specified limit, set the target
            // element to absolute.
            if (base.options.minWidth && $(window).width() < base.options.minWidth) {
                if (!isUnfixed() || !wasReset) {
                    postPosition();
                    target.trigger('preUnfixed.ScrollToFixed');
                    setUnfixed();
                    target.trigger('unfixed.ScrollToFixed');
                }
            } else if (base.options.maxWidth && $(window).width() > base.options.maxWidth) {
                if (!isUnfixed() || !wasReset) {
                    postPosition();
                    target.trigger('preUnfixed.ScrollToFixed');
                    setUnfixed();
                    target.trigger('unfixed.ScrollToFixed');
                }
            } else if (base.options.bottom == -1) {
                // If the vertical scroll position, plus the optional margin, would
                // put the target element at the specified limit, set the target
                // element to absolute.
                if (limit > 0 && y >= limit - getMarginTop()) {
                    if (!wasUnfixed && (!isAbsolute() || !wasReset)) {
                        postPosition();
                        target.trigger('preAbsolute.ScrollToFixed');
                        setAbsolute();
                        target.trigger('unfixed.ScrollToFixed');
                    }
                // If the vertical scroll position, plus the optional margin, would
                // put the target element above the top of the page, set the target
                // element to fixed.
                } else if (y >= offsetTop - getMarginTop()) {
                    if (!isFixed() || !wasReset) {
                        postPosition();
                        target.trigger('preFixed.ScrollToFixed');

                        // Set the target element to fixed.
                        setFixed();

                        // Reset the last offset left because we just went fixed.
                        lastOffsetLeft = -1;

                        target.trigger('fixed.ScrollToFixed');
                    }
                    // If the page has been scrolled horizontally as well, move the
                    // target element accordingly.
                    setLeft(x);
                } else {
                    // Set the target element to unfixed, placing it where it was
                    // before.
                    if (!isUnfixed() || !wasReset) {
                        postPosition();
                        target.trigger('preUnfixed.ScrollToFixed');
                        setUnfixed();
                        target.trigger('unfixed.ScrollToFixed');
                    }
                }
            } else {
                if (limit > 0) {
                    if (y + $(window).height() - target.outerHeight(true) >= limit - (getMarginTop() || -getBottom())) {
                        if (isFixed()) {
                            postPosition();
                            target.trigger('preUnfixed.ScrollToFixed');

                            if (originalPosition === 'absolute') {
                                setAbsolute();
                            } else {
                                setUnfixed();
                            }

                            target.trigger('unfixed.ScrollToFixed');
                        }
                    } else {
                        if (!isFixed()) {
                            postPosition();
                            target.trigger('preFixed.ScrollToFixed');
                            setFixed();
                        }
                        setLeft(x);
                        target.trigger('fixed.ScrollToFixed');
                    }
                } else {
                    setLeft(x);
                }
            }
        }

        function getBottom() {
            if (!base.options.bottom) return 0;
            return base.options.bottom;
        }

        function postPosition() {
            var position = target.css('position');

            if (position == 'absolute') {
                target.trigger('postAbsolute.ScrollToFixed');
            } else if (position == 'fixed') {
                target.trigger('postFixed.ScrollToFixed');
            } else {
                target.trigger('postUnfixed.ScrollToFixed');
            }
        }

        var windowResize = function(event) {
            // Check if the element is visible before updating it's position, which
            // improves behavior with responsive designs where this element is hidden.
            if(target.is(':visible')) {
                isReset = false;
                checkScroll();
            } else {
              // Ensure the spacer is hidden
              setUnfixed();
            }
        }

        var windowScroll = function(event) {
            (!!window.requestAnimationFrame) ? requestAnimationFrame(checkScroll) : checkScroll();
        }

        // From: http://kangax.github.com/cft/#IS_POSITION_FIXED_SUPPORTED
        var isPositionFixedSupported = function() {
            var container = document.body;

            if (document.createElement && container && container.appendChild && container.removeChild) {
                var el = document.createElement('div');

                if (!el.getBoundingClientRect) return null;

                el.innerHTML = 'x';
                el.style.cssText = 'position:fixed;top:100px;';
                container.appendChild(el);

                var originalHeight = container.style.height,
                originalScrollTop = container.scrollTop;

                container.style.height = '3000px';
                container.scrollTop = 500;

                var elementTop = el.getBoundingClientRect().top;
                container.style.height = originalHeight;

                var isSupported = (elementTop === 100);
                container.removeChild(el);
                container.scrollTop = originalScrollTop;

                return isSupported;
            }

            return null;
        }

        var preventDefault = function(e) {
            e = e || window.event;
            if (e.preventDefault) {
                e.preventDefault();
            }
            e.returnValue = false;
        }

        // Initializes this plugin. Captures the options passed in, turns this
        // off for devices that do not support fixed position, adds the spacer,
        // and binds to the window scroll and resize events.
        base.init = function() {
            // Capture the options for this plugin.
            base.options = $.extend({}, $.ScrollToFixed.defaultOptions, options);

            originalZIndex = target.css('z-index')

            // Turn off this functionality for devices that do not support it.
            // if (!(base.options && base.options.dontCheckForPositionFixedSupport)) {
            //     var fixedSupported = isPositionFixedSupported();
            //     if (!fixedSupported) return;
            // }

            // Put the target element on top of everything that could be below
            // it. This reduces flicker when the target element is transitioning
            // to fixed.
            base.$el.css('z-index', base.options.zIndex);

            // Create a spacer element to fill the void left by the target
            // element when it goes fixed.
            spacer = $('<div />');

            position = target.css('position');
            originalPosition = target.css('position');
            originalFloat = target.css('float');
            originalOffsetTop = target.css('top');

            // Place the spacer right after the target element.
            if (isUnfixed()) base.$el.after(spacer);

            // Reset the target element offsets when the window is resized, then
            // check to see if we need to fix or unfix the target element.
            $(window).bind('resize.ScrollToFixed', windowResize);

            // When the window scrolls, check to see if we need to fix or unfix
            // the target element.
            $(window).bind('scroll.ScrollToFixed', windowScroll);

            // For touch devices, call checkScroll directlly rather than
            // rAF wrapped windowScroll to animate the element
            if ('ontouchmove' in window) {
              $(window).bind('touchmove.ScrollToFixed', checkScroll);
            }

            if (base.options.preFixed) {
                target.bind('preFixed.ScrollToFixed', base.options.preFixed);
            }
            if (base.options.postFixed) {
                target.bind('postFixed.ScrollToFixed', base.options.postFixed);
            }
            if (base.options.preUnfixed) {
                target.bind('preUnfixed.ScrollToFixed', base.options.preUnfixed);
            }
            if (base.options.postUnfixed) {
                target.bind('postUnfixed.ScrollToFixed', base.options.postUnfixed);
            }
            if (base.options.preAbsolute) {
                target.bind('preAbsolute.ScrollToFixed', base.options.preAbsolute);
            }
            if (base.options.postAbsolute) {
                target.bind('postAbsolute.ScrollToFixed', base.options.postAbsolute);
            }
            if (base.options.fixed) {
                target.bind('fixed.ScrollToFixed', base.options.fixed);
            }
            if (base.options.unfixed) {
                target.bind('unfixed.ScrollToFixed', base.options.unfixed);
            }

            if (base.options.spacerClass) {
                spacer.addClass(base.options.spacerClass);
            }

            target.bind('resize.ScrollToFixed', function() {
                spacer.height(target.height());
            });

            target.bind('scroll.ScrollToFixed', function() {
                target.trigger('preUnfixed.ScrollToFixed');
                setUnfixed();
                target.trigger('unfixed.ScrollToFixed');
                checkScroll();
            });

            target.bind('detach.ScrollToFixed', function(ev) {
                preventDefault(ev);

                target.trigger('preUnfixed.ScrollToFixed');
                setUnfixed();
                target.trigger('unfixed.ScrollToFixed');

                $(window).unbind('resize.ScrollToFixed', windowResize);
                $(window).unbind('scroll.ScrollToFixed', windowScroll);

                target.unbind('.ScrollToFixed');

                //remove spacer from dom
                spacer.remove();

                base.$el.removeData('ScrollToFixed');
            });

            // Reset everything.
            windowResize();
        };

        // Initialize the plugin.
        base.init();
    };

    // Sets the option defaults.
    $.ScrollToFixed.defaultOptions = {
        marginTop : 0,
        limit : 0,
        bottom : -1,
        zIndex : 1000,
        baseClassName: 'scroll-to-fixed-fixed'
    };

    // Returns enhanced elements that will fix to the top of the page when the
    // page is scrolled.
    $.fn.scrollToFixed = function(options) {
        return this.each(function() {
            (new $.ScrollToFixed(this, options));
        });
    };
})(jQuery);


/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):"object"==typeof exports?e(require("jquery")):e(jQuery)}(function(m){var i=/\+/g;function v(e){return k.raw?e:encodeURIComponent(e)}function x(e,n){var o=k.raw?e:function(e){0===e.indexOf('"')&&(e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return e=decodeURIComponent(e.replace(i," ")),k.json?JSON.parse(e):e}catch(e){}}(e);return m.isFunction(n)?n(o):o}var k=m.cookie=function(e,n,o){if(void 0!==n&&!m.isFunction(n)){if("number"==typeof(o=m.extend({},k.defaults,o)).expires){var i=o.expires,r=o.expires=new Date;r.setTime(+r+864e5*i)}return document.cookie=[v(e),"=",function(e){return v(k.json?JSON.stringify(e):String(e))}(n),o.expires?"; expires="+o.expires.toUTCString():"",o.path?"; path="+o.path:"",o.domain?"; domain="+o.domain:"",o.secure?"; secure":""].join("")}for(var t,c=e?void 0:{},u=document.cookie?document.cookie.split("; "):[],a=0,d=u.length;a<d;a++){var f=u[a].split("="),p=(t=f.shift(),k.raw?t:decodeURIComponent(t)),s=f.join("=");if(e&&e===p){c=x(s,n);break}e||void 0===(s=x(s))||(c[p]=s)}return c};k.defaults={},m.removeCookie=function(e,n){return void 0!==m.cookie(e)&&(m.cookie(e,"",m.extend({},n,{expires:-1})),!m.cookie(e))}});

/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 *
 * @author: Jack Doyle, jack@greensock.com
 **/
var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";_gsScope._gsDefine("TweenMax",["core.Animation","core.SimpleTimeline","TweenLite"],function(a,b,c){var d=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},e=function(a,b,c){var d,e,f=a.cycle;for(d in f)e=f[d],a[d]="function"==typeof e?e(c,b[c],b):e[c%e.length];delete a.cycle},f=function(a){if("function"==typeof a)return a;var b="object"==typeof a?a:{each:a},c=b.ease,d=b.from||0,e=b.base||0,f={},g=isNaN(d),h=b.axis,i={center:.5,end:1}[d]||0;return function(a,j,k){var l,m,n,o,p,q,r,s,t,u=(k||b).length,v=f[u];if(!v){if(t="auto"===b.grid?0:(b.grid||[1/0])[0],!t){for(r=-(1/0);r<(r=k[t++].getBoundingClientRect().left)&&u>t;);t--}for(v=f[u]=[],l=g?Math.min(t,u)*i-.5:d%t,m=g?u*i/t-.5:d/t|0,r=0,s=1/0,q=0;u>q;q++)n=q%t-l,o=m-(q/t|0),v[q]=p=h?Math.abs("y"===h?o:n):Math.sqrt(n*n+o*o),p>r&&(r=p),s>p&&(s=p);v.max=r-s,v.min=s,v.v=u=b.amount||b.each*(t>u?u-1:h?"y"===h?u/t:t:Math.max(t,u/t))||0,v.b=0>u?e-u:e}return u=(v[a]-v.min)/v.max,v.b+(c?c.getRatio(u):u)*v.v}},g=function(a,b,d){c.call(this,a,b,d),this._cycle=0,this._yoyo=this.vars.yoyo===!0||!!this.vars.yoyoEase,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._repeat&&this._uncache(!0),this.render=g.prototype.render},h=1e-8,i=c._internals,j=i.isSelector,k=i.isArray,l=g.prototype=c.to({},.1,{}),m=[];g.version="2.1.3",l.constructor=g,l.kill()._gc=!1,g.killTweensOf=g.killDelayedCallsTo=c.killTweensOf,g.getTweensOf=c.getTweensOf,g.lagSmoothing=c.lagSmoothing,g.ticker=c.ticker,g.render=c.render,g.distribute=f,l.invalidate=function(){return this._yoyo=this.vars.yoyo===!0||!!this.vars.yoyoEase,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._yoyoEase=null,this._uncache(!0),c.prototype.invalidate.call(this)},l.updateTo=function(a,b){var d,e=this,f=e.ratio,g=e.vars.immediateRender||a.immediateRender;b&&e._startTime<e._timeline._time&&(e._startTime=e._timeline._time,e._uncache(!1),e._gc?e._enabled(!0,!1):e._timeline.insert(e,e._startTime-e._delay));for(d in a)e.vars[d]=a[d];if(e._initted||g)if(b)e._initted=!1,g&&e.render(0,!0,!0);else if(e._gc&&e._enabled(!0,!1),e._notifyPluginsOfEnabled&&e._firstPT&&c._onPluginEvent("_onDisable",e),e._time/e._duration>.998){var h=e._totalTime;e.render(0,!0,!1),e._initted=!1,e.render(h,!0,!1)}else if(e._initted=!1,e._init(),e._time>0||g)for(var i,j=1/(1-f),k=e._firstPT;k;)i=k.s+k.c,k.c*=j,k.s=i-k.c,k=k._next;return e},l.render=function(a,b,d){this._initted||0===this._duration&&this.vars.repeat&&this.invalidate();var e,f,g,j,k,l,m,n,o,p=this,q=p._dirty?p.totalDuration():p._totalDuration,r=p._time,s=p._totalTime,t=p._cycle,u=p._duration,v=p._rawPrevTime;if(a>=q-h&&a>=0?(p._totalTime=q,p._cycle=p._repeat,p._yoyo&&0!==(1&p._cycle)?(p._time=0,p.ratio=p._ease._calcEnd?p._ease.getRatio(0):0):(p._time=u,p.ratio=p._ease._calcEnd?p._ease.getRatio(1):1),p._reversed||(e=!0,f="onComplete",d=d||p._timeline.autoRemoveChildren),0===u&&(p._initted||!p.vars.lazy||d)&&(p._startTime===p._timeline._duration&&(a=0),(0>v||0>=a&&a>=-h||v===h&&"isPause"!==p.data)&&v!==a&&(d=!0,v>h&&(f="onReverseComplete")),p._rawPrevTime=n=!b||a||v===a?a:h)):h>a?(p._totalTime=p._time=p._cycle=0,p.ratio=p._ease._calcEnd?p._ease.getRatio(0):0,(0!==s||0===u&&v>0)&&(f="onReverseComplete",e=p._reversed),a>-h?a=0:0>a&&(p._active=!1,0===u&&(p._initted||!p.vars.lazy||d)&&(v>=0&&(d=!0),p._rawPrevTime=n=!b||a||v===a?a:h)),p._initted||(d=!0)):(p._totalTime=p._time=a,0!==p._repeat&&(j=u+p._repeatDelay,p._cycle=p._totalTime/j>>0,0!==p._cycle&&p._cycle===p._totalTime/j&&a>=s&&p._cycle--,p._time=p._totalTime-p._cycle*j,p._yoyo&&0!==(1&p._cycle)&&(p._time=u-p._time,o=p._yoyoEase||p.vars.yoyoEase,o&&(p._yoyoEase||(o!==!0||p._initted?p._yoyoEase=o=o===!0?p._ease:o instanceof Ease?o:Ease.map[o]:(o=p.vars.ease,p._yoyoEase=o=o?o instanceof Ease?o:"function"==typeof o?new Ease(o,p.vars.easeParams):Ease.map[o]||c.defaultEase:c.defaultEase)),p.ratio=o?1-o.getRatio((u-p._time)/u):0)),p._time>u?p._time=u:p._time<0&&(p._time=0)),p._easeType&&!o?(k=p._time/u,l=p._easeType,m=p._easePower,(1===l||3===l&&k>=.5)&&(k=1-k),3===l&&(k*=2),1===m?k*=k:2===m?k*=k*k:3===m?k*=k*k*k:4===m&&(k*=k*k*k*k),p.ratio=1===l?1-k:2===l?k:p._time/u<.5?k/2:1-k/2):o||(p.ratio=p._ease.getRatio(p._time/u))),r===p._time&&!d&&t===p._cycle)return void(s!==p._totalTime&&p._onUpdate&&(b||p._callback("onUpdate")));if(!p._initted){if(p._init(),!p._initted||p._gc)return;if(!d&&p._firstPT&&(p.vars.lazy!==!1&&p._duration||p.vars.lazy&&!p._duration))return p._time=r,p._totalTime=s,p._rawPrevTime=v,p._cycle=t,i.lazyTweens.push(p),void(p._lazy=[a,b]);!p._time||e||o?e&&this._ease._calcEnd&&!o&&(p.ratio=p._ease.getRatio(0===p._time?0:1)):p.ratio=p._ease.getRatio(p._time/u)}for(p._lazy!==!1&&(p._lazy=!1),p._active||!p._paused&&p._time!==r&&a>=0&&(p._active=!0),0===s&&(2===p._initted&&a>0&&p._init(),p._startAt&&(a>=0?p._startAt.render(a,!0,d):f||(f="_dummyGS")),p.vars.onStart&&(0!==p._totalTime||0===u)&&(b||p._callback("onStart"))),g=p._firstPT;g;)g.f?g.t[g.p](g.c*p.ratio+g.s):g.t[g.p]=g.c*p.ratio+g.s,g=g._next;p._onUpdate&&(0>a&&p._startAt&&p._startTime&&p._startAt.render(a,!0,d),b||(p._totalTime!==s||f)&&p._callback("onUpdate")),p._cycle!==t&&(b||p._gc||p.vars.onRepeat&&p._callback("onRepeat")),f&&(!p._gc||d)&&(0>a&&p._startAt&&!p._onUpdate&&p._startTime&&p._startAt.render(a,!0,d),e&&(p._timeline.autoRemoveChildren&&p._enabled(!1,!1),p._active=!1),!b&&p.vars[f]&&p._callback(f),0===u&&p._rawPrevTime===h&&n!==h&&(p._rawPrevTime=0))},g.to=function(a,b,c){return new g(a,b,c)},g.from=function(a,b,c){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,new g(a,b,c)},g.fromTo=function(a,b,c,d){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,new g(a,b,d)},g.staggerTo=g.allTo=function(a,b,h,i,l,n,o){var p,q,r,s,t=[],u=f(h.stagger||i),v=h.cycle,w=(h.startAt||m).cycle;for(k(a)||("string"==typeof a&&(a=c.selector(a)||a),j(a)&&(a=d(a))),a=a||[],p=a.length-1,r=0;p>=r;r++){q={};for(s in h)q[s]=h[s];if(v&&(e(q,a,r),null!=q.duration&&(b=q.duration,delete q.duration)),w){w=q.startAt={};for(s in h.startAt)w[s]=h.startAt[s];e(q.startAt,a,r)}q.delay=u(r,a[r],a)+(q.delay||0),r===p&&l&&(q.onComplete=function(){h.onComplete&&h.onComplete.apply(h.onCompleteScope||this,arguments),l.apply(o||h.callbackScope||this,n||m)}),t[r]=new g(a[r],b,q)}return t},g.staggerFrom=g.allFrom=function(a,b,c,d,e,f,h){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,g.staggerTo(a,b,c,d,e,f,h)},g.staggerFromTo=g.allFromTo=function(a,b,c,d,e,f,h,i){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,g.staggerTo(a,b,d,e,f,h,i)},g.delayedCall=function(a,b,c,d,e){return new g(b,0,{delay:a,onComplete:b,onCompleteParams:c,callbackScope:d,onReverseComplete:b,onReverseCompleteParams:c,immediateRender:!1,useFrames:e,overwrite:0})},g.set=function(a,b){return new g(a,0,b)},g.isTweening=function(a){return c.getTweensOf(a,!0).length>0};var n=function(a,b){for(var d=[],e=0,f=a._first;f;)f instanceof c?d[e++]=f:(b&&(d[e++]=f),d=d.concat(n(f,b)),e=d.length),f=f._next;return d},o=g.getAllTweens=function(b){return n(a._rootTimeline,b).concat(n(a._rootFramesTimeline,b))};g.killAll=function(a,c,d,e){null==c&&(c=!0),null==d&&(d=!0);var f,g,h,i=o(0!=e),j=i.length,k=c&&d&&e;for(h=0;j>h;h++)g=i[h],(k||g instanceof b||(f=g.target===g.vars.onComplete)&&d||c&&!f)&&(a?g.totalTime(g._reversed?0:g.totalDuration()):g._enabled(!1,!1))},g.killChildTweensOf=function(a,b){if(null!=a){var e,f,h,l,m,n=i.tweenLookup;if("string"==typeof a&&(a=c.selector(a)||a),j(a)&&(a=d(a)),k(a))for(l=a.length;--l>-1;)g.killChildTweensOf(a[l],b);else{e=[];for(h in n)for(f=n[h].target.parentNode;f;)f===a&&(e=e.concat(n[h].tweens)),f=f.parentNode;for(m=e.length,l=0;m>l;l++)b&&e[l].totalTime(e[l].totalDuration()),e[l]._enabled(!1,!1)}}};var p=function(a,c,d,e){c=c!==!1,d=d!==!1,e=e!==!1;for(var f,g,h=o(e),i=c&&d&&e,j=h.length;--j>-1;)g=h[j],(i||g instanceof b||(f=g.target===g.vars.onComplete)&&d||c&&!f)&&g.paused(a)};return g.pauseAll=function(a,b,c){p(!0,a,b,c)},g.resumeAll=function(a,b,c){p(!1,a,b,c)},g.globalTimeScale=function(b){var d=a._rootTimeline,e=c.ticker.time;return arguments.length?(b=b||h,d._startTime=e-(e-d._startTime)*d._timeScale/b,d=a._rootFramesTimeline,e=c.ticker.frame,d._startTime=e-(e-d._startTime)*d._timeScale/b,d._timeScale=a._rootTimeline._timeScale=b,b):d._timeScale},l.progress=function(a,b){return arguments.length?this.totalTime(this.duration()*(this._yoyo&&0!==(1&this._cycle)?1-a:a)+this._cycle*(this._duration+this._repeatDelay),b):this.duration()?this._time/this._duration:this.ratio},l.totalProgress=function(a,b){return arguments.length?this.totalTime(this.totalDuration()*a,b):this._totalTime/this.totalDuration()},l.time=function(a,b){if(!arguments.length)return this._time;this._dirty&&this.totalDuration();var c=this._duration,d=this._cycle,e=d*(c+this._repeatDelay);return a>c&&(a=c),this.totalTime(this._yoyo&&1&d?c-a+e:this._repeat?a+e:a,b)},l.duration=function(b){return arguments.length?a.prototype.duration.call(this,b):this._duration},l.totalDuration=function(a){return arguments.length?-1===this._repeat?this:this.duration((a-this._repeat*this._repeatDelay)/(this._repeat+1)):(this._dirty&&(this._totalDuration=-1===this._repeat?999999999999:this._duration*(this._repeat+1)+this._repeatDelay*this._repeat,this._dirty=!1),this._totalDuration)},l.repeat=function(a){return arguments.length?(this._repeat=a,this._uncache(!0)):this._repeat},l.repeatDelay=function(a){return arguments.length?(this._repeatDelay=a,this._uncache(!0)):this._repeatDelay},l.yoyo=function(a){return arguments.length?(this._yoyo=a,this):this._yoyo},g},!0),_gsScope._gsDefine("TimelineLite",["core.Animation","core.SimpleTimeline","TweenLite"],function(a,b,c){var d=function(a){b.call(this,a);var c,d,e=this,f=e.vars;e._labels={},e.autoRemoveChildren=!!f.autoRemoveChildren,e.smoothChildTiming=!!f.smoothChildTiming,e._sortChildren=!0,e._onUpdate=f.onUpdate;for(d in f)c=f[d],i(c)&&-1!==c.join("").indexOf("{self}")&&(f[d]=e._swapSelfInParams(c));i(f.tweens)&&e.add(f.tweens,0,f.align,f.stagger)},e=1e-8,f=c._internals,g=d._internals={},h=f.isSelector,i=f.isArray,j=f.lazyTweens,k=f.lazyRender,l=_gsScope._gsDefine.globals,m=function(a){var b,c={};for(b in a)c[b]=a[b];return c},n=function(a,b,c){var d,e,f=a.cycle;for(d in f)e=f[d],a[d]="function"==typeof e?e(c,b[c],b):e[c%e.length];delete a.cycle},o=g.pauseCallback=function(){},p=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},q=function(a,b,c,d){var e="immediateRender";return e in b||(b[e]=!(c&&c[e]===!1||d)),b},r=function(a){if("function"==typeof a)return a;var b="object"==typeof a?a:{each:a},c=b.ease,d=b.from||0,e=b.base||0,f={},g=isNaN(d),h=b.axis,i={center:.5,end:1}[d]||0;return function(a,j,k){var l,m,n,o,p,q,r,s,t,u=(k||b).length,v=f[u];if(!v){if(t="auto"===b.grid?0:(b.grid||[1/0])[0],!t){for(r=-(1/0);r<(r=k[t++].getBoundingClientRect().left)&&u>t;);t--}for(v=f[u]=[],l=g?Math.min(t,u)*i-.5:d%t,m=g?u*i/t-.5:d/t|0,r=0,s=1/0,q=0;u>q;q++)n=q%t-l,o=m-(q/t|0),v[q]=p=h?Math.abs("y"===h?o:n):Math.sqrt(n*n+o*o),p>r&&(r=p),s>p&&(s=p);v.max=r-s,v.min=s,v.v=u=b.amount||b.each*(t>u?u-1:h?"y"===h?u/t:t:Math.max(t,u/t))||0,v.b=0>u?e-u:e}return u=(v[a]-v.min)/v.max,v.b+(c?c.getRatio(u):u)*v.v}},s=d.prototype=new b;return d.version="2.1.3",d.distribute=r,s.constructor=d,s.kill()._gc=s._forcingPlayhead=s._hasPause=!1,s.to=function(a,b,d,e){var f=d.repeat&&l.TweenMax||c;return b?this.add(new f(a,b,d),e):this.set(a,d,e)},s.from=function(a,b,d,e){return this.add((d.repeat&&l.TweenMax||c).from(a,b,q(this,d)),e)},s.fromTo=function(a,b,d,e,f){var g=e.repeat&&l.TweenMax||c;return e=q(this,e,d),b?this.add(g.fromTo(a,b,d,e),f):this.set(a,e,f)},s.staggerTo=function(a,b,e,f,g,i,j,k){var l,o,q=new d({onComplete:i,onCompleteParams:j,callbackScope:k,smoothChildTiming:this.smoothChildTiming}),s=r(e.stagger||f),t=e.startAt,u=e.cycle;for("string"==typeof a&&(a=c.selector(a)||a),a=a||[],h(a)&&(a=p(a)),o=0;o<a.length;o++)l=m(e),t&&(l.startAt=m(t),t.cycle&&n(l.startAt,a,o)),u&&(n(l,a,o),null!=l.duration&&(b=l.duration,delete l.duration)),q.to(a[o],b,l,s(o,a[o],a));return this.add(q,g)},s.staggerFrom=function(a,b,c,d,e,f,g,h){return c.runBackwards=!0,this.staggerTo(a,b,q(this,c),d,e,f,g,h)},s.staggerFromTo=function(a,b,c,d,e,f,g,h,i){return d.startAt=c,this.staggerTo(a,b,q(this,d,c),e,f,g,h,i)},s.call=function(a,b,d,e){return this.add(c.delayedCall(0,a,b,d),e)},s.set=function(a,b,d){return this.add(new c(a,0,q(this,b,null,!0)),d)},d.exportRoot=function(a,b){a=a||{},null==a.smoothChildTiming&&(a.smoothChildTiming=!0);var e,f,g,h,i=new d(a),j=i._timeline;for(null==b&&(b=!0),j._remove(i,!0),i._startTime=0,i._rawPrevTime=i._time=i._totalTime=j._time,g=j._first;g;)h=g._next,b&&g instanceof c&&g.target===g.vars.onComplete||(f=g._startTime-g._delay,0>f&&(e=1),i.add(g,f)),g=h;return j.add(i,0),e&&i.totalDuration(),i},s.add=function(e,f,g,h){var j,k,l,m,n,o,p=this;if("number"!=typeof f&&(f=p._parseTimeOrLabel(f,0,!0,e)),!(e instanceof a)){if(e instanceof Array||e&&e.push&&i(e)){for(g=g||"normal",h=h||0,j=f,k=e.length,l=0;k>l;l++)i(m=e[l])&&(m=new d({tweens:m})),p.add(m,j),"string"!=typeof m&&"function"!=typeof m&&("sequence"===g?j=m._startTime+m.totalDuration()/m._timeScale:"start"===g&&(m._startTime-=m.delay())),j+=h;return p._uncache(!0)}if("string"==typeof e)return p.addLabel(e,f);if("function"!=typeof e)throw"Cannot add "+e+" into the timeline; it is not a tween, timeline, function, or string.";e=c.delayedCall(0,e)}if(b.prototype.add.call(p,e,f),(e._time||!e._duration&&e._initted)&&(j=(p.rawTime()-e._startTime)*e._timeScale,(!e._duration||Math.abs(Math.max(0,Math.min(e.totalDuration(),j)))-e._totalTime>1e-5)&&e.render(j,!1,!1)),(p._gc||p._time===p._duration)&&!p._paused&&p._duration<p.duration())for(n=p,o=n.rawTime()>e._startTime;n._timeline;)o&&n._timeline.smoothChildTiming?n.totalTime(n._totalTime,!0):n._gc&&n._enabled(!0,!1),n=n._timeline;return p},s.remove=function(b){if(b instanceof a){this._remove(b,!1);var c=b._timeline=b.vars.useFrames?a._rootFramesTimeline:a._rootTimeline;return b._startTime=(b._paused?b._pauseTime:c._time)-(b._reversed?b.totalDuration()-b._totalTime:b._totalTime)/b._timeScale,this}if(b instanceof Array||b&&b.push&&i(b)){for(var d=b.length;--d>-1;)this.remove(b[d]);return this}return"string"==typeof b?this.removeLabel(b):this.kill(null,b)},s._remove=function(a,c){b.prototype._remove.call(this,a,c);var d=this._last;return d?this._time>this.duration()&&(this._time=this._duration,this._totalTime=this._totalDuration):this._time=this._totalTime=this._duration=this._totalDuration=0,this},s.append=function(a,b){return this.add(a,this._parseTimeOrLabel(null,b,!0,a))},s.insert=s.insertMultiple=function(a,b,c,d){return this.add(a,b||0,c,d)},s.appendMultiple=function(a,b,c,d){return this.add(a,this._parseTimeOrLabel(null,b,!0,a),c,d)},s.addLabel=function(a,b){return this._labels[a]=this._parseTimeOrLabel(b),this},s.addPause=function(a,b,d,e){var f=c.delayedCall(0,o,d,e||this);return f.vars.onComplete=f.vars.onReverseComplete=b,f.data="isPause",this._hasPause=!0,this.add(f,a)},s.removeLabel=function(a){return delete this._labels[a],this},s.getLabelTime=function(a){return null!=this._labels[a]?this._labels[a]:-1},s._parseTimeOrLabel=function(b,c,d,e){var f,g;if(e instanceof a&&e.timeline===this)this.remove(e);else if(e&&(e instanceof Array||e.push&&i(e)))for(g=e.length;--g>-1;)e[g]instanceof a&&e[g].timeline===this&&this.remove(e[g]);if(f="number"!=typeof b||c?this.duration()>99999999999?this.recent().endTime(!1):this._duration:0,"string"==typeof c)return this._parseTimeOrLabel(c,d&&"number"==typeof b&&null==this._labels[c]?b-f:0,d);if(c=c||0,"string"!=typeof b||!isNaN(b)&&null==this._labels[b])null==b&&(b=f);else{if(g=b.indexOf("="),-1===g)return null==this._labels[b]?d?this._labels[b]=f+c:c:this._labels[b]+c;c=parseInt(b.charAt(g-1)+"1",10)*Number(b.substr(g+1)),b=g>1?this._parseTimeOrLabel(b.substr(0,g-1),0,d):f}return Number(b)+c},s.seek=function(a,b){return this.totalTime("number"==typeof a?a:this._parseTimeOrLabel(a),b!==!1)},s.stop=function(){return this.paused(!0)},s.gotoAndPlay=function(a,b){return this.play(a,b)},s.gotoAndStop=function(a,b){return this.pause(a,b)},s.render=function(a,b,c){this._gc&&this._enabled(!0,!1);var d,f,g,h,i,l,m,n,o=this,p=o._time,q=o._dirty?o.totalDuration():o._totalDuration,r=o._startTime,s=o._timeScale,t=o._paused;if(p!==o._time&&(a+=o._time-p),o._hasPause&&!o._forcingPlayhead&&!b){if(a>p)for(d=o._first;d&&d._startTime<=a&&!l;)d._duration||"isPause"!==d.data||d.ratio||0===d._startTime&&0===o._rawPrevTime||(l=d),d=d._next;else for(d=o._last;d&&d._startTime>=a&&!l;)d._duration||"isPause"===d.data&&d._rawPrevTime>0&&(l=d),d=d._prev;l&&(o._time=o._totalTime=a=l._startTime,n=o._startTime+(o._reversed?o._duration-a:a)/o._timeScale)}if(a>=q-e&&a>=0)o._totalTime=o._time=q,o._reversed||o._hasPausedChild()||(f=!0,h="onComplete",i=!!o._timeline.autoRemoveChildren,0===o._duration&&(0>=a&&a>=-e||o._rawPrevTime<0||o._rawPrevTime===e)&&o._rawPrevTime!==a&&o._first&&(i=!0,o._rawPrevTime>e&&(h="onReverseComplete"))),o._rawPrevTime=o._duration||!b||a||o._rawPrevTime===a?a:e,a=q+1e-4;else if(e>a)if(o._totalTime=o._time=0,a>-e&&(a=0),(0!==p||0===o._duration&&o._rawPrevTime!==e&&(o._rawPrevTime>0||0>a&&o._rawPrevTime>=0))&&(h="onReverseComplete",f=o._reversed),0>a)o._active=!1,o._timeline.autoRemoveChildren&&o._reversed?(i=f=!0,h="onReverseComplete"):o._rawPrevTime>=0&&o._first&&(i=!0),o._rawPrevTime=a;else{if(o._rawPrevTime=o._duration||!b||a||o._rawPrevTime===a?a:e,0===a&&f)for(d=o._first;d&&0===d._startTime;)d._duration||(f=!1),d=d._next;a=0,o._initted||(i=!0)}else o._totalTime=o._time=o._rawPrevTime=a;if(o._time!==p&&o._first||c||i||l){if(o._initted||(o._initted=!0),o._active||!o._paused&&o._time!==p&&a>0&&(o._active=!0),0===p&&o.vars.onStart&&(0===o._time&&o._duration||b||o._callback("onStart")),m=o._time,m>=p)for(d=o._first;d&&(g=d._next,m===o._time&&(!o._paused||t));)(d._active||d._startTime<=m&&!d._paused&&!d._gc)&&(l===d&&(o.pause(),o._pauseTime=n),d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)),d=g;else for(d=o._last;d&&(g=d._prev,m===o._time&&(!o._paused||t));){if(d._active||d._startTime<=p&&!d._paused&&!d._gc){if(l===d){for(l=d._prev;l&&l.endTime()>o._time;)l.render(l._reversed?l.totalDuration()-(a-l._startTime)*l._timeScale:(a-l._startTime)*l._timeScale,b,c),l=l._prev;l=null,o.pause(),o._pauseTime=n}d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)}d=g}o._onUpdate&&(b||(j.length&&k(),o._callback("onUpdate"))),h&&(o._gc||(r===o._startTime||s!==o._timeScale)&&(0===o._time||q>=o.totalDuration())&&(f&&(j.length&&k(),o._timeline.autoRemoveChildren&&o._enabled(!1,!1),o._active=!1),!b&&o.vars[h]&&o._callback(h)))}},s._hasPausedChild=function(){for(var a=this._first;a;){if(a._paused||a instanceof d&&a._hasPausedChild())return!0;a=a._next}return!1},s.getChildren=function(a,b,d,e){e=e||-9999999999;for(var f=[],g=this._first,h=0;g;)g._startTime<e||(g instanceof c?b!==!1&&(f[h++]=g):(d!==!1&&(f[h++]=g),a!==!1&&(f=f.concat(g.getChildren(!0,b,d)),h=f.length))),g=g._next;return f},s.getTweensOf=function(a,b){var d,e,f=this._gc,g=[],h=0;for(f&&this._enabled(!0,!0),d=c.getTweensOf(a),e=d.length;--e>-1;)(d[e].timeline===this||b&&this._contains(d[e]))&&(g[h++]=d[e]);return f&&this._enabled(!1,!0),g},s.recent=function(){return this._recent},s._contains=function(a){for(var b=a.timeline;b;){if(b===this)return!0;b=b.timeline}return!1},s.shiftChildren=function(a,b,c){c=c||0;for(var d,e=this._first,f=this._labels;e;)e._startTime>=c&&(e._startTime+=a),e=e._next;if(b)for(d in f)f[d]>=c&&(f[d]+=a);return this._uncache(!0)},s._kill=function(a,b){if(!a&&!b)return this._enabled(!1,!1);for(var c=b?this.getTweensOf(b):this.getChildren(!0,!0,!1),d=c.length,e=!1;--d>-1;)c[d]._kill(a,b)&&(e=!0);return e},s.clear=function(a){var b=this.getChildren(!1,!0,!0),c=b.length;for(this._time=this._totalTime=0;--c>-1;)b[c]._enabled(!1,!1);return a!==!1&&(this._labels={}),this._uncache(!0)},s.invalidate=function(){for(var b=this._first;b;)b.invalidate(),b=b._next;return a.prototype.invalidate.call(this)},s._enabled=function(a,c){if(a===this._gc)for(var d=this._first;d;)d._enabled(a,!0),d=d._next;return b.prototype._enabled.call(this,a,c)},s.totalTime=function(b,c,d){this._forcingPlayhead=!0;var e=a.prototype.totalTime.apply(this,arguments);return this._forcingPlayhead=!1,e},s.duration=function(a){return arguments.length?(0!==this.duration()&&0!==a&&this.timeScale(this._duration/a),this):(this._dirty&&this.totalDuration(),this._duration)},s.totalDuration=function(a){if(!arguments.length){if(this._dirty){for(var b,c,d=0,e=this,f=e._last,g=999999999999;f;)b=f._prev,f._dirty&&f.totalDuration(),f._startTime>g&&e._sortChildren&&!f._paused&&!e._calculatingDuration?(e._calculatingDuration=1,e.add(f,f._startTime-f._delay),e._calculatingDuration=0):g=f._startTime,f._startTime<0&&!f._paused&&(d-=f._startTime,e._timeline.smoothChildTiming&&(e._startTime+=f._startTime/e._timeScale,e._time-=f._startTime,e._totalTime-=f._startTime,e._rawPrevTime-=f._startTime),e.shiftChildren(-f._startTime,!1,-9999999999),g=0),c=f._startTime+f._totalDuration/f._timeScale,c>d&&(d=c),f=b;e._duration=e._totalDuration=d,e._dirty=!1}return this._totalDuration}return a&&this.totalDuration()?this.timeScale(this._totalDuration/a):this},s.paused=function(b){if(b===!1&&this._paused)for(var c=this._first;c;)c._startTime===this._time&&"isPause"===c.data&&(c._rawPrevTime=0),c=c._next;return a.prototype.paused.apply(this,arguments)},s.usesFrames=function(){for(var b=this._timeline;b._timeline;)b=b._timeline;return b===a._rootFramesTimeline},s.rawTime=function(a){return a&&(this._paused||this._repeat&&this.time()>0&&this.totalProgress()<1)?this._totalTime%(this._duration+this._repeatDelay):this._paused?this._totalTime:(this._timeline.rawTime(a)-this._startTime)*this._timeScale},d},!0),_gsScope._gsDefine("TimelineMax",["TimelineLite","TweenLite","easing.Ease"],function(a,b,c){var d=function(b){a.call(this,b),this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._cycle=0,this._yoyo=!!this.vars.yoyo,this._dirty=!0},e=1e-8,f=b._internals,g=f.lazyTweens,h=f.lazyRender,i=_gsScope._gsDefine.globals,j=new c(null,null,1,0),k=d.prototype=new a;return k.constructor=d,k.kill()._gc=!1,d.version="2.1.3",k.invalidate=function(){return this._yoyo=!!this.vars.yoyo,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._uncache(!0),a.prototype.invalidate.call(this)},k.addCallback=function(a,c,d,e){return this.add(b.delayedCall(0,a,d,e),c)},k.removeCallback=function(a,b){if(a)if(null==b)this._kill(null,a);else for(var c=this.getTweensOf(a,!1),d=c.length,e=this._parseTimeOrLabel(b);--d>-1;)c[d]._startTime===e&&c[d]._enabled(!1,!1);return this},k.removePause=function(b){return this.removeCallback(a._internals.pauseCallback,b)},k.tweenTo=function(a,c){c=c||{};var d,e,f,g={ease:j,useFrames:this.usesFrames(),immediateRender:!1,lazy:!1},h=c.repeat&&i.TweenMax||b;for(e in c)g[e]=c[e];return g.time=this._parseTimeOrLabel(a),d=Math.abs(Number(g.time)-this._time)/this._timeScale||.001,f=new h(this,d,g),g.onStart=function(){f.target.paused(!0),f.vars.time===f.target.time()||d!==f.duration()||f.isFromTo||f.duration(Math.abs(f.vars.time-f.target.time())/f.target._timeScale).render(f.time(),!0,!0),c.onStart&&c.onStart.apply(c.onStartScope||c.callbackScope||f,c.onStartParams||[])},f},k.tweenFromTo=function(a,b,c){c=c||{},a=this._parseTimeOrLabel(a),c.startAt={onComplete:this.seek,onCompleteParams:[a],callbackScope:this},c.immediateRender=c.immediateRender!==!1;var d=this.tweenTo(b,c);return d.isFromTo=1,d.duration(Math.abs(d.vars.time-a)/this._timeScale||.001)},k.render=function(a,b,c){this._gc&&this._enabled(!0,!1);var d,f,i,j,k,l,m,n,o,p=this,q=p._time,r=p._dirty?p.totalDuration():p._totalDuration,s=p._duration,t=p._totalTime,u=p._startTime,v=p._timeScale,w=p._rawPrevTime,x=p._paused,y=p._cycle;if(q!==p._time&&(a+=p._time-q),a>=r-e&&a>=0)p._locked||(p._totalTime=r,p._cycle=p._repeat),p._reversed||p._hasPausedChild()||(f=!0,j="onComplete",k=!!p._timeline.autoRemoveChildren,0===p._duration&&(0>=a&&a>=-e||0>w||w===e)&&w!==a&&p._first&&(k=!0,w>e&&(j="onReverseComplete"))),p._rawPrevTime=p._duration||!b||a||p._rawPrevTime===a?a:e,p._yoyo&&1&p._cycle?p._time=a=0:(p._time=s,a=s+1e-4);else if(e>a)if(p._locked||(p._totalTime=p._cycle=0),p._time=0,a>-e&&(a=0),(0!==q||0===s&&w!==e&&(w>0||0>a&&w>=0)&&!p._locked)&&(j="onReverseComplete",f=p._reversed),0>a)p._active=!1,p._timeline.autoRemoveChildren&&p._reversed?(k=f=!0,j="onReverseComplete"):w>=0&&p._first&&(k=!0),p._rawPrevTime=a;else{if(p._rawPrevTime=s||!b||a||p._rawPrevTime===a?a:e,0===a&&f)for(d=p._first;d&&0===d._startTime;)d._duration||(f=!1),d=d._next;a=0,p._initted||(k=!0)}else 0===s&&0>w&&(k=!0),p._time=p._rawPrevTime=a,p._locked||(p._totalTime=a,0!==p._repeat&&(l=s+p._repeatDelay,p._cycle=p._totalTime/l>>0,p._cycle&&p._cycle===p._totalTime/l&&a>=t&&p._cycle--,p._time=p._totalTime-p._cycle*l,p._yoyo&&1&p._cycle&&(p._time=s-p._time),p._time>s?(p._time=s,a=s+1e-4):p._time<0?p._time=a=0:a=p._time));if(p._hasPause&&!p._forcingPlayhead&&!b){if(a=p._time,a>q||p._repeat&&y!==p._cycle)for(d=p._first;d&&d._startTime<=a&&!m;)d._duration||"isPause"!==d.data||d.ratio||0===d._startTime&&0===p._rawPrevTime||(m=d),d=d._next;else for(d=p._last;d&&d._startTime>=a&&!m;)d._duration||"isPause"===d.data&&d._rawPrevTime>0&&(m=d),d=d._prev;m&&(o=p._startTime+(p._reversed?p._duration-m._startTime:m._startTime)/p._timeScale,m._startTime<s&&(p._time=p._rawPrevTime=a=m._startTime,p._totalTime=a+p._cycle*(p._totalDuration+p._repeatDelay)))}if(p._cycle!==y&&!p._locked){var z=p._yoyo&&0!==(1&y),A=z===(p._yoyo&&0!==(1&p._cycle)),B=p._totalTime,C=p._cycle,D=p._rawPrevTime,E=p._time;if(p._totalTime=y*s,p._cycle<y?z=!z:p._totalTime+=s,p._time=q,p._rawPrevTime=0===s?w-1e-4:w,p._cycle=y,p._locked=!0,q=z?0:s,p.render(q,b,0===s),b||p._gc||p.vars.onRepeat&&(p._cycle=C,p._locked=!1,p._callback("onRepeat")),q!==p._time)return;if(A&&(p._cycle=y,p._locked=!0,q=z?s+1e-4:-1e-4,p.render(q,!0,!1)),p._locked=!1,p._paused&&!x)return;p._time=E,p._totalTime=B,p._cycle=C,p._rawPrevTime=D}if(!(p._time!==q&&p._first||c||k||m))return void(t!==p._totalTime&&p._onUpdate&&(b||p._callback("onUpdate")));if(p._initted||(p._initted=!0),p._active||!p._paused&&p._totalTime!==t&&a>0&&(p._active=!0),0===t&&p.vars.onStart&&(0===p._totalTime&&p._totalDuration||b||p._callback("onStart")),n=p._time,n>=q)for(d=p._first;d&&(i=d._next,n===p._time&&(!p._paused||x));)(d._active||d._startTime<=p._time&&!d._paused&&!d._gc)&&(m===d&&(p.pause(),p._pauseTime=o),d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)),d=i;else for(d=p._last;d&&(i=d._prev,n===p._time&&(!p._paused||x));){if(d._active||d._startTime<=q&&!d._paused&&!d._gc){if(m===d){for(m=d._prev;m&&m.endTime()>p._time;)m.render(m._reversed?m.totalDuration()-(a-m._startTime)*m._timeScale:(a-m._startTime)*m._timeScale,b,c),m=m._prev;m=null,p.pause(),p._pauseTime=o}d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)}d=i}p._onUpdate&&(b||(g.length&&h(),p._callback("onUpdate"))),j&&(p._locked||p._gc||(u===p._startTime||v!==p._timeScale)&&(0===p._time||r>=p.totalDuration())&&(f&&(g.length&&h(),p._timeline.autoRemoveChildren&&p._enabled(!1,!1),p._active=!1),!b&&p.vars[j]&&p._callback(j)))},k.getActive=function(a,b,c){var d,e,f=[],g=this.getChildren(a||null==a,b||null==a,!!c),h=0,i=g.length;for(d=0;i>d;d++)e=g[d],e.isActive()&&(f[h++]=e);return f},k.getLabelAfter=function(a){a||0!==a&&(a=this._time);var b,c=this.getLabelsArray(),d=c.length;for(b=0;d>b;b++)if(c[b].time>a)return c[b].name;return null},k.getLabelBefore=function(a){null==a&&(a=this._time);for(var b=this.getLabelsArray(),c=b.length;--c>-1;)if(b[c].time<a)return b[c].name;return null},k.getLabelsArray=function(){var a,b=[],c=0;for(a in this._labels)b[c++]={time:this._labels[a],name:a};return b.sort(function(a,b){return a.time-b.time}),b},k.invalidate=function(){return this._locked=!1,a.prototype.invalidate.call(this)},k.progress=function(a,b){return arguments.length?this.totalTime(this.duration()*(this._yoyo&&0!==(1&this._cycle)?1-a:a)+this._cycle*(this._duration+this._repeatDelay),b):this._time/this.duration()||0},k.totalProgress=function(a,b){return arguments.length?this.totalTime(this.totalDuration()*a,b):this._totalTime/this.totalDuration()||0},k.totalDuration=function(b){return arguments.length?-1!==this._repeat&&b?this.timeScale(this.totalDuration()/b):this:(this._dirty&&(a.prototype.totalDuration.call(this),this._totalDuration=-1===this._repeat?999999999999:this._duration*(this._repeat+1)+this._repeatDelay*this._repeat),this._totalDuration)},k.time=function(a,b){if(!arguments.length)return this._time;this._dirty&&this.totalDuration();var c=this._duration,d=this._cycle,e=d*(c+this._repeatDelay);return a>c&&(a=c),this.totalTime(this._yoyo&&1&d?c-a+e:this._repeat?a+e:a,b)},k.repeat=function(a){return arguments.length?(this._repeat=a,this._uncache(!0)):this._repeat},k.repeatDelay=function(a){return arguments.length?(this._repeatDelay=a,this._uncache(!0)):this._repeatDelay},k.yoyo=function(a){return arguments.length?(this._yoyo=a,this):this._yoyo},k.currentLabel=function(a){return arguments.length?this.seek(a,!0):this.getLabelBefore(this._time+e)},d},!0),function(){var a=180/Math.PI,b=[],c=[],d=[],e={},f=_gsScope._gsDefine.globals,g=function(a,b,c,d){c===d&&(c=d-(d-b)/1e6),a===b&&(b=a+(c-a)/1e6),this.a=a,this.b=b,this.c=c,this.d=d,this.da=d-a,this.ca=c-a,this.ba=b-a},h=",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",i=function(a,b,c,d){var e={a:a},f={},g={},h={c:d},i=(a+b)/2,j=(b+c)/2,k=(c+d)/2,l=(i+j)/2,m=(j+k)/2,n=(m-l)/8;return e.b=i+(a-i)/4,f.b=l+n,e.c=f.a=(e.b+f.b)/2,f.c=g.a=(l+m)/2,g.b=m-n,h.b=k+(d-k)/4,g.c=h.a=(g.b+h.b)/2,[e,f,g,h]},j=function(a,e,f,g,h){var j,k,l,m,n,o,p,q,r,s,t,u,v,w=a.length-1,x=0,y=a[0].a;for(j=0;w>j;j++)n=a[x],k=n.a,l=n.d,m=a[x+1].d,h?(t=b[j],u=c[j],v=(u+t)*e*.25/(g?.5:d[j]||.5),o=l-(l-k)*(g?.5*e:0!==t?v/t:0),p=l+(m-l)*(g?.5*e:0!==u?v/u:0),q=l-(o+((p-o)*(3*t/(t+u)+.5)/4||0))):(o=l-(l-k)*e*.5,p=l+(m-l)*e*.5,q=l-(o+p)/2),o+=q,p+=q,n.c=r=o,0!==j?n.b=y:n.b=y=n.a+.6*(n.c-n.a),n.da=l-k,n.ca=r-k,n.ba=y-k,f?(s=i(k,y,r,l),a.splice(x,1,s[0],s[1],s[2],s[3]),x+=4):x++,y=p;n=a[x],n.b=y,n.c=y+.4*(n.d-y),n.da=n.d-n.a,n.ca=n.c-n.a,n.ba=y-n.a,f&&(s=i(n.a,y,n.c,n.d),a.splice(x,1,s[0],s[1],s[2],s[3]))},k=function(a,d,e,f){var h,i,j,k,l,m,n=[];if(f)for(a=[f].concat(a),i=a.length;--i>-1;)"string"==typeof(m=a[i][d])&&"="===m.charAt(1)&&(a[i][d]=f[d]+Number(m.charAt(0)+m.substr(2)));if(h=a.length-2,0>h)return n[0]=new g(a[0][d],0,0,a[0][d]),n;for(i=0;h>i;i++)j=a[i][d],k=a[i+1][d],n[i]=new g(j,0,0,k),e&&(l=a[i+2][d],b[i]=(b[i]||0)+(k-j)*(k-j),c[i]=(c[i]||0)+(l-k)*(l-k));return n[i]=new g(a[i][d],0,0,a[i+1][d]),n},l=function(a,f,g,i,l,m){var n,o,p,q,r,s,t,u,v={},w=[],x=m||a[0];l="string"==typeof l?","+l+",":h,null==f&&(f=1);for(o in a[0])w.push(o);if(a.length>1){for(u=a[a.length-1],t=!0,n=w.length;--n>-1;)if(o=w[n],Math.abs(x[o]-u[o])>.05){t=!1;break}t&&(a=a.concat(),m&&a.unshift(m),a.push(a[1]),m=a[a.length-3])}for(b.length=c.length=d.length=0,n=w.length;--n>-1;)o=w[n],e[o]=-1!==l.indexOf(","+o+","),v[o]=k(a,o,e[o],m);for(n=b.length;--n>-1;)b[n]=Math.sqrt(b[n]),c[n]=Math.sqrt(c[n]);if(!i){for(n=w.length;--n>-1;)if(e[o])for(p=v[w[n]],
																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																				 s=p.length-1,q=0;s>q;q++)r=p[q+1].da/c[q]+p[q].da/b[q]||0,d[q]=(d[q]||0)+r*r;for(n=d.length;--n>-1;)d[n]=Math.sqrt(d[n])}for(n=w.length,q=g?4:1;--n>-1;)o=w[n],p=v[o],j(p,f,g,i,e[o]),t&&(p.splice(0,q),p.splice(p.length-q,q));return v},m=function(a,b,c){b=b||"soft";var d,e,f,h,i,j,k,l,m,n,o,p={},q="cubic"===b?3:2,r="soft"===b,s=[];if(r&&c&&(a=[c].concat(a)),null==a||a.length<q+1)throw"invalid Bezier data";for(m in a[0])s.push(m);for(j=s.length;--j>-1;){for(m=s[j],p[m]=i=[],n=0,l=a.length,k=0;l>k;k++)d=null==c?a[k][m]:"string"==typeof(o=a[k][m])&&"="===o.charAt(1)?c[m]+Number(o.charAt(0)+o.substr(2)):Number(o),r&&k>1&&l-1>k&&(i[n++]=(d+i[n-2])/2),i[n++]=d;for(l=n-q+1,n=0,k=0;l>k;k+=q)d=i[k],e=i[k+1],f=i[k+2],h=2===q?0:i[k+3],i[n++]=o=3===q?new g(d,e,f,h):new g(d,(2*e+d)/3,(2*e+f)/3,f);i.length=n}return p},n=function(a,b,c){for(var d,e,f,g,h,i,j,k,l,m,n,o=1/c,p=a.length;--p>-1;)for(m=a[p],f=m.a,g=m.d-f,h=m.c-f,i=m.b-f,d=e=0,k=1;c>=k;k++)j=o*k,l=1-j,d=e-(e=(j*j*g+3*l*(j*h+l*i))*j),n=p*c+k-1,b[n]=(b[n]||0)+d*d},o=function(a,b){b=b>>0||6;var c,d,e,f,g=[],h=[],i=0,j=0,k=b-1,l=[],m=[];for(c in a)n(a[c],g,b);for(e=g.length,d=0;e>d;d++)i+=Math.sqrt(g[d]),f=d%b,m[f]=i,f===k&&(j+=i,f=d/b>>0,l[f]=m,h[f]=j,i=0,m=[]);return{length:j,lengths:h,segments:l}},p=_gsScope._gsDefine.plugin({propName:"bezier",priority:-1,version:"1.3.9",API:2,global:!0,init:function(a,b,c){this._target=a,b instanceof Array&&(b={values:b}),this._func={},this._mod={},this._props=[],this._timeRes=null==b.timeResolution?6:parseInt(b.timeResolution,10);var d,e,f,g,h,i=b.values||[],j={},k=i[0],n=b.autoRotate||c.vars.orientToBezier;this._autoRotate=n?n instanceof Array?n:[["x","y","rotation",n===!0?0:Number(n)||0]]:null;for(d in k)this._props.push(d);for(f=this._props.length;--f>-1;)d=this._props[f],this._overwriteProps.push(d),e=this._func[d]="function"==typeof a[d],j[d]=e?a[d.indexOf("set")||"function"!=typeof a["get"+d.substr(3)]?d:"get"+d.substr(3)]():parseFloat(a[d]),h||j[d]!==i[0][d]&&(h=j);if(this._beziers="cubic"!==b.type&&"quadratic"!==b.type&&"soft"!==b.type?l(i,isNaN(b.curviness)?1:b.curviness,!1,"thruBasic"===b.type,b.correlate,h):m(i,b.type,j),this._segCount=this._beziers[d].length,this._timeRes){var p=o(this._beziers,this._timeRes);this._length=p.length,this._lengths=p.lengths,this._segments=p.segments,this._l1=this._li=this._s1=this._si=0,this._l2=this._lengths[0],this._curSeg=this._segments[0],this._s2=this._curSeg[0],this._prec=1/this._curSeg.length}if(n=this._autoRotate)for(this._initialRotations=[],n[0]instanceof Array||(this._autoRotate=n=[n]),f=n.length;--f>-1;){for(g=0;3>g;g++)d=n[f][g],this._func[d]="function"==typeof a[d]?a[d.indexOf("set")||"function"!=typeof a["get"+d.substr(3)]?d:"get"+d.substr(3)]:!1;d=n[f][2],this._initialRotations[f]=(this._func[d]?this._func[d].call(this._target):this._target[d])||0,this._overwriteProps.push(d)}return this._startRatio=c.vars.runBackwards?1:0,!0},set:function(b){var c,d,e,f,g,h,i,j,k,l,m,n=this._segCount,o=this._func,p=this._target,q=b!==this._startRatio;if(this._timeRes){if(k=this._lengths,l=this._curSeg,m=b*this._length,e=this._li,m>this._l2&&n-1>e){for(j=n-1;j>e&&(this._l2=k[++e])<=m;);this._l1=k[e-1],this._li=e,this._curSeg=l=this._segments[e],this._s2=l[this._s1=this._si=0]}else if(m<this._l1&&e>0){for(;e>0&&(this._l1=k[--e])>=m;);0===e&&m<this._l1?this._l1=0:e++,this._l2=k[e],this._li=e,this._curSeg=l=this._segments[e],this._s1=l[(this._si=l.length-1)-1]||0,this._s2=l[this._si]}if(c=e,m-=this._l1,e=this._si,m>this._s2&&e<l.length-1){for(j=l.length-1;j>e&&(this._s2=l[++e])<=m;);this._s1=l[e-1],this._si=e}else if(m<this._s1&&e>0){for(;e>0&&(this._s1=l[--e])>=m;);0===e&&m<this._s1?this._s1=0:e++,this._s2=l[e],this._si=e}h=1===b?1:(e+(m-this._s1)/(this._s2-this._s1))*this._prec||0}else c=0>b?0:b>=1?n-1:n*b>>0,h=(b-c*(1/n))*n;for(d=1-h,e=this._props.length;--e>-1;)f=this._props[e],g=this._beziers[f][c],i=(h*h*g.da+3*d*(h*g.ca+d*g.ba))*h+g.a,this._mod[f]&&(i=this._mod[f](i,p)),o[f]?p[f](i):p[f]=i;if(this._autoRotate){var r,s,t,u,v,w,x,y=this._autoRotate;for(e=y.length;--e>-1;)f=y[e][2],w=y[e][3]||0,x=y[e][4]===!0?1:a,g=this._beziers[y[e][0]],r=this._beziers[y[e][1]],g&&r&&(g=g[c],r=r[c],s=g.a+(g.b-g.a)*h,u=g.b+(g.c-g.b)*h,s+=(u-s)*h,u+=(g.c+(g.d-g.c)*h-u)*h,t=r.a+(r.b-r.a)*h,v=r.b+(r.c-r.b)*h,t+=(v-t)*h,v+=(r.c+(r.d-r.c)*h-v)*h,i=q?Math.atan2(v-t,u-s)*x+w:this._initialRotations[e],this._mod[f]&&(i=this._mod[f](i,p)),o[f]?p[f](i):p[f]=i)}}}),q=p.prototype;p.bezierThrough=l,p.cubicToQuadratic=i,p._autoCSS=!0,p.quadraticToCubic=function(a,b,c){return new g(a,(2*b+a)/3,(2*b+c)/3,c)},p._cssRegister=function(){var a=f.CSSPlugin;if(a){var b=a._internals,c=b._parseToProxy,d=b._setPluginRatio,e=b.CSSPropTween;b._registerComplexSpecialProp("bezier",{parser:function(a,b,f,g,h,i){b instanceof Array&&(b={values:b}),i=new p;var j,k,l,m=b.values,n=m.length-1,o=[],q={};if(0>n)return h;for(j=0;n>=j;j++)l=c(a,m[j],g,h,i,n!==j),o[j]=l.end;for(k in b)q[k]=b[k];return q.values=o,h=new e(a,"bezier",0,0,l.pt,2),h.data=l,h.plugin=i,h.setRatio=d,0===q.autoRotate&&(q.autoRotate=!0),!q.autoRotate||q.autoRotate instanceof Array||(j=q.autoRotate===!0?0:Number(q.autoRotate),q.autoRotate=null!=l.end.left?[["left","top","rotation",j,!1]]:null!=l.end.x?[["x","y","rotation",j,!1]]:!1),q.autoRotate&&(g._transform||g._enableTransforms(!1),l.autoRotate=g._target._gsTransform,l.proxy.rotation=l.autoRotate.rotation||0,g._overwriteProps.push("rotation")),i._onInitTween(l.proxy,q,g._tween),h}})}},q._mod=function(a){for(var b,c=this._overwriteProps,d=c.length;--d>-1;)b=a[c[d]],b&&"function"==typeof b&&(this._mod[c[d]]=b)},q._kill=function(a){var b,c,d=this._props;for(b in this._beziers)if(b in a)for(delete this._beziers[b],delete this._func[b],c=d.length;--c>-1;)d[c]===b&&d.splice(c,1);if(d=this._autoRotate)for(c=d.length;--c>-1;)a[d[c][2]]&&d.splice(c,1);return this._super._kill.call(this,a)}}(),_gsScope._gsDefine("plugins.CSSPlugin",["plugins.TweenPlugin","TweenLite"],function(a,b){var c,d,e,f,g=function(){a.call(this,"css"),this._overwriteProps.length=0,this.setRatio=g.prototype.setRatio},h=_gsScope._gsDefine.globals,i={},j=g.prototype=new a("css");j.constructor=g,g.version="2.1.3",g.API=2,g.defaultTransformPerspective=0,g.defaultSkewType="compensated",g.defaultSmoothOrigin=!0,j="px",g.suffixMap={top:j,right:j,bottom:j,left:j,width:j,height:j,fontSize:j,padding:j,margin:j,perspective:j,lineHeight:""};var k,l,m,n,o,p,q,r,s=/(?:\-|\.|\b)(\d|\.|e\-)+/g,t=/(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,u=/(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,v=/(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b),?/gi,w=/(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,x=/(?:\d|\-|\+|=|#|\.)*/g,y=/opacity *= *([^)]*)/i,z=/opacity:([^;]*)/i,A=/alpha\(opacity *=.+?\)/i,B=/^(rgb|hsl)/,C=/([A-Z])/g,D=/-([a-z])/gi,E=/(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,F=function(a,b){return b.toUpperCase()},G=/(?:Left|Right|Width)/i,H=/(M11|M12|M21|M22)=[\d\-\.e]+/gi,I=/progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,J=/,(?=[^\)]*(?:\(|$))/gi,K=/[\s,\(]/i,L=Math.PI/180,M=180/Math.PI,N={},O={style:{}},P=_gsScope.document||{createElement:function(){return O}},Q=function(a,b){var c=P.createElementNS?P.createElementNS(b||"http://www.w3.org/1999/xhtml",a):P.createElement(a);return c.style?c:P.createElement(a)},R=Q("div"),S=Q("img"),T=g._internals={_specialProps:i},U=(_gsScope.navigator||{}).userAgent||"",V=function(){var a=U.indexOf("Android"),b=Q("a");return m=-1!==U.indexOf("Safari")&&-1===U.indexOf("Chrome")&&(-1===a||parseFloat(U.substr(a+8,2))>3),o=m&&parseFloat(U.substr(U.indexOf("Version/")+8,2))<6,n=-1!==U.indexOf("Firefox"),(/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(U)||/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(U))&&(p=parseFloat(RegExp.$1)),b?(b.style.cssText="top:1px;opacity:.55;",/^0.55/.test(b.style.opacity)):!1}(),W=function(a){return y.test("string"==typeof a?a:(a.currentStyle?a.currentStyle.filter:a.style.filter)||"")?parseFloat(RegExp.$1)/100:1},X=function(a){_gsScope.console&&console.log(a)},Y="",Z="",$=function(a,b){b=b||R;var c,d,e=b.style;if(void 0!==e[a])return a;for(a=a.charAt(0).toUpperCase()+a.substr(1),c=["O","Moz","ms","Ms","Webkit"],d=5;--d>-1&&void 0===e[c[d]+a];);return d>=0?(Z=3===d?"ms":c[d],Y="-"+Z.toLowerCase()+"-",Z+a):null},_="undefined"!=typeof window?window:P.defaultView||{getComputedStyle:function(){}},aa=function(a){return _.getComputedStyle(a)},ba=g.getStyle=function(a,b,c,d,e){var f;return V||"opacity"!==b?(!d&&a.style[b]?f=a.style[b]:(c=c||aa(a))?f=c[b]||c.getPropertyValue(b)||c.getPropertyValue(b.replace(C,"-$1").toLowerCase()):a.currentStyle&&(f=a.currentStyle[b]),null==e||f&&"none"!==f&&"auto"!==f&&"auto auto"!==f?f:e):W(a)},ca=T.convertToPixels=function(a,c,d,e,f){if("px"===e||!e&&"lineHeight"!==c)return d;if("auto"===e||!d)return 0;var h,i,j,k=G.test(c),l=a,m=R.style,n=0>d,o=1===d;if(n&&(d=-d),o&&(d*=100),"lineHeight"!==c||e)if("%"===e&&-1!==c.indexOf("border"))h=d/100*(k?a.clientWidth:a.clientHeight);else{if(m.cssText="border:0 solid red;position:"+ba(a,"position")+";line-height:0;","%"!==e&&l.appendChild&&"v"!==e.charAt(0)&&"rem"!==e)m[k?"borderLeftWidth":"borderTopWidth"]=d+e;else{if(l=a.parentNode||P.body,-1!==ba(l,"display").indexOf("flex")&&(m.position="absolute"),i=l._gsCache,j=b.ticker.frame,i&&k&&i.time===j)return i.width*d/100;m[k?"width":"height"]=d+e}l.appendChild(R),h=parseFloat(R[k?"offsetWidth":"offsetHeight"]),l.removeChild(R),k&&"%"===e&&g.cacheWidths!==!1&&(i=l._gsCache=l._gsCache||{},i.time=j,i.width=h/d*100),0!==h||f||(h=ca(a,c,d,e,!0))}else i=aa(a).lineHeight,a.style.lineHeight=d,h=parseFloat(aa(a).lineHeight),a.style.lineHeight=i;return o&&(h/=100),n?-h:h},da=T.calculateOffset=function(a,b,c){if("absolute"!==ba(a,"position",c))return 0;var d="left"===b?"Left":"Top",e=ba(a,"margin"+d,c);return a["offset"+d]-(ca(a,b,parseFloat(e),e.replace(x,""))||0)},ea=function(a,b){var c,d,e,f={};if(b=b||aa(a,null))if(c=b.length)for(;--c>-1;)e=b[c],(-1===e.indexOf("-transform")||Fa===e)&&(f[e.replace(D,F)]=b.getPropertyValue(e));else for(c in b)(-1===c.indexOf("Transform")||Ea===c)&&(f[c]=b[c]);else if(b=a.currentStyle||a.style)for(c in b)"string"==typeof c&&void 0===f[c]&&(f[c.replace(D,F)]=b[c]);return V||(f.opacity=W(a)),d=Ta(a,b,!1),f.rotation=d.rotation,f.skewX=d.skewX,f.scaleX=d.scaleX,f.scaleY=d.scaleY,f.x=d.x,f.y=d.y,Ha&&(f.z=d.z,f.rotationX=d.rotationX,f.rotationY=d.rotationY,f.scaleZ=d.scaleZ),f.filters&&delete f.filters,f},fa=function(a,b,c,d,e){var f,g,h,i={},j=a.style;for(g in c)"cssText"!==g&&"length"!==g&&isNaN(g)&&(b[g]!==(f=c[g])||e&&e[g])&&-1===g.indexOf("Origin")&&("number"==typeof f||"string"==typeof f)&&(i[g]="auto"!==f||"left"!==g&&"top"!==g?""!==f&&"auto"!==f&&"none"!==f||"string"!=typeof b[g]||""===b[g].replace(w,"")?f:0:da(a,g),void 0!==j[g]&&(h=new ua(j,g,j[g],h)));if(d)for(g in d)"className"!==g&&(i[g]=d[g]);return{difs:i,firstMPT:h}},ga={width:["Left","Right"],height:["Top","Bottom"]},ha=["marginLeft","marginRight","marginTop","marginBottom"],ia=function(a,b,c){if("svg"===(a.nodeName+"").toLowerCase())return(c||aa(a))[b]||0;if(a.getCTM&&Qa(a))return a.getBBox()[b]||0;var d=parseFloat("width"===b?a.offsetWidth:a.offsetHeight),e=ga[b],f=e.length;for(c=c||aa(a,null);--f>-1;)d-=parseFloat(ba(a,"padding"+e[f],c,!0))||0,d-=parseFloat(ba(a,"border"+e[f]+"Width",c,!0))||0;return d},ja=function(a,b){if("contain"===a||"auto"===a||"auto auto"===a)return a+" ";(null==a||""===a)&&(a="0 0");var c,d=a.split(" "),e=-1!==a.indexOf("left")?"0%":-1!==a.indexOf("right")?"100%":d[0],f=-1!==a.indexOf("top")?"0%":-1!==a.indexOf("bottom")?"100%":d[1];if(d.length>3&&!b){for(d=a.split(", ").join(",").split(","),a=[],c=0;c<d.length;c++)a.push(ja(d[c]));return a.join(",")}return null==f?f="center"===e?"50%":"0":"center"===f&&(f="50%"),("center"===e||isNaN(parseFloat(e))&&-1===(e+"").indexOf("="))&&(e="50%"),a=e+" "+f+(d.length>2?" "+d[2]:""),b&&(b.oxp=-1!==e.indexOf("%"),b.oyp=-1!==f.indexOf("%"),b.oxr="="===e.charAt(1),b.oyr="="===f.charAt(1),b.ox=parseFloat(e.replace(w,"")),b.oy=parseFloat(f.replace(w,"")),b.v=a),b||a},ka=function(a,b){return"function"==typeof a&&(a=a(r,q)),"string"==typeof a&&"="===a.charAt(1)?parseInt(a.charAt(0)+"1",10)*parseFloat(a.substr(2)):parseFloat(a)-parseFloat(b)||0},la=function(a,b){"function"==typeof a&&(a=a(r,q));var c="string"==typeof a&&"="===a.charAt(1);return"string"==typeof a&&"v"===a.charAt(a.length-2)&&(a=(c?a.substr(0,2):0)+window["inner"+("vh"===a.substr(-2)?"Height":"Width")]*(parseFloat(c?a.substr(2):a)/100)),null==a?b:c?parseInt(a.charAt(0)+"1",10)*parseFloat(a.substr(2))+b:parseFloat(a)||0},ma=function(a,b,c,d){var e,f,g,h,i,j=1e-6;return"function"==typeof a&&(a=a(r,q)),null==a?h=b:"number"==typeof a?h=a:(e=360,f=a.split("_"),i="="===a.charAt(1),g=(i?parseInt(a.charAt(0)+"1",10)*parseFloat(f[0].substr(2)):parseFloat(f[0]))*(-1===a.indexOf("rad")?1:M)-(i?0:b),f.length&&(d&&(d[c]=b+g),-1!==a.indexOf("short")&&(g%=e,g!==g%(e/2)&&(g=0>g?g+e:g-e)),-1!==a.indexOf("_cw")&&0>g?g=(g+9999999999*e)%e-(g/e|0)*e:-1!==a.indexOf("ccw")&&g>0&&(g=(g-9999999999*e)%e-(g/e|0)*e)),h=b+g),j>h&&h>-j&&(h=0),h},na={aqua:[0,255,255],lime:[0,255,0],silver:[192,192,192],black:[0,0,0],maroon:[128,0,0],teal:[0,128,128],blue:[0,0,255],navy:[0,0,128],white:[255,255,255],fuchsia:[255,0,255],olive:[128,128,0],yellow:[255,255,0],orange:[255,165,0],gray:[128,128,128],purple:[128,0,128],green:[0,128,0],red:[255,0,0],pink:[255,192,203],cyan:[0,255,255],transparent:[255,255,255,0]},oa=function(a,b,c){return a=0>a?a+1:a>1?a-1:a,255*(1>6*a?b+(c-b)*a*6:.5>a?c:2>3*a?b+(c-b)*(2/3-a)*6:b)+.5|0},pa=g.parseColor=function(a,b){var c,d,e,f,g,h,i,j,k,l,m;if(a)if("number"==typeof a)c=[a>>16,a>>8&255,255&a];else{if(","===a.charAt(a.length-1)&&(a=a.substr(0,a.length-1)),na[a])c=na[a];else if("#"===a.charAt(0))4===a.length&&(d=a.charAt(1),e=a.charAt(2),f=a.charAt(3),a="#"+d+d+e+e+f+f),a=parseInt(a.substr(1),16),c=[a>>16,a>>8&255,255&a];else if("hsl"===a.substr(0,3))if(c=m=a.match(s),b){if(-1!==a.indexOf("="))return a.match(t)}else g=Number(c[0])%360/360,h=Number(c[1])/100,i=Number(c[2])/100,e=.5>=i?i*(h+1):i+h-i*h,d=2*i-e,c.length>3&&(c[3]=Number(c[3])),c[0]=oa(g+1/3,d,e),c[1]=oa(g,d,e),c[2]=oa(g-1/3,d,e);else c=a.match(s)||na.transparent;c[0]=Number(c[0]),c[1]=Number(c[1]),c[2]=Number(c[2]),c.length>3&&(c[3]=Number(c[3]))}else c=na.black;return b&&!m&&(d=c[0]/255,e=c[1]/255,f=c[2]/255,j=Math.max(d,e,f),k=Math.min(d,e,f),i=(j+k)/2,j===k?g=h=0:(l=j-k,h=i>.5?l/(2-j-k):l/(j+k),g=j===d?(e-f)/l+(f>e?6:0):j===e?(f-d)/l+2:(d-e)/l+4,g*=60),c[0]=g+.5|0,c[1]=100*h+.5|0,c[2]=100*i+.5|0),c},qa=function(a,b){var c,d,e,f=a.match(ra)||[],g=0,h="";if(!f.length)return a;for(c=0;c<f.length;c++)d=f[c],e=a.substr(g,a.indexOf(d,g)-g),g+=e.length+d.length,d=pa(d,b),3===d.length&&d.push(1),h+=e+(b?"hsla("+d[0]+","+d[1]+"%,"+d[2]+"%,"+d[3]:"rgba("+d.join(","))+")";return h+a.substr(g)},ra="(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";for(j in na)ra+="|"+j+"\\b";ra=new RegExp(ra+")","gi"),g.colorStringFilter=function(a){var b,c=a[0]+" "+a[1];ra.test(c)&&(b=-1!==c.indexOf("hsl(")||-1!==c.indexOf("hsla("),a[0]=qa(a[0],b),a[1]=qa(a[1],b)),ra.lastIndex=0},b.defaultStringFilter||(b.defaultStringFilter=g.colorStringFilter);var sa=function(a,b,c,d){if(null==a)return function(a){return a};var e,f=b?(a.match(ra)||[""])[0]:"",g=a.split(f).join("").match(u)||[],h=a.substr(0,a.indexOf(g[0])),i=")"===a.charAt(a.length-1)?")":"",j=-1!==a.indexOf(" ")?" ":",",k=g.length,l=k>0?g[0].replace(s,""):"";return k?e=b?function(a){var b,m,n,o;if("number"==typeof a)a+=l;else if(d&&J.test(a)){for(o=a.replace(J,"|").split("|"),n=0;n<o.length;n++)o[n]=e(o[n]);return o.join(",")}if(b=(a.match(ra)||[f])[0],m=a.split(b).join("").match(u)||[],n=m.length,k>n--)for(;++n<k;)m[n]=c?m[(n-1)/2|0]:g[n];return h+m.join(j)+j+b+i+(-1!==a.indexOf("inset")?" inset":"")}:function(a){var b,f,m;if("number"==typeof a)a+=l;else if(d&&J.test(a)){for(f=a.replace(J,"|").split("|"),m=0;m<f.length;m++)f[m]=e(f[m]);return f.join(",")}if(b=a.match(","===j?u:v)||[],m=b.length,k>m--)for(;++m<k;)b[m]=c?b[(m-1)/2|0]:g[m];return(h&&"none"!==a?a.substr(0,a.indexOf(b[0]))||h:h)+b.join(j)+i}:function(a){return a}},ta=function(a){return a=a.split(","),function(b,c,d,e,f,g,h){var i,j=(c+"").split(" ");for(h={},i=0;4>i;i++)h[a[i]]=j[i]=j[i]||j[(i-1)/2>>0];return e.parse(b,h,f,g)}},ua=(T._setPluginRatio=function(a){this.plugin.setRatio(a);for(var b,c,d,e,f,g=this.data,h=g.proxy,i=g.firstMPT,j=1e-6;i;)b=h[i.v],i.r?b=i.r(b):j>b&&b>-j&&(b=0),i.t[i.p]=b,i=i._next;if(g.autoRotate&&(g.autoRotate.rotation=g.mod?g.mod.call(this._tween,h.rotation,this.t,this._tween):h.rotation),1===a||0===a)for(i=g.firstMPT,f=1===a?"e":"b";i;){if(c=i.t,c.type){if(1===c.type){for(e=c.xs0+c.s+c.xs1,d=1;d<c.l;d++)e+=c["xn"+d]+c["xs"+(d+1)];c[f]=e}}else c[f]=c.s+c.xs0;i=i._next}},function(a,b,c,d,e){this.t=a,this.p=b,this.v=c,this.r=e,d&&(d._prev=this,this._next=d)}),va=(T._parseToProxy=function(a,b,c,d,e,f){var g,h,i,j,k,l=d,m={},n={},o=c._transform,p=N;for(c._transform=null,N=b,d=k=c.parse(a,b,d,e),N=p,f&&(c._transform=o,l&&(l._prev=null,l._prev&&(l._prev._next=null)));d&&d!==l;){if(d.type<=1&&(h=d.p,n[h]=d.s+d.c,m[h]=d.s,f||(j=new ua(d,"s",h,j,d.r),d.c=0),1===d.type))for(g=d.l;--g>0;)i="xn"+g,h=d.p+"_"+i,n[h]=d.data[i],m[h]=d[i],f||(j=new ua(d,i,h,j,d.rxp[i]));d=d._next}return{proxy:m,end:n,firstMPT:j,pt:k}},T.CSSPropTween=function(a,b,d,e,g,h,i,j,k,l,m){this.t=a,this.p=b,this.s=d,this.c=e,this.n=i||b,a instanceof va||f.push(this.n),this.r=j?"function"==typeof j?j:Math.round:j,this.type=h||0,k&&(this.pr=k,c=!0),this.b=void 0===l?d:l,this.e=void 0===m?d+e:m,g&&(this._next=g,g._prev=this)}),wa=function(a,b,c,d,e,f){var g=new va(a,b,c,d-c,e,-1,f);return g.b=c,g.e=g.xs0=d,g},xa=g.parseComplex=function(a,b,c,d,e,f,h,i,j,l){c=c||f||"","function"==typeof d&&(d=d(r,q)),h=new va(a,b,0,0,h,l?2:1,null,!1,i,c,d),d+="",e&&ra.test(d+c)&&(d=[c,d],g.colorStringFilter(d),c=d[0],d=d[1]);var m,n,o,p,u,v,w,x,y,z,A,B,C,D=c.split(", ").join(",").split(" "),E=d.split(", ").join(",").split(" "),F=D.length,G=k!==!1;for((-1!==d.indexOf(",")||-1!==c.indexOf(","))&&(-1!==(d+c).indexOf("rgb")||-1!==(d+c).indexOf("hsl")?(D=D.join(" ").replace(J,", ").split(" "),E=E.join(" ").replace(J,", ").split(" ")):(D=D.join(" ").split(",").join(", ").split(" "),E=E.join(" ").split(",").join(", ").split(" ")),F=D.length),F!==E.length&&(D=(f||"").split(" "),F=D.length),h.plugin=j,h.setRatio=l,ra.lastIndex=0,m=0;F>m;m++)if(p=D[m],u=E[m]+"",x=parseFloat(p),x||0===x)h.appendXtra("",x,ka(u,x),u.replace(t,""),G&&-1!==u.indexOf("px")?Math.round:!1,!0);else if(e&&ra.test(p))B=u.indexOf(")")+1,B=")"+(B?u.substr(B):""),C=-1!==u.indexOf("hsl")&&V,z=u,p=pa(p,C),u=pa(u,C),y=p.length+u.length>6,y&&!V&&0===u[3]?(h["xs"+h.l]+=h.l?" transparent":"transparent",h.e=h.e.split(E[m]).join("transparent")):(V||(y=!1),C?h.appendXtra(z.substr(0,z.indexOf("hsl"))+(y?"hsla(":"hsl("),p[0],ka(u[0],p[0]),",",!1,!0).appendXtra("",p[1],ka(u[1],p[1]),"%,",!1).appendXtra("",p[2],ka(u[2],p[2]),y?"%,":"%"+B,!1):h.appendXtra(z.substr(0,z.indexOf("rgb"))+(y?"rgba(":"rgb("),p[0],u[0]-p[0],",",Math.round,!0).appendXtra("",p[1],u[1]-p[1],",",Math.round).appendXtra("",p[2],u[2]-p[2],y?",":B,Math.round),y&&(p=p.length<4?1:p[3],h.appendXtra("",p,(u.length<4?1:u[3])-p,B,!1))),ra.lastIndex=0;else if(v=p.match(s)){if(w=u.match(t),!w||w.length!==v.length)return h;for(o=0,n=0;n<v.length;n++)A=v[n],z=p.indexOf(A,o),h.appendXtra(p.substr(o,z-o),Number(A),ka(w[n],A),"",G&&"px"===p.substr(z+A.length,2)?Math.round:!1,0===n),o=z+A.length;h["xs"+h.l]+=p.substr(o)}else h["xs"+h.l]+=h.l||h["xs"+h.l]?" "+u:u;if(-1!==d.indexOf("=")&&h.data){for(B=h.xs0+h.data.s,m=1;m<h.l;m++)B+=h["xs"+m]+h.data["xn"+m];h.e=B+h["xs"+m]}return h.l||(h.type=-1,h.xs0=h.e),h.xfirst||h},ya=9;for(j=va.prototype,j.l=j.pr=0;--ya>0;)j["xn"+ya]=0,j["xs"+ya]="";j.xs0="",j._next=j._prev=j.xfirst=j.data=j.plugin=j.setRatio=j.rxp=null,j.appendXtra=function(a,b,c,d,e,f){var g=this,h=g.l;return g["xs"+h]+=f&&(h||g["xs"+h])?" "+a:a||"",c||0===h||g.plugin?(g.l++,g.type=g.setRatio?2:1,g["xs"+g.l]=d||"",h>0?(g.data["xn"+h]=b+c,g.rxp["xn"+h]=e,g["xn"+h]=b,g.plugin||(g.xfirst=new va(g,"xn"+h,b,c,g.xfirst||g,0,g.n,e,g.pr),g.xfirst.xs0=0),g):(g.data={s:b+c},g.rxp={},g.s=b,g.c=c,g.r=e,g)):(g["xs"+h]+=b+(d||""),g)};var za=function(a,b){b=b||{},this.p=b.prefix?$(a)||a:a,i[a]=i[this.p]=this,this.format=b.formatter||sa(b.defaultValue,b.color,b.collapsible,b.multi),b.parser&&(this.parse=b.parser),this.clrs=b.color,this.multi=b.multi,this.keyword=b.keyword,this.dflt=b.defaultValue,this.allowFunc=b.allowFunc,this.pr=b.priority||0},Aa=T._registerComplexSpecialProp=function(a,b,c){"object"!=typeof b&&(b={parser:c});var d,e,f=a.split(","),g=b.defaultValue;for(c=c||[g],d=0;d<f.length;d++)b.prefix=0===d&&b.prefix,b.defaultValue=c[d]||g,e=new za(f[d],b)},Ba=T._registerPluginProp=function(a){if(!i[a]){var b=a.charAt(0).toUpperCase()+a.substr(1)+"Plugin";Aa(a,{parser:function(a,c,d,e,f,g,j){var k=h.com.greensock.plugins[b];return k?(k._cssRegister(),i[d].parse(a,c,d,e,f,g,j)):(X("Error: "+b+" js file not loaded."),f)}})}};j=za.prototype,j.parseComplex=function(a,b,c,d,e,f){var g,h,i,j,k,l,m=this.keyword;if(this.multi&&(J.test(c)||J.test(b)?(h=b.replace(J,"|").split("|"),i=c.replace(J,"|").split("|")):m&&(h=[b],i=[c])),i){for(j=i.length>h.length?i.length:h.length,g=0;j>g;g++)b=h[g]=h[g]||this.dflt,c=i[g]=i[g]||this.dflt,m&&(k=b.indexOf(m),l=c.indexOf(m),k!==l&&(-1===l?h[g]=h[g].split(m).join(""):-1===k&&(h[g]+=" "+m)));b=h.join(", "),c=i.join(", ")}return xa(a,this.p,b,c,this.clrs,this.dflt,d,this.pr,e,f)},j.parse=function(a,b,c,d,f,g,h){return this.parseComplex(a.style,this.format(ba(a,this.p,e,!1,this.dflt)),this.format(b),f,g)},g.registerSpecialProp=function(a,b,c){Aa(a,{parser:function(a,d,e,f,g,h,i){var j=new va(a,e,0,0,g,2,e,!1,c);return j.plugin=h,j.setRatio=b(a,d,f._tween,e),j},priority:c})},g.useSVGTransformAttr=!0;var Ca,Da="scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),Ea=$("transform"),Fa=Y+"transform",Ga=$("transformOrigin"),Ha=null!==$("perspective"),Ia=T.Transform=function(){this.perspective=parseFloat(g.defaultTransformPerspective)||0,this.force3D=g.defaultForce3D!==!1&&Ha?g.defaultForce3D||"auto":!1},Ja=_gsScope.SVGElement,Ka=function(a,b,c){var d,e=P.createElementNS("http://www.w3.org/2000/svg",a),f=/([a-z])([A-Z])/g;for(d in c)e.setAttributeNS(null,d.replace(f,"$1-$2").toLowerCase(),c[d]);return b.appendChild(e),e},La=P.documentElement||{},Ma=function(){var a,b,c,d=p||/Android/i.test(U)&&!_gsScope.chrome;return P.createElementNS&&La.appendChild&&!d&&(a=Ka("svg",La),b=Ka("rect",a,{width:100,height:50,x:100}),c=b.getBoundingClientRect().width,b.style[Ga]="50% 50%",b.style[Ea]="scaleX(0.5)",d=c===b.getBoundingClientRect().width&&!(n&&Ha),La.removeChild(a)),d}(),Na=function(a,b,c,d,e,f){var h,i,j,k,l,m,n,o,p,q,r,s,t,u,v=a._gsTransform,w=Sa(a,!0);v&&(t=v.xOrigin,u=v.yOrigin),(!d||(h=d.split(" ")).length<2)&&(n=a.getBBox(),0===n.x&&0===n.y&&n.width+n.height===0&&(n={x:parseFloat(a.hasAttribute("x")?a.getAttribute("x"):a.hasAttribute("cx")?a.getAttribute("cx"):0)||0,y:parseFloat(a.hasAttribute("y")?a.getAttribute("y"):a.hasAttribute("cy")?a.getAttribute("cy"):0)||0,width:0,height:0}),b=ja(b).split(" "),h=[(-1!==b[0].indexOf("%")?parseFloat(b[0])/100*n.width:parseFloat(b[0]))+n.x,(-1!==b[1].indexOf("%")?parseFloat(b[1])/100*n.height:parseFloat(b[1]))+n.y]),c.xOrigin=k=parseFloat(h[0]),c.yOrigin=l=parseFloat(h[1]),d&&w!==Ra&&(m=w[0],n=w[1],o=w[2],p=w[3],q=w[4],r=w[5],s=m*p-n*o,s&&(i=k*(p/s)+l*(-o/s)+(o*r-p*q)/s,j=k*(-n/s)+l*(m/s)-(m*r-n*q)/s,k=c.xOrigin=h[0]=i,l=c.yOrigin=h[1]=j)),v&&(f&&(c.xOffset=v.xOffset,c.yOffset=v.yOffset,v=c),e||e!==!1&&g.defaultSmoothOrigin!==!1?(i=k-t,j=l-u,v.xOffset+=i*w[0]+j*w[2]-i,v.yOffset+=i*w[1]+j*w[3]-j):v.xOffset=v.yOffset=0),f||a.setAttribute("data-svg-origin",h.join(" "))},Oa=function(a){var b,c=Q("svg",this.ownerSVGElement&&this.ownerSVGElement.getAttribute("xmlns")||"http://www.w3.org/2000/svg"),d=this.parentNode,e=this.nextSibling,f=this.style.cssText;if(La.appendChild(c),c.appendChild(this),this.style.display="block",a)try{b=this.getBBox(),this._originalGetBBox=this.getBBox,this.getBBox=Oa}catch(g){}else this._originalGetBBox&&(b=this._originalGetBBox());return e?d.insertBefore(this,e):d.appendChild(this),La.removeChild(c),this.style.cssText=f,b},Pa=function(a){try{return a.getBBox()}catch(b){return Oa.call(a,!0)}},Qa=function(a){return!(!Ja||!a.getCTM||a.parentNode&&!a.ownerSVGElement||!Pa(a))},Ra=[1,0,0,1,0,0],Sa=function(a,b){var c,d,e,f,g,h,i,j=a._gsTransform||new Ia,k=1e5,l=a.style;if(Ea?d=ba(a,Fa,null,!0):a.currentStyle&&(d=a.currentStyle.filter.match(H),d=d&&4===d.length?[d[0].substr(4),Number(d[2].substr(4)),Number(d[1].substr(4)),d[3].substr(4),j.x||0,j.y||0].join(","):""),c=!d||"none"===d||"matrix(1, 0, 0, 1, 0, 0)"===d,Ea&&c&&!a.offsetParent&&a!==La&&(f=l.display,l.display="block",i=a.parentNode,i&&a.offsetParent||(g=1,h=a.nextSibling,La.appendChild(a)),d=ba(a,Fa,null,!0),c=!d||"none"===d||"matrix(1, 0, 0, 1, 0, 0)"===d,f?l.display=f:Xa(l,"display"),g&&(h?i.insertBefore(a,h):i?i.appendChild(a):La.removeChild(a))),(j.svg||a.getCTM&&Qa(a))&&(c&&-1!==(l[Ea]+"").indexOf("matrix")&&(d=l[Ea],c=0),e=a.getAttribute("transform"),c&&e&&(e=a.transform.baseVal.consolidate().matrix,d="matrix("+e.a+","+e.b+","+e.c+","+e.d+","+e.e+","+e.f+")",c=0)),c)return Ra;for(e=(d||"").match(s)||[],ya=e.length;--ya>-1;)f=Number(e[ya]),e[ya]=(g=f-(f|=0))?(g*k+(0>g?-.5:.5)|0)/k+f:f;return b&&e.length>6?[e[0],e[1],e[4],e[5],e[12],e[13]]:e},Ta=T.getTransform=function(a,c,d,e){if(a._gsTransform&&d&&!e)return a._gsTransform;var f,h,i,j,k,l,m=d?a._gsTransform||new Ia:new Ia,n=m.scaleX<0,o=2e-5,p=1e5,q=Ha?parseFloat(ba(a,Ga,c,!1,"0 0 0").split(" ")[2])||m.zOrigin||0:0,r=parseFloat(g.defaultTransformPerspective)||0;if(m.svg=!(!a.getCTM||!Qa(a)),m.svg&&(Na(a,ba(a,Ga,c,!1,"50% 50%")+"",m,a.getAttribute("data-svg-origin")),Ca=g.useSVGTransformAttr||Ma),f=Sa(a),f!==Ra){if(16===f.length){var s,t,u,v,w,x=f[0],y=f[1],z=f[2],A=f[3],B=f[4],C=f[5],D=f[6],E=f[7],F=f[8],G=f[9],H=f[10],I=f[12],J=f[13],K=f[14],L=f[11],N=Math.atan2(D,H);m.zOrigin&&(K=-m.zOrigin,I=F*K-f[12],J=G*K-f[13],K=H*K+m.zOrigin-f[14]),m.rotationX=N*M,N&&(v=Math.cos(-N),w=Math.sin(-N),s=B*v+F*w,t=C*v+G*w,u=D*v+H*w,F=B*-w+F*v,G=C*-w+G*v,H=D*-w+H*v,L=E*-w+L*v,B=s,C=t,D=u),N=Math.atan2(-z,H),m.rotationY=N*M,N&&(v=Math.cos(-N),w=Math.sin(-N),s=x*v-F*w,t=y*v-G*w,u=z*v-H*w,G=y*w+G*v,H=z*w+H*v,L=A*w+L*v,x=s,y=t,z=u),N=Math.atan2(y,x),m.rotation=N*M,N&&(v=Math.cos(N),w=Math.sin(N),s=x*v+y*w,t=B*v+C*w,u=F*v+G*w,y=y*v-x*w,C=C*v-B*w,G=G*v-F*w,x=s,B=t,F=u),m.rotationX&&Math.abs(m.rotationX)+Math.abs(m.rotation)>359.9&&(m.rotationX=m.rotation=0,m.rotationY=180-m.rotationY),N=Math.atan2(B,C),m.scaleX=(Math.sqrt(x*x+y*y+z*z)*p+.5|0)/p,m.scaleY=(Math.sqrt(C*C+D*D)*p+.5|0)/p,m.scaleZ=(Math.sqrt(F*F+G*G+H*H)*p+.5|0)/p,x/=m.scaleX,B/=m.scaleY,y/=m.scaleX,C/=m.scaleY,Math.abs(N)>o?(m.skewX=N*M,B=0,"simple"!==m.skewType&&(m.scaleY*=1/Math.cos(N))):m.skewX=0,m.perspective=L?1/(0>L?-L:L):0,m.x=I,m.y=J,m.z=K,m.svg&&(m.x-=m.xOrigin-(m.xOrigin*x-m.yOrigin*B),m.y-=m.yOrigin-(m.yOrigin*y-m.xOrigin*C))}else if(!Ha||e||!f.length||m.x!==f[4]||m.y!==f[5]||!m.rotationX&&!m.rotationY){var O=f.length>=6,P=O?f[0]:1,Q=f[1]||0,R=f[2]||0,S=O?f[3]:1;m.x=f[4]||0,m.y=f[5]||0,i=Math.sqrt(P*P+Q*Q),j=Math.sqrt(S*S+R*R),k=P||Q?Math.atan2(Q,P)*M:m.rotation||0,l=R||S?Math.atan2(R,S)*M+k:m.skewX||0,m.scaleX=i,m.scaleY=j,m.rotation=k,m.skewX=l,Ha&&(m.rotationX=m.rotationY=m.z=0,m.perspective=r,m.scaleZ=1),m.svg&&(m.x-=m.xOrigin-(m.xOrigin*P+m.yOrigin*R),m.y-=m.yOrigin-(m.xOrigin*Q+m.yOrigin*S))}Math.abs(m.skewX)>90&&Math.abs(m.skewX)<270&&(n?(m.scaleX*=-1,m.skewX+=m.rotation<=0?180:-180,m.rotation+=m.rotation<=0?180:-180):(m.scaleY*=-1,m.skewX+=m.skewX<=0?180:-180)),m.zOrigin=q;for(h in m)m[h]<o&&m[h]>-o&&(m[h]=0)}return d&&(a._gsTransform=m,m.svg&&(Ca&&a.style[Ea]?b.delayedCall(.001,function(){Xa(a.style,Ea)}):!Ca&&a.getAttribute("transform")&&b.delayedCall(.001,function(){a.removeAttribute("transform")}))),m},Ua=function(a){var b,c,d=this.data,e=-d.rotation*L,f=e+d.skewX*L,g=1e5,h=(Math.cos(e)*d.scaleX*g|0)/g,i=(Math.sin(e)*d.scaleX*g|0)/g,j=(Math.sin(f)*-d.scaleY*g|0)/g,k=(Math.cos(f)*d.scaleY*g|0)/g,l=this.t.style,m=this.t.currentStyle;if(m){c=i,i=-j,j=-c,b=m.filter,l.filter="";var n,o,q=this.t.offsetWidth,r=this.t.offsetHeight,s="absolute"!==m.position,t="progid:DXImageTransform.Microsoft.Matrix(M11="+h+", M12="+i+", M21="+j+", M22="+k,u=d.x+q*d.xPercent/100,v=d.y+r*d.yPercent/100;if(null!=d.ox&&(n=(d.oxp?q*d.ox*.01:d.ox)-q/2,o=(d.oyp?r*d.oy*.01:d.oy)-r/2,u+=n-(n*h+o*i),v+=o-(n*j+o*k)),s?(n=q/2,o=r/2,t+=", Dx="+(n-(n*h+o*i)+u)+", Dy="+(o-(n*j+o*k)+v)+")"):t+=", sizingMethod='auto expand')",-1!==b.indexOf("DXImageTransform.Microsoft.Matrix(")?l.filter=b.replace(I,t):l.filter=t+" "+b,(0===a||1===a)&&1===h&&0===i&&0===j&&1===k&&(s&&-1===t.indexOf("Dx=0, Dy=0")||y.test(b)&&100!==parseFloat(RegExp.$1)||-1===b.indexOf(b.indexOf("Alpha"))&&l.removeAttribute("filter")),!s){var w,z,A,B=8>p?1:-1;for(n=d.ieOffsetX||0,o=d.ieOffsetY||0,d.ieOffsetX=Math.round((q-((0>h?-h:h)*q+(0>i?-i:i)*r))/2+u),d.ieOffsetY=Math.round((r-((0>k?-k:k)*r+(0>j?-j:j)*q))/2+v),ya=0;4>ya;ya++)z=ha[ya],w=m[z],c=-1!==w.indexOf("px")?parseFloat(w):ca(this.t,z,parseFloat(w),w.replace(x,""))||0,A=c!==d[z]?2>ya?-d.ieOffsetX:-d.ieOffsetY:2>ya?n-d.ieOffsetX:o-d.ieOffsetY,l[z]=(d[z]=Math.round(c-A*(0===ya||2===ya?1:B)))+"px"}}},Va=T.set3DTransformRatio=T.setTransformRatio=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,o,p,q,r,s,t,u,v,w,x,y,z=this.data,A=this.t.style,B=z.rotation,C=z.rotationX,D=z.rotationY,E=z.scaleX,F=z.scaleY,G=z.scaleZ,H=z.x,I=z.y,J=z.z,K=z.svg,M=z.perspective,N=z.force3D,O=z.skewY,P=z.skewX;if(O&&(P+=O,B+=O),((1===a||0===a)&&"auto"===N&&(this.tween._totalTime===this.tween._totalDuration||!this.tween._totalTime)||!N)&&!J&&!M&&!D&&!C&&1===G||Ca&&K||!Ha)return void(B||P||K?(B*=L,x=P*L,y=1e5,c=Math.cos(B)*E,f=Math.sin(B)*E,d=Math.sin(B-x)*-F,g=Math.cos(B-x)*F,x&&"simple"===z.skewType&&(b=Math.tan(x-O*L),b=Math.sqrt(1+b*b),d*=b,g*=b,O&&(b=Math.tan(O*L),b=Math.sqrt(1+b*b),c*=b,f*=b)),K&&(H+=z.xOrigin-(z.xOrigin*c+z.yOrigin*d)+z.xOffset,I+=z.yOrigin-(z.xOrigin*f+z.yOrigin*g)+z.yOffset,Ca&&(z.xPercent||z.yPercent)&&(q=this.t.getBBox(),H+=.01*z.xPercent*q.width,I+=.01*z.yPercent*q.height),q=1e-6,q>H&&H>-q&&(H=0),q>I&&I>-q&&(I=0)),u=(c*y|0)/y+","+(f*y|0)/y+","+(d*y|0)/y+","+(g*y|0)/y+","+H+","+I+")",K&&Ca?this.t.setAttribute("transform","matrix("+u):A[Ea]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix(":"matrix(")+u):A[Ea]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix(":"matrix(")+E+",0,0,"+F+","+H+","+I+")");if(n&&(q=1e-4,q>E&&E>-q&&(E=G=2e-5),q>F&&F>-q&&(F=G=2e-5),!M||z.z||z.rotationX||z.rotationY||(M=0)),B||P)B*=L,r=c=Math.cos(B),s=f=Math.sin(B),P&&(B-=P*L,r=Math.cos(B),s=Math.sin(B),"simple"===z.skewType&&(b=Math.tan((P-O)*L),b=Math.sqrt(1+b*b),r*=b,s*=b,z.skewY&&(b=Math.tan(O*L),b=Math.sqrt(1+b*b),c*=b,f*=b))),d=-s,g=r;else{if(!(D||C||1!==G||M||K))return void(A[Ea]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) translate3d(":"translate3d(")+H+"px,"+I+"px,"+J+"px)"+(1!==E||1!==F?" scale("+E+","+F+")":""));c=g=1,d=f=0}k=1,e=h=i=j=l=m=0,o=M?-1/M:0,p=z.zOrigin,q=1e-6,v=",",w="0",B=D*L,B&&(r=Math.cos(B),s=Math.sin(B),i=-s,l=o*-s,e=c*s,h=f*s,k=r,o*=r,c*=r,f*=r),B=C*L,B&&(r=Math.cos(B),s=Math.sin(B),b=d*r+e*s,t=g*r+h*s,j=k*s,m=o*s,e=d*-s+e*r,h=g*-s+h*r,k*=r,o*=r,d=b,g=t),1!==G&&(e*=G,h*=G,k*=G,o*=G),1!==F&&(d*=F,g*=F,j*=F,m*=F),1!==E&&(c*=E,f*=E,i*=E,l*=E),(p||K)&&(p&&(H+=e*-p,I+=h*-p,J+=k*-p+p),K&&(H+=z.xOrigin-(z.xOrigin*c+z.yOrigin*d)+z.xOffset,I+=z.yOrigin-(z.xOrigin*f+z.yOrigin*g)+z.yOffset),q>H&&H>-q&&(H=w),q>I&&I>-q&&(I=w),q>J&&J>-q&&(J=0)),u=z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix3d(":"matrix3d(",u+=(q>c&&c>-q?w:c)+v+(q>f&&f>-q?w:f)+v+(q>i&&i>-q?w:i),u+=v+(q>l&&l>-q?w:l)+v+(q>d&&d>-q?w:d)+v+(q>g&&g>-q?w:g),
	C||D||1!==G?(u+=v+(q>j&&j>-q?w:j)+v+(q>m&&m>-q?w:m)+v+(q>e&&e>-q?w:e),u+=v+(q>h&&h>-q?w:h)+v+(q>k&&k>-q?w:k)+v+(q>o&&o>-q?w:o)+v):u+=",0,0,0,0,1,0,",u+=H+v+I+v+J+v+(M?1+-J/M:1)+")",A[Ea]=u};j=Ia.prototype,j.x=j.y=j.z=j.skewX=j.skewY=j.rotation=j.rotationX=j.rotationY=j.zOrigin=j.xPercent=j.yPercent=j.xOffset=j.yOffset=0,j.scaleX=j.scaleY=j.scaleZ=1,Aa("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin",{parser:function(a,b,c,d,f,h,i){if(d._lastParsedTransform===i)return f;d._lastParsedTransform=i;var j=i.scale&&"function"==typeof i.scale?i.scale:0;j&&(i.scale=j(r,a));var k,l,m,n,o,p,s,t,u,v=a._gsTransform,w=a.style,x=1e-6,y=Da.length,z=i,A={},B="transformOrigin",C=Ta(a,e,!0,z.parseTransform),D=z.transform&&("function"==typeof z.transform?z.transform(r,q):z.transform);if(C.skewType=z.skewType||C.skewType||g.defaultSkewType,d._transform=C,"rotationZ"in z&&(z.rotation=z.rotationZ),D&&"string"==typeof D&&Ea)l=R.style,l[Ea]=D,l.display="block",l.position="absolute",-1!==D.indexOf("%")&&(l.width=ba(a,"width"),l.height=ba(a,"height")),P.body.appendChild(R),k=Ta(R,null,!1),"simple"===C.skewType&&(k.scaleY*=Math.cos(k.skewX*L)),C.svg&&(p=C.xOrigin,s=C.yOrigin,k.x-=C.xOffset,k.y-=C.yOffset,(z.transformOrigin||z.svgOrigin)&&(D={},Na(a,ja(z.transformOrigin),D,z.svgOrigin,z.smoothOrigin,!0),p=D.xOrigin,s=D.yOrigin,k.x-=D.xOffset-C.xOffset,k.y-=D.yOffset-C.yOffset),(p||s)&&(t=Sa(R,!0),k.x-=p-(p*t[0]+s*t[2]),k.y-=s-(p*t[1]+s*t[3]))),P.body.removeChild(R),k.perspective||(k.perspective=C.perspective),null!=z.xPercent&&(k.xPercent=la(z.xPercent,C.xPercent)),null!=z.yPercent&&(k.yPercent=la(z.yPercent,C.yPercent));else if("object"==typeof z){if(k={scaleX:la(null!=z.scaleX?z.scaleX:z.scale,C.scaleX),scaleY:la(null!=z.scaleY?z.scaleY:z.scale,C.scaleY),scaleZ:la(z.scaleZ,C.scaleZ),x:la(z.x,C.x),y:la(z.y,C.y),z:la(z.z,C.z),xPercent:la(z.xPercent,C.xPercent),yPercent:la(z.yPercent,C.yPercent),perspective:la(z.transformPerspective,C.perspective)},o=z.directionalRotation,null!=o)if("object"==typeof o)for(l in o)z[l]=o[l];else z.rotation=o;"string"==typeof z.x&&-1!==z.x.indexOf("%")&&(k.x=0,k.xPercent=la(z.x,C.xPercent)),"string"==typeof z.y&&-1!==z.y.indexOf("%")&&(k.y=0,k.yPercent=la(z.y,C.yPercent)),k.rotation=ma("rotation"in z?z.rotation:"shortRotation"in z?z.shortRotation+"_short":C.rotation,C.rotation,"rotation",A),Ha&&(k.rotationX=ma("rotationX"in z?z.rotationX:"shortRotationX"in z?z.shortRotationX+"_short":C.rotationX||0,C.rotationX,"rotationX",A),k.rotationY=ma("rotationY"in z?z.rotationY:"shortRotationY"in z?z.shortRotationY+"_short":C.rotationY||0,C.rotationY,"rotationY",A)),k.skewX=ma(z.skewX,C.skewX),k.skewY=ma(z.skewY,C.skewY)}for(Ha&&null!=z.force3D&&(C.force3D=z.force3D,n=!0),m=C.force3D||C.z||C.rotationX||C.rotationY||k.z||k.rotationX||k.rotationY||k.perspective,m||null==z.scale||(k.scaleZ=1);--y>-1;)u=Da[y],D=k[u]-C[u],(D>x||-x>D||null!=z[u]||null!=N[u])&&(n=!0,f=new va(C,u,C[u],D,f),u in A&&(f.e=A[u]),f.xs0=0,f.plugin=h,d._overwriteProps.push(f.n));return D="function"==typeof z.transformOrigin?z.transformOrigin(r,q):z.transformOrigin,C.svg&&(D||z.svgOrigin)&&(p=C.xOffset,s=C.yOffset,Na(a,ja(D),k,z.svgOrigin,z.smoothOrigin),f=wa(C,"xOrigin",(v?C:k).xOrigin,k.xOrigin,f,B),f=wa(C,"yOrigin",(v?C:k).yOrigin,k.yOrigin,f,B),(p!==C.xOffset||s!==C.yOffset)&&(f=wa(C,"xOffset",v?p:C.xOffset,C.xOffset,f,B),f=wa(C,"yOffset",v?s:C.yOffset,C.yOffset,f,B)),D="0px 0px"),(D||Ha&&m&&C.zOrigin)&&(Ea?(n=!0,u=Ga,D||(D=(ba(a,u,e,!1,"50% 50%")+"").split(" "),D=D[0]+" "+D[1]+" "+C.zOrigin+"px"),D+="",f=new va(w,u,0,0,f,-1,B),f.b=w[u],f.plugin=h,Ha?(l=C.zOrigin,D=D.split(" "),C.zOrigin=(D.length>2?parseFloat(D[2]):l)||0,f.xs0=f.e=D[0]+" "+(D[1]||"50%")+" 0px",f=new va(C,"zOrigin",0,0,f,-1,f.n),f.b=l,f.xs0=f.e=C.zOrigin):f.xs0=f.e=D):ja(D+"",C)),n&&(d._transformType=C.svg&&Ca||!m&&3!==this._transformType?2:3),j&&(i.scale=j),f},allowFunc:!0,prefix:!0}),Aa("boxShadow",{defaultValue:"0px 0px 0px 0px #999",prefix:!0,color:!0,multi:!0,keyword:"inset"}),Aa("clipPath",{defaultValue:"inset(0%)",prefix:!0,multi:!0,formatter:sa("inset(0% 0% 0% 0%)",!1,!0)}),Aa("borderRadius",{defaultValue:"0px",parser:function(a,b,c,f,g,h){b=this.format(b);var i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y=["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],z=a.style;for(q=parseFloat(a.offsetWidth),r=parseFloat(a.offsetHeight),i=b.split(" "),j=0;j<y.length;j++)this.p.indexOf("border")&&(y[j]=$(y[j])),m=l=ba(a,y[j],e,!1,"0px"),-1!==m.indexOf(" ")&&(l=m.split(" "),m=l[0],l=l[1]),n=k=i[j],o=parseFloat(m),t=m.substr((o+"").length),u="="===n.charAt(1),u?(p=parseInt(n.charAt(0)+"1",10),n=n.substr(2),p*=parseFloat(n),s=n.substr((p+"").length-(0>p?1:0))||""):(p=parseFloat(n),s=n.substr((p+"").length)),""===s&&(s=d[c]||t),s!==t&&(v=ca(a,"borderLeft",o,t),w=ca(a,"borderTop",o,t),"%"===s?(m=v/q*100+"%",l=w/r*100+"%"):"em"===s?(x=ca(a,"borderLeft",1,"em"),m=v/x+"em",l=w/x+"em"):(m=v+"px",l=w+"px"),u&&(n=parseFloat(m)+p+s,k=parseFloat(l)+p+s)),g=xa(z,y[j],m+" "+l,n+" "+k,!1,"0px",g);return g},prefix:!0,formatter:sa("0px 0px 0px 0px",!1,!0)}),Aa("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius",{defaultValue:"0px",parser:function(a,b,c,d,f,g){return xa(a.style,c,this.format(ba(a,c,e,!1,"0px 0px")),this.format(b),!1,"0px",f)},prefix:!0,formatter:sa("0px 0px",!1,!0)}),Aa("backgroundPosition",{defaultValue:"0 0",parser:function(a,b,c,d,f,g){var h,i,j,k,l,m,n="background-position",o=e||aa(a,null),q=this.format((o?p?o.getPropertyValue(n+"-x")+" "+o.getPropertyValue(n+"-y"):o.getPropertyValue(n):a.currentStyle.backgroundPositionX+" "+a.currentStyle.backgroundPositionY)||"0 0"),r=this.format(b);if(-1!==q.indexOf("%")!=(-1!==r.indexOf("%"))&&r.split(",").length<2&&(m=ba(a,"backgroundImage").replace(E,""),m&&"none"!==m)){for(h=q.split(" "),i=r.split(" "),S.setAttribute("src",m),j=2;--j>-1;)q=h[j],k=-1!==q.indexOf("%"),k!==(-1!==i[j].indexOf("%"))&&(l=0===j?a.offsetWidth-S.width:a.offsetHeight-S.height,h[j]=k?parseFloat(q)/100*l+"px":parseFloat(q)/l*100+"%");q=h.join(" ")}return this.parseComplex(a.style,q,r,f,g)},formatter:ja}),Aa("backgroundSize",{defaultValue:"0 0",formatter:function(a){return a+="","co"===a.substr(0,2)?a:ja(-1===a.indexOf(" ")?a+" "+a:a)}}),Aa("perspective",{defaultValue:"0px",prefix:!0}),Aa("perspectiveOrigin",{defaultValue:"50% 50%",prefix:!0}),Aa("transformStyle",{prefix:!0}),Aa("backfaceVisibility",{prefix:!0}),Aa("userSelect",{prefix:!0}),Aa("margin",{parser:ta("marginTop,marginRight,marginBottom,marginLeft")}),Aa("padding",{parser:ta("paddingTop,paddingRight,paddingBottom,paddingLeft")}),Aa("clip",{defaultValue:"rect(0px,0px,0px,0px)",parser:function(a,b,c,d,f,g){var h,i,j;return 9>p?(i=a.currentStyle,j=8>p?" ":",",h="rect("+i.clipTop+j+i.clipRight+j+i.clipBottom+j+i.clipLeft+")",b=this.format(b).split(",").join(j)):(h=this.format(ba(a,this.p,e,!1,this.dflt)),b=this.format(b)),this.parseComplex(a.style,h,b,f,g)}}),Aa("textShadow",{defaultValue:"0px 0px 0px #999",color:!0,multi:!0}),Aa("autoRound,strictUnits",{parser:function(a,b,c,d,e){return e}}),Aa("border",{defaultValue:"0px solid #000",parser:function(a,b,c,d,f,g){var h=ba(a,"borderTopWidth",e,!1,"0px"),i=this.format(b).split(" "),j=i[0].replace(x,"");return"px"!==j&&(h=parseFloat(h)/ca(a,"borderTopWidth",1,j)+j),this.parseComplex(a.style,this.format(h+" "+ba(a,"borderTopStyle",e,!1,"solid")+" "+ba(a,"borderTopColor",e,!1,"#000")),i.join(" "),f,g)},color:!0,formatter:function(a){var b=a.split(" ");return b[0]+" "+(b[1]||"solid")+" "+(a.match(ra)||["#000"])[0]}}),Aa("borderWidth",{parser:ta("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}),Aa("float,cssFloat,styleFloat",{parser:function(a,b,c,d,e,f){var g=a.style,h="cssFloat"in g?"cssFloat":"styleFloat";return new va(g,h,0,0,e,-1,c,!1,0,g[h],b)}});var Wa=function(a){var b,c=this.t,d=c.filter||ba(this.data,"filter")||"",e=this.s+this.c*a|0;100===e&&(-1===d.indexOf("atrix(")&&-1===d.indexOf("radient(")&&-1===d.indexOf("oader(")?(c.removeAttribute("filter"),b=!ba(this.data,"filter")):(c.filter=d.replace(A,""),b=!0)),b||(this.xn1&&(c.filter=d=d||"alpha(opacity="+e+")"),-1===d.indexOf("pacity")?0===e&&this.xn1||(c.filter=d+" alpha(opacity="+e+")"):c.filter=d.replace(y,"opacity="+e))};Aa("opacity,alpha,autoAlpha",{defaultValue:"1",parser:function(a,b,c,d,f,g){var h=parseFloat(ba(a,"opacity",e,!1,"1")),i=a.style,j="autoAlpha"===c;return"string"==typeof b&&"="===b.charAt(1)&&(b=("-"===b.charAt(0)?-1:1)*parseFloat(b.substr(2))+h),j&&1===h&&"hidden"===ba(a,"visibility",e)&&0!==b&&(h=0),V?f=new va(i,"opacity",h,b-h,f):(f=new va(i,"opacity",100*h,100*(b-h),f),f.xn1=j?1:0,i.zoom=1,f.type=2,f.b="alpha(opacity="+f.s+")",f.e="alpha(opacity="+(f.s+f.c)+")",f.data=a,f.plugin=g,f.setRatio=Wa),j&&(f=new va(i,"visibility",0,0,f,-1,null,!1,0,0!==h?"inherit":"hidden",0===b?"hidden":"inherit"),f.xs0="inherit",d._overwriteProps.push(f.n),d._overwriteProps.push(c)),f}});var Xa=function(a,b){b&&(a.removeProperty?(("ms"===b.substr(0,2)||"webkit"===b.substr(0,6))&&(b="-"+b),a.removeProperty(b.replace(C,"-$1").toLowerCase())):a.removeAttribute(b))},Ya=function(a){if(this.t._gsClassPT=this,1===a||0===a){this.t.setAttribute("class",0===a?this.b:this.e);for(var b=this.data,c=this.t.style;b;)b.v?c[b.p]=b.v:Xa(c,b.p),b=b._next;1===a&&this.t._gsClassPT===this&&(this.t._gsClassPT=null)}else this.t.getAttribute("class")!==this.e&&this.t.setAttribute("class",this.e)};Aa("className",{parser:function(a,b,d,f,g,h,i){var j,k,l,m,n,o=a.getAttribute("class")||"",p=a.style.cssText;if(g=f._classNamePT=new va(a,d,0,0,g,2),g.setRatio=Ya,g.pr=-11,c=!0,g.b=o,k=ea(a,e),l=a._gsClassPT){for(m={},n=l.data;n;)m[n.p]=1,n=n._next;l.setRatio(1)}return a._gsClassPT=g,g.e="="!==b.charAt(1)?b:o.replace(new RegExp("(?:\\s|^)"+b.substr(2)+"(?![\\w-])"),"")+("+"===b.charAt(0)?" "+b.substr(2):""),a.setAttribute("class",g.e),j=fa(a,k,ea(a),i,m),a.setAttribute("class",o),g.data=j.firstMPT,a.style.cssText!==p&&(a.style.cssText=p),g=g.xfirst=f.parse(a,j.difs,g,h)}});var Za=function(a){if((1===a||0===a)&&this.data._totalTime===this.data._totalDuration&&"isFromStart"!==this.data.data){var b,c,d,e,f,g=this.t.style,h=i.transform.parse;if("all"===this.e)g.cssText="",e=!0;else for(b=this.e.split(" ").join("").split(","),d=b.length;--d>-1;)c=b[d],i[c]&&(i[c].parse===h?e=!0:c="transformOrigin"===c?Ga:i[c].p),Xa(g,c);e&&(Xa(g,Ea),f=this.t._gsTransform,f&&(f.svg&&(this.t.removeAttribute("data-svg-origin"),this.t.removeAttribute("transform")),delete this.t._gsTransform))}};for(Aa("clearProps",{parser:function(a,b,d,e,f){return f=new va(a,d,0,0,f,2),f.setRatio=Za,f.e=b,f.pr=-10,f.data=e._tween,c=!0,f}}),j="bezier,throwProps,physicsProps,physics2D".split(","),ya=j.length;ya--;)Ba(j[ya]);j=g.prototype,j._firstPT=j._lastParsedTransform=j._transform=null,j._onInitTween=function(a,b,h,j){if(!a.nodeType)return!1;this._target=q=a,this._tween=h,this._vars=b,r=j,k=b.autoRound,c=!1,d=b.suffixMap||g.suffixMap,e=aa(a,""),f=this._overwriteProps;var n,p,s,t,u,v,w,x,y,A=a.style;if(l&&""===A.zIndex&&(n=ba(a,"zIndex",e),("auto"===n||""===n)&&this._addLazySet(A,"zIndex",0)),"string"==typeof b&&(t=A.cssText,n=ea(a,e),A.cssText=t+";"+b,n=fa(a,n,ea(a)).difs,!V&&z.test(b)&&(n.opacity=parseFloat(RegExp.$1)),b=n,A.cssText=t),b.className?this._firstPT=p=i.className.parse(a,b.className,"className",this,null,null,b):this._firstPT=p=this.parse(a,b,null),this._transformType){for(y=3===this._transformType,Ea?m&&(l=!0,""===A.zIndex&&(w=ba(a,"zIndex",e),("auto"===w||""===w)&&this._addLazySet(A,"zIndex",0)),o&&this._addLazySet(A,"WebkitBackfaceVisibility",this._vars.WebkitBackfaceVisibility||(y?"visible":"hidden"))):A.zoom=1,s=p;s&&s._next;)s=s._next;x=new va(a,"transform",0,0,null,2),this._linkCSSP(x,null,s),x.setRatio=Ea?Va:Ua,x.data=this._transform||Ta(a,e,!0),x.tween=h,x.pr=-1,f.pop()}if(c){for(;p;){for(v=p._next,s=t;s&&s.pr>p.pr;)s=s._next;(p._prev=s?s._prev:u)?p._prev._next=p:t=p,(p._next=s)?s._prev=p:u=p,p=v}this._firstPT=t}return!0},j.parse=function(a,b,c,f){var g,h,j,l,m,n,o,p,s,t,u=a.style;for(g in b){if(n=b[g],h=i[g],"function"!=typeof n||h&&h.allowFunc||(n=n(r,q)),h)c=h.parse(a,n,g,this,c,f,b);else{if("--"===g.substr(0,2)){this._tween._propLookup[g]=this._addTween.call(this._tween,a.style,"setProperty",aa(a).getPropertyValue(g)+"",n+"",g,!1,g);continue}m=ba(a,g,e)+"",s="string"==typeof n,"color"===g||"fill"===g||"stroke"===g||-1!==g.indexOf("Color")||s&&B.test(n)?(s||(n=pa(n),n=(n.length>3?"rgba(":"rgb(")+n.join(",")+")"),c=xa(u,g,m,n,!0,"transparent",c,0,f)):s&&K.test(n)?c=xa(u,g,m,n,!0,null,c,0,f):(j=parseFloat(m),o=j||0===j?m.substr((j+"").length):"",(""===m||"auto"===m)&&("width"===g||"height"===g?(j=ia(a,g,e),o="px"):"left"===g||"top"===g?(j=da(a,g,e),o="px"):(j="opacity"!==g?0:1,o="")),t=s&&"="===n.charAt(1),t?(l=parseInt(n.charAt(0)+"1",10),n=n.substr(2),l*=parseFloat(n),p=n.replace(x,"")):(l=parseFloat(n),p=s?n.replace(x,""):""),""===p&&(p=g in d?d[g]:o),n=l||0===l?(t?l+j:l)+p:b[g],o!==p&&(""!==p||"lineHeight"===g)&&(l||0===l)&&j&&(j=ca(a,g,j,o),"%"===p?(j/=ca(a,g,100,"%")/100,b.strictUnits!==!0&&(m=j+"%")):"em"===p||"rem"===p||"vw"===p||"vh"===p?j/=ca(a,g,1,p):"px"!==p&&(l=ca(a,g,l,p),p="px"),t&&(l||0===l)&&(n=l+j+p)),t&&(l+=j),!j&&0!==j||!l&&0!==l?void 0!==u[g]&&(n||n+""!="NaN"&&null!=n)?(c=new va(u,g,l||j||0,0,c,-1,g,!1,0,m,n),c.xs0="none"!==n||"display"!==g&&-1===g.indexOf("Style")?n:m):X("invalid "+g+" tween value: "+b[g]):(c=new va(u,g,j,l-j,c,0,g,k!==!1&&("px"===p||"zIndex"===g),0,m,n),c.xs0=p))}f&&c&&!c.plugin&&(c.plugin=f)}return c},j.setRatio=function(a){var b,c,d,e=this._firstPT,f=1e-6;if(1!==a||this._tween._time!==this._tween._duration&&0!==this._tween._time)if(a||this._tween._time!==this._tween._duration&&0!==this._tween._time||this._tween._rawPrevTime===-1e-6)for(;e;){if(b=e.c*a+e.s,e.r?b=e.r(b):f>b&&b>-f&&(b=0),e.type)if(1===e.type)if(d=e.l,2===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2;else if(3===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3;else if(4===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3+e.xn3+e.xs4;else if(5===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3+e.xn3+e.xs4+e.xn4+e.xs5;else{for(c=e.xs0+b+e.xs1,d=1;d<e.l;d++)c+=e["xn"+d]+e["xs"+(d+1)];e.t[e.p]=c}else-1===e.type?e.t[e.p]=e.xs0:e.setRatio&&e.setRatio(a);else e.t[e.p]=b+e.xs0;e=e._next}else for(;e;)2!==e.type?e.t[e.p]=e.b:e.setRatio(a),e=e._next;else for(;e;){if(2!==e.type)if(e.r&&-1!==e.type)if(b=e.r(e.s+e.c),e.type){if(1===e.type){for(d=e.l,c=e.xs0+b+e.xs1,d=1;d<e.l;d++)c+=e["xn"+d]+e["xs"+(d+1)];e.t[e.p]=c}}else e.t[e.p]=b+e.xs0;else e.t[e.p]=e.e;else e.setRatio(a);e=e._next}},j._enableTransforms=function(a){this._transform=this._transform||Ta(this._target,e,!0),this._transformType=this._transform.svg&&Ca||!a&&3!==this._transformType?2:3};var $a=function(a){this.t[this.p]=this.e,this.data._linkCSSP(this,this._next,null,!0)};j._addLazySet=function(a,b,c){var d=this._firstPT=new va(a,b,0,0,this._firstPT,2);d.e=c,d.setRatio=$a,d.data=this},j._linkCSSP=function(a,b,c,d){return a&&(b&&(b._prev=a),a._next&&(a._next._prev=a._prev),a._prev?a._prev._next=a._next:this._firstPT===a&&(this._firstPT=a._next,d=!0),c?c._next=a:d||null!==this._firstPT||(this._firstPT=a),a._next=b,a._prev=c),a},j._mod=function(a){for(var b=this._firstPT;b;)"function"==typeof a[b.p]&&(b.r=a[b.p]),b=b._next},j._kill=function(b){var c,d,e,f=b;if(b.autoAlpha||b.alpha){f={};for(d in b)f[d]=b[d];f.opacity=1,f.autoAlpha&&(f.visibility=1)}for(b.className&&(c=this._classNamePT)&&(e=c.xfirst,e&&e._prev?this._linkCSSP(e._prev,c._next,e._prev._prev):e===this._firstPT&&(this._firstPT=c._next),c._next&&this._linkCSSP(c._next,c._next._next,e._prev),this._classNamePT=null),c=this._firstPT;c;)c.plugin&&c.plugin!==d&&c.plugin._kill&&(c.plugin._kill(b),d=c.plugin),c=c._next;return a.prototype._kill.call(this,f)};var _a=function(a,b,c){var d,e,f,g;if(a.slice)for(e=a.length;--e>-1;)_a(a[e],b,c);else for(d=a.childNodes,e=d.length;--e>-1;)f=d[e],g=f.type,f.style&&(b.push(ea(f)),c&&c.push(f)),1!==g&&9!==g&&11!==g||!f.childNodes.length||_a(f,b,c)};return g.cascadeTo=function(a,c,d){var e,f,g,h,i=b.to(a,c,d),j=[i],k=[],l=[],m=[],n=b._internals.reservedProps;for(a=i._targets||i.target,_a(a,k,m),i.render(c,!0,!0),_a(a,l),i.render(0,!0,!0),i._enabled(!0),e=m.length;--e>-1;)if(f=fa(m[e],k[e],l[e]),f.firstMPT){f=f.difs;for(g in d)n[g]&&(f[g]=d[g]);h={};for(g in f)h[g]=k[e][g];j.push(b.fromTo(m[e],c,h,f))}return j},a.activate([g]),g},!0),function(){var a=_gsScope._gsDefine.plugin({propName:"roundProps",version:"1.7.0",priority:-1,API:2,init:function(a,b,c){return this._tween=c,!0}}),b=function(a){var b=1>a?Math.pow(10,(a+"").length-2):1;return function(c){return(Math.round(c/a)*a*b|0)/b}},c=function(a,b){for(;a;)a.f||a.blob||(a.m=b||Math.round),a=a._next},d=a.prototype;d._onInitAllProps=function(){var a,d,e,f,g=this._tween,h=g.vars.roundProps,i={},j=g._propLookup.roundProps;if("object"!=typeof h||h.push)for("string"==typeof h&&(h=h.split(",")),e=h.length;--e>-1;)i[h[e]]=Math.round;else for(f in h)i[f]=b(h[f]);for(f in i)for(a=g._firstPT;a;)d=a._next,a.pg?a.t._mod(i):a.n===f&&(2===a.f&&a.t?c(a.t._firstPT,i[f]):(this._add(a.t,f,a.s,a.c,i[f]),d&&(d._prev=a._prev),a._prev?a._prev._next=d:g._firstPT===a&&(g._firstPT=d),a._next=a._prev=null,g._propLookup[f]=j)),a=d;return!1},d._add=function(a,b,c,d,e){this._addTween(a,b,c,c+d,b,e||Math.round),this._overwriteProps.push(b)}}(),function(){_gsScope._gsDefine.plugin({propName:"attr",API:2,version:"0.6.1",init:function(a,b,c,d){var e,f;if("function"!=typeof a.setAttribute)return!1;for(e in b)f=b[e],"function"==typeof f&&(f=f(d,a)),this._addTween(a,"setAttribute",a.getAttribute(e)+"",f+"",e,!1,e),this._overwriteProps.push(e);return!0}})}(),_gsScope._gsDefine.plugin({propName:"directionalRotation",version:"0.3.1",API:2,init:function(a,b,c,d){"object"!=typeof b&&(b={rotation:b}),this.finals={};var e,f,g,h,i,j,k=b.useRadians===!0?2*Math.PI:360,l=1e-6;for(e in b)"useRadians"!==e&&(h=b[e],"function"==typeof h&&(h=h(d,a)),j=(h+"").split("_"),f=j[0],g=parseFloat("function"!=typeof a[e]?a[e]:a[e.indexOf("set")||"function"!=typeof a["get"+e.substr(3)]?e:"get"+e.substr(3)]()),h=this.finals[e]="string"==typeof f&&"="===f.charAt(1)?g+parseInt(f.charAt(0)+"1",10)*Number(f.substr(2)):Number(f)||0,i=h-g,j.length&&(f=j.join("_"),-1!==f.indexOf("short")&&(i%=k,i!==i%(k/2)&&(i=0>i?i+k:i-k)),-1!==f.indexOf("_cw")&&0>i?i=(i+9999999999*k)%k-(i/k|0)*k:-1!==f.indexOf("ccw")&&i>0&&(i=(i-9999999999*k)%k-(i/k|0)*k)),(i>l||-l>i)&&(this._addTween(a,e,g,g+i,e),this._overwriteProps.push(e)));return!0},set:function(a){var b;if(1!==a)this._super.setRatio.call(this,a);else for(b=this._firstPT;b;)b.f?b.t[b.p](this.finals[b.p]):b.t[b.p]=this.finals[b.p],b=b._next}})._autoCSS=!0,_gsScope._gsDefine("easing.Back",["easing.Ease"],function(a){var b,c,d,e,f=_gsScope.GreenSockGlobals||_gsScope,g=f.com.greensock,h=2*Math.PI,i=Math.PI/2,j=g._class,k=function(b,c){var d=j("easing."+b,function(){},!0),e=d.prototype=new a;return e.constructor=d,e.getRatio=c,d},l=a.register||function(){},m=function(a,b,c,d,e){var f=j("easing."+a,{easeOut:new b,easeIn:new c,easeInOut:new d},!0);return l(f,a),f},n=function(a,b,c){this.t=a,this.v=b,c&&(this.next=c,c.prev=this,this.c=c.v-b,this.gap=c.t-a)},o=function(b,c){var d=j("easing."+b,function(a){this._p1=a||0===a?a:1.70158,this._p2=1.525*this._p1},!0),e=d.prototype=new a;return e.constructor=d,e.getRatio=c,e.config=function(a){return new d(a)},d},p=m("Back",o("BackOut",function(a){return(a-=1)*a*((this._p1+1)*a+this._p1)+1}),o("BackIn",function(a){return a*a*((this._p1+1)*a-this._p1)}),o("BackInOut",function(a){return(a*=2)<1?.5*a*a*((this._p2+1)*a-this._p2):.5*((a-=2)*a*((this._p2+1)*a+this._p2)+2)})),q=j("easing.SlowMo",function(a,b,c){b=b||0===b?b:.7,null==a?a=.7:a>1&&(a=1),this._p=1!==a?b:0,this._p1=(1-a)/2,this._p2=a,this._p3=this._p1+this._p2,this._calcEnd=c===!0},!0),r=q.prototype=new a;return r.constructor=q,r.getRatio=function(a){var b=a+(.5-a)*this._p;return a<this._p1?this._calcEnd?1-(a=1-a/this._p1)*a:b-(a=1-a/this._p1)*a*a*a*b:a>this._p3?this._calcEnd?1===a?0:1-(a=(a-this._p3)/this._p1)*a:b+(a-b)*(a=(a-this._p3)/this._p1)*a*a*a:this._calcEnd?1:b},q.ease=new q(.7,.7),r.config=q.config=function(a,b,c){return new q(a,b,c)},b=j("easing.SteppedEase",function(a,b){a=a||1,this._p1=1/a,this._p2=a+(b?0:1),this._p3=b?1:0},!0),r=b.prototype=new a,r.constructor=b,r.getRatio=function(a){return 0>a?a=0:a>=1&&(a=.999999999),((this._p2*a|0)+this._p3)*this._p1},r.config=b.config=function(a,c){return new b(a,c)},c=j("easing.ExpoScaleEase",function(a,b,c){this._p1=Math.log(b/a),this._p2=b-a,this._p3=a,this._ease=c},!0),r=c.prototype=new a,r.constructor=c,r.getRatio=function(a){return this._ease&&(a=this._ease.getRatio(a)),(this._p3*Math.exp(this._p1*a)-this._p3)/this._p2},r.config=c.config=function(a,b,d){return new c(a,b,d)},d=j("easing.RoughEase",function(b){b=b||{};for(var c,d,e,f,g,h,i=b.taper||"none",j=[],k=0,l=0|(b.points||20),m=l,o=b.randomize!==!1,p=b.clamp===!0,q=b.template instanceof a?b.template:null,r="number"==typeof b.strength?.4*b.strength:.4;--m>-1;)c=o?Math.random():1/l*m,d=q?q.getRatio(c):c,"none"===i?e=r:"out"===i?(f=1-c,e=f*f*r):"in"===i?e=c*c*r:.5>c?(f=2*c,e=f*f*.5*r):(f=2*(1-c),e=f*f*.5*r),o?d+=Math.random()*e-.5*e:m%2?d+=.5*e:d-=.5*e,p&&(d>1?d=1:0>d&&(d=0)),j[k++]={x:c,y:d};for(j.sort(function(a,b){return a.x-b.x}),h=new n(1,1,null),m=l;--m>-1;)g=j[m],h=new n(g.x,g.y,h);this._prev=new n(0,0,0!==h.t?h:h.next)},!0),r=d.prototype=new a,r.constructor=d,r.getRatio=function(a){var b=this._prev;if(a>b.t){for(;b.next&&a>=b.t;)b=b.next;b=b.prev}else for(;b.prev&&a<=b.t;)b=b.prev;return this._prev=b,b.v+(a-b.t)/b.gap*b.c},r.config=function(a){return new d(a)},d.ease=new d,m("Bounce",k("BounceOut",function(a){return 1/2.75>a?7.5625*a*a:2/2.75>a?7.5625*(a-=1.5/2.75)*a+.75:2.5/2.75>a?7.5625*(a-=2.25/2.75)*a+.9375:7.5625*(a-=2.625/2.75)*a+.984375}),k("BounceIn",function(a){return(a=1-a)<1/2.75?1-7.5625*a*a:2/2.75>a?1-(7.5625*(a-=1.5/2.75)*a+.75):2.5/2.75>a?1-(7.5625*(a-=2.25/2.75)*a+.9375):1-(7.5625*(a-=2.625/2.75)*a+.984375)}),k("BounceInOut",function(a){var b=.5>a;return a=b?1-2*a:2*a-1,a=1/2.75>a?7.5625*a*a:2/2.75>a?7.5625*(a-=1.5/2.75)*a+.75:2.5/2.75>a?7.5625*(a-=2.25/2.75)*a+.9375:7.5625*(a-=2.625/2.75)*a+.984375,b?.5*(1-a):.5*a+.5})),m("Circ",k("CircOut",function(a){return Math.sqrt(1-(a-=1)*a)}),k("CircIn",function(a){return-(Math.sqrt(1-a*a)-1)}),k("CircInOut",function(a){return(a*=2)<1?-.5*(Math.sqrt(1-a*a)-1):.5*(Math.sqrt(1-(a-=2)*a)+1)})),e=function(b,c,d){var e=j("easing."+b,function(a,b){this._p1=a>=1?a:1,this._p2=(b||d)/(1>a?a:1),this._p3=this._p2/h*(Math.asin(1/this._p1)||0),this._p2=h/this._p2},!0),f=e.prototype=new a;return f.constructor=e,f.getRatio=c,f.config=function(a,b){return new e(a,b)},e},m("Elastic",e("ElasticOut",function(a){return this._p1*Math.pow(2,-10*a)*Math.sin((a-this._p3)*this._p2)+1},.3),e("ElasticIn",function(a){return-(this._p1*Math.pow(2,10*(a-=1))*Math.sin((a-this._p3)*this._p2))},.3),e("ElasticInOut",function(a){return(a*=2)<1?-.5*(this._p1*Math.pow(2,10*(a-=1))*Math.sin((a-this._p3)*this._p2)):this._p1*Math.pow(2,-10*(a-=1))*Math.sin((a-this._p3)*this._p2)*.5+1},.45)),m("Expo",k("ExpoOut",function(a){return 1-Math.pow(2,-10*a)}),k("ExpoIn",function(a){return Math.pow(2,10*(a-1))-.001}),k("ExpoInOut",function(a){return(a*=2)<1?.5*Math.pow(2,10*(a-1)):.5*(2-Math.pow(2,-10*(a-1)))})),m("Sine",k("SineOut",function(a){return Math.sin(a*i)}),k("SineIn",function(a){return-Math.cos(a*i)+1}),k("SineInOut",function(a){return-.5*(Math.cos(Math.PI*a)-1)})),j("easing.EaseLookup",{find:function(b){return a.map[b]}},!0),l(f.SlowMo,"SlowMo","ease,"),l(d,"RoughEase","ease,"),l(b,"SteppedEase","ease,"),p},!0)}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()(),function(a,b){"use strict";var c={},d=a.document,e=a.GreenSockGlobals=a.GreenSockGlobals||a,f=e[b];if(f)return"undefined"!=typeof module&&module.exports&&(module.exports=f),f;var g,h,i,j,k,l=function(a){var b,c=a.split("."),d=e;for(b=0;b<c.length;b++)d[c[b]]=d=d[c[b]]||{};return d},m=l("com.greensock"),n=1e-8,o=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},p=function(){},q=function(){var a=Object.prototype.toString,b=a.call([]);return function(c){return null!=c&&(c instanceof Array||"object"==typeof c&&!!c.push&&a.call(c)===b)}}(),r={},s=function(d,f,g,h){this.sc=r[d]?r[d].sc:[],r[d]=this,this.gsClass=null,this.func=g;var i=[];this.check=function(j){for(var k,m,n,o,p=f.length,q=p;--p>-1;)(k=r[f[p]]||new s(f[p],[])).gsClass?(i[p]=k.gsClass,q--):j&&k.sc.push(this);if(0===q&&g){if(m=("com.greensock."+d).split("."),n=m.pop(),o=l(m.join("."))[n]=this.gsClass=g.apply(g,i),h)if(e[n]=c[n]=o,"undefined"!=typeof module&&module.exports)if(d===b){module.exports=c[b]=o;for(p in c)o[p]=c[p]}else c[b]&&(c[b][n]=o);else"function"==typeof define&&define.amd&&define((a.GreenSockAMDPath?a.GreenSockAMDPath+"/":"")+d.split(".").pop(),[],function(){return o});for(p=0;p<this.sc.length;p++)this.sc[p].check()}},this.check(!0)},t=a._gsDefine=function(a,b,c,d){return new s(a,b,c,d)},u=m._class=function(a,b,c){return b=b||function(){},t(a,[],function(){return b},c),b};t.globals=e;var v=[0,0,1,1],w=u("easing.Ease",function(a,b,c,d){this._func=a,this._type=c||0,this._power=d||0,this._params=b?v.concat(b):v},!0),x=w.map={},y=w.register=function(a,b,c,d){for(var e,f,g,h,i=b.split(","),j=i.length,k=(c||"easeIn,easeOut,easeInOut").split(",");--j>-1;)for(f=i[j],e=d?u("easing."+f,null,!0):m.easing[f]||{},g=k.length;--g>-1;)h=k[g],x[f+"."+h]=x[h+f]=e[h]=a.getRatio?a:a[h]||new a};for(i=w.prototype,i._calcEnd=!1,i.getRatio=function(a){if(this._func)return this._params[0]=a,this._func.apply(null,this._params);var b=this._type,c=this._power,d=1===b?1-a:2===b?a:.5>a?2*a:2*(1-a);return 1===c?d*=d:2===c?d*=d*d:3===c?d*=d*d*d:4===c&&(d*=d*d*d*d),1===b?1-d:2===b?d:.5>a?d/2:1-d/2},g=["Linear","Quad","Cubic","Quart","Quint,Strong"],h=g.length;--h>-1;)i=g[h]+",Power"+h,y(new w(null,null,1,h),i,"easeOut",!0),y(new w(null,null,2,h),i,"easeIn"+(0===h?",easeNone":"")),y(new w(null,null,3,h),i,"easeInOut");x.linear=m.easing.Linear.easeIn,x.swing=m.easing.Quad.easeInOut;var z=u("events.EventDispatcher",function(a){this._listeners={},this._eventTarget=a||this});i=z.prototype,i.addEventListener=function(a,b,c,d,e){e=e||0;var f,g,h=this._listeners[a],i=0;for(this!==j||k||j.wake(),null==h&&(this._listeners[a]=h=[]),g=h.length;--g>-1;)f=h[g],f.c===b&&f.s===c?h.splice(g,1):0===i&&f.pr<e&&(i=g+1);h.splice(i,0,{c:b,s:c,up:d,pr:e})},i.removeEventListener=function(a,b){var c,d=this._listeners[a];if(d)for(c=d.length;--c>-1;)if(d[c].c===b)return void d.splice(c,1)},i.dispatchEvent=function(a){var b,c,d,e=this._listeners[a];if(e)for(b=e.length,b>1&&(e=e.slice(0)),c=this._eventTarget;--b>-1;)d=e[b],d&&(d.up?d.c.call(d.s||c,{type:a,target:c}):d.c.call(d.s||c))};var A=a.requestAnimationFrame,B=a.cancelAnimationFrame,C=Date.now||function(){return(new Date).getTime()},D=C();for(g=["ms","moz","webkit","o"],h=g.length;--h>-1&&!A;)A=a[g[h]+"RequestAnimationFrame"],B=a[g[h]+"CancelAnimationFrame"]||a[g[h]+"CancelRequestAnimationFrame"];u("Ticker",function(a,b){var c,e,f,g,h,i=this,l=C(),m=b!==!1&&A?"auto":!1,o=500,q=33,r="tick",s=function(a){var b,d,j=C()-D;j>o&&(l+=j-q),D+=j,i.time=(D-l)/1e3,b=i.time-h,(!c||b>0||a===!0)&&(i.frame++,h+=b+(b>=g?.004:g-b),d=!0),a!==!0&&(f=e(s)),d&&i.dispatchEvent(r)};z.call(i),i.time=i.frame=0,i.tick=function(){s(!0)},i.lagSmoothing=function(a,b){return arguments.length?(o=a||1/n,void(q=Math.min(b,o,0))):1/n>o},i.sleep=function(){null!=f&&(m&&B?B(f):clearTimeout(f),e=p,f=null,i===j&&(k=!1))},i.wake=function(a){null!==f?i.sleep():a?l+=-D+(D=C()):i.frame>10&&(D=C()-o+5),e=0===c?p:m&&A?A:function(a){return setTimeout(a,1e3*(h-i.time)+1|0)},i===j&&(k=!0),s(2)},i.fps=function(a){return arguments.length?(c=a,g=1/(c||60),h=this.time+g,void i.wake()):c},i.useRAF=function(a){return arguments.length?(i.sleep(),m=a,void i.fps(c)):m},i.fps(a),setTimeout(function(){"auto"===m&&i.frame<5&&"hidden"!==(d||{}).visibilityState&&i.useRAF(!1)},1500)}),i=m.Ticker.prototype=new m.events.EventDispatcher,i.constructor=m.Ticker;var E=u("core.Animation",function(a,b){if(this.vars=b=b||{},this._duration=this._totalDuration=a||0,this._delay=Number(b.delay)||0,this._timeScale=1,this._active=!!b.immediateRender,this.data=b.data,this._reversed=!!b.reversed,Z){k||j.wake();var c=this.vars.useFrames?Y:Z;c.add(this,c._time),this.vars.paused&&this.paused(!0)}});j=E.ticker=new m.Ticker,i=E.prototype,i._dirty=i._gc=i._initted=i._paused=!1,i._totalTime=i._time=0,i._rawPrevTime=-1,i._next=i._last=i._onUpdate=i._timeline=i.timeline=null,i._paused=!1;var F=function(){k&&C()-D>2e3&&("hidden"!==(d||{}).visibilityState||!j.lagSmoothing())&&j.wake();var a=setTimeout(F,2e3);a.unref&&a.unref()};F(),i.play=function(a,b){return null!=a&&this.seek(a,b),this.reversed(!1).paused(!1)},i.pause=function(a,b){return null!=a&&this.seek(a,b),this.paused(!0)},i.resume=function(a,b){return null!=a&&this.seek(a,b),this.paused(!1)},i.seek=function(a,b){return this.totalTime(Number(a),b!==!1)},i.restart=function(a,b){return this.reversed(!1).paused(!1).totalTime(a?-this._delay:0,b!==!1,!0)},i.reverse=function(a,b){return null!=a&&this.seek(a||this.totalDuration(),b),this.reversed(!0).paused(!1)},i.render=function(a,b,c){},i.invalidate=function(){return this._time=this._totalTime=0,this._initted=this._gc=!1,this._rawPrevTime=-1,(this._gc||!this.timeline)&&this._enabled(!0),this},i.isActive=function(){var a,b=this._timeline,c=this._startTime;return!b||!this._gc&&!this._paused&&b.isActive()&&(a=b.rawTime(!0))>=c&&a<c+this.totalDuration()/this._timeScale-n},i._enabled=function(a,b){return k||j.wake(),this._gc=!a,this._active=this.isActive(),b!==!0&&(a&&!this.timeline?this._timeline.add(this,this._startTime-this._delay):!a&&this.timeline&&this._timeline._remove(this,!0)),!1},i._kill=function(a,b){return this._enabled(!1,!1)},i.kill=function(a,b){return this._kill(a,b),this},i._uncache=function(a){for(var b=a?this:this.timeline;b;)b._dirty=!0,b=b.timeline;return this},i._swapSelfInParams=function(a){for(var b=a.length,c=a.concat();--b>-1;)"{self}"===a[b]&&(c[b]=this);return c},i._callback=function(a){var b=this.vars,c=b[a],d=b[a+"Params"],e=b[a+"Scope"]||b.callbackScope||this,f=d?d.length:0;switch(f){case 0:c.call(e);break;case 1:c.call(e,d[0]);break;case 2:c.call(e,d[0],d[1]);break;default:c.apply(e,d)}},i.eventCallback=function(a,b,c,d){if("on"===(a||"").substr(0,2)){var e=this.vars;if(1===arguments.length)return e[a];null==b?delete e[a]:(e[a]=b,e[a+"Params"]=q(c)&&-1!==c.join("").indexOf("{self}")?this._swapSelfInParams(c):c,e[a+"Scope"]=d),"onUpdate"===a&&(this._onUpdate=b)}return this},i.delay=function(a){return arguments.length?(this._timeline.smoothChildTiming&&this.startTime(this._startTime+a-this._delay),this._delay=a,this):this._delay},i.duration=function(a){return arguments.length?(this._duration=this._totalDuration=a,this._uncache(!0),this._timeline.smoothChildTiming&&this._time>0&&this._time<this._duration&&0!==a&&this.totalTime(this._totalTime*(a/this._duration),!0),this):(this._dirty=!1,this._duration)},i.totalDuration=function(a){return this._dirty=!1,arguments.length?this.duration(a):this._totalDuration},i.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),this.totalTime(a>this._duration?this._duration:a,b)):this._time},i.totalTime=function(a,b,c){if(k||j.wake(),!arguments.length)return this._totalTime;if(this._timeline){if(0>a&&!c&&(a+=this.totalDuration()),this._timeline.smoothChildTiming){this._dirty&&this.totalDuration();var d=this._totalDuration,e=this._timeline;if(a>d&&!c&&(a=d),this._startTime=(this._paused?this._pauseTime:e._time)-(this._reversed?d-a:a)/this._timeScale,e._dirty||this._uncache(!1),e._timeline)for(;e._timeline;)e._timeline._time!==(e._startTime+e._totalTime)/e._timeScale&&e.totalTime(e._totalTime,!0),
	e=e._timeline}this._gc&&this._enabled(!0,!1),(this._totalTime!==a||0===this._duration)&&(K.length&&_(),this.render(a,b,!1),K.length&&_())}return this},i.progress=i.totalProgress=function(a,b){var c=this.duration();return arguments.length?this.totalTime(c*a,b):c?this._time/c:this.ratio},i.startTime=function(a){return arguments.length?(a!==this._startTime&&(this._startTime=a,this.timeline&&this.timeline._sortChildren&&this.timeline.add(this,a-this._delay)),this):this._startTime},i.endTime=function(a){return this._startTime+(0!=a?this.totalDuration():this.duration())/this._timeScale},i.timeScale=function(a){if(!arguments.length)return this._timeScale;var b,c;for(a=a||n,this._timeline&&this._timeline.smoothChildTiming&&(b=this._pauseTime,c=b||0===b?b:this._timeline.totalTime(),this._startTime=c-(c-this._startTime)*this._timeScale/a),this._timeScale=a,c=this.timeline;c&&c.timeline;)c._dirty=!0,c.totalDuration(),c=c.timeline;return this},i.reversed=function(a){return arguments.length?(a!=this._reversed&&(this._reversed=a,this.totalTime(this._timeline&&!this._timeline.smoothChildTiming?this.totalDuration()-this._totalTime:this._totalTime,!0)),this):this._reversed},i.paused=function(a){if(!arguments.length)return this._paused;var b,c,d=this._timeline;return a!=this._paused&&d&&(k||a||j.wake(),b=d.rawTime(),c=b-this._pauseTime,!a&&d.smoothChildTiming&&(this._startTime+=c,this._uncache(!1)),this._pauseTime=a?b:null,this._paused=a,this._active=this.isActive(),!a&&0!==c&&this._initted&&this.duration()&&(b=d.smoothChildTiming?this._totalTime:(b-this._startTime)/this._timeScale,this.render(b,b===this._totalTime,!0))),this._gc&&!a&&this._enabled(!0,!1),this};var G=u("core.SimpleTimeline",function(a){E.call(this,0,a),this.autoRemoveChildren=this.smoothChildTiming=!0});i=G.prototype=new E,i.constructor=G,i.kill()._gc=!1,i._first=i._last=i._recent=null,i._sortChildren=!1,i.add=i.insert=function(a,b,c,d){var e,f;if(a._startTime=Number(b||0)+a._delay,a._paused&&this!==a._timeline&&(a._pauseTime=this.rawTime()-(a._timeline.rawTime()-a._pauseTime)),a.timeline&&a.timeline._remove(a,!0),a.timeline=a._timeline=this,a._gc&&a._enabled(!0,!0),e=this._last,this._sortChildren)for(f=a._startTime;e&&e._startTime>f;)e=e._prev;return e?(a._next=e._next,e._next=a):(a._next=this._first,this._first=a),a._next?a._next._prev=a:this._last=a,a._prev=e,this._recent=a,this._timeline&&this._uncache(!0),this},i._remove=function(a,b){return a.timeline===this&&(b||a._enabled(!1,!0),a._prev?a._prev._next=a._next:this._first===a&&(this._first=a._next),a._next?a._next._prev=a._prev:this._last===a&&(this._last=a._prev),a._next=a._prev=a.timeline=null,a===this._recent&&(this._recent=this._last),this._timeline&&this._uncache(!0)),this},i.render=function(a,b,c){var d,e=this._first;for(this._totalTime=this._time=this._rawPrevTime=a;e;)d=e._next,(e._active||a>=e._startTime&&!e._paused&&!e._gc)&&(e._reversed?e.render((e._dirty?e.totalDuration():e._totalDuration)-(a-e._startTime)*e._timeScale,b,c):e.render((a-e._startTime)*e._timeScale,b,c)),e=d},i.rawTime=function(){return k||j.wake(),this._totalTime};var H=u("TweenLite",function(b,c,d){if(E.call(this,c,d),this.render=H.prototype.render,null==b)throw"Cannot tween a null target.";this.target=b="string"!=typeof b?b:H.selector(b)||b;var e,f,g,h=b.jquery||b.length&&b!==a&&b[0]&&(b[0]===a||b[0].nodeType&&b[0].style&&!b.nodeType),i=this.vars.overwrite;if(this._overwrite=i=null==i?X[H.defaultOverwrite]:"number"==typeof i?i>>0:X[i],(h||b instanceof Array||b.push&&q(b))&&"number"!=typeof b[0])for(this._targets=g=o(b),this._propLookup=[],this._siblings=[],e=0;e<g.length;e++)f=g[e],f?"string"!=typeof f?f.length&&f!==a&&f[0]&&(f[0]===a||f[0].nodeType&&f[0].style&&!f.nodeType)?(g.splice(e--,1),this._targets=g=g.concat(o(f))):(this._siblings[e]=aa(f,this,!1),1===i&&this._siblings[e].length>1&&ca(f,this,null,1,this._siblings[e])):(f=g[e--]=H.selector(f),"string"==typeof f&&g.splice(e+1,1)):g.splice(e--,1);else this._propLookup={},this._siblings=aa(b,this,!1),1===i&&this._siblings.length>1&&ca(b,this,null,1,this._siblings);(this.vars.immediateRender||0===c&&0===this._delay&&this.vars.immediateRender!==!1)&&(this._time=-n,this.render(Math.min(0,-this._delay)))},!0),I=function(b){return b&&b.length&&b!==a&&b[0]&&(b[0]===a||b[0].nodeType&&b[0].style&&!b.nodeType)},J=function(a,b){var c,d={};for(c in a)W[c]||c in b&&"transform"!==c&&"x"!==c&&"y"!==c&&"width"!==c&&"height"!==c&&"className"!==c&&"border"!==c||!(!T[c]||T[c]&&T[c]._autoCSS)||(d[c]=a[c],delete a[c]);a.css=d};i=H.prototype=new E,i.constructor=H,i.kill()._gc=!1,i.ratio=0,i._firstPT=i._targets=i._overwrittenProps=i._startAt=null,i._notifyPluginsOfEnabled=i._lazy=!1,H.version="2.1.3",H.defaultEase=i._ease=new w(null,null,1,1),H.defaultOverwrite="auto",H.ticker=j,H.autoSleep=120,H.lagSmoothing=function(a,b){j.lagSmoothing(a,b)},H.selector=a.$||a.jQuery||function(b){var c=a.$||a.jQuery;return c?(H.selector=c,c(b)):(d||(d=a.document),d?d.querySelectorAll?d.querySelectorAll(b):d.getElementById("#"===b.charAt(0)?b.substr(1):b):b)};var K=[],L={},M=/(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,N=/[\+-]=-?[\.\d]/,O=function(a){for(var b,c=this._firstPT,d=1e-6;c;)b=c.blob?1===a&&null!=this.end?this.end:a?this.join(""):this.start:c.c*a+c.s,c.m?b=c.m.call(this._tween,b,this._target||c.t,this._tween):d>b&&b>-d&&!c.blob&&(b=0),c.f?c.fp?c.t[c.p](c.fp,b):c.t[c.p](b):c.t[c.p]=b,c=c._next},P=function(a){return(1e3*a|0)/1e3+""},Q=function(a,b,c,d){var e,f,g,h,i,j,k,l=[],m=0,n="",o=0;for(l.start=a,l.end=b,a=l[0]=a+"",b=l[1]=b+"",c&&(c(l),a=l[0],b=l[1]),l.length=0,e=a.match(M)||[],f=b.match(M)||[],d&&(d._next=null,d.blob=1,l._firstPT=l._applyPT=d),i=f.length,h=0;i>h;h++)k=f[h],j=b.substr(m,b.indexOf(k,m)-m),n+=j||!h?j:",",m+=j.length,o?o=(o+1)%5:"rgba("===j.substr(-5)&&(o=1),k===e[h]||e.length<=h?n+=k:(n&&(l.push(n),n=""),g=parseFloat(e[h]),l.push(g),l._firstPT={_next:l._firstPT,t:l,p:l.length-1,s:g,c:("="===k.charAt(1)?parseInt(k.charAt(0)+"1",10)*parseFloat(k.substr(2)):parseFloat(k)-g)||0,f:0,m:o&&4>o?Math.round:P}),m+=k.length;return n+=b.substr(m),n&&l.push(n),l.setRatio=O,N.test(b)&&(l.end=null),l},R=function(a,b,c,d,e,f,g,h,i){"function"==typeof d&&(d=d(i||0,a));var j,k=typeof a[b],l="function"!==k?"":b.indexOf("set")||"function"!=typeof a["get"+b.substr(3)]?b:"get"+b.substr(3),m="get"!==c?c:l?g?a[l](g):a[l]():a[b],n="string"==typeof d&&"="===d.charAt(1),o={t:a,p:b,s:m,f:"function"===k,pg:0,n:e||b,m:f?"function"==typeof f?f:Math.round:0,pr:0,c:n?parseInt(d.charAt(0)+"1",10)*parseFloat(d.substr(2)):parseFloat(d)-m||0};return("number"!=typeof m||"number"!=typeof d&&!n)&&(g||isNaN(m)||!n&&isNaN(d)||"boolean"==typeof m||"boolean"==typeof d?(o.fp=g,j=Q(m,n?parseFloat(o.s)+o.c+(o.s+"").replace(/[0-9\-\.]/g,""):d,h||H.defaultStringFilter,o),o={t:j,p:"setRatio",s:0,c:1,f:2,pg:0,n:e||b,pr:0,m:0}):(o.s=parseFloat(m),n||(o.c=parseFloat(d)-o.s||0))),o.c?((o._next=this._firstPT)&&(o._next._prev=o),this._firstPT=o,o):void 0},S=H._internals={isArray:q,isSelector:I,lazyTweens:K,blobDif:Q},T=H._plugins={},U=S.tweenLookup={},V=0,W=S.reservedProps={ease:1,delay:1,overwrite:1,onComplete:1,onCompleteParams:1,onCompleteScope:1,useFrames:1,runBackwards:1,startAt:1,onUpdate:1,onUpdateParams:1,onUpdateScope:1,onStart:1,onStartParams:1,onStartScope:1,onReverseComplete:1,onReverseCompleteParams:1,onReverseCompleteScope:1,onRepeat:1,onRepeatParams:1,onRepeatScope:1,easeParams:1,yoyo:1,immediateRender:1,repeat:1,repeatDelay:1,data:1,paused:1,reversed:1,autoCSS:1,lazy:1,onOverwrite:1,callbackScope:1,stringFilter:1,id:1,yoyoEase:1,stagger:1},X={none:0,all:1,auto:2,concurrent:3,allOnStart:4,preexisting:5,"true":1,"false":0},Y=E._rootFramesTimeline=new G,Z=E._rootTimeline=new G,$=30,_=S.lazyRender=function(){var a,b,c=K.length;for(L={},a=0;c>a;a++)b=K[a],b&&b._lazy!==!1&&(b.render(b._lazy[0],b._lazy[1],!0),b._lazy=!1);K.length=0};Z._startTime=j.time,Y._startTime=j.frame,Z._active=Y._active=!0,setTimeout(_,1),E._updateRoot=H.render=function(){var a,b,c;if(K.length&&_(),Z.render((j.time-Z._startTime)*Z._timeScale,!1,!1),Y.render((j.frame-Y._startTime)*Y._timeScale,!1,!1),K.length&&_(),j.frame>=$){$=j.frame+(parseInt(H.autoSleep,10)||120);for(c in U){for(b=U[c].tweens,a=b.length;--a>-1;)b[a]._gc&&b.splice(a,1);0===b.length&&delete U[c]}if(c=Z._first,(!c||c._paused)&&H.autoSleep&&!Y._first&&1===j._listeners.tick.length){for(;c&&c._paused;)c=c._next;c||j.sleep()}}},j.addEventListener("tick",E._updateRoot);var aa=function(a,b,c){var d,e,f=a._gsTweenID;if(U[f||(a._gsTweenID=f="t"+V++)]||(U[f]={target:a,tweens:[]}),b&&(d=U[f].tweens,d[e=d.length]=b,c))for(;--e>-1;)d[e]===b&&d.splice(e,1);return U[f].tweens},ba=function(a,b,c,d){var e,f,g=a.vars.onOverwrite;return g&&(e=g(a,b,c,d)),g=H.onOverwrite,g&&(f=g(a,b,c,d)),e!==!1&&f!==!1},ca=function(a,b,c,d,e){var f,g,h,i;if(1===d||d>=4){for(i=e.length,f=0;i>f;f++)if((h=e[f])!==b)h._gc||h._kill(null,a,b)&&(g=!0);else if(5===d)break;return g}var j,k=b._startTime+n,l=[],m=0,o=0===b._duration;for(f=e.length;--f>-1;)(h=e[f])===b||h._gc||h._paused||(h._timeline!==b._timeline?(j=j||da(b,0,o),0===da(h,j,o)&&(l[m++]=h)):h._startTime<=k&&h._startTime+h.totalDuration()/h._timeScale>k&&((o||!h._initted)&&k-h._startTime<=2*n||(l[m++]=h)));for(f=m;--f>-1;)if(h=l[f],i=h._firstPT,2===d&&h._kill(c,a,b)&&(g=!0),2!==d||!h._firstPT&&h._initted&&i){if(2!==d&&!ba(h,b))continue;h._enabled(!1,!1)&&(g=!0)}return g},da=function(a,b,c){for(var d=a._timeline,e=d._timeScale,f=a._startTime;d._timeline;){if(f+=d._startTime,e*=d._timeScale,d._paused)return-100;d=d._timeline}return f/=e,f>b?f-b:c&&f===b||!a._initted&&2*n>f-b?n:(f+=a.totalDuration()/a._timeScale/e)>b+n?0:f-b-n};i._init=function(){var a,b,c,d,e,f,g=this.vars,h=this._overwrittenProps,i=this._duration,j=!!g.immediateRender,k=g.ease,l=this._startAt;if(g.startAt){l&&(l.render(-1,!0),l.kill()),e={};for(d in g.startAt)e[d]=g.startAt[d];if(e.data="isStart",e.overwrite=!1,e.immediateRender=!0,e.lazy=j&&g.lazy!==!1,e.startAt=e.delay=null,e.onUpdate=g.onUpdate,e.onUpdateParams=g.onUpdateParams,e.onUpdateScope=g.onUpdateScope||g.callbackScope||this,this._startAt=H.to(this.target||{},0,e),j)if(this._time>0)this._startAt=null;else if(0!==i)return}else if(g.runBackwards&&0!==i)if(l)l.render(-1,!0),l.kill(),this._startAt=null;else{0!==this._time&&(j=!1),c={};for(d in g)W[d]&&"autoCSS"!==d||(c[d]=g[d]);if(c.overwrite=0,c.data="isFromStart",c.lazy=j&&g.lazy!==!1,c.immediateRender=j,this._startAt=H.to(this.target,0,c),j){if(0===this._time)return}else this._startAt._init(),this._startAt._enabled(!1),this.vars.immediateRender&&(this._startAt=null)}if(this._ease=k=k?k instanceof w?k:"function"==typeof k?new w(k,g.easeParams):x[k]||H.defaultEase:H.defaultEase,g.easeParams instanceof Array&&k.config&&(this._ease=k.config.apply(k,g.easeParams)),this._easeType=this._ease._type,this._easePower=this._ease._power,this._firstPT=null,this._targets)for(f=this._targets.length,a=0;f>a;a++)this._initProps(this._targets[a],this._propLookup[a]={},this._siblings[a],h?h[a]:null,a)&&(b=!0);else b=this._initProps(this.target,this._propLookup,this._siblings,h,0);if(b&&H._onPluginEvent("_onInitAllProps",this),h&&(this._firstPT||"function"!=typeof this.target&&this._enabled(!1,!1)),g.runBackwards)for(c=this._firstPT;c;)c.s+=c.c,c.c=-c.c,c=c._next;this._onUpdate=g.onUpdate,this._initted=!0},i._initProps=function(b,c,d,e,f){var g,h,i,j,k,l;if(null==b)return!1;L[b._gsTweenID]&&_(),this.vars.css||b.style&&b!==a&&b.nodeType&&T.css&&this.vars.autoCSS!==!1&&J(this.vars,b);for(g in this.vars)if(l=this.vars[g],W[g])l&&(l instanceof Array||l.push&&q(l))&&-1!==l.join("").indexOf("{self}")&&(this.vars[g]=l=this._swapSelfInParams(l,this));else if(T[g]&&(j=new T[g])._onInitTween(b,this.vars[g],this,f)){for(this._firstPT=k={_next:this._firstPT,t:j,p:"setRatio",s:0,c:1,f:1,n:g,pg:1,pr:j._priority,m:0},h=j._overwriteProps.length;--h>-1;)c[j._overwriteProps[h]]=this._firstPT;(j._priority||j._onInitAllProps)&&(i=!0),(j._onDisable||j._onEnable)&&(this._notifyPluginsOfEnabled=!0),k._next&&(k._next._prev=k)}else c[g]=R.call(this,b,g,"get",l,g,0,null,this.vars.stringFilter,f);return e&&this._kill(e,b)?this._initProps(b,c,d,e,f):this._overwrite>1&&this._firstPT&&d.length>1&&ca(b,this,c,this._overwrite,d)?(this._kill(c,b),this._initProps(b,c,d,e,f)):(this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration)&&(L[b._gsTweenID]=!0),i)},i.render=function(a,b,c){var d,e,f,g,h=this,i=h._time,j=h._duration,k=h._rawPrevTime;if(a>=j-n&&a>=0)h._totalTime=h._time=j,h.ratio=h._ease._calcEnd?h._ease.getRatio(1):1,h._reversed||(d=!0,e="onComplete",c=c||h._timeline.autoRemoveChildren),0===j&&(h._initted||!h.vars.lazy||c)&&(h._startTime===h._timeline._duration&&(a=0),(0>k||0>=a&&a>=-n||k===n&&"isPause"!==h.data)&&k!==a&&(c=!0,k>n&&(e="onReverseComplete")),h._rawPrevTime=g=!b||a||k===a?a:n);else if(n>a)h._totalTime=h._time=0,h.ratio=h._ease._calcEnd?h._ease.getRatio(0):0,(0!==i||0===j&&k>0)&&(e="onReverseComplete",d=h._reversed),a>-n?a=0:0>a&&(h._active=!1,0===j&&(h._initted||!h.vars.lazy||c)&&(k>=0&&(k!==n||"isPause"!==h.data)&&(c=!0),h._rawPrevTime=g=!b||a||k===a?a:n)),(!h._initted||h._startAt&&h._startAt.progress())&&(c=!0);else if(h._totalTime=h._time=a,h._easeType){var l=a/j,m=h._easeType,o=h._easePower;(1===m||3===m&&l>=.5)&&(l=1-l),3===m&&(l*=2),1===o?l*=l:2===o?l*=l*l:3===o?l*=l*l*l:4===o&&(l*=l*l*l*l),h.ratio=1===m?1-l:2===m?l:.5>a/j?l/2:1-l/2}else h.ratio=h._ease.getRatio(a/j);if(h._time!==i||c){if(!h._initted){if(h._init(),!h._initted||h._gc)return;if(!c&&h._firstPT&&(h.vars.lazy!==!1&&h._duration||h.vars.lazy&&!h._duration))return h._time=h._totalTime=i,h._rawPrevTime=k,K.push(h),void(h._lazy=[a,b]);h._time&&!d?h.ratio=h._ease.getRatio(h._time/j):d&&h._ease._calcEnd&&(h.ratio=h._ease.getRatio(0===h._time?0:1))}for(h._lazy!==!1&&(h._lazy=!1),h._active||!h._paused&&h._time!==i&&a>=0&&(h._active=!0),0===i&&(h._startAt&&(a>=0?h._startAt.render(a,!0,c):e||(e="_dummyGS")),h.vars.onStart&&(0!==h._time||0===j)&&(b||h._callback("onStart"))),f=h._firstPT;f;)f.f?f.t[f.p](f.c*h.ratio+f.s):f.t[f.p]=f.c*h.ratio+f.s,f=f._next;h._onUpdate&&(0>a&&h._startAt&&a!==-1e-4&&h._startAt.render(a,!0,c),b||(h._time!==i||d||c)&&h._callback("onUpdate")),e&&(!h._gc||c)&&(0>a&&h._startAt&&!h._onUpdate&&a!==-1e-4&&h._startAt.render(a,!0,c),d&&(h._timeline.autoRemoveChildren&&h._enabled(!1,!1),h._active=!1),!b&&h.vars[e]&&h._callback(e),0===j&&h._rawPrevTime===n&&g!==n&&(h._rawPrevTime=0))}},i._kill=function(a,b,c){if("all"===a&&(a=null),null==a&&(null==b||b===this.target))return this._lazy=!1,this._enabled(!1,!1);b="string"!=typeof b?b||this._targets||this.target:H.selector(b)||b;var d,e,f,g,h,i,j,k,l,m=c&&this._time&&c._startTime===this._startTime&&this._timeline===c._timeline,n=this._firstPT;if((q(b)||I(b))&&"number"!=typeof b[0])for(d=b.length;--d>-1;)this._kill(a,b[d],c)&&(i=!0);else{if(this._targets){for(d=this._targets.length;--d>-1;)if(b===this._targets[d]){h=this._propLookup[d]||{},this._overwrittenProps=this._overwrittenProps||[],e=this._overwrittenProps[d]=a?this._overwrittenProps[d]||{}:"all";break}}else{if(b!==this.target)return!1;h=this._propLookup,e=this._overwrittenProps=a?this._overwrittenProps||{}:"all"}if(h){if(j=a||h,k=a!==e&&"all"!==e&&a!==h&&("object"!=typeof a||!a._tempKill),c&&(H.onOverwrite||this.vars.onOverwrite)){for(f in j)h[f]&&(l||(l=[]),l.push(f));if((l||!a)&&!ba(this,c,b,l))return!1}for(f in j)(g=h[f])&&(m&&(g.f?g.t[g.p](g.s):g.t[g.p]=g.s,i=!0),g.pg&&g.t._kill(j)&&(i=!0),g.pg&&0!==g.t._overwriteProps.length||(g._prev?g._prev._next=g._next:g===this._firstPT&&(this._firstPT=g._next),g._next&&(g._next._prev=g._prev),g._next=g._prev=null),delete h[f]),k&&(e[f]=1);!this._firstPT&&this._initted&&n&&this._enabled(!1,!1)}}return i},i.invalidate=function(){this._notifyPluginsOfEnabled&&H._onPluginEvent("_onDisable",this);var a=this._time;return this._firstPT=this._overwrittenProps=this._startAt=this._onUpdate=null,this._notifyPluginsOfEnabled=this._active=this._lazy=!1,this._propLookup=this._targets?{}:[],E.prototype.invalidate.call(this),this.vars.immediateRender&&(this._time=-n,this.render(a,!1,this.vars.lazy!==!1)),this},i._enabled=function(a,b){if(k||j.wake(),a&&this._gc){var c,d=this._targets;if(d)for(c=d.length;--c>-1;)this._siblings[c]=aa(d[c],this,!0);else this._siblings=aa(this.target,this,!0)}return E.prototype._enabled.call(this,a,b),this._notifyPluginsOfEnabled&&this._firstPT?H._onPluginEvent(a?"_onEnable":"_onDisable",this):!1},H.to=function(a,b,c){return new H(a,b,c)},H.from=function(a,b,c){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,new H(a,b,c)},H.fromTo=function(a,b,c,d){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,new H(a,b,d)},H.delayedCall=function(a,b,c,d,e){return new H(b,0,{delay:a,onComplete:b,onCompleteParams:c,callbackScope:d,onReverseComplete:b,onReverseCompleteParams:c,immediateRender:!1,lazy:!1,useFrames:e,overwrite:0})},H.set=function(a,b){return new H(a,0,b)},H.getTweensOf=function(a,b){if(null==a)return[];a="string"!=typeof a?a:H.selector(a)||a;var c,d,e,f;if((q(a)||I(a))&&"number"!=typeof a[0]){for(c=a.length,d=[];--c>-1;)d=d.concat(H.getTweensOf(a[c],b));for(c=d.length;--c>-1;)for(f=d[c],e=c;--e>-1;)f===d[e]&&d.splice(c,1)}else if(a._gsTweenID)for(d=aa(a).concat(),c=d.length;--c>-1;)(d[c]._gc||b&&!d[c].isActive())&&d.splice(c,1);return d||[]},H.killTweensOf=H.killDelayedCallsTo=function(a,b,c){"object"==typeof b&&(c=b,b=!1);for(var d=H.getTweensOf(a,b),e=d.length;--e>-1;)d[e]._kill(c,a)};var ea=u("plugins.TweenPlugin",function(a,b){this._overwriteProps=(a||"").split(","),this._propName=this._overwriteProps[0],this._priority=b||0,this._super=ea.prototype},!0);if(i=ea.prototype,ea.version="1.19.0",ea.API=2,i._firstPT=null,i._addTween=R,i.setRatio=O,i._kill=function(a){var b,c=this._overwriteProps,d=this._firstPT;if(null!=a[this._propName])this._overwriteProps=[];else for(b=c.length;--b>-1;)null!=a[c[b]]&&c.splice(b,1);for(;d;)null!=a[d.n]&&(d._next&&(d._next._prev=d._prev),d._prev?(d._prev._next=d._next,d._prev=null):this._firstPT===d&&(this._firstPT=d._next)),d=d._next;return!1},i._mod=i._roundProps=function(a){for(var b,c=this._firstPT;c;)b=a[this._propName]||null!=c.n&&a[c.n.split(this._propName+"_").join("")],b&&"function"==typeof b&&(2===c.f?c.t._applyPT.m=b:c.m=b),c=c._next},H._onPluginEvent=function(a,b){var c,d,e,f,g,h=b._firstPT;if("_onInitAllProps"===a){for(;h;){for(g=h._next,d=e;d&&d.pr>h.pr;)d=d._next;(h._prev=d?d._prev:f)?h._prev._next=h:e=h,(h._next=d)?d._prev=h:f=h,h=g}h=b._firstPT=e}for(;h;)h.pg&&"function"==typeof h.t[a]&&h.t[a]()&&(c=!0),h=h._next;return c},ea.activate=function(a){for(var b=a.length;--b>-1;)a[b].API===ea.API&&(T[(new a[b])._propName]=a[b]);return!0},t.plugin=function(a){if(!(a&&a.propName&&a.init&&a.API))throw"illegal plugin definition.";var b,c=a.propName,d=a.priority||0,e=a.overwriteProps,f={init:"_onInitTween",set:"setRatio",kill:"_kill",round:"_mod",mod:"_mod",initAll:"_onInitAllProps"},g=u("plugins."+c.charAt(0).toUpperCase()+c.substr(1)+"Plugin",function(){ea.call(this,c,d),this._overwriteProps=e||[]},a.global===!0),h=g.prototype=new ea(c);h.constructor=g,g.API=a.API;for(b in f)"function"==typeof a[b]&&(h[f[b]]=a[b]);return g.version=a.version,ea.activate([g]),g},g=a._gsQueue){for(h=0;h<g.length;h++)g[h]();for(i in r)r[i].func||a.console.log("GSAP encountered missing dependency: "+i)}k=!1}("undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window,"TweenMax");



/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
!function(a,b,c,d){function e(b,c){this.settings=null,this.options=a.extend({},e.Defaults,c),this.$element=a(b),this._handlers={},this._plugins={},this._supress={},this._current=null,this._speed=null,this._coordinates=[],this._breakpoint=null,this._width=null,this._items=[],this._clones=[],this._mergers=[],this._widths=[],this._invalidated={},this._pipe=[],this._drag={time:null,target:null,pointer:null,stage:{start:null,current:null},direction:null},this._states={current:{},tags:{initializing:["busy"],animating:["busy"],dragging:["interacting"]}},a.each(["onResize","onThrottledResize"],a.proxy(function(b,c){this._handlers[c]=a.proxy(this[c],this)},this)),a.each(e.Plugins,a.proxy(function(a,b){this._plugins[a.charAt(0).toLowerCase()+a.slice(1)]=new b(this)},this)),a.each(e.Workers,a.proxy(function(b,c){this._pipe.push({filter:c.filter,run:a.proxy(c.run,this)})},this)),this.setup(),this.initialize()}e.Defaults={items:3,loop:!1,center:!1,rewind:!1,checkVisibility:!0,mouseDrag:!0,touchDrag:!0,pullDrag:!0,freeDrag:!1,margin:0,stagePadding:0,merge:!1,mergeFit:!0,autoWidth:!1,startPosition:0,rtl:!1,smartSpeed:250,fluidSpeed:!1,dragEndSpeed:!1,responsive:{},responsiveRefreshRate:200,responsiveBaseElement:b,fallbackEasing:"swing",slideTransition:"",info:!1,nestedItemSelector:!1,itemElement:"div",stageElement:"div",refreshClass:"owl-refresh",loadedClass:"owl-loaded",loadingClass:"owl-loading",rtlClass:"owl-rtl",responsiveClass:"owl-responsive",dragClass:"owl-drag",itemClass:"owl-item",stageClass:"owl-stage",stageOuterClass:"owl-stage-outer",grabClass:"owl-grab"},e.Width={Default:"default",Inner:"inner",Outer:"outer"},e.Type={Event:"event",State:"state"},e.Plugins={},e.Workers=[{filter:["width","settings"],run:function(){this._width=this.$element.width()}},{filter:["width","items","settings"],run:function(a){a.current=this._items&&this._items[this.relative(this._current)]}},{filter:["items","settings"],run:function(){this.$stage.children(".cloned").remove()}},{filter:["width","items","settings"],run:function(a){var b=this.settings.margin||"",c=!this.settings.autoWidth,d=this.settings.rtl,e={width:"auto","margin-left":d?b:"","margin-right":d?"":b};!c&&this.$stage.children().css(e),a.css=e}},{filter:["width","items","settings"],run:function(a){var b=(this.width()/this.settings.items).toFixed(3)-this.settings.margin,c=null,d=this._items.length,e=!this.settings.autoWidth,f=[];for(a.items={merge:!1,width:b};d--;)c=this._mergers[d],c=this.settings.mergeFit&&Math.min(c,this.settings.items)||c,a.items.merge=c>1||a.items.merge,f[d]=e?b*c:this._items[d].width();this._widths=f}},{filter:["items","settings"],run:function(){var b=[],c=this._items,d=this.settings,e=Math.max(2*d.items,4),f=2*Math.ceil(c.length/2),g=d.loop&&c.length?d.rewind?e:Math.max(e,f):0,h="",i="";for(g/=2;g>0;)b.push(this.normalize(b.length/2,!0)),h+=c[b[b.length-1]][0].outerHTML,b.push(this.normalize(c.length-1-(b.length-1)/2,!0)),i=c[b[b.length-1]][0].outerHTML+i,g-=1;this._clones=b,a(h).addClass("cloned").appendTo(this.$stage),a(i).addClass("cloned").prependTo(this.$stage)}},{filter:["width","items","settings"],run:function(){for(var a=this.settings.rtl?1:-1,b=this._clones.length+this._items.length,c=-1,d=0,e=0,f=[];++c<b;)d=f[c-1]||0,e=this._widths[this.relative(c)]+this.settings.margin,f.push(d+e*a);this._coordinates=f}},{filter:["width","items","settings"],run:function(){var a=this.settings.stagePadding,b=this._coordinates,c={width:Math.ceil(Math.abs(b[b.length-1]))+2*a,"padding-left":a||"","padding-right":a||""};this.$stage.css(c)}},{filter:["width","items","settings"],run:function(a){var b=this._coordinates.length,c=!this.settings.autoWidth,d=this.$stage.children();if(c&&a.items.merge)for(;b--;)a.css.width=this._widths[this.relative(b)],d.eq(b).css(a.css);else c&&(a.css.width=a.items.width,d.css(a.css))}},{filter:["items"],run:function(){this._coordinates.length<1&&this.$stage.removeAttr("style")}},{filter:["width","items","settings"],run:function(a){a.current=a.current?this.$stage.children().index(a.current):0,a.current=Math.max(this.minimum(),Math.min(this.maximum(),a.current)),this.reset(a.current)}},{filter:["position"],run:function(){this.animate(this.coordinates(this._current))}},{filter:["width","position","items","settings"],run:function(){var a,b,c,d,e=this.settings.rtl?1:-1,f=2*this.settings.stagePadding,g=this.coordinates(this.current())+f,h=g+this.width()*e,i=[];for(c=0,d=this._coordinates.length;c<d;c++)a=this._coordinates[c-1]||0,b=Math.abs(this._coordinates[c])+f*e,(this.op(a,"<=",g)&&this.op(a,">",h)||this.op(b,"<",g)&&this.op(b,">",h))&&i.push(c);this.$stage.children(".active").removeClass("active"),this.$stage.children(":eq("+i.join("), :eq(")+")").addClass("active"),this.$stage.children(".center").removeClass("center"),this.settings.center&&this.$stage.children().eq(this.current()).addClass("center")}}],e.prototype.initializeStage=function(){this.$stage=this.$element.find("."+this.settings.stageClass),this.$stage.length||(this.$element.addClass(this.options.loadingClass),this.$stage=a("<"+this.settings.stageElement+">",{class:this.settings.stageClass}).wrap(a("<div/>",{class:this.settings.stageOuterClass})),this.$element.append(this.$stage.parent()))},e.prototype.initializeItems=function(){var b=this.$element.find(".owl-item");if(b.length)return this._items=b.get().map(function(b){return a(b)}),this._mergers=this._items.map(function(){return 1}),void this.refresh();this.replace(this.$element.children().not(this.$stage.parent())),this.isVisible()?this.refresh():this.invalidate("width"),this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass)},e.prototype.initialize=function(){if(this.enter("initializing"),this.trigger("initialize"),this.$element.toggleClass(this.settings.rtlClass,this.settings.rtl),this.settings.autoWidth&&!this.is("pre-loading")){var a,b,c;a=this.$element.find("img"),b=this.settings.nestedItemSelector?"."+this.settings.nestedItemSelector:d,c=this.$element.children(b).width(),a.length&&c<=0&&this.preloadAutoWidthImages(a)}this.initializeStage(),this.initializeItems(),this.registerEventHandlers(),this.leave("initializing"),this.trigger("initialized")},e.prototype.isVisible=function(){return!this.settings.checkVisibility||this.$element.is(":visible")},e.prototype.setup=function(){var b=this.viewport(),c=this.options.responsive,d=-1,e=null;c?(a.each(c,function(a){a<=b&&a>d&&(d=Number(a))}),e=a.extend({},this.options,c[d]),"function"==typeof e.stagePadding&&(e.stagePadding=e.stagePadding()),delete e.responsive,e.responsiveClass&&this.$element.attr("class",this.$element.attr("class").replace(new RegExp("("+this.options.responsiveClass+"-)\\S+\\s","g"),"$1"+d))):e=a.extend({},this.options),this.trigger("change",{property:{name:"settings",value:e}}),this._breakpoint=d,this.settings=e,this.invalidate("settings"),this.trigger("changed",{property:{name:"settings",value:this.settings}})},e.prototype.optionsLogic=function(){this.settings.autoWidth&&(this.settings.stagePadding=!1,this.settings.merge=!1)},e.prototype.prepare=function(b){var c=this.trigger("prepare",{content:b});return c.data||(c.data=a("<"+this.settings.itemElement+"/>").addClass(this.options.itemClass).append(b)),this.trigger("prepared",{content:c.data}),c.data},e.prototype.update=function(){for(var b=0,c=this._pipe.length,d=a.proxy(function(a){return this[a]},this._invalidated),e={};b<c;)(this._invalidated.all||a.grep(this._pipe[b].filter,d).length>0)&&this._pipe[b].run(e),b++;this._invalidated={},!this.is("valid")&&this.enter("valid")},e.prototype.width=function(a){switch(a=a||e.Width.Default){case e.Width.Inner:case e.Width.Outer:return this._width;default:return this._width-2*this.settings.stagePadding+this.settings.margin}},e.prototype.refresh=function(){this.enter("refreshing"),this.trigger("refresh"),this.setup(),this.optionsLogic(),this.$element.addClass(this.options.refreshClass),this.update(),this.$element.removeClass(this.options.refreshClass),this.leave("refreshing"),this.trigger("refreshed")},e.prototype.onThrottledResize=function(){b.clearTimeout(this.resizeTimer),this.resizeTimer=b.setTimeout(this._handlers.onResize,this.settings.responsiveRefreshRate)},e.prototype.onResize=function(){return!!this._items.length&&(this._width!==this.$element.width()&&(!!this.isVisible()&&(this.enter("resizing"),this.trigger("resize").isDefaultPrevented()?(this.leave("resizing"),!1):(this.invalidate("width"),this.refresh(),this.leave("resizing"),void this.trigger("resized")))))},e.prototype.registerEventHandlers=function(){a.support.transition&&this.$stage.on(a.support.transition.end+".owl.core",a.proxy(this.onTransitionEnd,this)),!1!==this.settings.responsive&&this.on(b,"resize",this._handlers.onThrottledResize),this.settings.mouseDrag&&(this.$element.addClass(this.options.dragClass),this.$stage.on("mousedown.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("dragstart.owl.core selectstart.owl.core",function(){return!1})),this.settings.touchDrag&&(this.$stage.on("touchstart.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("touchcancel.owl.core",a.proxy(this.onDragEnd,this)))},e.prototype.onDragStart=function(b){var d=null;3!==b.which&&(a.support.transform?(d=this.$stage.css("transform").replace(/.*\(|\)| /g,"").split(","),d={x:d[16===d.length?12:4],y:d[16===d.length?13:5]}):(d=this.$stage.position(),d={x:this.settings.rtl?d.left+this.$stage.width()-this.width()+this.settings.margin:d.left,y:d.top}),this.is("animating")&&(a.support.transform?this.animate(d.x):this.$stage.stop(),this.invalidate("position")),this.$element.toggleClass(this.options.grabClass,"mousedown"===b.type),this.speed(0),this._drag.time=(new Date).getTime(),this._drag.target=a(b.target),this._drag.stage.start=d,this._drag.stage.current=d,this._drag.pointer=this.pointer(b),a(c).on("mouseup.owl.core touchend.owl.core",a.proxy(this.onDragEnd,this)),a(c).one("mousemove.owl.core touchmove.owl.core",a.proxy(function(b){var d=this.difference(this._drag.pointer,this.pointer(b));a(c).on("mousemove.owl.core touchmove.owl.core",a.proxy(this.onDragMove,this)),Math.abs(d.x)<Math.abs(d.y)&&this.is("valid")||(b.preventDefault(),this.enter("dragging"),this.trigger("drag"))},this)))},e.prototype.onDragMove=function(a){var b=null,c=null,d=null,e=this.difference(this._drag.pointer,this.pointer(a)),f=this.difference(this._drag.stage.start,e);this.is("dragging")&&(a.preventDefault(),this.settings.loop?(b=this.coordinates(this.minimum()),c=this.coordinates(this.maximum()+1)-b,f.x=((f.x-b)%c+c)%c+b):(b=this.settings.rtl?this.coordinates(this.maximum()):this.coordinates(this.minimum()),c=this.settings.rtl?this.coordinates(this.minimum()):this.coordinates(this.maximum()),d=this.settings.pullDrag?-1*e.x/5:0,f.x=Math.max(Math.min(f.x,b+d),c+d)),this._drag.stage.current=f,this.animate(f.x))},e.prototype.onDragEnd=function(b){var d=this.difference(this._drag.pointer,this.pointer(b)),e=this._drag.stage.current,f=d.x>0^this.settings.rtl?"left":"right";a(c).off(".owl.core"),this.$element.removeClass(this.options.grabClass),(0!==d.x&&this.is("dragging")||!this.is("valid"))&&(this.speed(this.settings.dragEndSpeed||this.settings.smartSpeed),this.current(this.closest(e.x,0!==d.x?f:this._drag.direction)),this.invalidate("position"),this.update(),this._drag.direction=f,(Math.abs(d.x)>3||(new Date).getTime()-this._drag.time>300)&&this._drag.target.one("click.owl.core",function(){return!1})),this.is("dragging")&&(this.leave("dragging"),this.trigger("dragged"))},e.prototype.closest=function(b,c){var e=-1,f=30,g=this.width(),h=this.coordinates();return this.settings.freeDrag||a.each(h,a.proxy(function(a,i){return"left"===c&&b>i-f&&b<i+f?e=a:"right"===c&&b>i-g-f&&b<i-g+f?e=a+1:this.op(b,"<",i)&&this.op(b,">",h[a+1]!==d?h[a+1]:i-g)&&(e="left"===c?a+1:a),-1===e},this)),this.settings.loop||(this.op(b,">",h[this.minimum()])?e=b=this.minimum():this.op(b,"<",h[this.maximum()])&&(e=b=this.maximum())),e},e.prototype.animate=function(b){var c=this.speed()>0;this.is("animating")&&this.onTransitionEnd(),c&&(this.enter("animating"),this.trigger("translate")),a.support.transform3d&&a.support.transition?this.$stage.css({transform:"translate3d("+b+"px,0px,0px)",transition:this.speed()/1e3+"s"+(this.settings.slideTransition?" "+this.settings.slideTransition:"")}):c?this.$stage.animate({left:b+"px"},this.speed(),this.settings.fallbackEasing,a.proxy(this.onTransitionEnd,this)):this.$stage.css({left:b+"px"})},e.prototype.is=function(a){return this._states.current[a]&&this._states.current[a]>0},e.prototype.current=function(a){if(a===d)return this._current;if(0===this._items.length)return d;if(a=this.normalize(a),this._current!==a){var b=this.trigger("change",{property:{name:"position",value:a}});b.data!==d&&(a=this.normalize(b.data)),this._current=a,this.invalidate("position"),this.trigger("changed",{property:{name:"position",value:this._current}})}return this._current},e.prototype.invalidate=function(b){return"string"===a.type(b)&&(this._invalidated[b]=!0,this.is("valid")&&this.leave("valid")),a.map(this._invalidated,function(a,b){return b})},e.prototype.reset=function(a){(a=this.normalize(a))!==d&&(this._speed=0,this._current=a,this.suppress(["translate","translated"]),this.animate(this.coordinates(a)),this.release(["translate","translated"]))},e.prototype.normalize=function(a,b){var c=this._items.length,e=b?0:this._clones.length;return!this.isNumeric(a)||c<1?a=d:(a<0||a>=c+e)&&(a=((a-e/2)%c+c)%c+e/2),a},e.prototype.relative=function(a){return a-=this._clones.length/2,this.normalize(a,!0)},e.prototype.maximum=function(a){var b,c,d,e=this.settings,f=this._coordinates.length;if(e.loop)f=this._clones.length/2+this._items.length-1;else if(e.autoWidth||e.merge){if(b=this._items.length)for(c=this._items[--b].width(),d=this.$element.width();b--&&!((c+=this._items[b].width()+this.settings.margin)>d););f=b+1}else f=e.center?this._items.length-1:this._items.length-e.items;return a&&(f-=this._clones.length/2),Math.max(f,0)},e.prototype.minimum=function(a){return a?0:this._clones.length/2},e.prototype.items=function(a){return a===d?this._items.slice():(a=this.normalize(a,!0),this._items[a])},e.prototype.mergers=function(a){return a===d?this._mergers.slice():(a=this.normalize(a,!0),this._mergers[a])},e.prototype.clones=function(b){var c=this._clones.length/2,e=c+this._items.length,f=function(a){return a%2==0?e+a/2:c-(a+1)/2};return b===d?a.map(this._clones,function(a,b){return f(b)}):a.map(this._clones,function(a,c){return a===b?f(c):null})},e.prototype.speed=function(a){return a!==d&&(this._speed=a),this._speed},e.prototype.coordinates=function(b){var c,e=1,f=b-1;return b===d?a.map(this._coordinates,a.proxy(function(a,b){return this.coordinates(b)},this)):(this.settings.center?(this.settings.rtl&&(e=-1,f=b+1),c=this._coordinates[b],c+=(this.width()-c+(this._coordinates[f]||0))/2*e):c=this._coordinates[f]||0,c=Math.ceil(c))},e.prototype.duration=function(a,b,c){return 0===c?0:Math.min(Math.max(Math.abs(b-a),1),6)*Math.abs(c||this.settings.smartSpeed)},e.prototype.to=function(a,b){var c=this.current(),d=null,e=a-this.relative(c),f=(e>0)-(e<0),g=this._items.length,h=this.minimum(),i=this.maximum();this.settings.loop?(!this.settings.rewind&&Math.abs(e)>g/2&&(e+=-1*f*g),a=c+e,(d=((a-h)%g+g)%g+h)!==a&&d-e<=i&&d-e>0&&(c=d-e,a=d,this.reset(c))):this.settings.rewind?(i+=1,a=(a%i+i)%i):a=Math.max(h,Math.min(i,a)),this.speed(this.duration(c,a,b)),this.current(a),this.isVisible()&&this.update()},e.prototype.next=function(a){a=a||!1,this.to(this.relative(this.current())+1,a)},e.prototype.prev=function(a){a=a||!1,this.to(this.relative(this.current())-1,a)},e.prototype.onTransitionEnd=function(a){if(a!==d&&(a.stopPropagation(),(a.target||a.srcElement||a.originalTarget)!==this.$stage.get(0)))return!1;this.leave("animating"),this.trigger("translated")},e.prototype.viewport=function(){var d;return this.options.responsiveBaseElement!==b?d=a(this.options.responsiveBaseElement).width():b.innerWidth?d=b.innerWidth:c.documentElement&&c.documentElement.clientWidth?d=c.documentElement.clientWidth:console.warn("Can not detect viewport width."),d},e.prototype.replace=function(b){this.$stage.empty(),this._items=[],b&&(b=b instanceof jQuery?b:a(b)),this.settings.nestedItemSelector&&(b=b.find("."+this.settings.nestedItemSelector)),b.filter(function(){return 1===this.nodeType}).each(a.proxy(function(a,b){b=this.prepare(b),this.$stage.append(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)},this)),this.reset(this.isNumeric(this.settings.startPosition)?this.settings.startPosition:0),this.invalidate("items")},e.prototype.add=function(b,c){var e=this.relative(this._current);c=c===d?this._items.length:this.normalize(c,!0),b=b instanceof jQuery?b:a(b),this.trigger("add",{content:b,position:c}),b=this.prepare(b),0===this._items.length||c===this._items.length?(0===this._items.length&&this.$stage.append(b),0!==this._items.length&&this._items[c-1].after(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)):(this._items[c].before(b),this._items.splice(c,0,b),this._mergers.splice(c,0,1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)),this._items[e]&&this.reset(this._items[e].index()),this.invalidate("items"),this.trigger("added",{content:b,position:c})},e.prototype.remove=function(a){(a=this.normalize(a,!0))!==d&&(this.trigger("remove",{content:this._items[a],position:a}),this._items[a].remove(),this._items.splice(a,1),this._mergers.splice(a,1),this.invalidate("items"),this.trigger("removed",{content:null,position:a}))},e.prototype.preloadAutoWidthImages=function(b){b.each(a.proxy(function(b,c){this.enter("pre-loading"),c=a(c),a(new Image).one("load",a.proxy(function(a){c.attr("src",a.target.src),c.css("opacity",1),this.leave("pre-loading"),!this.is("pre-loading")&&!this.is("initializing")&&this.refresh()},this)).attr("src",c.attr("src")||c.attr("data-src")||c.attr("data-src-retina"))},this))},e.prototype.destroy=function(){this.$element.off(".owl.core"),this.$stage.off(".owl.core"),a(c).off(".owl.core"),!1!==this.settings.responsive&&(b.clearTimeout(this.resizeTimer),this.off(b,"resize",this._handlers.onThrottledResize));for(var d in this._plugins)this._plugins[d].destroy();this.$stage.children(".cloned").remove(),this.$stage.unwrap(),this.$stage.children().contents().unwrap(),this.$stage.children().unwrap(),this.$stage.remove(),this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class",this.$element.attr("class").replace(new RegExp(this.options.responsiveClass+"-\\S+\\s","g"),"")).removeData("owl.carousel")},e.prototype.op=function(a,b,c){var d=this.settings.rtl;switch(b){case"<":return d?a>c:a<c;case">":return d?a<c:a>c;case">=":return d?a<=c:a>=c;case"<=":return d?a>=c:a<=c}},e.prototype.on=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d):a.attachEvent&&a.attachEvent("on"+b,c)},e.prototype.off=function(a,b,c,d){a.removeEventListener?a.removeEventListener(b,c,d):a.detachEvent&&a.detachEvent("on"+b,c)},e.prototype.trigger=function(b,c,d,f,g){var h={item:{count:this._items.length,index:this.current()}},i=a.camelCase(a.grep(["on",b,d],function(a){return a}).join("-").toLowerCase()),j=a.Event([b,"owl",d||"carousel"].join(".").toLowerCase(),a.extend({relatedTarget:this},h,c));return this._supress[b]||(a.each(this._plugins,function(a,b){b.onTrigger&&b.onTrigger(j)}),this.register({type:e.Type.Event,name:b}),this.$element.trigger(j),this.settings&&"function"==typeof this.settings[i]&&this.settings[i].call(this,j)),j},e.prototype.enter=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]===d&&(this._states.current[b]=0),this._states.current[b]++},this))},e.prototype.leave=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]--},this))},e.prototype.register=function(b){if(b.type===e.Type.Event){if(a.event.special[b.name]||(a.event.special[b.name]={}),!a.event.special[b.name].owl){var c=a.event.special[b.name]._default;a.event.special[b.name]._default=function(a){return!c||!c.apply||a.namespace&&-1!==a.namespace.indexOf("owl")?a.namespace&&a.namespace.indexOf("owl")>-1:c.apply(this,arguments)},a.event.special[b.name].owl=!0}}else b.type===e.Type.State&&(this._states.tags[b.name]?this._states.tags[b.name]=this._states.tags[b.name].concat(b.tags):this._states.tags[b.name]=b.tags,this._states.tags[b.name]=a.grep(this._states.tags[b.name],a.proxy(function(c,d){return a.inArray(c,this._states.tags[b.name])===d},this)))},e.prototype.suppress=function(b){a.each(b,a.proxy(function(a,b){this._supress[b]=!0},this))},e.prototype.release=function(b){a.each(b,a.proxy(function(a,b){delete this._supress[b]},this))},e.prototype.pointer=function(a){var c={x:null,y:null};return a=a.originalEvent||a||b.event,a=a.touches&&a.touches.length?a.touches[0]:a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:a,a.pageX?(c.x=a.pageX,c.y=a.pageY):(c.x=a.clientX,c.y=a.clientY),c},e.prototype.isNumeric=function(a){return!isNaN(parseFloat(a))},e.prototype.difference=function(a,b){return{x:a.x-b.x,y:a.y-b.y}},a.fn.owlCarousel=function(b){var c=Array.prototype.slice.call(arguments,1);return this.each(function(){var d=a(this),f=d.data("owl.carousel");f||(f=new e(this,"object"==typeof b&&b),d.data("owl.carousel",f),a.each(["next","prev","to","destroy","refresh","replace","add","remove"],function(b,c){f.register({type:e.Type.Event,name:c}),f.$element.on(c+".owl.carousel.core",a.proxy(function(a){a.namespace&&a.relatedTarget!==this&&(this.suppress([c]),f[c].apply(this,[].slice.call(arguments,1)),this.release([c]))},f))})),"string"==typeof b&&"_"!==b.charAt(0)&&f[b].apply(f,c)})},a.fn.owlCarousel.Constructor=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._interval=null,this._visible=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoRefresh&&this.watch()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={autoRefresh:!0,autoRefreshInterval:500},e.prototype.watch=function(){this._interval||(this._visible=this._core.isVisible(),this._interval=b.setInterval(a.proxy(this.refresh,this),this._core.settings.autoRefreshInterval))},e.prototype.refresh=function(){this._core.isVisible()!==this._visible&&(this._visible=!this._visible,this._core.$element.toggleClass("owl-hidden",!this._visible),this._visible&&this._core.invalidate("width")&&this._core.refresh())},e.prototype.destroy=function(){var a,c;b.clearInterval(this._interval);for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoRefresh=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._loaded=[],this._handlers={"initialized.owl.carousel change.owl.carousel resized.owl.carousel":a.proxy(function(b){if(b.namespace&&this._core.settings&&this._core.settings.lazyLoad&&(b.property&&"position"==b.property.name||"initialized"==b.type)){var c=this._core.settings,e=c.center&&Math.ceil(c.items/2)||c.items,f=c.center&&-1*e||0,g=(b.property&&b.property.value!==d?b.property.value:this._core.current())+f,h=this._core.clones().length,i=a.proxy(function(a,b){this.load(b)},this);for(c.lazyLoadEager>0&&(e+=c.lazyLoadEager,c.loop&&(g-=c.lazyLoadEager,e++));f++<e;)this.load(h/2+this._core.relative(g)),h&&a.each(this._core.clones(this._core.relative(g)),i),g++}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={lazyLoad:!1,lazyLoadEager:0},e.prototype.load=function(c){var d=this._core.$stage.children().eq(c),e=d&&d.find(".owl-lazy");!e||a.inArray(d.get(0),this._loaded)>-1||(e.each(a.proxy(function(c,d){var e,f=a(d),g=b.devicePixelRatio>1&&f.attr("data-src-retina")||f.attr("data-src")||f.attr("data-srcset");this._core.trigger("load",{element:f,url:g},"lazy"),f.is("img")?f.one("load.owl.lazy",a.proxy(function(){f.css("opacity",1),this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("src",g):f.is("source")?f.one("load.owl.lazy",a.proxy(function(){this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("srcset",g):(e=new Image,e.onload=a.proxy(function(){f.css({"background-image":'url("'+g+'")',opacity:"1"}),this._core.trigger("loaded",{element:f,url:g},"lazy")},this),e.src=g)},this)),this._loaded.push(d.get(0)))},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this._core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Lazy=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(c){this._core=c,this._previousHeight=null,this._handlers={"initialized.owl.carousel refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&this.update()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&"position"===a.property.name&&this.update()},this),"loaded.owl.lazy":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&a.element.closest("."+this._core.settings.itemClass).index()===this._core.current()&&this.update()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers),this._intervalId=null;var d=this;a(b).on("load",function(){d._core.settings.autoHeight&&d.update()}),a(b).resize(function(){d._core.settings.autoHeight&&(null!=d._intervalId&&clearTimeout(d._intervalId),d._intervalId=setTimeout(function(){d.update()},250))})};e.Defaults={autoHeight:!1,autoHeightClass:"owl-height"},e.prototype.update=function(){var b=this._core._current,c=b+this._core.settings.items,d=this._core.settings.lazyLoad,e=this._core.$stage.children().toArray().slice(b,c),f=[],g=0;a.each(e,function(b,c){f.push(a(c).height())}),g=Math.max.apply(null,f),g<=1&&d&&this._previousHeight&&(g=this._previousHeight),this._previousHeight=g,this._core.$stage.parent().height(g).addClass(this._core.settings.autoHeightClass)},e.prototype.destroy=function(){var a,b;for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoHeight=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._videos={},this._playing=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.register({type:"state",name:"playing",tags:["interacting"]})},this),"resize.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.video&&this.isInFullScreen()&&a.preventDefault()},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.is("resizing")&&this._core.$stage.find(".cloned .owl-video-frame").remove()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"===a.property.name&&this._playing&&this.stop()},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find(".owl-video");c.length&&(c.css("display","none"),this.fetch(c,a(b.content)))}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers),this._core.$element.on("click.owl.video",".owl-video-play-icon",a.proxy(function(a){this.play(a)},this))};e.Defaults={video:!1,videoHeight:!1,videoWidth:!1},e.prototype.fetch=function(a,b){var c=function(){return a.attr("data-vimeo-id")?"vimeo":a.attr("data-vzaar-id")?"vzaar":"youtube"}(),d=a.attr("data-vimeo-id")||a.attr("data-youtube-id")||a.attr("data-vzaar-id"),e=a.attr("data-width")||this._core.settings.videoWidth,f=a.attr("data-height")||this._core.settings.videoHeight,g=a.attr("href");if(!g)throw new Error("Missing video URL.");if(d=g.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/),d[3].indexOf("youtu")>-1)c="youtube";else if(d[3].indexOf("vimeo")>-1)c="vimeo";else{if(!(d[3].indexOf("vzaar")>-1))throw new Error("Video URL not supported.");c="vzaar"}d=d[6],this._videos[g]={type:c,id:d,width:e,height:f},b.attr("data-video",g),this.thumbnail(a,this._videos[g])},e.prototype.thumbnail=function(b,c){var d,e,f,g=c.width&&c.height?"width:"+c.width+"px;height:"+c.height+"px;":"",h=b.find("img"),i="src",j="",k=this._core.settings,l=function(c){e='<div class="owl-video-play-icon"></div>',d=k.lazyLoad?a("<div/>",{class:"owl-video-tn "+j,srcType:c}):a("<div/>",{class:"owl-video-tn",style:"opacity:1;background-image:url("+c+")"}),b.after(d),b.after(e)};if(b.wrap(a("<div/>",{class:"owl-video-wrapper",style:g})),this._core.settings.lazyLoad&&(i="data-src",j="owl-lazy"),h.length)return l(h.attr(i)),h.remove(),!1;"youtube"===c.type?(f="//img.youtube.com/vi/"+c.id+"/hqdefault.jpg",l(f)):"vimeo"===c.type?a.ajax({type:"GET",url:"//vimeo.com/api/v2/video/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a[0].thumbnail_large,l(f)}}):"vzaar"===c.type&&a.ajax({type:"GET",url:"//vzaar.com/api/videos/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a.framegrab_url,l(f)}})},e.prototype.stop=function(){this._core.trigger("stop",null,"video"),this._playing.find(".owl-video-frame").remove(),this._playing.removeClass("owl-video-playing"),this._playing=null,this._core.leave("playing"),this._core.trigger("stopped",null,"video")},e.prototype.play=function(b){var c,d=a(b.target),e=d.closest("."+this._core.settings.itemClass),f=this._videos[e.attr("data-video")],g=f.width||"100%",h=f.height||this._core.$stage.height();this._playing||(this._core.enter("playing"),this._core.trigger("play",null,"video"),e=this._core.items(this._core.relative(e.index())),this._core.reset(e.index()),c=a('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'),c.attr("height",h),c.attr("width",g),"youtube"===f.type?c.attr("src","//www.youtube.com/embed/"+f.id+"?autoplay=1&rel=0&v="+f.id):"vimeo"===f.type?c.attr("src","//player.vimeo.com/video/"+f.id+"?autoplay=1"):"vzaar"===f.type&&c.attr("src","//view.vzaar.com/"+f.id+"/player?autoplay=true"),a(c).wrap('<div class="owl-video-frame" />').insertAfter(e.find(".owl-video")),this._playing=e.addClass("owl-video-playing"))},e.prototype.isInFullScreen=function(){var b=c.fullscreenElement||c.mozFullScreenElement||c.webkitFullscreenElement;return b&&a(b).parent().hasClass("owl-video-frame")},e.prototype.destroy=function(){var a,b;this._core.$element.off("click.owl.video");for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Video=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this.core=b,this.core.options=a.extend({},e.Defaults,this.core.options),this.swapping=!0,this.previous=d,this.next=d,this.handlers={"change.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&(this.previous=this.core.current(),this.next=a.property.value)},this),"drag.owl.carousel dragged.owl.carousel translated.owl.carousel":a.proxy(function(a){a.namespace&&(this.swapping="translated"==a.type)},this),"translate.owl.carousel":a.proxy(function(a){a.namespace&&this.swapping&&(this.core.options.animateOut||this.core.options.animateIn)&&this.swap()},this)},this.core.$element.on(this.handlers)};e.Defaults={animateOut:!1,
	animateIn:!1},e.prototype.swap=function(){if(1===this.core.settings.items&&a.support.animation&&a.support.transition){this.core.speed(0);var b,c=a.proxy(this.clear,this),d=this.core.$stage.children().eq(this.previous),e=this.core.$stage.children().eq(this.next),f=this.core.settings.animateIn,g=this.core.settings.animateOut;this.core.current()!==this.previous&&(g&&(b=this.core.coordinates(this.previous)-this.core.coordinates(this.next),d.one(a.support.animation.end,c).css({left:b+"px"}).addClass("animated owl-animated-out").addClass(g)),f&&e.one(a.support.animation.end,c).addClass("animated owl-animated-in").addClass(f))}},e.prototype.clear=function(b){a(b.target).css({left:""}).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut),this.core.onTransitionEnd()},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this.core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Animate=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._call=null,this._time=0,this._timeout=0,this._paused=!0,this._handlers={"changed.owl.carousel":a.proxy(function(a){a.namespace&&"settings"===a.property.name?this._core.settings.autoplay?this.play():this.stop():a.namespace&&"position"===a.property.name&&this._paused&&(this._time=0)},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoplay&&this.play()},this),"play.owl.autoplay":a.proxy(function(a,b,c){a.namespace&&this.play(b,c)},this),"stop.owl.autoplay":a.proxy(function(a){a.namespace&&this.stop()},this),"mouseover.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"mouseleave.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.play()},this),"touchstart.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"touchend.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this.play()},this)},this._core.$element.on(this._handlers),this._core.options=a.extend({},e.Defaults,this._core.options)};e.Defaults={autoplay:!1,autoplayTimeout:5e3,autoplayHoverPause:!1,autoplaySpeed:!1},e.prototype._next=function(d){this._call=b.setTimeout(a.proxy(this._next,this,d),this._timeout*(Math.round(this.read()/this._timeout)+1)-this.read()),this._core.is("interacting")||c.hidden||this._core.next(d||this._core.settings.autoplaySpeed)},e.prototype.read=function(){return(new Date).getTime()-this._time},e.prototype.play=function(c,d){var e;this._core.is("rotating")||this._core.enter("rotating"),c=c||this._core.settings.autoplayTimeout,e=Math.min(this._time%(this._timeout||c),c),this._paused?(this._time=this.read(),this._paused=!1):b.clearTimeout(this._call),this._time+=this.read()%c-e,this._timeout=c,this._call=b.setTimeout(a.proxy(this._next,this,d),c-e)},e.prototype.stop=function(){this._core.is("rotating")&&(this._time=0,this._paused=!0,b.clearTimeout(this._call),this._core.leave("rotating"))},e.prototype.pause=function(){this._core.is("rotating")&&!this._paused&&(this._time=this.read(),this._paused=!0,b.clearTimeout(this._call))},e.prototype.destroy=function(){var a,b;this.stop();for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.autoplay=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(b){this._core=b,this._initialized=!1,this._pages=[],this._controls={},this._templates=[],this.$element=this._core.$element,this._overrides={next:this._core.next,prev:this._core.prev,to:this._core.to},this._handlers={"prepared.owl.carousel":a.proxy(function(b){b.namespace&&this._core.settings.dotsData&&this._templates.push('<div class="'+this._core.settings.dotClass+'">'+a(b.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot")+"</div>")},this),"added.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,0,this._templates.pop())},this),"remove.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,1)},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&this.draw()},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&!this._initialized&&(this._core.trigger("initialize",null,"navigation"),this.initialize(),this.update(),this.draw(),this._initialized=!0,this._core.trigger("initialized",null,"navigation"))},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._initialized&&(this._core.trigger("refresh",null,"navigation"),this.update(),this.draw(),this._core.trigger("refreshed",null,"navigation"))},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers)};e.Defaults={nav:!1,navText:['<span aria-label="Previous">&#x2039;</span>','<span aria-label="Next">&#x203a;</span>'],navSpeed:!1,navElement:'button type="button" role="presentation"',navContainer:!1,navContainerClass:"owl-nav",navClass:["owl-prev","owl-next"],slideBy:1,dotClass:"owl-dot",dotsClass:"owl-dots",dots:!0,dotsEach:!1,dotsData:!1,dotsSpeed:!1,dotsContainer:!1},e.prototype.initialize=function(){var b,c=this._core.settings;this._controls.$relative=(c.navContainer?a(c.navContainer):a("<div>").addClass(c.navContainerClass).appendTo(this.$element)).addClass("disabled"),this._controls.$previous=a("<"+c.navElement+">").addClass(c.navClass[0]).html(c.navText[0]).prependTo(this._controls.$relative).on("click",a.proxy(function(a){this.prev(c.navSpeed)},this)),this._controls.$next=a("<"+c.navElement+">").addClass(c.navClass[1]).html(c.navText[1]).appendTo(this._controls.$relative).on("click",a.proxy(function(a){this.next(c.navSpeed)},this)),c.dotsData||(this._templates=[a('<button role="button">').addClass(c.dotClass).append(a("<span>")).prop("outerHTML")]),this._controls.$absolute=(c.dotsContainer?a(c.dotsContainer):a("<div>").addClass(c.dotsClass).appendTo(this.$element)).addClass("disabled"),this._controls.$absolute.on("click","button",a.proxy(function(b){var d=a(b.target).parent().is(this._controls.$absolute)?a(b.target).index():a(b.target).parent().index();b.preventDefault(),this.to(d,c.dotsSpeed)},this));for(b in this._overrides)this._core[b]=a.proxy(this[b],this)},e.prototype.destroy=function(){var a,b,c,d,e;e=this._core.settings;for(a in this._handlers)this.$element.off(a,this._handlers[a]);for(b in this._controls)"$relative"===b&&e.navContainer?this._controls[b].html(""):this._controls[b].remove();for(d in this.overides)this._core[d]=this._overrides[d];for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},e.prototype.update=function(){var a,b,c,d=this._core.clones().length/2,e=d+this._core.items().length,f=this._core.maximum(!0),g=this._core.settings,h=g.center||g.autoWidth||g.dotsData?1:g.dotsEach||g.items;if("page"!==g.slideBy&&(g.slideBy=Math.min(g.slideBy,g.items)),g.dots||"page"==g.slideBy)for(this._pages=[],a=d,b=0,c=0;a<e;a++){if(b>=h||0===b){if(this._pages.push({start:Math.min(f,a-d),end:a-d+h-1}),Math.min(f,a-d)===f)break;b=0,++c}b+=this._core.mergers(this._core.relative(a))}},e.prototype.draw=function(){var b,c=this._core.settings,d=this._core.items().length<=c.items,e=this._core.relative(this._core.current()),f=c.loop||c.rewind;this._controls.$relative.toggleClass("disabled",!c.nav||d),c.nav&&(this._controls.$previous.toggleClass("disabled",!f&&e<=this._core.minimum(!0)),this._controls.$next.toggleClass("disabled",!f&&e>=this._core.maximum(!0))),this._controls.$absolute.toggleClass("disabled",!c.dots||d),c.dots&&(b=this._pages.length-this._controls.$absolute.children().length,c.dotsData&&0!==b?this._controls.$absolute.html(this._templates.join("")):b>0?this._controls.$absolute.append(new Array(b+1).join(this._templates[0])):b<0&&this._controls.$absolute.children().slice(b).remove(),this._controls.$absolute.find(".active").removeClass("active"),this._controls.$absolute.children().eq(a.inArray(this.current(),this._pages)).addClass("active"))},e.prototype.onTrigger=function(b){var c=this._core.settings;b.page={index:a.inArray(this.current(),this._pages),count:this._pages.length,size:c&&(c.center||c.autoWidth||c.dotsData?1:c.dotsEach||c.items)}},e.prototype.current=function(){var b=this._core.relative(this._core.current());return a.grep(this._pages,a.proxy(function(a,c){return a.start<=b&&a.end>=b},this)).pop()},e.prototype.getPosition=function(b){var c,d,e=this._core.settings;return"page"==e.slideBy?(c=a.inArray(this.current(),this._pages),d=this._pages.length,b?++c:--c,c=this._pages[(c%d+d)%d].start):(c=this._core.relative(this._core.current()),d=this._core.items().length,b?c+=e.slideBy:c-=e.slideBy),c},e.prototype.next=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!0),b)},e.prototype.prev=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!1),b)},e.prototype.to=function(b,c,d){var e;!d&&this._pages.length?(e=this._pages.length,a.proxy(this._overrides.to,this._core)(this._pages[(b%e+e)%e].start,c)):a.proxy(this._overrides.to,this._core)(b,c)},a.fn.owlCarousel.Constructor.Plugins.Navigation=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(c){this._core=c,this._hashes={},this.$element=this._core.$element,this._handlers={"initialized.owl.carousel":a.proxy(function(c){c.namespace&&"URLHash"===this._core.settings.startPosition&&a(b).trigger("hashchange.owl.navigation")},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");if(!c)return;this._hashes[c]=b.content}},this),"changed.owl.carousel":a.proxy(function(c){if(c.namespace&&"position"===c.property.name){var d=this._core.items(this._core.relative(this._core.current())),e=a.map(this._hashes,function(a,b){return a===d?b:null}).join();if(!e||b.location.hash.slice(1)===e)return;b.location.hash=e}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers),a(b).on("hashchange.owl.navigation",a.proxy(function(a){var c=b.location.hash.substring(1),e=this._core.$stage.children(),f=this._hashes[c]&&e.index(this._hashes[c]);f!==d&&f!==this._core.current()&&this._core.to(this._core.relative(f),!1,!0)},this))};e.Defaults={URLhashListener:!1},e.prototype.destroy=function(){var c,d;a(b).off("hashchange.owl.navigation");for(c in this._handlers)this._core.$element.off(c,this._handlers[c]);for(d in Object.getOwnPropertyNames(this))"function"!=typeof this[d]&&(this[d]=null)},a.fn.owlCarousel.Constructor.Plugins.Hash=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){function e(b,c){var e=!1,f=b.charAt(0).toUpperCase()+b.slice(1);return a.each((b+" "+h.join(f+" ")+f).split(" "),function(a,b){if(g[b]!==d)return e=!c||b,!1}),e}function f(a){return e(a,!0)}var g=a("<support>").get(0).style,h="Webkit Moz O ms".split(" "),i={transition:{end:{WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd",transition:"transitionend"}},animation:{end:{WebkitAnimation:"webkitAnimationEnd",MozAnimation:"animationend",OAnimation:"oAnimationEnd",animation:"animationend"}}},j={csstransforms:function(){return!!e("transform")},csstransforms3d:function(){return!!e("perspective")},csstransitions:function(){return!!e("transition")},cssanimations:function(){return!!e("animation")}};j.csstransitions()&&(a.support.transition=new String(f("transition")),a.support.transition.end=i.transition.end[a.support.transition]),j.cssanimations()&&(a.support.animation=new String(f("animation")),a.support.animation.end=i.animation.end[a.support.animation]),j.csstransforms()&&(a.support.transform=new String(f("transform")),a.support.transform3d=j.csstransforms3d())}(window.Zepto||window.jQuery,window,document);

/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.3.15
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */

!function (a) {
	"use strict";
	"function" == typeof define && define.amd ? define(["jquery"], a) : "undefined" != typeof exports ? module.exports = a(require("jquery")) : a(jQuery);
}(function (a) {
	"use strict";
	var b = window.Slick || {};
	b = function () {
		function c(c, d) {
			var f, g, e = this;
			if (e.defaults = {
				accessibility: !0,
				adaptiveHeight: !1,
				appendArrows: a(c),
				appendDots: a(c),
				arrows: !0,
				asNavFor: null,
				prevArrow: '<button type="button" data-role="none" class="slick-prev">Previous</button>',
				nextArrow: '<button type="button" data-role="none" class="slick-next">Next</button>',
				autoplay: !1,
				autoplaySpeed: 3e3,
				centerMode: !1,
				centerPadding: "50px",
				cssEase: "ease",
				customPaging: function (a, b) {return '<button type="button" data-role="none">' + (b + 1) + "</button>";},
				dots: !1,
				dotsClass: "slick-dots",
				draggable: !0,
				easing: "linear",
				fade: !1,
				focusOnSelect: !1,
				infinite: !0,
				initialSlide: 0,
				lazyLoad: "ondemand",
				onBeforeChange: null,
				onAfterChange: null,
				onInit: null,
				onReInit: null,
				onSetPosition: null,
				pauseOnHover: !0,
				pauseOnDotsHover: !1,
				respondTo: "window",
				responsive: null,
				rtl: !1,
				slide: "div",
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 500,
				swipe: !0,
				swipeToSlide: !1,
				touchMove: !0,
				touchThreshold: 5,
				useCSS: !0,
				variableWidth: !1,
				vertical: !1,
				waitForAnimate: !0
			}, e.initials = {
				animating: !1,
				dragging: !1,
				autoPlayTimer: null,
				currentDirection: 0,
				currentLeft: null,
				currentSlide: 0,
				direction: 1,
				$dots: null,
				listWidth: null,
				listHeight: null,
				loadIndex: 0,
				$nextArrow: null,
				$prevArrow: null,
				slideCount: null,
				slideWidth: null,
				$slideTrack: null,
				$slides: null,
				sliding: !1,
				slideOffset: 0,
				swipeLeft: null,
				$list: null,
				touchObject: {},
				transformsEnabled: !1
			}, a.extend(e, e.initials), e.activeBreakpoint = null, e.animType = null, e.animProp = null, e.breakpoints = [], e.breakpointSettings = [], e.cssTransitions = !1, e.paused = !1, e.positionProp = null, e.respondTo = null, e.shouldClick = !0, e.$slider = a(c), e.$slidesCache = null, e.transformType = null, e.transitionType = null, e.windowWidth = 0, e.windowTimer = null, e.options = a.extend({}, e.defaults, d), e.currentSlide = e.options.initialSlide, e.originalSettings = e.options, f = e.options.responsive || null, f && f.length > -1) {
				e.respondTo = e.options.respondTo || "window";
				for (g in f) f.hasOwnProperty(g) && (e.breakpoints.push(f[g].breakpoint), e.breakpointSettings[f[g].breakpoint] = f[g].settings);
				e.breakpoints.sort(function (a, b) {return b - a;});
			}
			e.autoPlay = a.proxy(e.autoPlay, e), e.autoPlayClear = a.proxy(e.autoPlayClear, e), e.changeSlide = a.proxy(e.changeSlide, e), e.clickHandler = a.proxy(e.clickHandler, e), e.selectHandler = a.proxy(e.selectHandler, e), e.setPosition = a.proxy(e.setPosition, e), e.swipeHandler = a.proxy(e.swipeHandler, e), e.dragHandler = a.proxy(e.dragHandler, e), e.keyHandler = a.proxy(e.keyHandler, e), e.autoPlayIterator = a.proxy(e.autoPlayIterator, e), e.instanceUid = b++, e.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, e.init(), e.checkResponsive();
		}

		var b = 0;
		return c;
	}(), b.prototype.addSlide = function (b, c, d) {
		var e = this;
		if ("boolean" == typeof c) d = c, c = null; else if (0 > c || c >= e.slideCount) return !1;
		e.unload(), "number" == typeof c ? 0 === c && 0 === e.$slides.length ? a(b).appendTo(e.$slideTrack) : d ? a(b).insertBefore(e.$slides.eq(c)) : a(b).insertAfter(e.$slides.eq(c)) : d === !0 ? a(b).prependTo(e.$slideTrack) : a(b).appendTo(e.$slideTrack), e.$slides = e.$slideTrack.children(this.options.slide), e.$slideTrack.children(this.options.slide).detach(), e.$slideTrack.append(e.$slides), e.$slides.each(function (b, c) {a(c).attr("index", b);}), e.$slidesCache = e.$slides, e.reinit();
	}, b.prototype.animateSlide = function (b, c) {
		var d = {}, e = this;
		if (1 === e.options.slidesToShow && e.options.adaptiveHeight === !0 && e.options.vertical === !1) {
			var f = e.$slides.eq(e.currentSlide).outerHeight(!0);
			e.$list.animate({height: f}, e.options.speed);
		}
		e.options.rtl === !0 && e.options.vertical === !1 && (b = -b), e.transformsEnabled === !1 ? e.options.vertical === !1 ? e.$slideTrack.animate({left: b}, e.options.speed, e.options.easing, c) : e.$slideTrack.animate({top: b}, e.options.speed, e.options.easing, c) : e.cssTransitions === !1 ? a({animStart: e.currentLeft}).animate({animStart: b}, {
			duration: e.options.speed,
			easing: e.options.easing,
			step: function (a) {e.options.vertical === !1 ? (d[e.animType] = "translate(" + a + "px, 0px)", e.$slideTrack.css(d)) : (d[e.animType] = "translate(0px," + a + "px)", e.$slideTrack.css(d));},
			complete: function () {c && c.call();}
		}) : (e.applyTransition(), d[e.animType] = e.options.vertical === !1 ? "translate3d(" + b + "px, 0px, 0px)" : "translate3d(0px," + b + "px, 0px)", e.$slideTrack.css(d), c && setTimeout(function () {e.disableTransition(), c.call();}, e.options.speed));
	}, b.prototype.asNavFor = function (b) {
		var c = this, d = null != c.options.asNavFor ? a(c.options.asNavFor).getSlick() : null;
		null != d && d.slideHandler(b, !0);
	}, b.prototype.applyTransition = function (a) {
		var b = this, c = {};
		c[b.transitionType] = b.options.fade === !1 ? b.transformType + " " + b.options.speed + "ms " + b.options.cssEase : "opacity " + b.options.speed + "ms " + b.options.cssEase, b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c);
	}, b.prototype.autoPlay = function () {
		var a = this;
		a.autoPlayTimer && clearInterval(a.autoPlayTimer), a.slideCount > a.options.slidesToShow && a.paused !== !0 && (a.autoPlayTimer = setInterval(a.autoPlayIterator, a.options.autoplaySpeed));
	}, b.prototype.autoPlayClear = function () {
		var a = this;
		a.autoPlayTimer && clearInterval(a.autoPlayTimer);
	}, b.prototype.autoPlayIterator = function () {
		var a = this;
		a.options.infinite === !1 ? 1 === a.direction ? (a.currentSlide + 1 === a.slideCount - 1 && (a.direction = 0), a.slideHandler(a.currentSlide + a.options.slidesToScroll)) : (0 === a.currentSlide - 1 && (a.direction = 1), a.slideHandler(a.currentSlide - a.options.slidesToScroll)) : a.slideHandler(a.currentSlide + a.options.slidesToScroll);
	}, b.prototype.buildArrows = function () {
		var b = this;
		b.options.arrows === !0 && b.slideCount > b.options.slidesToShow && (b.$prevArrow = a(b.options.prevArrow), b.$nextArrow = a(b.options.nextArrow), b.htmlExpr.test(b.options.prevArrow) && b.$prevArrow.appendTo(b.options.appendArrows), b.htmlExpr.test(b.options.nextArrow) && b.$nextArrow.appendTo(b.options.appendArrows), b.options.infinite !== !0 && b.$prevArrow.addClass("slick-disabled"));
	}, b.prototype.buildDots = function () {
		var c, d, b = this;
		if (b.options.dots === !0 && b.slideCount > b.options.slidesToShow) {
			for (d = '<ul class="' + b.options.dotsClass + '">', c = 0; c <= b.getDotCount(); c += 1) d += "<li>" + b.options.customPaging.call(this, b, c) + "</li>";
			d += "</ul>", b.$dots = a(d).appendTo(b.options.appendDots), b.$dots.find("li").first().addClass("slick-active");
		}
	}, b.prototype.buildOut = function () {
		var b = this;
		b.$slides = b.$slider.children(b.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), b.slideCount = b.$slides.length, b.$slides.each(function (b, c) {a(c).attr("index", b);}), b.$slidesCache = b.$slides, b.$slider.addClass("slick-slider"), b.$slideTrack = 0 === b.slideCount ? a('<div class="slick-track"/>').appendTo(b.$slider) : b.$slides.wrapAll('<div class="slick-track"/>').parent(), b.$list = b.$slideTrack.wrap('<div class="slick-list"/>').parent(), b.$slideTrack.css("opacity", 0), b.options.centerMode === !0 && (b.options.slidesToScroll = 1), a("img[data-lazy]", b.$slider).not("[src]").addClass("slick-loading"), b.setupInfinite(), b.buildArrows(), b.buildDots(), b.updateDots(), b.options.accessibility === !0 && b.$list.prop("tabIndex", 0), b.setSlideClasses("number" == typeof this.currentSlide ? this.currentSlide : 0), b.options.draggable === !0 && b.$list.addClass("draggable");
	}, b.prototype.checkResponsive = function () {
		var c, d, e, b = this, f = b.$slider.width(), g = window.innerWidth || a(window).width();
		if ("window" === b.respondTo ? e = g : "slider" === b.respondTo ? e = f : "min" === b.respondTo && (e = Math.min(g, f)), b.originalSettings.responsive && b.originalSettings.responsive.length > -1 && null !== b.originalSettings.responsive) {
			d = null;
			for (c in b.breakpoints) b.breakpoints.hasOwnProperty(c) && e < b.breakpoints[c] && (d = b.breakpoints[c]);
			null !== d ? null !== b.activeBreakpoint ? d !== b.activeBreakpoint && (b.activeBreakpoint = d, b.options = a.extend({}, b.originalSettings, b.breakpointSettings[d]), b.refresh()) : (b.activeBreakpoint = d, b.options = a.extend({}, b.originalSettings, b.breakpointSettings[d]), b.refresh()) : null !== b.activeBreakpoint && (b.activeBreakpoint = null, b.options = b.originalSettings, b.refresh());
		}
	}, b.prototype.changeSlide = function (b, c) {
		var f, g, h, i, j, d = this, e = a(b.target);
		switch (e.is("a") && b.preventDefault(), h = 0 !== d.slideCount % d.options.slidesToScroll, f = h ? 0 : (d.slideCount - d.currentSlide) % d.options.slidesToScroll, b.data.message) {
			case"previous":
				g = 0 === f ? d.options.slidesToScroll : d.options.slidesToShow - f, d.slideCount > d.options.slidesToShow && d.slideHandler(d.currentSlide - g, !1, c);
				break;
			case"next":
				g = 0 === f ? d.options.slidesToScroll : f, d.slideCount > d.options.slidesToShow && d.slideHandler(d.currentSlide + g, !1, c);
				break;
			case"index":
				var k = 0 === b.data.index ? 0 : b.data.index || a(b.target).parent().index() * d.options.slidesToScroll;
				if (i = d.getNavigableIndexes(), j = 0, i[k] && i[k] === k) if (k > i[i.length - 1]) k = i[i.length - 1]; else for (var l in i) {
					if (k < i[l]) {
						k = j;
						break;
					}
					j = i[l];
				}
				d.slideHandler(k, !1, c);
			default:
				return;
		}
	}, b.prototype.clickHandler = function (a) {
		var b = this;
		b.shouldClick === !1 && (a.stopImmediatePropagation(), a.stopPropagation(), a.preventDefault());
	}, b.prototype.destroy = function () {
		var b = this;
		b.autoPlayClear(), b.touchObject = {}, a(".slick-cloned", b.$slider).remove(), b.$dots && b.$dots.remove(), b.$prevArrow && "object" != typeof b.options.prevArrow && b.$prevArrow.remove(), b.$nextArrow && "object" != typeof b.options.nextArrow && b.$nextArrow.remove(), b.$slides.parent().hasClass("slick-track") && b.$slides.unwrap().unwrap(), b.$slides.removeClass("slick-slide slick-active slick-center slick-visible").removeAttr("index").css({
			position: "",
			left: "",
			top: "",
			zIndex: "",
			opacity: "",
			width: ""
		}), b.$slider.removeClass("slick-slider"), b.$slider.removeClass("slick-initialized"), b.$list.off(".slick"), a(window).off(".slick-" + b.instanceUid), a(document).off(".slick-" + b.instanceUid);
	}, b.prototype.disableTransition = function (a) {
		var b = this, c = {};
		c[b.transitionType] = "", b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c);
	}, b.prototype.fadeSlide = function (a, b, c) {
		var d = this;
		d.cssTransitions === !1 ? (d.$slides.eq(b).css({zIndex: 1e3}), d.$slides.eq(b).animate({opacity: 1}, d.options.speed, d.options.easing, c), d.$slides.eq(a).animate({opacity: 0}, d.options.speed, d.options.easing)) : (d.applyTransition(b), d.applyTransition(a), d.$slides.eq(b).css({
			opacity: 1,
			zIndex: 1e3
		}), d.$slides.eq(a).css({opacity: 0}), c && setTimeout(function () {d.disableTransition(b), d.disableTransition(a), c.call();}, d.options.speed));
	}, b.prototype.filterSlides = function (a) {
		var b = this;
		null !== a && (b.unload(), b.$slideTrack.children(this.options.slide).detach(), b.$slidesCache.filter(a).appendTo(b.$slideTrack), b.reinit());
	}, b.prototype.getCurrent = function () {
		var a = this;
		return a.currentSlide;
	}, b.prototype.getDotCount = function () {
		var a = this, b = 0, c = 0, d = 0;
		if (a.options.infinite === !0) d = Math.ceil(a.slideCount / a.options.slidesToScroll); else for (; b < a.slideCount;) ++d, b = c + a.options.slidesToShow, c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow;
		return d - 1;
	}, b.prototype.getLeft = function (a) {
		var c, d, g, b = this, e = 0;
		return b.slideOffset = 0, d = b.$slides.first().outerHeight(), b.options.infinite === !0 ? (b.slideCount > b.options.slidesToShow && (b.slideOffset = -1 * b.slideWidth * b.options.slidesToShow, e = -1 * d * b.options.slidesToShow), 0 !== b.slideCount % b.options.slidesToScroll && a + b.options.slidesToScroll > b.slideCount && b.slideCount > b.options.slidesToShow && (a > b.slideCount ? (b.slideOffset = -1 * (b.options.slidesToShow - (a - b.slideCount)) * b.slideWidth, e = -1 * (b.options.slidesToShow - (a - b.slideCount)) * d) : (b.slideOffset = -1 * b.slideCount % b.options.slidesToScroll * b.slideWidth, e = -1 * b.slideCount % b.options.slidesToScroll * d))) : a + b.options.slidesToShow > b.slideCount && (b.slideOffset = (a + b.options.slidesToShow - b.slideCount) * b.slideWidth, e = (a + b.options.slidesToShow - b.slideCount) * d), b.slideCount <= b.options.slidesToShow && (b.slideOffset = 0, e = 0), b.options.centerMode === !0 && b.options.infinite === !0 ? b.slideOffset += b.slideWidth * Math.floor(b.options.slidesToShow / 2) - b.slideWidth : b.options.centerMode === !0 && (b.slideOffset = 0, b.slideOffset += b.slideWidth * Math.floor(b.options.slidesToShow / 2)), c = b.options.vertical === !1 ? -1 * a * b.slideWidth + b.slideOffset : -1 * a * d + e, b.options.variableWidth === !0 && (g = b.slideCount <= b.options.slidesToShow || b.options.infinite === !1 ? b.$slideTrack.children(".slick-slide").eq(a) : b.$slideTrack.children(".slick-slide").eq(a + b.options.slidesToShow), c = g[0] ? -1 * g[0].offsetLeft : 0, b.options.centerMode === !0 && (g = b.options.infinite === !1 ? b.$slideTrack.children(".slick-slide").eq(a) : b.$slideTrack.children(".slick-slide").eq(a + b.options.slidesToShow + 1), c = g[0] ? -1 * g[0].offsetLeft : 0, c += (b.$list.width() - g.outerWidth()) / 2)), c;
	}, b.prototype.getNavigableIndexes = function () {
		for (var a = this, b = 0, c = 0, d = []; b < a.slideCount;) d.push(b), b = c + a.options.slidesToScroll, c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow;
		return d;
	}, b.prototype.getSlideCount = function () {
		var c, b = this;
		if (b.options.swipeToSlide === !0) {
			var d = null;
			return b.$slideTrack.find(".slick-slide").each(function (c, e) {return e.offsetLeft + a(e).outerWidth() / 2 > -1 * b.swipeLeft ? (d = e, !1) : void 0;}), c = Math.abs(a(d).attr("index") - b.currentSlide);
		}
		return b.options.slidesToScroll;
	}, b.prototype.init = function () {
		var b = this;
		a(b.$slider).hasClass("slick-initialized") || (a(b.$slider).addClass("slick-initialized"), b.buildOut(), b.setProps(), b.startLoad(), b.loadSlider(), b.initializeEvents(), b.updateArrows(), b.updateDots()), null !== b.options.onInit && b.options.onInit.call(this, b);
	}, b.prototype.initArrowEvents = function () {
		var a = this;
		a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.on("click.slick", {message: "previous"}, a.changeSlide), a.$nextArrow.on("click.slick", {message: "next"}, a.changeSlide));
	}, b.prototype.initDotEvents = function () {
		var b = this;
		b.options.dots === !0 && b.slideCount > b.options.slidesToShow && a("li", b.$dots).on("click.slick", {message: "index"}, b.changeSlide), b.options.dots === !0 && b.options.pauseOnDotsHover === !0 && b.options.autoplay === !0 && a("li", b.$dots).on("mouseenter.slick", function () {b.paused = !0, b.autoPlayClear();}).on("mouseleave.slick", function () {b.paused = !1, b.autoPlay();});
	}, b.prototype.initializeEvents = function () {
		var b = this;
		b.initArrowEvents(), b.initDotEvents(), b.$list.on("touchstart.slick mousedown.slick", {action: "start"}, b.swipeHandler), b.$list.on("touchmove.slick mousemove.slick", {action: "move"}, b.swipeHandler), b.$list.on("touchend.slick mouseup.slick", {action: "end"}, b.swipeHandler), b.$list.on("touchcancel.slick mouseleave.slick", {action: "end"}, b.swipeHandler), b.$list.on("click.slick", b.clickHandler), b.options.pauseOnHover === !0 && b.options.autoplay === !0 && (b.$list.on("mouseenter.slick", function () {b.paused = !0, b.autoPlayClear();}), b.$list.on("mouseleave.slick", function () {b.paused = !1, b.autoPlay();})), b.options.accessibility === !0 && b.$list.on("keydown.slick", b.keyHandler), b.options.focusOnSelect === !0 && a(b.options.slide, b.$slideTrack).on("click.slick", b.selectHandler), a(window).on("orientationchange.slick.slick-" + b.instanceUid, function () {b.checkResponsive(), b.setPosition();}), a(window).on("resize.slick.slick-" + b.instanceUid, function () {a(window).width() !== b.windowWidth && (clearTimeout(b.windowDelay), b.windowDelay = window.setTimeout(function () {b.windowWidth = a(window).width(), b.checkResponsive(), b.setPosition();}, 50));}), a("*[draggable!=true]", b.$slideTrack).on("dragstart", function (a) {a.preventDefault();}), a(window).on("load.slick.slick-" + b.instanceUid, b.setPosition), a(document).on("ready.slick.slick-" + b.instanceUid, b.setPosition);
	}, b.prototype.initUI = function () {
		var a = this;
		a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.show(), a.$nextArrow.show()), a.options.dots === !0 && a.slideCount > a.options.slidesToShow && a.$dots.show(), a.options.autoplay === !0 && a.autoPlay();
	}, b.prototype.keyHandler = function (a) {
		var b = this;
		37 === a.keyCode && b.options.accessibility === !0 ? b.changeSlide({data: {message: "previous"}}) : 39 === a.keyCode && b.options.accessibility === !0 && b.changeSlide({data: {message: "next"}});
	}, b.prototype.lazyLoad = function () {
		function g(b) {
			a("img[data-lazy]", b).each(function () {
				var b = a(this), c = a(this).attr("data-lazy");
				b.load(function () {b.animate({opacity: 1}, 200);}).css({opacity: 0}).attr("src", c).removeAttr("data-lazy").removeClass("slick-loading");
			});
		}

		var c, d, e, f, b = this;
		b.options.centerMode === !0 ? b.options.infinite === !0 ? (e = b.currentSlide + (b.options.slidesToShow / 2 + 1), f = e + b.options.slidesToShow + 2) : (e = Math.max(0, b.currentSlide - (b.options.slidesToShow / 2 + 1)), f = 2 + (b.options.slidesToShow / 2 + 1) + b.currentSlide) : (e = b.options.infinite ? b.options.slidesToShow + b.currentSlide : b.currentSlide, f = e + b.options.slidesToShow, b.options.fade === !0 && (e > 0 && e--, f <= b.slideCount && f++)), c = b.$slider.find(".slick-slide").slice(e, f), g(c), b.slideCount <= b.options.slidesToShow ? (d = b.$slider.find(".slick-slide"), g(d)) : b.currentSlide >= b.slideCount - b.options.slidesToShow ? (d = b.$slider.find(".slick-cloned").slice(0, b.options.slidesToShow), g(d)) : 0 === b.currentSlide && (d = b.$slider.find(".slick-cloned").slice(-1 * b.options.slidesToShow), g(d));
	}, b.prototype.loadSlider = function () {
		var a = this;
		a.setPosition(), a.$slideTrack.css({opacity: 1}), a.$slider.removeClass("slick-loading"), a.initUI(), "progressive" === a.options.lazyLoad && a.progressiveLazyLoad();
	}, b.prototype.postSlide = function (a) {
		var b = this;
		null !== b.options.onAfterChange && b.options.onAfterChange.call(this, b, a), b.animating = !1, b.setPosition(), b.swipeLeft = null, b.options.autoplay === !0 && b.paused === !1 && b.autoPlay();
	}, b.prototype.progressiveLazyLoad = function () {
		var c, d, b = this;
		c = a("img[data-lazy]", b.$slider).length, c > 0 && (d = a("img[data-lazy]", b.$slider).first(), d.attr("src", d.attr("data-lazy")).removeClass("slick-loading").load(function () {d.removeAttr("data-lazy"), b.progressiveLazyLoad();}).error(function () {d.removeAttr("data-lazy"), b.progressiveLazyLoad();}));
	}, b.prototype.refresh = function () {
		var b = this, c = b.currentSlide;
		b.destroy(), a.extend(b, b.initials), b.init(), b.changeSlide({data: {message: "index", index: c}}, !0);
	}, b.prototype.reinit = function () {
		var b = this;
		b.$slides = b.$slideTrack.children(b.options.slide).addClass("slick-slide"), b.slideCount = b.$slides.length, b.currentSlide >= b.slideCount && 0 !== b.currentSlide && (b.currentSlide = b.currentSlide - b.options.slidesToScroll), b.slideCount <= b.options.slidesToShow && (b.currentSlide = 0), b.setProps(), b.setupInfinite(), b.buildArrows(), b.updateArrows(), b.initArrowEvents(), b.buildDots(), b.updateDots(), b.initDotEvents(), b.options.focusOnSelect === !0 && a(b.options.slide, b.$slideTrack).on("click.slick", b.selectHandler), b.setSlideClasses(0), b.setPosition(), null !== b.options.onReInit && b.options.onReInit.call(this, b);
	}, b.prototype.removeSlide = function (a, b, c) {
		var d = this;
		return "boolean" == typeof a ? (b = a, a = b === !0 ? 0 : d.slideCount - 1) : a = b === !0 ? --a : a, d.slideCount < 1 || 0 > a || a > d.slideCount - 1 ? !1 : (d.unload(), c === !0 ? d.$slideTrack.children().remove() : d.$slideTrack.children(this.options.slide).eq(a).remove(), d.$slides = d.$slideTrack.children(this.options.slide), d.$slideTrack.children(this.options.slide).detach(), d.$slideTrack.append(d.$slides), d.$slidesCache = d.$slides, d.reinit(), void 0);
	}, b.prototype.setCSS = function (a) {
		var d, e, b = this, c = {};
		b.options.rtl === !0 && (a = -a), d = "left" == b.positionProp ? a + "px" : "0px", e = "top" == b.positionProp ? a + "px" : "0px", c[b.positionProp] = a, b.transformsEnabled === !1 ? b.$slideTrack.css(c) : (c = {}, b.cssTransitions === !1 ? (c[b.animType] = "translate(" + d + ", " + e + ")", b.$slideTrack.css(c)) : (c[b.animType] = "translate3d(" + d + ", " + e + ", 0px)", b.$slideTrack.css(c)));
	}, b.prototype.setDimensions = function () {
		var b = this;
		if (b.options.vertical === !1 ? b.options.centerMode === !0 && b.$list.css({padding: "0px " + b.options.centerPadding}) : (b.$list.height(b.$slides.first().outerHeight(!0) * b.options.slidesToShow), b.options.centerMode === !0 && b.$list.css({padding: b.options.centerPadding + " 0px"})), b.listWidth = b.$list.width(), b.listHeight = b.$list.height(), b.options.vertical === !1 && b.options.variableWidth === !1) b.slideWidth = Math.ceil(b.listWidth / b.options.slidesToShow), b.$slideTrack.width(Math.ceil(b.slideWidth * b.$slideTrack.children(".slick-slide").length)); else if (b.options.variableWidth === !0) {
			var c = 0;
			b.slideWidth = Math.ceil(b.listWidth / b.options.slidesToShow), b.$slideTrack.children(".slick-slide").each(function () {c += Math.ceil(a(this).outerWidth(!0));}), b.$slideTrack.width(Math.ceil(c) + 1);
		} else b.slideWidth = Math.ceil(b.listWidth), b.$slideTrack.height(Math.ceil(b.$slides.first().outerHeight(!0) * b.$slideTrack.children(".slick-slide").length));
		var d = b.$slides.first().outerWidth(!0) - b.$slides.first().width();
		b.options.variableWidth === !1 && b.$slideTrack.children(".slick-slide").width(b.slideWidth - d);
	}, b.prototype.setFade = function () {
		var c, b = this;
		b.$slides.each(function (d, e) {
			c = -1 * b.slideWidth * d, b.options.rtl === !0 ? a(e).css({
				position: "relative",
				right: c,
				top: 0,
				zIndex: 800,
				opacity: 0
			}) : a(e).css({position: "relative", left: c, top: 0, zIndex: 800, opacity: 0});
		}), b.$slides.eq(b.currentSlide).css({zIndex: 900, opacity: 1});
	}, b.prototype.setHeight = function () {
		var a = this;
		if (1 === a.options.slidesToShow && a.options.adaptiveHeight === !0 && a.options.vertical === !1) {
			var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
			a.$list.css("height", b);
		}
	}, b.prototype.setPosition = function () {
		var a = this;
		a.setDimensions(), a.setHeight(), a.options.fade === !1 ? a.setCSS(a.getLeft(a.currentSlide)) : a.setFade(), null !== a.options.onSetPosition && a.options.onSetPosition.call(this, a);
	}, b.prototype.setProps = function () {
		var a = this, b = document.body.style;
		a.positionProp = a.options.vertical === !0 ? "top" : "left", "top" === a.positionProp ? a.$slider.addClass("slick-vertical") : a.$slider.removeClass("slick-vertical"), (void 0 !== b.WebkitTransition || void 0 !== b.MozTransition || void 0 !== b.msTransition) && a.options.useCSS === !0 && (a.cssTransitions = !0), void 0 !== b.OTransform && (a.animType = "OTransform", a.transformType = "-o-transform", a.transitionType = "OTransition", void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)), void 0 !== b.MozTransform && (a.animType = "MozTransform", a.transformType = "-moz-transform", a.transitionType = "MozTransition", void 0 === b.perspectiveProperty && void 0 === b.MozPerspective && (a.animType = !1)), void 0 !== b.webkitTransform && (a.animType = "webkitTransform", a.transformType = "-webkit-transform", a.transitionType = "webkitTransition", void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)), void 0 !== b.msTransform && (a.animType = "msTransform", a.transformType = "-ms-transform", a.transitionType = "msTransition", void 0 === b.msTransform && (a.animType = !1)), void 0 !== b.transform && a.animType !== !1 && (a.animType = "transform", a.transformType = "transform", a.transitionType = "transition"), a.transformsEnabled = null !== a.animType && a.animType !== !1;
	}, b.prototype.setSlideClasses = function (a) {
		var c, d, e, f, b = this;
		b.$slider.find(".slick-slide").removeClass("slick-active").removeClass("slick-center"), d = b.$slider.find(".slick-slide"), b.options.centerMode === !0 ? (c = Math.floor(b.options.slidesToShow / 2), b.options.infinite === !0 && (a >= c && a <= b.slideCount - 1 - c ? b.$slides.slice(a - c, a + c + 1).addClass("slick-active") : (e = b.options.slidesToShow + a, d.slice(e - c + 1, e + c + 2).addClass("slick-active")), 0 === a ? d.eq(d.length - 1 - b.options.slidesToShow).addClass("slick-center") : a === b.slideCount - 1 && d.eq(b.options.slidesToShow).addClass("slick-center")), b.$slides.eq(a).addClass("slick-center")) : a >= 0 && a <= b.slideCount - b.options.slidesToShow ? b.$slides.slice(a, a + b.options.slidesToShow).addClass("slick-active") : d.length <= b.options.slidesToShow ? d.addClass("slick-active") : (f = b.slideCount % b.options.slidesToShow, e = b.options.infinite === !0 ? b.options.slidesToShow + a : a, b.options.slidesToShow == b.options.slidesToScroll && b.slideCount - a < b.options.slidesToShow ? d.slice(e - (b.options.slidesToShow - f), e + f).addClass("slick-active") : d.slice(e, e + b.options.slidesToShow).addClass("slick-active")), "ondemand" === b.options.lazyLoad && b.lazyLoad();
	}, b.prototype.setupInfinite = function () {
		var c, d, e, b = this;
		if (b.options.fade === !0 && (b.options.centerMode = !1), b.options.infinite === !0 && b.options.fade === !1 && (d = null, b.slideCount > b.options.slidesToShow)) {
			for (e = b.options.centerMode === !0 ? b.options.slidesToShow + 1 : b.options.slidesToShow, c = b.slideCount; c > b.slideCount - e; c -= 1) d = c - 1, a(b.$slides[d]).clone(!0).attr("id", "").attr("index", d - b.slideCount).prependTo(b.$slideTrack).addClass("slick-cloned");
			for (c = 0; e > c; c += 1) d = c, a(b.$slides[d]).clone(!0).attr("id", "").attr("index", d + b.slideCount).appendTo(b.$slideTrack).addClass("slick-cloned");
			b.$slideTrack.find(".slick-cloned").find("[id]").each(function () {a(this).attr("id", "");});
		}
	}, b.prototype.selectHandler = function (b) {
		var c = this, d = parseInt(a(b.target).parents(".slick-slide").attr("index"));
		return d || (d = 0), c.slideCount <= c.options.slidesToShow ? (c.$slider.find(".slick-slide").removeClass("slick-active"), c.$slides.eq(d).addClass("slick-active"), c.options.centerMode === !0 && (c.$slider.find(".slick-slide").removeClass("slick-center"), c.$slides.eq(d).addClass("slick-center")), c.asNavFor(d), void 0) : (c.slideHandler(d), void 0);
	}, b.prototype.slideHandler = function (a, b, c) {
		var d, e, f, g, i = null, j = this;
		return b = b || !1, j.animating === !0 && j.options.waitForAnimate === !0 || j.options.fade === !0 && j.currentSlide === a || j.slideCount <= j.options.slidesToShow ? void 0 : (b === !1 && j.asNavFor(a), d = a, i = j.getLeft(d), g = j.getLeft(j.currentSlide), j.currentLeft = null === j.swipeLeft ? g : j.swipeLeft, j.options.infinite === !1 && j.options.centerMode === !1 && (0 > a || a > j.getDotCount() * j.options.slidesToScroll) ? (j.options.fade === !1 && (d = j.currentSlide, c !== !0 ? j.animateSlide(g, function () {j.postSlide(d);}) : j.postSlide(d)), void 0) : j.options.infinite === !1 && j.options.centerMode === !0 && (0 > a || a > j.slideCount - j.options.slidesToScroll) ? (j.options.fade === !1 && (d = j.currentSlide, c !== !0 ? j.animateSlide(g, function () {j.postSlide(d);}) : j.postSlide(d)), void 0) : (j.options.autoplay === !0 && clearInterval(j.autoPlayTimer), e = 0 > d ? 0 !== j.slideCount % j.options.slidesToScroll ? j.slideCount - j.slideCount % j.options.slidesToScroll : j.slideCount + d : d >= j.slideCount ? 0 !== j.slideCount % j.options.slidesToScroll ? 0 : d - j.slideCount : d, j.animating = !0, null !== j.options.onBeforeChange && a !== j.currentSlide && j.options.onBeforeChange.call(this, j, j.currentSlide, e), f = j.currentSlide, j.currentSlide = e, j.setSlideClasses(j.currentSlide), j.updateDots(), j.updateArrows(), j.options.fade === !0 ? (c !== !0 ? j.fadeSlide(f, e, function () {j.postSlide(e);}) : j.postSlide(e), void 0) : (c !== !0 ? j.animateSlide(i, function () {j.postSlide(e);}) : j.postSlide(e), void 0)));
	}, b.prototype.startLoad = function () {
		var a = this;
		a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.hide(), a.$nextArrow.hide()), a.options.dots === !0 && a.slideCount > a.options.slidesToShow && a.$dots.hide(), a.$slider.addClass("slick-loading");
	}, b.prototype.swipeDirection = function () {
		var a, b, c, d, e = this;
		return a = e.touchObject.startX - e.touchObject.curX, b = e.touchObject.startY - e.touchObject.curY, c = Math.atan2(b, a), d = Math.round(180 * c / Math.PI), 0 > d && (d = 360 - Math.abs(d)), 45 >= d && d >= 0 ? e.options.rtl === !1 ? "left" : "right" : 360 >= d && d >= 315 ? e.options.rtl === !1 ? "left" : "right" : d >= 135 && 225 >= d ? e.options.rtl === !1 ? "right" : "left" : "vertical";
	}, b.prototype.swipeEnd = function () {
		var b = this;
		if (b.dragging = !1, b.shouldClick = b.touchObject.swipeLength > 10 ? !1 : !0, void 0 === b.touchObject.curX) return !1;
		if (b.touchObject.swipeLength >= b.touchObject.minSwipe) switch (b.swipeDirection()) {
			case"left":
				b.slideHandler(b.currentSlide + b.getSlideCount()), b.currentDirection = 0, b.touchObject = {};
				break;
			case"right":
				b.slideHandler(b.currentSlide - b.getSlideCount()), b.currentDirection = 1, b.touchObject = {};
		} else b.touchObject.startX !== b.touchObject.curX && (b.slideHandler(b.currentSlide), b.touchObject = {});
	}, b.prototype.swipeHandler = function (a) {
		var b = this;
		if (!(b.options.swipe === !1 || "ontouchend" in document && b.options.swipe === !1 || b.options.draggable === !1 && -1 !== a.type.indexOf("mouse"))) switch (b.touchObject.fingerCount = a.originalEvent && void 0 !== a.originalEvent.touches ? a.originalEvent.touches.length : 1, b.touchObject.minSwipe = b.listWidth / b.options.touchThreshold, a.data.action) {
			case"start":
				b.swipeStart(a);
				break;
			case"move":
				b.swipeMove(a);
				break;
			case"end":
				b.swipeEnd(a);
		}
	}, b.prototype.swipeMove = function (a) {
		var c, d, e, f, b = this;
		return f = void 0 !== a.originalEvent ? a.originalEvent.touches : null, !b.dragging || f && 1 !== f.length ? !1 : (c = b.getLeft(b.currentSlide), b.touchObject.curX = void 0 !== f ? f[0].pageX : a.clientX, b.touchObject.curY = void 0 !== f ? f[0].pageY : a.clientY, b.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(b.touchObject.curX - b.touchObject.startX, 2))), d = b.swipeDirection(), "vertical" !== d ? (void 0 !== a.originalEvent && b.touchObject.swipeLength > 4 && a.preventDefault(), e = (b.options.rtl === !1 ? 1 : -1) * (b.touchObject.curX > b.touchObject.startX ? 1 : -1), b.swipeLeft = b.options.vertical === !1 ? c + b.touchObject.swipeLength * e : c + b.touchObject.swipeLength * (b.$list.height() / b.listWidth) * e, b.options.fade === !0 || b.options.touchMove === !1 ? !1 : b.animating === !0 ? (b.swipeLeft = null, !1) : (b.setCSS(b.swipeLeft), void 0)) : void 0);
	}, b.prototype.swipeStart = function (a) {
		var c, b = this;
		return 1 !== b.touchObject.fingerCount || b.slideCount <= b.options.slidesToShow ? (b.touchObject = {}, !1) : (void 0 !== a.originalEvent && void 0 !== a.originalEvent.touches && (c = a.originalEvent.touches[0]), b.touchObject.startX = b.touchObject.curX = void 0 !== c ? c.pageX : a.clientX, b.touchObject.startY = b.touchObject.curY = void 0 !== c ? c.pageY : a.clientY, b.dragging = !0, void 0);
	}, b.prototype.unfilterSlides = function () {
		var a = this;
		null !== a.$slidesCache && (a.unload(), a.$slideTrack.children(this.options.slide).detach(), a.$slidesCache.appendTo(a.$slideTrack), a.reinit());
	}, b.prototype.unload = function () {
		var b = this;
		a(".slick-cloned", b.$slider).remove(), b.$dots && b.$dots.remove(), b.$prevArrow && "object" != typeof b.options.prevArrow && b.$prevArrow.remove(), b.$nextArrow && "object" != typeof b.options.nextArrow && b.$nextArrow.remove(), b.$slides.removeClass("slick-slide slick-active slick-visible").css("width", "");
	}, b.prototype.updateArrows = function () {
		var b, a = this;
		b = Math.floor(a.options.slidesToShow / 2), a.options.arrows === !0 && a.options.infinite !== !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.removeClass("slick-disabled"), a.$nextArrow.removeClass("slick-disabled"), 0 === a.currentSlide ? (a.$prevArrow.addClass("slick-disabled"), a.$nextArrow.removeClass("slick-disabled")) : a.currentSlide >= a.slideCount - a.options.slidesToShow && a.options.centerMode === !1 ? (a.$nextArrow.addClass("slick-disabled"), a.$prevArrow.removeClass("slick-disabled")) : a.currentSlide > a.slideCount - a.options.slidesToShow + b && a.options.centerMode === !0 && (a.$nextArrow.addClass("slick-disabled"), a.$prevArrow.removeClass("slick-disabled")));
	}, b.prototype.updateDots = function () {
		var a = this;
		null !== a.$dots && (a.$dots.find("li").removeClass("slick-active"), a.$dots.find("li").eq(Math.floor(a.currentSlide / a.options.slidesToScroll)).addClass("slick-active"));
	}, a.fn.slick = function (a) {
		var c = this;
		return c.each(function (c, d) {d.slick = new b(d, a);});
	}, a.fn.slickAdd = function (a, b, c) {
		var d = this;
		return d.each(function (d, e) {e.slick.addSlide(a, b, c);});
	}, a.fn.slickCurrentSlide = function () {
		var a = this;
		return a.get(0).slick.getCurrent();
	}, a.fn.slickFilter = function (a) {
		var b = this;
		return b.each(function (b, c) {c.slick.filterSlides(a);});
	}, a.fn.slickGoTo = function (a, b) {
		var c = this;
		return c.each(function (c, d) {d.slick.changeSlide({data: {message: "index", index: parseInt(a)}}, b);});
	}, a.fn.slickNext = function () {
		var a = this;
		return a.each(function (a, b) {b.slick.changeSlide({data: {message: "next"}});});
	}, a.fn.slickPause = function () {
		var a = this;
		return a.each(function (a, b) {b.slick.autoPlayClear(), b.slick.paused = !0;});
	}, a.fn.slickPlay = function () {
		var a = this;
		return a.each(function (a, b) {b.slick.paused = !1, b.slick.autoPlay();});
	}, a.fn.slickPrev = function () {
		var a = this;
		return a.each(function (a, b) {b.slick.changeSlide({data: {message: "previous"}});});
	}, a.fn.slickRemove = function (a, b) {
		var c = this;
		return c.each(function (c, d) {d.slick.removeSlide(a, b);});
	}, a.fn.slickRemoveAll = function () {
		var a = this;
		return a.each(function (a, b) {b.slick.removeSlide(null, null, !0);});
	}, a.fn.slickGetOption = function (a) {
		var b = this;
		return b.get(0).slick.options[a];
	}, a.fn.slickSetOption = function (a, b, c) {
		var d = this;
		return d.each(function (d, e) {e.slick.options[a] = b, c === !0 && (e.slick.unload(), e.slick.reinit());});
	}, a.fn.slickUnfilter = function () {
		var a = this;
		return a.each(function (a, b) {b.slick.unfilterSlides();});
	}, a.fn.unslick = function () {
		var a = this;
		return a.each(function (a, b) {b.slick && b.slick.destroy();});
	}, a.fn.getSlick = function () {
		var a = null, b = this;
		return b.each(function (b, c) {a = c.slick;}), a;
	};
});
/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
!(function (a) {
	a.fn.prepareTransition = function () {
		return this.each(function () {
			var b = a(this);
			b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function () {b.removeClass("is-transitioning");});
			var c = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"];
			var d = 0;
			a.each(c, function (a, c) {d = parseFloat(b.css(c)) || d;});
			if (d != 0) {
				b.addClass("is-transitioning");
				b[0].offsetWidth;
			}
		});
	};
})(jQuery);


/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e, r, a) {
	var n = new RegExp("(" + r + "=).*?(&|$)"), c = e;
	return c = e.search(n) >= 0 ? e.replace(n, "$1" + a + "$2") : c + (c.indexOf("?") > 0 ? "&" : "?") + r + "=" + a;
};

/**
 * @license
 * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash core -o ./dist/lodash.core.js`
 */
;(function () {
	function n(n, t) {
		for (var r = -1, e = t.length, u = n.length; ++r < e;) n[u + r] = t[r];
		return n;
	}

	function t(n, t, r) {
		for (var e = -1, u = n.length; ++e < u;) {
			var o = n[e], i = t(o);
			if (null != i && (c === an ? i === i : r(i, c))) var c = i, f = o;
		}
		return f;
	}

	function r(n, t, r) {
		var e;
		return r(n, function (n, r, u) {return t(n, r, u) ? (e = n, false) : void 0;}), e;
	}

	function e(n, t, r, e, u) {return u(n, function (n, u, o) {r = e ? (e = false, n) : t(r, n, u, o);}), r;}

	function u(n, t) {return O(t, function (t) {return n[t];});}

	function o(n) {return n && n.Object === Object ? n : null;}

	function i(n) {
		return vn[n];
	}

	function c(n) {
		var t = false;
		if (null != n && typeof n.toString != "function") try {
			t = !!(n + "");
		} catch (r) {
		}
		return t;
	}

	function f(n, t) {return n = typeof n == "number" || hn.test(n) ? +n : -1, n > -1 && 0 == n % 1 && (null == t ? 9007199254740991 : t) > n;}

	function a(n) {
		if (Y(n) && !Pn(n)) {
			if (n instanceof l) return n;
			if (En.call(n, "__wrapped__")) {
				var t = new l(n.__wrapped__, n.__chain__);
				return t.__actions__ = N(n.__actions__), t;
			}
		}
		return new l(n);
	}

	function l(n, t) {this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!t;}

	function p(n, t, r, e) {
		var u;
		return (u = n === an) || (u = xn[r],
			u = (n === u || n !== n && u !== u) && !En.call(e, r)), u ? t : n;
	}

	function s(n) {return X(n) ? Fn(n) : {};}

	function h(n, t, r) {
		if (typeof n != "function") throw new TypeError("Expected a function");
		return setTimeout(function () {n.apply(an, r);}, t);
	}

	function v(n, t) {
		var r = true;
		return $n(n, function (n, e, u) {return r = !!t(n, e, u);}), r;
	}

	function y(n, t) {
		var r = [];
		return $n(n, function (n, e, u) {t(n, e, u) && r.push(n);}), r;
	}

	function _(t, r, e, u) {
		u || (u = []);
		for (var o = -1, i = t.length; ++o < i;) {
			var c = t[o];
			r > 0 && Y(c) && L(c) && (e || Pn(c) || K(c)) ? r > 1 ? _(c, r - 1, e, u) : n(u, c) : e || (u[u.length] = c);
		}
		return u;
	}

	function g(n, t) {return n && qn(n, t, en);}

	function b(n, t) {return y(t, function (t) {return Q(n[t]);});}

	function j(n, t, r, e, u) {return n === t ? true : null == n || null == t || !X(n) && !Y(t) ? n !== n && t !== t : m(n, t, j, r, e, u);}

	function m(n, t, r, e, u, o) {
		var i = Pn(n), f = Pn(t), a = "[object Array]", l = "[object Array]";
		i || (a = kn.call(n), "[object Arguments]" == a && (a = "[object Object]")), f || (l = kn.call(t), "[object Arguments]" == l && (l = "[object Object]"));
		var p = "[object Object]" == a && !c(n), f = "[object Object]" == l && !c(t);
		return !(l = a == l) || i || p ? 2 & u || (a = p && En.call(n, "__wrapped__"),
			f = f && En.call(t, "__wrapped__"), !a && !f) ? l ? (o || (o = []), (a = J(o, function (t) {return t[0] === n;})) && a[1] ? a[1] == t : (o.push([n, t]), t = (i ? I : q)(n, t, r, e, u, o), o.pop(), t)) : false : r(a ? n.value() : n, f ? t.value() : t, e, u, o) : $(n, t, a);
	}

	function d(n) {
		var t = typeof n;
		return "function" == t ? n : null == n ? cn : ("object" == t ? x : A)(n);
	}

	function w(n) {
		n = null == n ? n : Object(n);
		var t, r = [];
		for (t in n) r.push(t);
		return r;
	}

	function O(n, t) {
		var r = -1, e = L(n) ? Array(n.length) : [];
		return $n(n, function (n, u, o) {e[++r] = t(n, u, o);}), e;
	}

	function x(n) {
		var t = en(n);
		return function (r) {
			var e = t.length;
			if (null == r) return !e;
			for (r = Object(r); e--;) {
				var u = t[e];
				if (!(u in r && j(n[u], r[u], an, 3))) return false;
			}
			return true;
		};
	}

	function E(n, t) {return n = Object(n), P(t, function (t, r) {return r in n && (t[r] = n[r]), t;}, {});}

	function A(n) {return function (t) {return null == t ? an : t[n];};}

	function k(n, t, r) {
		var e = -1, u = n.length;
		for (0 > t && (t = -t > u ? 0 : u + t), r = r > u ? u : r, 0 > r && (r += u), u = t > r ? 0 : r - t >>> 0, t >>>= 0, r = Array(u); ++e < u;) r[e] = n[e + t];
		return r;
	}

	function N(n) {return k(n, 0, n.length);}

	function S(n, t) {
		var r;
		return $n(n, function (n, e, u) {
			return r = t(n, e, u),
				!r;
		}), !!r;
	}

	function T(t, r) {return P(r, function (t, r) {return r.func.apply(r.thisArg, n([t], r.args));}, t);}

	function F(n, t, r, e) {
		r || (r = {});
		for (var u = -1, o = t.length; ++u < o;) {
			var i = t[u], c = e ? e(r[i], n[i], i, r, n) : n[i], f = r, a = f[i];
			En.call(f, i) && (a === c || a !== a && c !== c) && (c !== an || i in f) || (f[i] = c);
		}
		return r;
	}

	function R(n) {
		return V(function (t, r) {
			var e = -1, u = r.length, o = u > 1 ? r[u - 1] : an, o = typeof o == "function" ? (u--, o) : an;
			for (t = Object(t); ++e < u;) {
				var i = r[e];
				i && n(t, i, e, o);
			}
			return t;
		});
	}

	function B(n) {
		return function () {
			var t = arguments, r = s(n.prototype), t = n.apply(r, t);
			return X(t) ? t : r;
		};
	}

	function D(n, t, r) {
		function e() {
			for (var o = -1, i = arguments.length, c = -1, f = r.length, a = Array(f + i), l = this && this !== wn && this instanceof e ? u : n; ++c < f;) a[c] = r[c];
			for (; i--;) a[c++] = arguments[++o];
			return l.apply(t, a);
		}

		if (typeof n != "function") throw new TypeError("Expected a function");
		var u = B(n);
		return e;
	}

	function I(n, t, r, e, u, o) {
		var i = -1, c = 1 & u, f = n.length, a = t.length;
		if (f != a && !(2 & u && a > f)) return false;
		for (a = true; ++i < f;) {
			var l = n[i], p = t[i];
			if (void 0 !== an) {
				a = false;
				break;
			}
			if (c) {
				if (!S(t, function (n) {
					return l === n || r(l, n, e, u, o);
				})) {
					a = false;
					break;
				}
			} else if (l !== p && !r(l, p, e, u, o)) {
				a = false;
				break;
			}
		}
		return a;
	}

	function $(n, t, r) {
		switch (r) {
			case"[object Boolean]":
			case"[object Date]":
				return +n == +t;
			case"[object Error]":
				return n.name == t.name && n.message == t.message;
			case"[object Number]":
				return n != +n ? t != +t : n == +t;
			case"[object RegExp]":
			case"[object String]":
				return n == t + "";
		}
		return false;
	}

	function q(n, t, r, e, u, o) {
		var i = 2 & u, c = en(n), f = c.length, a = en(t).length;
		if (f != a && !i) return false;
		for (var l = f; l--;) {
			var p = c[l];
			if (!(i ? p in t : En.call(t, p))) return false;
		}
		for (a = true; ++l < f;) {
			var p = c[l], s = n[p], h = t[p];
			if (void 0 !== an || s !== h && !r(s, h, e, u, o)) {
				a = false;
				break;
			}
			i || (i = "constructor" == p);
		}
		return a && !i && (r = n.constructor, e = t.constructor, r != e && "constructor" in n && "constructor" in t && !(typeof r == "function" && r instanceof r && typeof e == "function" && e instanceof e) && (a = false)), a;
	}

	function z(n) {
		var t = n ? n.length : an;
		if (W(t) && (Pn(n) || nn(n) || K(n))) {
			n = String;
			for (var r = -1, e = Array(t); ++r < t;) e[r] = n(r);
			t = e;
		} else t = null;
		return t;
	}

	function C(n) {
		var t = n && n.constructor, t = Q(t) && t.prototype || xn;
		return n === t;
	}

	function G(n) {
		return n ? n[0] : an;
	}

	function J(n, t) {return r(n, d(t), $n);}

	function M(n, t) {return $n(n, typeof t == "function" ? t : cn);}

	function P(n, t, r) {return e(n, d(t), r, 3 > arguments.length, $n);}

	function U(n, t) {
		var r;
		if (typeof t != "function") throw new TypeError("Expected a function");
		return n = Un(n), function () {return 0 < --n && (r = t.apply(this, arguments)), 1 >= n && (t = an), r;};
	}

	function V(n) {
		var t;
		if (typeof n != "function") throw new TypeError("Expected a function");
		return t = In(t === an ? n.length - 1 : Un(t), 0), function () {
			for (var r = arguments, e = -1, u = In(r.length - t, 0), o = Array(u); ++e < u;) o[e] = r[t + e];
			for (u = Array(t + 1), e = -1; ++e < t;) u[e] = r[e];
			return u[t] = o, n.apply(this, u);
		};
	}

	function H(n, t) {return n > t;}

	function K(n) {return Y(n) && L(n) && En.call(n, "callee") && (!Rn.call(n, "callee") || "[object Arguments]" == kn.call(n));}

	function L(n) {return null != n && !(typeof n == "function" && Q(n)) && W(zn(n));}

	function Q(n) {return n = X(n) ? kn.call(n) : "", "[object Function]" == n || "[object GeneratorFunction]" == n;}

	function W(n) {return typeof n == "number" && n > -1 && 0 == n % 1 && 9007199254740991 >= n;}

	function X(n) {
		var t = typeof n;
		return !!n && ("object" == t || "function" == t);
	}

	function Y(n) {return !!n && typeof n == "object";}

	function Z(n) {return typeof n == "number" || Y(n) && "[object Number]" == kn.call(n);}

	function nn(n) {return typeof n == "string" || !Pn(n) && Y(n) && "[object String]" == kn.call(n);}

	function tn(n, t) {return t > n;}

	function rn(n) {return typeof n == "string" ? n : null == n ? "" : n + "";}

	function en(n) {
		var t = C(n);
		if (!t && !L(n)) return Dn(Object(n));
		var r, e = z(n), u = !!e, e = e || [], o = e.length;
		for (r in n) !En.call(n, r) || u && ("length" == r || f(r, o)) || t && "constructor" == r || e.push(r);
		return e;
	}

	function un(n) {
		for (var t = -1, r = C(n), e = w(n), u = e.length, o = z(n), i = !!o, o = o || [], c = o.length; ++t < u;) {
			var a = e[t];
			i && ("length" == a || f(a, c)) || "constructor" == a && (r || !En.call(n, a)) || o.push(a);
		}
		return o;
	}

	function on(n) {return n ? u(n, en(n)) : [];}

	function cn(n) {return n;}

	function fn(t, r, e) {
		var u = en(r), o = b(r, u);
		null != e || X(r) && (o.length || !u.length) || (e = r, r = t, t = this, o = b(r, en(r)));
		var i = X(e) && "chain" in e ? e.chain : true, c = Q(t);
		return $n(o, function (e) {
			var u = r[e];
			t[e] = u, c && (t.prototype[e] = function () {
				var r = this.__chain__;
				if (i || r) {
					var e = t(this.__wrapped__);
					return (e.__actions__ = N(this.__actions__)).push({
						func: u, args: arguments,
						thisArg: t
					}), e.__chain__ = r, e;
				}
				return u.apply(t, n([this.value()], arguments));
			});
		}), t;
	}

	var an, ln = 1 / 0, pn = /[&<>"'`]/g, sn = RegExp(pn.source), hn = /^(?:0|[1-9]\d*)$/,
		vn = {"&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "`": "&#96;"},
		yn = {"function": true, object: true}, _n = yn[typeof exports] && exports && !exports.nodeType ? exports : an,
		gn = yn[typeof module] && module && !module.nodeType ? module : an, bn = gn && gn.exports === _n ? _n : an,
		jn = o(yn[typeof self] && self), mn = o(yn[typeof window] && window), dn = o(yn[typeof this] && this),
		wn = o(_n && gn && typeof global == "object" && global) || mn !== (dn && dn.window) && mn || jn || dn || Function("return this")(),
		On = Array.prototype, xn = Object.prototype, En = xn.hasOwnProperty, An = 0, kn = xn.toString, Nn = wn._,
		Sn = wn.Reflect, Tn = Sn ? Sn.f : an, Fn = Object.create, Rn = xn.propertyIsEnumerable, Bn = wn.isFinite,
		Dn = Object.keys, In = Math.max, $n = function (n, t) {
			return function (r, e) {
				if (null == r) return r;
				if (!L(r)) return n(r, e);
				for (var u = r.length, o = t ? u : -1, i = Object(r); (t ? o-- : ++o < u) && false !== e(i[o], o, i);) ;
				return r;
			};
		}(g), qn = function (n) {
			return function (t, r, e) {
				var u = -1, o = Object(t);
				e = e(t);
				for (var i = e.length; i--;) {
					var c = e[n ? i : ++u];
					if (false === r(o[c], c, o)) break;
				}
				return t;
			};
		}();
	Tn && !Rn.call({valueOf: 1}, "valueOf") && (w = function (n) {
		n = Tn(n);
		for (var t, r = []; !(t = n.next()).done;) r.push(t.value);
		return r;
	});
	var zn = A("length"), Cn = V(function (t, r) {
			return Pn(t) || (t = null == t ? [] : [Object(t)]), _(r, 1),
				n(N(t), on);
		}), Gn = V(function (n, t, r) {return D(n, t, r);}), Jn = V(function (n, t) {return h(n, 1, t);}),
		Mn = V(function (n, t, r) {return h(n, Vn(t) || 0, r);}), Pn = Array.isArray, Un = Number, Vn = Number,
		Hn = R(function (n, t) {F(t, en(t), n);}), Kn = R(function (n, t) {F(t, un(t), n);}),
		Ln = R(function (n, t, r, e) {F(t, un(t), n, e);}), Qn = V(function (n) {return n.push(an, p), Ln.apply(an, n);}),
		Wn = V(function (n, t) {return null == n ? {} : E(n, _(t, 1));}), Xn = d;
	l.prototype = s(a.prototype), l.prototype.constructor = l, a.assignIn = Kn, a.before = U, a.bind = Gn, a.chain = function (n) {
		return n = a(n),
			n.__chain__ = true, n;
	}, a.compact = function (n) {return y(n, Boolean);}, a.concat = Cn, a.create = function (n, t) {
		var r = s(n);
		return t ? Hn(r, t) : r;
	}, a.defaults = Qn, a.defer = Jn, a.delay = Mn, a.filter = function (n, t) {return y(n, d(t));}, a.flatten = function (n) {return n && n.length ? _(n, 1) : [];}, a.flattenDeep = function (n) {return n && n.length ? _(n, ln) : [];}, a.iteratee = Xn, a.keys = en, a.map = function (n, t) {return O(n, d(t));}, a.matches = function (n) {return x(Hn({}, n));}, a.mixin = fn, a.negate = function (n) {
		if (typeof n != "function") throw new TypeError("Expected a function");
		return function () {return !n.apply(this, arguments);};
	}, a.once = function (n) {return U(2, n);}, a.pick = Wn, a.slice = function (n, t, r) {
		var e = n ? n.length : 0;
		return r = r === an ? e : +r, e ? k(n, null == t ? 0 : +t, r) : [];
	}, a.sortBy = function (n, t) {
		var r = 0;
		return t = d(t), O(O(n, function (n, e, u) {return {c: n, b: r++, a: t(n, e, u)};}).sort(function (n, t) {
			var r;
			n:{
				r = n.a;
				var e = t.a;
				if (r !== e) {
					var u = null === r, o = r === an, i = r === r, c = null === e, f = e === an, a = e === e;
					if (r > e && !c || !i || u && !f && a || o && a) {
						r = 1;
						break n;
					}
					if (e > r && !u || !a || c && !o && i || f && i) {
						r = -1;
						break n;
					}
				}
				r = 0;
			}
			return r || n.b - t.b;
		}), A("c"));
	}, a.tap = function (n, t) {return t(n), n;}, a.thru = function (n, t) {return t(n);}, a.toArray = function (n) {return L(n) ? n.length ? N(n) : [] : on(n);}, a.values = on, a.extend = Kn, fn(a, a), a.clone = function (n) {return X(n) ? Pn(n) ? N(n) : F(n, en(n)) : n;}, a.escape = function (n) {return (n = rn(n)) && sn.test(n) ? n.replace(pn, i) : n;}, a.every = function (n, t, r) {return t = r ? an : t, v(n, d(t));}, a.find = J, a.forEach = M, a.has = function (n, t) {return null != n && En.call(n, t);}, a.head = G, a.identity = cn, a.indexOf = function (n, t, r) {
		var e = n ? n.length : 0;
		r = typeof r == "number" ? 0 > r ? In(e + r, 0) : r : 0,
			r = (r || 0) - 1;
		for (var u = t === t; ++r < e;) {
			var o = n[r];
			if (u ? o === t : o !== o) return r;
		}
		return -1;
	}, a.isArguments = K, a.isArray = Pn, a.isBoolean = function (n) {return true === n || false === n || Y(n) && "[object Boolean]" == kn.call(n);}, a.isDate = function (n) {return Y(n) && "[object Date]" == kn.call(n);}, a.isEmpty = function (n) {
		if (L(n) && (Pn(n) || nn(n) || Q(n.splice) || K(n))) return !n.length;
		for (var t in n) if (En.call(n, t)) return false;
		return true;
	}, a.isEqual = function (n, t) {return j(n, t);}, a.isFinite = function (n) {return typeof n == "number" && Bn(n);}, a.isFunction = Q, a.isNaN = function (n) {
		return Z(n) && n != +n;
	}, a.isNull = function (n) {return null === n;}, a.isNumber = Z, a.isObject = X, a.isRegExp = function (n) {return X(n) && "[object RegExp]" == kn.call(n);}, a.isString = nn, a.isUndefined = function (n) {return n === an;}, a.last = function (n) {
		var t = n ? n.length : 0;
		return t ? n[t - 1] : an;
	}, a.max = function (n) {return n && n.length ? t(n, cn, H) : an;}, a.min = function (n) {return n && n.length ? t(n, cn, tn) : an;}, a.noConflict = function () {return wn._ === this && (wn._ = Nn), this;}, a.noop = function () {}, a.reduce = P, a.result = function (n, t, r) {
		return t = null == n ? an : n[t],
		t === an && (t = r), Q(t) ? t.call(n) : t;
	}, a.size = function (n) {return null == n ? 0 : (n = L(n) ? n : en(n), n.length);}, a.some = function (n, t, r) {return t = r ? an : t, S(n, d(t));}, a.uniqueId = function (n) {
		var t = ++An;
		return rn(n) + t;
	}, a.each = M, a.first = G, fn(a, function () {
		var n = {};
		return g(a, function (t, r) {En.call(a.prototype, r) || (n[r] = t);}), n;
	}(), {chain: false}), a.VERSION = "4.5.1", $n("pop join replace reverse split push shift sort splice unshift".split(" "), function (n) {
		var t = (/^(?:replace|split)$/.test(n) ? String.prototype : On)[n],
			r = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", e = /^(?:pop|join|replace|shift)$/.test(n);
		a.prototype[n] = function () {
			var n = arguments;
			return e && !this.__chain__ ? t.apply(this.value(), n) : this[r](function (r) {return t.apply(r, n);});
		};
	}), a.prototype.toJSON = a.prototype.valueOf = a.prototype.value = function () {return T(this.__wrapped__, this.__actions__);}, (mn || jn || {})._ = a, typeof define == "function" && typeof define.amd == "object" && define.amd ? define(function () {return a;}) : _n && gn ? (bn && ((gn.exports = a)._ = a), _n._ = a) : wn._ = a;
}).call(this);


/*! jQuery Validation Plugin - v1.19.1 - 6/15/2019
 * https://jqueryvalidation.org/
 * Copyright (c) 2019 Jörn Zaefferer; Licensed MIT */
!function (a) {
	"function" == typeof define && define.amd ? define(["jquery"], a) : "object" == typeof module && module.exports ? module.exports = a(require("jquery")) : a(jQuery);
}(function (a) {
	a.extend(a.fn, {
		validate: function (b) {
			if (!this.length) return void (b && b.debug && window.console && console.warn("Nothing selected, can't validate, returning nothing."));
			var c = a.data(this[0], "validator");
			return c ? c : (this.attr("novalidate", "novalidate"), c = new a.validator(b, this[0]), a.data(this[0], "validator", c), c.settings.onsubmit && (this.on("click.validate", ":submit", function (b) {
				c.submitButton = b.currentTarget, a(this).hasClass("cancel") && (c.cancelSubmit = !0), void 0 !== a(this).attr("formnovalidate") && (c.cancelSubmit = !0);
			}), this.on("submit.validate", function (b) {
				function d() {
					var d, e;
					return c.submitButton && (c.settings.submitHandler || c.formSubmitted) && (d = a("<input type='hidden'/>").attr("name", c.submitButton.name).val(a(c.submitButton).val()).appendTo(c.currentForm)), !(c.settings.submitHandler && !c.settings.debug) || (e = c.settings.submitHandler.call(c, c.currentForm, b), d && d.remove(), void 0 !== e && e);
				}

				return c.settings.debug && b.preventDefault(), c.cancelSubmit ? (c.cancelSubmit = !1, d()) : c.form() ? c.pendingRequest ? (c.formSubmitted = !0, !1) : d() : (c.focusInvalid(), !1);
			})), c);
		}, valid: function () {
			var b, c, d;
			return a(this[0]).is("form") ? b = this.validate().form() : (d = [], b = !0, c = a(this[0].form).validate(), this.each(function () {
				b = c.element(this) && b, b || (d = d.concat(c.errorList));
			}), c.errorList = d), b;
		}, rules: function (b, c) {
			var d, e, f, g, h, i, j = this[0],
				k = "undefined" != typeof this.attr("contenteditable") && "false" !== this.attr("contenteditable");
			if (null != j && (!j.form && k && (j.form = this.closest("form")[0], j.name = this.attr("name")), null != j.form)) {
				if (b) switch (d = a.data(j.form, "validator").settings, e = d.rules, f = a.validator.staticRules(j), b) {
					case"add":
						a.extend(f, a.validator.normalizeRule(c)), delete f.messages, e[j.name] = f, c.messages && (d.messages[j.name] = a.extend(d.messages[j.name], c.messages));
						break;
					case"remove":
						return c ? (i = {}, a.each(c.split(/\s/), function (a, b) {
							i[b] = f[b], delete f[b];
						}), i) : (delete e[j.name], f);
				}
				return g = a.validator.normalizeRules(a.extend({}, a.validator.classRules(j), a.validator.attributeRules(j), a.validator.dataRules(j), a.validator.staticRules(j)), j), g.required && (h = g.required, delete g.required, g = a.extend({required: h}, g)), g.remote && (h = g.remote, delete g.remote, g = a.extend(g, {remote: h})), g;
			}
		}
	}), a.extend(a.expr.pseudos || a.expr[":"], {
		blank: function (b) {
			return !a.trim("" + a(b).val());
		}, filled: function (b) {
			var c = a(b).val();
			return null !== c && !!a.trim("" + c);
		}, unchecked: function (b) {
			return !a(b).prop("checked");
		}
	}), a.validator = function (b, c) {
		this.settings = a.extend(!0, {}, a.validator.defaults, b), this.currentForm = c, this.init();
	}, a.validator.format = function (b, c) {
		return 1 === arguments.length ? function () {
			var c = a.makeArray(arguments);
			return c.unshift(b), a.validator.format.apply(this, c);
		} : void 0 === c ? b : (arguments.length > 2 && c.constructor !== Array && (c = a.makeArray(arguments).slice(1)), c.constructor !== Array && (c = [c]), a.each(c, function (a, c) {
			b = b.replace(new RegExp("\\{" + a + "\\}", "g"), function () {
				return c;
			});
		}), b);
	}, a.extend(a.validator, {
		defaults: {
			messages: {},
			groups: {},
			rules: {},
			errorClass: "error",
			pendingClass: "pending",
			validClass: "valid",
			errorElement: "label",
			focusCleanup: !1,
			focusInvalid: !0,
			errorContainer: a([]),
			errorLabelContainer: a([]),
			onsubmit: !0,
			ignore: ":hidden",
			ignoreTitle: !1,
			onfocusin: function (a) {
				this.lastActive = a, this.settings.focusCleanup && (this.settings.unhighlight && this.settings.unhighlight.call(this, a, this.settings.errorClass, this.settings.validClass), this.hideThese(this.errorsFor(a)));
			},
			onfocusout: function (a) {
				this.checkable(a) || !(a.name in this.submitted) && this.optional(a) || this.element(a);
			},
			onkeyup: function (b, c) {
				var d = [16, 17, 18, 20, 35, 36, 37, 38, 39, 40, 45, 144, 225];
				9 === c.which && "" === this.elementValue(b) || a.inArray(c.keyCode, d) !== -1 || (b.name in this.submitted || b.name in this.invalid) && this.element(b);
			},
			onclick: function (a) {
				a.name in this.submitted ? this.element(a) : a.parentNode.name in this.submitted && this.element(a.parentNode);
			},
			highlight: function (b, c, d) {
				"radio" === b.type ? this.findByName(b.name).addClass(c).removeClass(d) : a(b).addClass(c).removeClass(d);
			},
			unhighlight: function (b, c, d) {
				"radio" === b.type ? this.findByName(b.name).removeClass(c).addClass(d) : a(b).removeClass(c).addClass(d);
			}
		},
		setDefaults: function (b) {
			a.extend(a.validator.defaults, b);
		},
		messages: {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			equalTo: "Please enter the same value again.",
			maxlength: a.validator.format("Please enter no more than {0} characters."),
			minlength: a.validator.format("Please enter at least {0} characters."),
			rangelength: a.validator.format("Please enter a value between {0} and {1} characters long."),
			range: a.validator.format("Please enter a value between {0} and {1}."),
			max: a.validator.format("Please enter a value less than or equal to {0}."),
			min: a.validator.format("Please enter a value greater than or equal to {0}."),
			step: a.validator.format("Please enter a multiple of {0}.")
		},
		autoCreateRanges: !1,
		prototype: {
			init: function () {
				function b(b) {
					var c = "undefined" != typeof a(this).attr("contenteditable") && "false" !== a(this).attr("contenteditable");
					if (!this.form && c && (this.form = a(this).closest("form")[0], this.name = a(this).attr("name")), d === this.form) {
						var e = a.data(this.form, "validator"), f = "on" + b.type.replace(/^validate/, ""),
							g = e.settings;
						g[f] && !a(this).is(g.ignore) && g[f].call(e, this, b);
					}
				}

				this.labelContainer = a(this.settings.errorLabelContainer), this.errorContext = this.labelContainer.length && this.labelContainer || a(this.currentForm), this.containers = a(this.settings.errorContainer).add(this.settings.errorLabelContainer), this.submitted = {}, this.valueCache = {}, this.pendingRequest = 0, this.pending = {}, this.invalid = {}, this.reset();
				var c, d = this.currentForm, e = this.groups = {};
				a.each(this.settings.groups, function (b, c) {
					"string" == typeof c && (c = c.split(/\s/)), a.each(c, function (a, c) {
						e[c] = b;
					});
				}), c = this.settings.rules, a.each(c, function (b, d) {
					c[b] = a.validator.normalizeRule(d);
				}), a(this.currentForm).on("focusin.validate focusout.validate keyup.validate", ":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], [type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], [type='radio'], [type='checkbox'], [contenteditable], [type='button']", b).on("click.validate", "select, option, [type='radio'], [type='checkbox']", b), this.settings.invalidHandler && a(this.currentForm).on("invalid-form.validate", this.settings.invalidHandler);
			}, form: function () {
				return this.checkForm(), a.extend(this.submitted, this.errorMap), this.invalid = a.extend({}, this.errorMap), this.valid() || a(this.currentForm).triggerHandler("invalid-form", [this]), this.showErrors(), this.valid();
			}, checkForm: function () {
				this.prepareForm();
				for (var a = 0, b = this.currentElements = this.elements(); b[a]; a++) this.check(b[a]);
				return this.valid();
			}, element: function (b) {
				var c, d, e = this.clean(b), f = this.validationTargetFor(e), g = this, h = !0;
				return void 0 === f ? delete this.invalid[e.name] : (this.prepareElement(f), this.currentElements = a(f), d = this.groups[f.name], d && a.each(this.groups, function (a, b) {
					b === d && a !== f.name && (e = g.validationTargetFor(g.clean(g.findByName(a))), e && e.name in g.invalid && (g.currentElements.push(e), h = g.check(e) && h));
				}), c = this.check(f) !== !1, h = h && c, c ? this.invalid[f.name] = !1 : this.invalid[f.name] = !0, this.numberOfInvalids() || (this.toHide = this.toHide.add(this.containers)), this.showErrors(), a(b).attr("aria-invalid", !c)), h;
			}, showErrors: function (b) {
				if (b) {
					var c = this;
					a.extend(this.errorMap, b), this.errorList = a.map(this.errorMap, function (a, b) {
						return {message: a, element: c.findByName(b)[0]};
					}), this.successList = a.grep(this.successList, function (a) {
						return !(a.name in b);
					});
				}
				this.settings.showErrors ? this.settings.showErrors.call(this, this.errorMap, this.errorList) : this.defaultShowErrors();
			}, resetForm: function () {
				a.fn.resetForm && a(this.currentForm).resetForm(), this.invalid = {}, this.submitted = {}, this.prepareForm(), this.hideErrors();
				var b = this.elements().removeData("previousValue").removeAttr("aria-invalid");
				this.resetElements(b);
			}, resetElements: function (a) {
				var b;
				if (this.settings.unhighlight) for (b = 0; a[b]; b++) this.settings.unhighlight.call(this, a[b], this.settings.errorClass, ""), this.findByName(a[b].name).removeClass(this.settings.validClass); else a.removeClass(this.settings.errorClass).removeClass(this.settings.validClass);
			}, numberOfInvalids: function () {
				return this.objectLength(this.invalid);
			}, objectLength: function (a) {
				var b, c = 0;
				for (b in a) void 0 !== a[b] && null !== a[b] && a[b] !== !1 && c++;
				return c;
			}, hideErrors: function () {
				this.hideThese(this.toHide);
			}, hideThese: function (a) {
				a.not(this.containers).text(""), this.addWrapper(a).hide();
			}, valid: function () {
				return 0 === this.size();
			}, size: function () {
				return this.errorList.length;
			}, focusInvalid: function () {
				if (this.settings.focusInvalid) try {
					a(this.findLastActive() || this.errorList.length && this.errorList[0].element || []).filter(":visible").trigger("focus").trigger("focusin");
				} catch (b) {
				}
			}, findLastActive: function () {
				var b = this.lastActive;
				return b && 1 === a.grep(this.errorList, function (a) {
					return a.element.name === b.name;
				}).length && b;
			}, elements: function () {
				var b = this, c = {};
				return a(this.currentForm).find("input, select, textarea, [contenteditable]").not(":submit, :reset, :image, :disabled").not(this.settings.ignore).filter(function () {
					var d = this.name || a(this).attr("name"),
						e = "undefined" != typeof a(this).attr("contenteditable") && "false" !== a(this).attr("contenteditable");
					return !d && b.settings.debug && window.console && console.error("%o has no name assigned", this), e && (this.form = a(this).closest("form")[0], this.name = d), this.form === b.currentForm && (!(d in c || !b.objectLength(a(this).rules())) && (c[d] = !0, !0));
				});
			}, clean: function (b) {
				return a(b)[0];
			}, errors: function () {
				var b = this.settings.errorClass.split(" ").join(".");
				return a(this.settings.errorElement + "." + b, this.errorContext);
			}, resetInternals: function () {
				this.successList = [], this.errorList = [], this.errorMap = {}, this.toShow = a([]), this.toHide = a([]);
			}, reset: function () {
				this.resetInternals(), this.currentElements = a([]);
			}, prepareForm: function () {
				this.reset(), this.toHide = this.errors().add(this.containers);
			}, prepareElement: function (a) {
				this.reset(), this.toHide = this.errorsFor(a);
			}, elementValue: function (b) {
				var c, d, e = a(b), f = b.type,
					g = "undefined" != typeof e.attr("contenteditable") && "false" !== e.attr("contenteditable");
				return "radio" === f || "checkbox" === f ? this.findByName(b.name).filter(":checked").val() : "number" === f && "undefined" != typeof b.validity ? b.validity.badInput ? "NaN" : e.val() : (c = g ? e.text() : e.val(), "file" === f ? "C:\\fakepath\\" === c.substr(0, 12) ? c.substr(12) : (d = c.lastIndexOf("/"), d >= 0 ? c.substr(d + 1) : (d = c.lastIndexOf("\\"), d >= 0 ? c.substr(d + 1) : c)) : "string" == typeof c ? c.replace(/\r/g, "") : c);
			}, check: function (b) {
				b = this.validationTargetFor(this.clean(b));
				var c, d, e, f, g = a(b).rules(), h = a.map(g, function (a, b) {
					return b;
				}).length, i = !1, j = this.elementValue(b);
				"function" == typeof g.normalizer ? f = g.normalizer : "function" == typeof this.settings.normalizer && (f = this.settings.normalizer), f && (j = f.call(b, j), delete g.normalizer);
				for (d in g) {
					e = {method: d, parameters: g[d]};
					try {
						if (c = a.validator.methods[d].call(this, j, b, e.parameters), "dependency-mismatch" === c && 1 === h) {
							i = !0;
							continue;
						}
						if (i = !1, "pending" === c) return void (this.toHide = this.toHide.not(this.errorsFor(b)));
						if (!c) return this.formatAndAdd(b, e), !1;
					} catch (k) {
						throw this.settings.debug && window.console && console.log("Exception occurred when checking element " + b.id + ", check the '" + e.method + "' method.", k), k instanceof TypeError && (k.message += ".  Exception occurred when checking element " + b.id + ", check the '" + e.method + "' method."), k;
					}
				}
				if (!i) return this.objectLength(g) && this.successList.push(b), !0;
			}, customDataMessage: function (b, c) {
				return a(b).data("msg" + c.charAt(0).toUpperCase() + c.substring(1).toLowerCase()) || a(b).data("msg");
			}, customMessage: function (a, b) {
				var c = this.settings.messages[a];
				return c && (c.constructor === String ? c : c[b]);
			}, findDefined: function () {
				for (var a = 0; a < arguments.length; a++) if (void 0 !== arguments[a]) return arguments[a];
			}, defaultMessage: function (b, c) {
				"string" == typeof c && (c = {method: c});
				var d = this.findDefined(this.customMessage(b.name, c.method), this.customDataMessage(b, c.method), !this.settings.ignoreTitle && b.title || void 0, a.validator.messages[c.method], "<strong>Warning: No message defined for " + b.name + "</strong>"),
					e = /\$?\{(\d+)\}/g;
				return "function" == typeof d ? d = d.call(this, c.parameters, b) : e.test(d) && (d = a.validator.format(d.replace(e, "{$1}"), c.parameters)), d;
			}, formatAndAdd: function (a, b) {
				var c = this.defaultMessage(a, b);
				this.errorList.push({
					message: c,
					element: a,
					method: b.method
				}), this.errorMap[a.name] = c, this.submitted[a.name] = c;
			}, addWrapper: function (a) {
				return this.settings.wrapper && (a = a.add(a.parent(this.settings.wrapper))), a;
			}, defaultShowErrors: function () {
				var a, b, c;
				for (a = 0; this.errorList[a]; a++) c = this.errorList[a], this.settings.highlight && this.settings.highlight.call(this, c.element, this.settings.errorClass, this.settings.validClass), this.showLabel(c.element, c.message);
				if (this.errorList.length && (this.toShow = this.toShow.add(this.containers)), this.settings.success) for (a = 0; this.successList[a]; a++) this.showLabel(this.successList[a]);
				if (this.settings.unhighlight) for (a = 0, b = this.validElements(); b[a]; a++) this.settings.unhighlight.call(this, b[a], this.settings.errorClass, this.settings.validClass);
				this.toHide = this.toHide.not(this.toShow), this.hideErrors(), this.addWrapper(this.toShow).show();
			}, validElements: function () {
				return this.currentElements.not(this.invalidElements());
			}, invalidElements: function () {
				return a(this.errorList).map(function () {
					return this.element;
				});
			}, showLabel: function (b, c) {
				var d, e, f, g, h = this.errorsFor(b), i = this.idOrName(b), j = a(b).attr("aria-describedby");
				h.length ? (h.removeClass(this.settings.validClass).addClass(this.settings.errorClass), h.html(c)) : (h = a("<" + this.settings.errorElement + ">").attr("id", i + "-error").addClass(this.settings.errorClass).html(c || ""), d = h, this.settings.wrapper && (d = h.hide().show().wrap("<" + this.settings.wrapper + "/>").parent()), this.labelContainer.length ? this.labelContainer.append(d) : this.settings.errorPlacement ? this.settings.errorPlacement.call(this, d, a(b)) : d.insertAfter(b), h.is("label") ? h.attr("for", i) : 0 === h.parents("label[for='" + this.escapeCssMeta(i) + "']").length && (f = h.attr("id"), j ? j.match(new RegExp("\\b" + this.escapeCssMeta(f) + "\\b")) || (j += " " + f) : j = f, a(b).attr("aria-describedby", j), e = this.groups[b.name], e && (g = this, a.each(g.groups, function (b, c) {
					c === e && a("[name='" + g.escapeCssMeta(b) + "']", g.currentForm).attr("aria-describedby", h.attr("id"));
				})))), !c && this.settings.success && (h.text(""), "string" == typeof this.settings.success ? h.addClass(this.settings.success) : this.settings.success(h, b)), this.toShow = this.toShow.add(h);
			}, errorsFor: function (b) {
				var c = this.escapeCssMeta(this.idOrName(b)), d = a(b).attr("aria-describedby"),
					e = "label[for='" + c + "'], label[for='" + c + "'] *";
				return d && (e = e + ", #" + this.escapeCssMeta(d).replace(/\s+/g, ", #")), this.errors().filter(e);
			}, escapeCssMeta: function (a) {
				return a.replace(/([\\!"#$%&'()*+,.\/:;<=>?@\[\]^`{|}~])/g, "\\$1");
			}, idOrName: function (a) {
				return this.groups[a.name] || (this.checkable(a) ? a.name : a.id || a.name);
			}, validationTargetFor: function (b) {
				return this.checkable(b) && (b = this.findByName(b.name)), a(b).not(this.settings.ignore)[0];
			}, checkable: function (a) {
				return /radio|checkbox/i.test(a.type);
			}, findByName: function (b) {
				return a(this.currentForm).find("[name='" + this.escapeCssMeta(b) + "']");
			}, getLength: function (b, c) {
				switch (c.nodeName.toLowerCase()) {
					case"select":
						return a("option:selected", c).length;
					case"input":
						if (this.checkable(c)) return this.findByName(c.name).filter(":checked").length;
				}
				return b.length;
			}, depend: function (a, b) {
				return !this.dependTypes[typeof a] || this.dependTypes[typeof a](a, b);
			}, dependTypes: {
				"boolean": function (a) {
					return a;
				}, string: function (b, c) {
					return !!a(b, c.form).length;
				}, "function": function (a, b) {
					return a(b);
				}
			}, optional: function (b) {
				var c = this.elementValue(b);
				return !a.validator.methods.required.call(this, c, b) && "dependency-mismatch";
			}, startRequest: function (b) {
				this.pending[b.name] || (this.pendingRequest++, a(b).addClass(this.settings.pendingClass), this.pending[b.name] = !0);
			}, stopRequest: function (b, c) {
				this.pendingRequest--, this.pendingRequest < 0 && (this.pendingRequest = 0), delete this.pending[b.name], a(b).removeClass(this.settings.pendingClass), c && 0 === this.pendingRequest && this.formSubmitted && this.form() ? (a(this.currentForm).submit(), this.submitButton && a("input:hidden[name='" + this.submitButton.name + "']", this.currentForm).remove(), this.formSubmitted = !1) : !c && 0 === this.pendingRequest && this.formSubmitted && (a(this.currentForm).triggerHandler("invalid-form", [this]), this.formSubmitted = !1);
			}, previousValue: function (b, c) {
				return c = "string" == typeof c && c || "remote", a.data(b, "previousValue") || a.data(b, "previousValue", {
					old: null,
					valid: !0,
					message: this.defaultMessage(b, {method: c})
				});
			}, destroy: function () {
				this.resetForm(), a(this.currentForm).off(".validate").removeData("validator").find(".validate-equalTo-blur").off(".validate-equalTo").removeClass("validate-equalTo-blur").find(".validate-lessThan-blur").off(".validate-lessThan").removeClass("validate-lessThan-blur").find(".validate-lessThanEqual-blur").off(".validate-lessThanEqual").removeClass("validate-lessThanEqual-blur").find(".validate-greaterThanEqual-blur").off(".validate-greaterThanEqual").removeClass("validate-greaterThanEqual-blur").find(".validate-greaterThan-blur").off(".validate-greaterThan").removeClass("validate-greaterThan-blur");
			}
		},
		classRuleSettings: {
			required: {required: !0},
			email: {email: !0},
			url: {url: !0},
			date: {date: !0},
			dateISO: {dateISO: !0},
			number: {number: !0},
			digits: {digits: !0},
			creditcard: {creditcard: !0}
		},
		addClassRules: function (b, c) {
			b.constructor === String ? this.classRuleSettings[b] = c : a.extend(this.classRuleSettings, b);
		},
		classRules: function (b) {
			var c = {}, d = a(b).attr("class");
			return d && a.each(d.split(" "), function () {
				this in a.validator.classRuleSettings && a.extend(c, a.validator.classRuleSettings[this]);
			}), c;
		},
		normalizeAttributeRule: function (a, b, c, d) {
			/min|max|step/.test(c) && (null === b || /number|range|text/.test(b)) && (d = Number(d), isNaN(d) && (d = void 0)), d || 0 === d ? a[c] = d : b === c && "range" !== b && (a[c] = !0);
		},
		attributeRules: function (b) {
			var c, d, e = {}, f = a(b), g = b.getAttribute("type");
			for (c in a.validator.methods) "required" === c ? (d = b.getAttribute(c), "" === d && (d = !0), d = !!d) : d = f.attr(c), this.normalizeAttributeRule(e, g, c, d);
			return e.maxlength && /-1|2147483647|524288/.test(e.maxlength) && delete e.maxlength, e;
		},
		dataRules: function (b) {
			var c, d, e = {}, f = a(b), g = b.getAttribute("type");
			for (c in a.validator.methods) d = f.data("rule" + c.charAt(0).toUpperCase() + c.substring(1).toLowerCase()), "" === d && (d = !0), this.normalizeAttributeRule(e, g, c, d);
			return e;
		},
		staticRules: function (b) {
			var c = {}, d = a.data(b.form, "validator");
			return d.settings.rules && (c = a.validator.normalizeRule(d.settings.rules[b.name]) || {}), c;
		},
		normalizeRules: function (b, c) {
			return a.each(b, function (d, e) {
				if (e === !1) return void delete b[d];
				if (e.param || e.depends) {
					var f = !0;
					switch (typeof e.depends) {
						case"string":
							f = !!a(e.depends, c.form).length;
							break;
						case"function":
							f = e.depends.call(c, c);
					}
					f ? b[d] = void 0 === e.param || e.param : (a.data(c.form, "validator").resetElements(a(c)), delete b[d]);
				}
			}), a.each(b, function (d, e) {
				b[d] = a.isFunction(e) && "normalizer" !== d ? e(c) : e;
			}), a.each(["minlength", "maxlength"], function () {
				b[this] && (b[this] = Number(b[this]));
			}), a.each(["rangelength", "range"], function () {
				var c;
				b[this] && (a.isArray(b[this]) ? b[this] = [Number(b[this][0]), Number(b[this][1])] : "string" == typeof b[this] && (c = b[this].replace(/[\[\]]/g, "").split(/[\s,]+/), b[this] = [Number(c[0]), Number(c[1])]));
			}), a.validator.autoCreateRanges && (null != b.min && null != b.max && (b.range = [b.min, b.max], delete b.min, delete b.max), null != b.minlength && null != b.maxlength && (b.rangelength = [b.minlength, b.maxlength], delete b.minlength, delete b.maxlength)), b;
		},
		normalizeRule: function (b) {
			if ("string" == typeof b) {
				var c = {};
				a.each(b.split(/\s/), function () {
					c[this] = !0;
				}), b = c;
			}
			return b;
		},
		addMethod: function (b, c, d) {
			a.validator.methods[b] = c, a.validator.messages[b] = void 0 !== d ? d : a.validator.messages[b], c.length < 3 && a.validator.addClassRules(b, a.validator.normalizeRule(b));
		},
		methods: {
			required: function (b, c, d) {
				if (!this.depend(d, c)) return "dependency-mismatch";
				if ("select" === c.nodeName.toLowerCase()) {
					var e = a(c).val();
					return e && e.length > 0;
				}
				return this.checkable(c) ? this.getLength(b, c) > 0 : void 0 !== b && null !== b && b.length > 0;
			}, email: function (a, b) {
				return this.optional(b) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(a);
			}, url: function (a, b) {
				return this.optional(b) || /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[\/?#]\S*)?$/i.test(a);
			}, date: function () {
				var a = !1;
				return function (b, c) {
					return a || (a = !0, this.settings.debug && window.console && console.warn("The `date` method is deprecated and will be removed in version '2.0.0'.\nPlease don't use it, since it relies on the Date constructor, which\nbehaves very differently across browsers and locales. Use `dateISO`\ninstead or one of the locale specific methods in `localizations/`\nand `additional-methods.js`.")), this.optional(c) || !/Invalid|NaN/.test(new Date(b).toString());
				};
			}(), dateISO: function (a, b) {
				return this.optional(b) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(a);
			}, number: function (a, b) {
				return this.optional(b) || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(a);
			}, digits: function (a, b) {
				return this.optional(b) || /^\d+$/.test(a);
			}, minlength: function (b, c, d) {
				var e = a.isArray(b) ? b.length : this.getLength(b, c);
				return this.optional(c) || e >= d;
			}, maxlength: function (b, c, d) {
				var e = a.isArray(b) ? b.length : this.getLength(b, c);
				return this.optional(c) || e <= d;
			}, rangelength: function (b, c, d) {
				var e = a.isArray(b) ? b.length : this.getLength(b, c);
				return this.optional(c) || e >= d[0] && e <= d[1];
			}, min: function (a, b, c) {
				return this.optional(b) || a >= c;
			}, max: function (a, b, c) {
				return this.optional(b) || a <= c;
			}, range: function (a, b, c) {
				return this.optional(b) || a >= c[0] && a <= c[1];
			}, step: function (b, c, d) {
				var e, f = a(c).attr("type"), g = "Step attribute on input type " + f + " is not supported.",
					h = ["text", "number", "range"], i = new RegExp("\\b" + f + "\\b"), j = f && !i.test(h.join()),
					k = function (a) {
						var b = ("" + a).match(/(?:\.(\d+))?$/);
						return b && b[1] ? b[1].length : 0;
					}, l = function (a) {
						return Math.round(a * Math.pow(10, e));
					}, m = !0;
				if (j) throw new Error(g);
				return e = k(d), (k(b) > e || l(b) % l(d) !== 0) && (m = !1), this.optional(c) || m;
			}, equalTo: function (b, c, d) {
				var e = a(d);
				return this.settings.onfocusout && e.not(".validate-equalTo-blur").length && e.addClass("validate-equalTo-blur").on("blur.validate-equalTo", function () {
					a(c).valid();
				}), b === e.val();
			}, remote: function (b, c, d, e) {
				if (this.optional(c)) return "dependency-mismatch";
				e = "string" == typeof e && e || "remote";
				var f, g, h, i = this.previousValue(c, e);
				return this.settings.messages[c.name] || (this.settings.messages[c.name] = {}), i.originalMessage = i.originalMessage || this.settings.messages[c.name][e], this.settings.messages[c.name][e] = i.message, d = "string" == typeof d && {url: d} || d, h = a.param(a.extend({data: b}, d.data)), i.old === h ? i.valid : (i.old = h, f = this, this.startRequest(c), g = {}, g[c.name] = b, a.ajax(a.extend(!0, {
					mode: "abort",
					port: "validate" + c.name,
					dataType: "json",
					data: g,
					context: f.currentForm,
					success: function (a) {
						var d, g, h, j = a === !0 || "true" === a;
						f.settings.messages[c.name][e] = i.originalMessage, j ? (h = f.formSubmitted, f.resetInternals(), f.toHide = f.errorsFor(c), f.formSubmitted = h, f.successList.push(c), f.invalid[c.name] = !1, f.showErrors()) : (d = {}, g = a || f.defaultMessage(c, {
							method: e,
							parameters: b
						}), d[c.name] = i.message = g, f.invalid[c.name] = !0, f.showErrors(d)), i.valid = j, f.stopRequest(c, j);
					}
				}, d)), "pending");
			}
		}
	});
	var b, c = {};
	return a.ajaxPrefilter ? a.ajaxPrefilter(function (a, b, d) {
		var e = a.port;
		"abort" === a.mode && (c[e] && c[e].abort(), c[e] = d);
	}) : (b = a.ajax, a.ajax = function (d) {
		var e = ("mode" in d ? d : a.ajaxSettings).mode, f = ("port" in d ? d : a.ajaxSettings).port;
		return "abort" === e ? (c[f] && c[f].abort(), c[f] = b.apply(this, arguments), c[f]) : b.apply(this, arguments);
	}), a;
});

/*
 * Debounce function
 * based on unminified version from http://davidwalsh.name/javascript-debounce-function
 */
theme.debounce = function (n, t, u) {
	var e;
	return function () {
		var a = this, r = arguments, i = function () {e = null, u || n.apply(a, r);}, o = u && !e;
		clearTimeout(e), e = setTimeout(i, t), o && n.apply(a, r);
	};
};


/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
	this.constructors = {};
	this.instances = [];

	$(document)
		.on('shopify:section:load', this._onSectionLoad.bind(this))
		.on('shopify:section:unload', this._onSectionUnload.bind(this))
		.on('shopify:section:select', this._onSelect.bind(this))
		.on('shopify:section:deselect', this._onDeselect.bind(this))
		.on('shopify:block:select', this._onBlockSelect.bind(this))
		.on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
	_createInstance: function (container, constructor) {
		var $container = $(container);
		var id = $container.attr('data-section-id');
		var type = $container.attr('data-section-type');

		constructor = constructor || this.constructors[type];

		if (_.isUndefined(constructor)) {
			return;
		}

		var instance = _.assignIn(new constructor(container), {
			id: id,
			type: type,
			container: container
		});

		this.instances.push(instance);
	},

	_onSectionLoad: function (evt) {
		var container = $('[data-section-id]', evt.target)[0];
		if (container) {
			this._createInstance(container);
		}
	},

	_onSectionUnload: function (evt) {
		this.instances = _.filter(this.instances, function (instance) {
			var isEventInstance = instance.id === evt.originalEvent.detail.sectionId;

			if (isEventInstance) {
				if (_.isFunction(instance.onUnload)) {
					instance.onUnload(evt);
				}
			}

			return !isEventInstance;
		});
	},

	_onSelect: function (evt) {
		// eslint-disable-next-line no-shadow
		var instance = _.find(this.instances, function (instance) {
			return instance.id === evt.originalEvent.detail.sectionId;
		});

		if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
			instance.onSelect(evt);
		}
	},

	_onDeselect: function (evt) {
		// eslint-disable-next-line no-shadow
		var instance = _.find(this.instances, function (instance) {
			return instance.id === evt.originalEvent.detail.sectionId;
		});

		if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
			instance.onDeselect(evt);
		}
	},

	_onBlockSelect: function (evt) {
		// eslint-disable-next-line no-shadow
		var instance = _.find(this.instances, function (instance) {
			return instance.id === evt.originalEvent.detail.sectionId;
		});

		if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
			instance.onBlockSelect(evt);
		}
	},

	_onBlockDeselect: function (evt) {
		// eslint-disable-next-line no-shadow
		var instance = _.find(this.instances, function (instance) {
			return instance.id === evt.originalEvent.detail.sectionId;
		});

		if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
			instance.onBlockDeselect(evt);
		}
	},

	register: function (type, constructor) {
		this.constructors[type] = constructor;

		$('[data-section-type=' + type + ']').each(
			function (index, container) {
				this._createInstance(container, constructor);
			}.bind(this)
		);
	}
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
	var moneyFormat = '$';

	function formatMoney(cents, format) {
		if (typeof cents === 'string') {
			cents = cents.replace('.', '');
		}
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = format || moneyFormat;

		function formatWithDelimiters(number, precision, thousands, decimal) {
			thousands = thousands || ',';
			decimal = decimal || '.';

			if (isNaN(number) || number === null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			var parts = number.split('.');
			var dollarsAmount = parts[0].replace(
				/(\d)(?=(\d\d\d)+(?!\d))/g,
				'$1' + thousands
			);
			var centsAmount = parts[1] ? decimal + parts[1] : '';

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
			case 'amount_no_decimals_with_space_separator':
				value = formatWithDelimiters(cents, 0, ' ');
				break;
			case 'amount_with_apostrophe_separator':
				value = formatWithDelimiters(cents, 2, "'");
				break;
		}

		return formatString.replace(placeholderRegex, value);
	}

	return {
		formatMoney: formatMoney
	};
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function () {
	/**
	 * Preloads an image in memory and uses the browsers cache to store it until needed.
	 *
	 * @param {Array} images - A list of image urls
	 * @param {String} size - A shopify image size attribute
	 */

	function preload(images, size) {
		if (typeof images === 'string') {
			images = [images];
		}

		for (var i = 0; i < images.length; i++) {
			var image = images[i];
			this.loadImage(this.getSizedImageUrl(image, size));
		}
	}

	/**
	 * Loads and caches an image in the browsers cache.
	 * @param {string} path - An image url
	 */
	function loadImage(path) {
		new Image().src = path;
	}

	/**
	 * Swaps the src of an image for another OR returns the imageURL to the callback function
	 * @param image
	 * @param element
	 * @param callback
	 */
	function switchImage(image, element, callback) {
		var size = this.imageSize(element.src);
		var imageUrl = this.getSizedImageUrl(image.src, size);

		if (callback) {
			callback(imageUrl, image, element); // eslint-disable-line callback-return
		} else {
			element.src = imageUrl;
		}
	}

	/**
	 * +++ Useful
	 * Find the Shopify image attribute size
	 *
	 * @param {string} src
	 * @returns {null}
	 */
	function imageSize(src) {
		var match = src.match(
			/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[.@]/
		);

		if (match !== null) {
			return match[1];
		} else {
			return null;
		}
	}

	/**
	 * +++ Useful
	 * Adds a Shopify size attribute to a URL
	 *
	 * @param src
	 * @param size
	 * @returns {*}
	 */
	function getSizedImageUrl(src, size) {
		if (size === null) {
			return src;
		}

		if (size === 'master') {
			return this.removeProtocol(src);
		}

		var match = src.match(
			/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
		);

		if (match !== null) {
			var prefix = src.split(match[0]);
			var suffix = match[0];

			return this.removeProtocol(prefix[0] + '_' + size + suffix);
		}

		return null;
	}

	function removeProtocol(path) {
		return path.replace(/http(s)?:/, '');
	}

	return {
		preload: preload,
		loadImage: loadImage,
		switchImage: switchImage,
		imageSize: imageSize,
		getSizedImageUrl: getSizedImageUrl,
		removeProtocol: removeProtocol
	};
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
	/**
	 * Variant constructor
	 *
	 * @param {object} options - Settings from `product.js`
	 */
	function Variants(options) {
		this.$container = options.$container;
		this.product = options.product;
		this.singleOptionSelector = options.singleOptionSelector;
		this.originalSelectorId = options.originalSelectorId;
		this.enableHistoryState = options.enableHistoryState;
		this.currentVariant = this._getVariantFromOptions();

		$(this.singleOptionSelector, this.$container).on(
			'change',
			this._onSelectChange.bind(this)
		);
	}

	Variants.prototype = _.assignIn({}, Variants.prototype, {
		/**
		 * Get the currently selected options from add-to-cart form. Works with all
		 * form input elements.
		 *
		 * @return {array} options - Values of currently selected variants
		 */
		_getCurrentOptions: function () {
			var currentOptions = _.map(
				$(this.singleOptionSelector, this.$container),
				function (element) {
					var $element = $(element);
					var type = $element.attr('type');
					var currentOption = {};

					if (type === 'radio' || type === 'checkbox') {
						if ($element[0].checked) {
							currentOption.value = $element.val();
							currentOption.index = $element.data('index');

							return currentOption;
						} else {
							return false;
						}
					} else {
						currentOption.value = $element.val();
						currentOption.index = $element.data('index');

						return currentOption;
					}
				}
			);

			// remove any unchecked input values if using radio buttons or checkboxes
			currentOptions = _.compact(currentOptions);

			return currentOptions;
		},

		/**
		 * Find variant based on selected values.
		 *
		 * @param  {array} selectedValues - Values of variant inputs
		 * @return {object || undefined} found - Variant object from product.variants
		 */
		_getVariantFromOptions: function () {
			var selectedValues = this._getCurrentOptions();
			var variants = this.product.variants;



			var found = _.find(variants, function (variant) {
				return selectedValues.every(function (values) {
					return _.isEqual(variant[values.index], values.value);
				});
			});

			return found;
		},

		/**
		 * Event handler for when a variant input changes.
		 */
		_onSelectChange: function () {
			var variant = this._getVariantFromOptions();

			this.$container.trigger({
				type: 'variantChange',
				variant: variant
			});

			if (!variant) {
				return;
			}

			this._updateMasterSelect(variant);
			this._updateImages(variant);
			this._updatePrice(variant);
			this._updateSKU(variant);
			this.currentVariant = variant;

			if (this.enableHistoryState) {
				this._updateHistoryState(variant);
			}
		},

		/**
		 * Trigger event when variant image changes
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event}  variantImageChange
		 */
		_updateImages: function (variant) {
			var variantImage = variant.featured_image || {};
			var currentVariantImage = this.currentVariant.featured_image || {};

			if (
				!variant.featured_image ||
				variantImage.src === currentVariantImage.src
			) {
				return;
			}

			this.$container.trigger({
				type: 'variantImageChange',
				variant: variant
			});
		},

		/**
		 * Trigger event when variant price changes.
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event} variantPriceChange
		 */
		_updatePrice: function (variant) {
			if (
				variant.price === this.currentVariant.price &&
				variant.compare_at_price === this.currentVariant.compare_at_price
			) {
				return;
			}

			this.$container.trigger({
				type: 'variantPriceChange',
				variant: variant
			});
		},

		/**
		 * Trigger event when variant SKU changes.
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event} variantSKUChange
		 */
		_updateSKU: function (variant) {
			if (variant.sku === this.currentVariant.sku) {
				return;
			}

			this.$container.trigger({
				type: 'variantSKUChange',
				variant: variant
			});
		},

		/**
		 * Update history state for product deeplinking
		 *
		 * @param  {variant} variant - Currently selected variant
		 * @return {k}         [description]
		 */
		_updateHistoryState: function (variant) {
			if (!history.replaceState || !variant) {
				return;
			}

			var newurl =
				window.location.protocol +
				'//' +
				window.location.host +
				window.location.pathname +
				'?variant=' +
				variant.id;
			window.history.replaceState({path: newurl}, '', newurl);
		},

		/**
		 * Update hidden master select of variant change
		 *
		 * @param  {variant} variant - Currently selected variant
		 */
		_updateMasterSelect: function (variant) {
			$(this.originalSelectorId, this.$container).val(variant.id);
		}
	});

	return Variants;
})();


/* ================ MODULES ================ */

/*!
handlebars v1.3.0

Copyright (C) 2011 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

@license
*/
var Handlebars = function () {
	var e = function () {
		"use strict";

		function t(e) {this.string = e;}

		var e;
		t.prototype.toString = function () {return "" + this.string;};
		e = t;
		return e;
	}();
	var t = function (e) {
		"use strict";

		function o(e) {return r[e] || "&";}

		function u(e, t) {
			for (var n in t) {
				if (Object.prototype.hasOwnProperty.call(t, n)) {
					e[n] = t[n];
				}
			}
		}

		function c(e) {
			if (e instanceof n) {
				return e.toString();
			} else if (!e && e !== 0) {
				return "";
			}
			e = "" + e;
			if (!s.test(e)) {
				return e;
			}
			return e.replace(i, o);
		}

		function h(e) {
			if (!e && e !== 0) {
				return true;
			} else if (l(e) && e.length === 0) {
				return true;
			} else {
				return false;
			}
		}

		var t = {};
		var n = e;
		var r = {"&": "&", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;", "`": "&#x60;"};
		var i = /[&<>"'`]/g;
		var s = /[&<>"'`]/;
		t.extend = u;
		var a = Object.prototype.toString;
		t.toString = a;
		var f = function (e) {return typeof e === "function";};
		if (f(/x/)) {
			f = function (e) {return typeof e === "function" && a.call(e) === "[object Function]";};
		}
		var f;
		t.isFunction = f;
		var l = Array.isArray || function (e) {return e && typeof e === "object" ? a.call(e) === "[object Array]" : false;};
		t.isArray = l;
		t.escapeExpression = c;
		t.isEmpty = h;
		return t;
	}(e);
	var n = function () {
		"use strict";

		function n(e, n) {
			var r;
			if (n && n.firstLine) {
				r = n.firstLine;
				e += " - " + r + ":" + n.firstColumn;
			}
			var i = Error.prototype.constructor.call(this, e);
			for (var s = 0; s < t.length; s++) {
				this[t[s]] = i[t[s]];
			}
			if (r) {
				this.lineNumber = r;
				this.column = n.firstColumn;
			}
		}

		var e;
		var t = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"];
		n.prototype = new Error;
		e = n;
		return e;
	}();
	var r = function (e, t) {
		"use strict";

		function h(e, t) {
			this.helpers = e || {};
			this.partials = t || {};
			p(this);
		}

		function p(e) {
			e.registerHelper("helperMissing", function (e) {
				if (arguments.length === 2) {
					return undefined;
				} else {
					throw new i("Missing helper: '" + e + "'");
				}
			});
			e.registerHelper("blockHelperMissing", function (t, n) {
				var r = n.inverse || function () {}, i = n.fn;
				if (f(t)) {
					t = t.call(this);
				}
				if (t === true) {
					return i(this);
				} else if (t === false || t == null) {
					return r(this);
				} else if (a(t)) {
					if (t.length > 0) {
						return e.helpers.each(t, n);
					} else {
						return r(this);
					}
				} else {
					return i(t);
				}
			});
			e.registerHelper("each", function (e, t) {
				var n = t.fn, r = t.inverse;
				var i = 0, s = "", o;
				if (f(e)) {
					e = e.call(this);
				}
				if (t.data) {
					o = m(t.data);
				}
				if (e && typeof e === "object") {
					if (a(e)) {
						for (var u = e.length; i < u; i++) {
							if (o) {
								o.index = i;
								o.first = i === 0;
								o.last = i === e.length - 1;
							}
							s = s + n(e[i], {data: o});
						}
					} else {
						for (var l in e) {
							if (e.hasOwnProperty(l)) {
								if (o) {
									o.key = l;
									o.index = i;
									o.first = i === 0;
								}
								s = s + n(e[l], {data: o});
								i++;
							}
						}
					}
				}
				if (i === 0) {
					s = r(this);
				}
				return s;
			});
			e.registerHelper("if", function (e, t) {
				if (f(e)) {
					e = e.call(this);
				}
				if (!t.hash.includeZero && !e || r.isEmpty(e)) {
					return t.inverse(this);
				} else {
					return t.fn(this);
				}
			});
			e.registerHelper("unless", function (t, n) {
				return e.helpers["if"].call(this, t, {
					fn: n.inverse,
					inverse: n.fn,
					hash: n.hash
				});
			});
			e.registerHelper("with", function (e, t) {
				if (f(e)) {
					e = e.call(this);
				}
				if (!r.isEmpty(e)) return t.fn(e);
			});
			e.registerHelper("log", function (t, n) {
				var r = n.data && n.data.level != null ? parseInt(n.data.level, 10) : 1;
				e.log(r, t);
			});
		}

		function v(e, t) {d.log(e, t);}

		var n = {};
		var r = e;
		var i = t;
		var s = "1.3.0";
		n.VERSION = s;
		var o = 4;
		n.COMPILER_REVISION = o;
		var u = {1: "<= 1.0.rc.2", 2: "== 1.0.0-rc.3", 3: "== 1.0.0-rc.4", 4: ">= 1.0.0"};
		n.REVISION_CHANGES = u;
		var a = r.isArray, f = r.isFunction, l = r.toString, c = "[object Object]";
		n.HandlebarsEnvironment = h;
		h.prototype = {
			constructor: h, logger: d, log: v, registerHelper: function (e, t, n) {
				if (l.call(e) === c) {
					if (n || t) {
						throw new i("Arg not supported with multiple helpers");
					}
					r.extend(this.helpers, e);
				} else {
					if (n) {
						t.not = n;
					}
					this.helpers[e] = t;
				}
			}, registerPartial: function (e, t) {
				if (l.call(e) === c) {
					r.extend(this.partials, e);
				} else {
					this.partials[e] = t;
				}
			}
		};
		var d = {
			methodMap: {0: "debug", 1: "info", 2: "warn", 3: "error"},
			DEBUG: 0,
			INFO: 1,
			WARN: 2,
			ERROR: 3,
			level: 3,
			log: function (e, t) {
				if (d.level <= e) {
					var n = d.methodMap[e];
					if (typeof console !== "undefined" && console[n]) {
						console[n].call(console, t);
					}
				}
			}
		};
		n.logger = d;
		n.log = v;
		var m = function (e) {
			var t = {};
			r.extend(t, e);
			return t;
		};
		n.createFrame = m;
		return n;
	}(t, n);
	var i = function (e, t, n) {
		"use strict";

		function a(e) {
			var t = e && e[0] || 1, n = o;
			if (t !== n) {
				if (t < n) {
					var r = u[n], i = u[t];
					throw new s("Template was precompiled with an older version of Handlebars than the current runtime. " + "Please update your precompiler to a newer version (" + r + ") or downgrade your runtime to an older version (" + i + ").");
				} else {
					throw new s("Template was precompiled with a newer version of Handlebars than the current runtime. " + "Please update your runtime to a newer version (" + e[1] + ").");
				}
			}
		}

		function f(e, t) {
			if (!t) {
				throw new s("No environment passed to template");
			}
			var n = function (e, n, r, i, o, u) {
				var a = t.VM.invokePartial.apply(this, arguments);
				if (a != null) {
					return a;
				}
				if (t.compile) {
					var f = {helpers: i, partials: o, data: u};
					o[n] = t.compile(e, {data: u !== undefined}, t);
					return o[n](r, f);
				} else {
					throw new s("The partial " + n + " could not be compiled when running in runtime-only mode");
				}
			};
			var r = {
				escapeExpression: i.escapeExpression,
				invokePartial: n,
				programs: [],
				program: function (e, t, n) {
					var r = this.programs[e];
					if (n) {
						r = c(e, t, n);
					} else if (!r) {
						r = this.programs[e] = c(e, t);
					}
					return r;
				},
				merge: function (e, t) {
					var n = e || t;
					if (e && t && e !== t) {
						n = {};
						i.extend(n, t);
						i.extend(n, e);
					}
					return n;
				},
				programWithDepth: t.VM.programWithDepth,
				noop: t.VM.noop,
				compilerInfo: null
			};
			return function (n, i) {
				i = i || {};
				var s = i.partial ? i : t, o, u;
				if (!i.partial) {
					o = i.helpers;
					u = i.partials;
				}
				var a = e.call(r, s, n, o, u, i.data);
				if (!i.partial) {
					t.VM.checkRevision(r.compilerInfo);
				}
				return a;
			};
		}

		function l(e, t, n) {
			var r = Array.prototype.slice.call(arguments, 3);
			var i = function (e, i) {
				i = i || {};
				return t.apply(this, [e, i.data || n].concat(r));
			};
			i.program = e;
			i.depth = r.length;
			return i;
		}

		function c(e, t, n) {
			var r = function (e, r) {
				r = r || {};
				return t(e, r.data || n);
			};
			r.program = e;
			r.depth = 0;
			return r;
		}

		function h(e, t, n, r, i, o) {
			var u = {partial: true, helpers: r, partials: i, data: o};
			if (e === undefined) {
				throw new s("The partial " + t + " could not be found");
			} else if (e instanceof Function) {
				return e(n, u);
			}
		}

		function p() {return "";}

		var r = {};
		var i = e;
		var s = t;
		var o = n.COMPILER_REVISION;
		var u = n.REVISION_CHANGES;
		r.checkRevision = a;
		r.template = f;
		r.programWithDepth = l;
		r.program = c;
		r.invokePartial = h;
		r.noop = p;
		return r;
	}(t, n, r);
	var s = function (e, t, n, r, i) {
		"use strict";
		var s;
		var o = e;
		var u = t;
		var a = n;
		var f = r;
		var l = i;
		var c = function () {
			var e = new o.HandlebarsEnvironment;
			f.extend(e, o);
			e.SafeString = u;
			e.Exception = a;
			e.Utils = f;
			e.VM = l;
			e.template = function (t) {return l.template(t, e);};
			return e;
		};
		var h = c();
		h.create = c;
		s = h;
		return s;
	}(r, e, n, t, i);
	var o = function (e) {
		"use strict";

		function r(e) {
			e = e || {};
			this.firstLine = e.first_line;
			this.firstColumn = e.first_column;
			this.lastColumn = e.last_column;
			this.lastLine = e.last_line;
		}

		var t;
		var n = e;
		var i = {
			ProgramNode: function (e, t, n, s) {
				var o, u;
				if (arguments.length === 3) {
					s = n;
					n = null;
				} else if (arguments.length === 2) {
					s = t;
					t = null;
				}
				r.call(this, s);
				this.type = "program";
				this.statements = e;
				this.strip = {};
				if (n) {
					u = n[0];
					if (u) {
						o = {
							first_line: u.firstLine,
							last_line: u.lastLine,
							last_column: u.lastColumn,
							first_column: u.firstColumn
						};
						this.inverse = new i.ProgramNode(n, t, o);
					} else {
						this.inverse = new i.ProgramNode(n, t);
					}
					this.strip.right = t.left;
				} else if (t) {
					this.strip.left = t.right;
				}
			}, MustacheNode: function (e, t, n, s, o) {
				r.call(this, o);
				this.type = "mustache";
				this.strip = s;
				if (n != null && n.charAt) {
					var u = n.charAt(3) || n.charAt(2);
					this.escaped = u !== "{" && u !== "&";
				} else {
					this.escaped = !!n;
				}
				if (e instanceof i.SexprNode) {
					this.sexpr = e;
				} else {
					this.sexpr = new i.SexprNode(e, t);
				}
				this.sexpr.isRoot = true;
				this.id = this.sexpr.id;
				this.params = this.sexpr.params;
				this.hash = this.sexpr.hash;
				this.eligibleHelper = this.sexpr.eligibleHelper;
				this.isHelper = this.sexpr.isHelper;
			}, SexprNode: function (e, t, n) {
				r.call(this, n);
				this.type = "sexpr";
				this.hash = t;
				var i = this.id = e[0];
				var s = this.params = e.slice(1);
				var o = this.eligibleHelper = i.isSimple;
				this.isHelper = o && (s.length || t);
			}, PartialNode: function (e, t, n, i) {
				r.call(this, i);
				this.type = "partial";
				this.partialName = e;
				this.context = t;
				this.strip = n;
			}, BlockNode: function (e, t, i, s, o) {
				r.call(this, o);
				if (e.sexpr.id.original !== s.path.original) {
					throw new n(e.sexpr.id.original + " doesn't match " + s.path.original, this);
				}
				this.type = "block";
				this.mustache = e;
				this.program = t;
				this.inverse = i;
				this.strip = {left: e.strip.left, right: s.strip.right};
				(t || i).strip.left = e.strip.right;
				(i || t).strip.right = s.strip.left;
				if (i && !t) {
					this.isInverse = true;
				}
			}, ContentNode: function (e, t) {
				r.call(this, t);
				this.type = "content";
				this.string = e;
			}, HashNode: function (e, t) {
				r.call(this, t);
				this.type = "hash";
				this.pairs = e;
			}, IdNode: function (e, t) {
				r.call(this, t);
				this.type = "ID";
				var i = "", s = [], o = 0;
				for (var u = 0, a = e.length; u < a; u++) {
					var f = e[u].part;
					i += (e[u].separator || "") + f;
					if (f === ".." || f === "." || f === "this") {
						if (s.length > 0) {
							throw new n("Invalid path: " + i, this);
						} else if (f === "..") {
							o++;
						} else {
							this.isScoped = true;
						}
					} else {
						s.push(f);
					}
				}
				this.original = i;
				this.parts = s;
				this.string = s.join(".");
				this.depth = o;
				this.isSimple = e.length === 1 && !this.isScoped && o === 0;
				this.stringModeValue = this.string;
			}, PartialNameNode: function (e, t) {
				r.call(this, t);
				this.type = "PARTIAL_NAME";
				this.name = e.original;
			}, DataNode: function (e, t) {
				r.call(this, t);
				this.type = "DATA";
				this.id = e;
			}, StringNode: function (e, t) {
				r.call(this, t);
				this.type = "STRING";
				this.original = this.string = this.stringModeValue = e;
			}, IntegerNode: function (e, t) {
				r.call(this, t);
				this.type = "INTEGER";
				this.original = this.integer = e;
				this.stringModeValue = Number(e);
			}, BooleanNode: function (e, t) {
				r.call(this, t);
				this.type = "BOOLEAN";
				this.bool = e;
				this.stringModeValue = e === "true";
			}, CommentNode: function (e, t) {
				r.call(this, t);
				this.type = "comment";
				this.comment = e;
			}
		};
		t = i;
		return t;
	}(n);
	var u = function () {
		"use strict";
		var e;
		var t = function () {
			function t(e, t) {return {left: e.charAt(2) === "~", right: t.charAt(0) === "~" || t.charAt(1) === "~"};}

			function r() {this.yy = {};}

			var e = {
				trace: function () {},
				yy: {},
				symbols_: {
					error: 2,
					root: 3,
					statements: 4,
					EOF: 5,
					program: 6,
					simpleInverse: 7,
					statement: 8,
					openInverse: 9,
					closeBlock: 10,
					openBlock: 11,
					mustache: 12,
					partial: 13,
					CONTENT: 14,
					COMMENT: 15,
					OPEN_BLOCK: 16,
					sexpr: 17,
					CLOSE: 18,
					OPEN_INVERSE: 19,
					OPEN_ENDBLOCK: 20,
					path: 21,
					OPEN: 22,
					OPEN_UNESCAPED: 23,
					CLOSE_UNESCAPED: 24,
					OPEN_PARTIAL: 25,
					partialName: 26,
					partial_option0: 27,
					sexpr_repetition0: 28,
					sexpr_option0: 29,
					dataName: 30,
					param: 31,
					STRING: 32,
					INTEGER: 33,
					BOOLEAN: 34,
					OPEN_SEXPR: 35,
					CLOSE_SEXPR: 36,
					hash: 37,
					hash_repetition_plus0: 38,
					hashSegment: 39,
					ID: 40,
					EQUALS: 41,
					DATA: 42,
					pathSegments: 43,
					SEP: 44,
					$accept: 0,
					$end: 1
				},
				terminals_: {
					2: "error",
					5: "EOF",
					14: "CONTENT",
					15: "COMMENT",
					16: "OPEN_BLOCK",
					18: "CLOSE",
					19: "OPEN_INVERSE",
					20: "OPEN_ENDBLOCK",
					22: "OPEN",
					23: "OPEN_UNESCAPED",
					24: "CLOSE_UNESCAPED",
					25: "OPEN_PARTIAL",
					32: "STRING",
					33: "INTEGER",
					34: "BOOLEAN",
					35: "OPEN_SEXPR",
					36: "CLOSE_SEXPR",
					40: "ID",
					41: "EQUALS",
					42: "DATA",
					44: "SEP"
				},
				productions_: [0, [3, 2], [3, 1], [6, 2], [6, 3], [6, 2], [6, 1], [6, 1], [6, 0], [4, 1], [4, 2], [8, 3], [8, 3], [8, 1], [8, 1], [8, 1], [8, 1], [11, 3], [9, 3], [10, 3], [12, 3], [12, 3], [13, 4], [7, 2], [17, 3], [17, 1], [31, 1], [31, 1], [31, 1], [31, 1], [31, 1], [31, 3], [37, 1], [39, 3], [26, 1], [26, 1], [26, 1], [30, 2], [21, 1], [43, 3], [43, 1], [27, 0], [27, 1], [28, 0], [28, 2], [29, 0], [29, 1], [38, 1], [38, 2]],
				performAction: function (n, r, i, s, o, u, a) {
					var f = u.length - 1;
					switch (o) {
						case 1:
							return new s.ProgramNode(u[f - 1], this._$);
							break;
						case 2:
							return new s.ProgramNode([], this._$);
							break;
						case 3:
							this.$ = new s.ProgramNode([], u[f - 1], u[f], this._$);
							break;
						case 4:
							this.$ = new s.ProgramNode(u[f - 2], u[f - 1], u[f], this._$);
							break;
						case 5:
							this.$ = new s.ProgramNode(u[f - 1], u[f], [], this._$);
							break;
						case 6:
							this.$ = new s.ProgramNode(u[f], this._$);
							break;
						case 7:
							this.$ = new s.ProgramNode([], this._$);
							break;
						case 8:
							this.$ = new s.ProgramNode([], this._$);
							break;
						case 9:
							this.$ = [u[f]];
							break;
						case 10:
							u[f - 1].push(u[f]);
							this.$ = u[f - 1];
							break;
						case 11:
							this.$ = new s.BlockNode(u[f - 2], u[f - 1].inverse, u[f - 1], u[f], this._$);
							break;
						case 12:
							this.$ = new s.BlockNode(u[f - 2], u[f - 1], u[f - 1].inverse, u[f], this._$);
							break;
						case 13:
							this.$ = u[f];
							break;
						case 14:
							this.$ = u[f];
							break;
						case 15:
							this.$ = new s.ContentNode(u[f], this._$);
							break;
						case 16:
							this.$ = new s.CommentNode(u[f], this._$);
							break;
						case 17:
							this.$ = new s.MustacheNode(u[f - 1], null, u[f - 2], t(u[f - 2], u[f]), this._$);
							break;
						case 18:
							this.$ = new s.MustacheNode(u[f - 1], null, u[f - 2], t(u[f - 2], u[f]), this._$);
							break;
						case 19:
							this.$ = {path: u[f - 1], strip: t(u[f - 2], u[f])};
							break;
						case 20:
							this.$ = new s.MustacheNode(u[f - 1], null, u[f - 2], t(u[f - 2], u[f]), this._$);
							break;
						case 21:
							this.$ = new s.MustacheNode(u[f - 1], null, u[f - 2], t(u[f - 2], u[f]), this._$);
							break;
						case 22:
							this.$ = new s.PartialNode(u[f - 2], u[f - 1], t(u[f - 3], u[f]), this._$);
							break;
						case 23:
							this.$ = t(u[f - 1], u[f]);
							break;
						case 24:
							this.$ = new s.SexprNode([u[f - 2]].concat(u[f - 1]), u[f], this._$);
							break;
						case 25:
							this.$ = new s.SexprNode([u[f]], null, this._$);
							break;
						case 26:
							this.$ = u[f];
							break;
						case 27:
							this.$ = new s.StringNode(u[f], this._$);
							break;
						case 28:
							this.$ = new s.IntegerNode(u[f], this._$);
							break;
						case 29:
							this.$ = new s.BooleanNode(u[f], this._$);
							break;
						case 30:
							this.$ = u[f];
							break;
						case 31:
							u[f - 1].isHelper = true;
							this.$ = u[f - 1];
							break;
						case 32:
							this.$ = new s.HashNode(u[f], this._$);
							break;
						case 33:
							this.$ = [u[f - 2], u[f]];
							break;
						case 34:
							this.$ = new s.PartialNameNode(u[f], this._$);
							break;
						case 35:
							this.$ = new s.PartialNameNode(new s.StringNode(u[f], this._$), this._$);
							break;
						case 36:
							this.$ = new s.PartialNameNode(new s.IntegerNode(u[f], this._$));
							break;
						case 37:
							this.$ = new s.DataNode(u[f], this._$);
							break;
						case 38:
							this.$ = new s.IdNode(u[f], this._$);
							break;
						case 39:
							u[f - 2].push({part: u[f], separator: u[f - 1]});
							this.$ = u[f - 2];
							break;
						case 40:
							this.$ = [{part: u[f]}];
							break;
						case 43:
							this.$ = [];
							break;
						case 44:
							u[f - 1].push(u[f]);
							break;
						case 47:
							this.$ = [u[f]];
							break;
						case 48:
							u[f - 1].push(u[f]);
							break;
					}
				},
				table: [{
					3: 1,
					4: 2,
					5: [1, 3],
					8: 4,
					9: 5,
					11: 6,
					12: 7,
					13: 8,
					14: [1, 9],
					15: [1, 10],
					16: [1, 12],
					19: [1, 11],
					22: [1, 13],
					23: [1, 14],
					25: [1, 15]
				}, {1: [3]}, {
					5: [1, 16],
					8: 17,
					9: 5,
					11: 6,
					12: 7,
					13: 8,
					14: [1, 9],
					15: [1, 10],
					16: [1, 12],
					19: [1, 11],
					22: [1, 13],
					23: [1, 14],
					25: [1, 15]
				}, {1: [2, 2]}, {
					5: [2, 9],
					14: [2, 9],
					15: [2, 9],
					16: [2, 9],
					19: [2, 9],
					20: [2, 9],
					22: [2, 9],
					23: [2, 9],
					25: [2, 9]
				}, {
					4: 20,
					6: 18,
					7: 19,
					8: 4,
					9: 5,
					11: 6,
					12: 7,
					13: 8,
					14: [1, 9],
					15: [1, 10],
					16: [1, 12],
					19: [1, 21],
					20: [2, 8],
					22: [1, 13],
					23: [1, 14],
					25: [1, 15]
				}, {
					4: 20,
					6: 22,
					7: 19,
					8: 4,
					9: 5,
					11: 6,
					12: 7,
					13: 8,
					14: [1, 9],
					15: [1, 10],
					16: [1, 12],
					19: [1, 21],
					20: [2, 8],
					22: [1, 13],
					23: [1, 14],
					25: [1, 15]
				}, {
					5: [2, 13],
					14: [2, 13],
					15: [2, 13],
					16: [2, 13],
					19: [2, 13],
					20: [2, 13],
					22: [2, 13],
					23: [2, 13],
					25: [2, 13]
				}, {
					5: [2, 14],
					14: [2, 14],
					15: [2, 14],
					16: [2, 14],
					19: [2, 14],
					20: [2, 14],
					22: [2, 14],
					23: [2, 14],
					25: [2, 14]
				}, {
					5: [2, 15],
					14: [2, 15],
					15: [2, 15],
					16: [2, 15],
					19: [2, 15],
					20: [2, 15],
					22: [2, 15],
					23: [2, 15],
					25: [2, 15]
				}, {
					5: [2, 16],
					14: [2, 16],
					15: [2, 16],
					16: [2, 16],
					19: [2, 16],
					20: [2, 16],
					22: [2, 16],
					23: [2, 16],
					25: [2, 16]
				}, {17: 23, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26}, {
					17: 29,
					21: 24,
					30: 25,
					40: [1, 28],
					42: [1, 27],
					43: 26
				}, {17: 30, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26}, {
					17: 31,
					21: 24,
					30: 25,
					40: [1, 28],
					42: [1, 27],
					43: 26
				}, {21: 33, 26: 32, 32: [1, 34], 33: [1, 35], 40: [1, 28], 43: 26}, {1: [2, 1]}, {
					5: [2, 10],
					14: [2, 10],
					15: [2, 10],
					16: [2, 10],
					19: [2, 10],
					20: [2, 10],
					22: [2, 10],
					23: [2, 10],
					25: [2, 10]
				}, {10: 36, 20: [1, 37]}, {
					4: 38,
					8: 4,
					9: 5,
					11: 6,
					12: 7,
					13: 8,
					14: [1, 9],
					15: [1, 10],
					16: [1, 12],
					19: [1, 11],
					20: [2, 7],
					22: [1, 13],
					23: [1, 14],
					25: [1, 15]
				}, {
					7: 39,
					8: 17,
					9: 5,
					11: 6,
					12: 7,
					13: 8,
					14: [1, 9],
					15: [1, 10],
					16: [1, 12],
					19: [1, 21],
					20: [2, 6],
					22: [1, 13],
					23: [1, 14],
					25: [1, 15]
				}, {17: 23, 18: [1, 40], 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26}, {
					10: 41,
					20: [1, 37]
				}, {18: [1, 42]}, {
					18: [2, 43],
					24: [2, 43],
					28: 43,
					32: [2, 43],
					33: [2, 43],
					34: [2, 43],
					35: [2, 43],
					36: [2, 43],
					40: [2, 43],
					42: [2, 43]
				}, {18: [2, 25], 24: [2, 25], 36: [2, 25]}, {
					18: [2, 38],
					24: [2, 38],
					32: [2, 38],
					33: [2, 38],
					34: [2, 38],
					35: [2, 38],
					36: [2, 38],
					40: [2, 38],
					42: [2, 38],
					44: [1, 44]
				}, {21: 45, 40: [1, 28], 43: 26}, {
					18: [2, 40],
					24: [2, 40],
					32: [2, 40],
					33: [2, 40],
					34: [2, 40],
					35: [2, 40],
					36: [2, 40],
					40: [2, 40],
					42: [2, 40],
					44: [2, 40]
				}, {18: [1, 46]}, {18: [1, 47]}, {24: [1, 48]}, {
					18: [2, 41],
					21: 50,
					27: 49,
					40: [1, 28],
					43: 26
				}, {18: [2, 34], 40: [2, 34]}, {18: [2, 35], 40: [2, 35]}, {18: [2, 36], 40: [2, 36]}, {
					5: [2, 11],
					14: [2, 11],
					15: [2, 11],
					16: [2, 11],
					19: [2, 11],
					20: [2, 11],
					22: [2, 11],
					23: [2, 11],
					25: [2, 11]
				}, {21: 51, 40: [1, 28], 43: 26}, {
					8: 17,
					9: 5,
					11: 6,
					12: 7,
					13: 8,
					14: [1, 9],
					15: [1, 10],
					16: [1, 12],
					19: [1, 11],
					20: [2, 3],
					22: [1, 13],
					23: [1, 14],
					25: [1, 15]
				}, {
					4: 52,
					8: 4,
					9: 5,
					11: 6,
					12: 7,
					13: 8,
					14: [1, 9],
					15: [1, 10],
					16: [1, 12],
					19: [1, 11],
					20: [2, 5],
					22: [1, 13],
					23: [1, 14],
					25: [1, 15]
				}, {
					14: [2, 23],
					15: [2, 23],
					16: [2, 23],
					19: [2, 23],
					20: [2, 23],
					22: [2, 23],
					23: [2, 23],
					25: [2, 23]
				}, {
					5: [2, 12],
					14: [2, 12],
					15: [2, 12],
					16: [2, 12],
					19: [2, 12],
					20: [2, 12],
					22: [2, 12],
					23: [2, 12],
					25: [2, 12]
				}, {
					14: [2, 18],
					15: [2, 18],
					16: [2, 18],
					19: [2, 18],
					20: [2, 18],
					22: [2, 18],
					23: [2, 18],
					25: [2, 18]
				}, {
					18: [2, 45],
					21: 56,
					24: [2, 45],
					29: 53,
					30: 60,
					31: 54,
					32: [1, 57],
					33: [1, 58],
					34: [1, 59],
					35: [1, 61],
					36: [2, 45],
					37: 55,
					38: 62,
					39: 63,
					40: [1, 64],
					42: [1, 27],
					43: 26
				}, {40: [1, 65]}, {
					18: [2, 37],
					24: [2, 37],
					32: [2, 37],
					33: [2, 37],
					34: [2, 37],
					35: [2, 37],
					36: [2, 37],
					40: [2, 37],
					42: [2, 37]
				}, {
					14: [2, 17],
					15: [2, 17],
					16: [2, 17],
					19: [2, 17],
					20: [2, 17],
					22: [2, 17],
					23: [2, 17],
					25: [2, 17]
				}, {
					5: [2, 20],
					14: [2, 20],
					15: [2, 20],
					16: [2, 20],
					19: [2, 20],
					20: [2, 20],
					22: [2, 20],
					23: [2, 20],
					25: [2, 20]
				}, {
					5: [2, 21],
					14: [2, 21],
					15: [2, 21],
					16: [2, 21],
					19: [2, 21],
					20: [2, 21],
					22: [2, 21],
					23: [2, 21],
					25: [2, 21]
				}, {18: [1, 66]}, {18: [2, 42]}, {18: [1, 67]}, {
					8: 17,
					9: 5,
					11: 6,
					12: 7,
					13: 8,
					14: [1, 9],
					15: [1, 10],
					16: [1, 12],
					19: [1, 11],
					20: [2, 4],
					22: [1, 13],
					23: [1, 14],
					25: [1, 15]
				}, {18: [2, 24], 24: [2, 24], 36: [2, 24]}, {
					18: [2, 44],
					24: [2, 44],
					32: [2, 44],
					33: [2, 44],
					34: [2, 44],
					35: [2, 44],
					36: [2, 44],
					40: [2, 44],
					42: [2, 44]
				}, {18: [2, 46], 24: [2, 46], 36: [2, 46]}, {
					18: [2, 26],
					24: [2, 26],
					32: [2, 26],
					33: [2, 26],
					34: [2, 26],
					35: [2, 26],
					36: [2, 26],
					40: [2, 26],
					42: [2, 26]
				}, {
					18: [2, 27],
					24: [2, 27],
					32: [2, 27],
					33: [2, 27],
					34: [2, 27],
					35: [2, 27],
					36: [2, 27],
					40: [2, 27],
					42: [2, 27]
				}, {
					18: [2, 28],
					24: [2, 28],
					32: [2, 28],
					33: [2, 28],
					34: [2, 28],
					35: [2, 28],
					36: [2, 28],
					40: [2, 28],
					42: [2, 28]
				}, {
					18: [2, 29],
					24: [2, 29],
					32: [2, 29],
					33: [2, 29],
					34: [2, 29],
					35: [2, 29],
					36: [2, 29],
					40: [2, 29],
					42: [2, 29]
				}, {
					18: [2, 30],
					24: [2, 30],
					32: [2, 30],
					33: [2, 30],
					34: [2, 30],
					35: [2, 30],
					36: [2, 30],
					40: [2, 30],
					42: [2, 30]
				}, {17: 68, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26}, {
					18: [2, 32],
					24: [2, 32],
					36: [2, 32],
					39: 69,
					40: [1, 70]
				}, {18: [2, 47], 24: [2, 47], 36: [2, 47], 40: [2, 47]}, {
					18: [2, 40],
					24: [2, 40],
					32: [2, 40],
					33: [2, 40],
					34: [2, 40],
					35: [2, 40],
					36: [2, 40],
					40: [2, 40],
					41: [1, 71],
					42: [2, 40],
					44: [2, 40]
				}, {
					18: [2, 39],
					24: [2, 39],
					32: [2, 39],
					33: [2, 39],
					34: [2, 39],
					35: [2, 39],
					36: [2, 39],
					40: [2, 39],
					42: [2, 39],
					44: [2, 39]
				}, {
					5: [2, 22],
					14: [2, 22],
					15: [2, 22],
					16: [2, 22],
					19: [2, 22],
					20: [2, 22],
					22: [2, 22],
					23: [2, 22],
					25: [2, 22]
				}, {
					5: [2, 19],
					14: [2, 19],
					15: [2, 19],
					16: [2, 19],
					19: [2, 19],
					20: [2, 19],
					22: [2, 19],
					23: [2, 19],
					25: [2, 19]
				}, {36: [1, 72]}, {18: [2, 48], 24: [2, 48], 36: [2, 48], 40: [2, 48]}, {41: [1, 71]}, {
					21: 56,
					30: 60,
					31: 73,
					32: [1, 57],
					33: [1, 58],
					34: [1, 59],
					35: [1, 61],
					40: [1, 28],
					42: [1, 27],
					43: 26
				}, {
					18: [2, 31],
					24: [2, 31],
					32: [2, 31],
					33: [2, 31],
					34: [2, 31],
					35: [2, 31],
					36: [2, 31],
					40: [2, 31],
					42: [2, 31]
				}, {18: [2, 33], 24: [2, 33], 36: [2, 33], 40: [2, 33]}],
				defaultActions: {3: [2, 2], 16: [2, 1], 50: [2, 42]},
				parseError: function (t, n) {throw new Error(t);},
				parse: function (t) {
					function v(e) {
						r.length = r.length - 2 * e;
						i.length = i.length - e;
						s.length = s.length - e;
					}

					function m() {
						var e;
						e = n.lexer.lex() || 1;
						if (typeof e !== "number") {
							e = n.symbols_[e] || e;
						}
						return e;
					}

					var n = this, r = [0], i = [null], s = [], o = this.table, u = "", a = 0, f = 0, l = 0, c = 2, h = 1;
					this.lexer.setInput(t);
					this.lexer.yy = this.yy;
					this.yy.lexer = this.lexer;
					this.yy.parser = this;
					if (typeof this.lexer.yylloc == "undefined") this.lexer.yylloc = {};
					var p = this.lexer.yylloc;
					s.push(p);
					var d = this.lexer.options && this.lexer.options.ranges;
					if (typeof this.yy.parseError === "function") this.parseError = this.yy.parseError;
					var g, y, b, w, E, S, x = {}, T, N, C, k;
					while (true) {
						b = r[r.length - 1];
						if (this.defaultActions[b]) {
							w = this.defaultActions[b];
						} else {
							if (g === null || typeof g == "undefined") {
								g = m();
							}
							w = o[b] && o[b][g];
						}
						if (typeof w === "undefined" || !w.length || !w[0]) {
							var L = "";
							if (!l) {
								k = [];
								for (T in o[b]) if (this.terminals_[T] && T > 2) {
									k.push("'" + this.terminals_[T] + "'");
								}
								if (this.lexer.showPosition) {
									L = "Parse error on line " + (a + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + k.join(", ") + ", got '" + (this.terminals_[g] || g) + "'";
								} else {
									L = "Parse error on line " + (a + 1) + ": Unexpected " + (g == 1 ? "end of input" : "'" + (this.terminals_[g] || g) + "'");
								}
								this.parseError(L, {
									text: this.lexer.match,
									token: this.terminals_[g] || g,
									line: this.lexer.yylineno,
									loc: p,
									expected: k
								});
							}
						}
						if (w[0] instanceof Array && w.length > 1) {
							throw new Error("Parse Error: multiple actions possible at state: " + b + ", token: " + g);
						}
						switch (w[0]) {
							case 1:
								r.push(g);
								i.push(this.lexer.yytext);
								s.push(this.lexer.yylloc);
								r.push(w[1]);
								g = null;
								if (!y) {
									f = this.lexer.yyleng;
									u = this.lexer.yytext;
									a = this.lexer.yylineno;
									p = this.lexer.yylloc;
									if (l > 0) l--;
								} else {
									g = y;
									y = null;
								}
								break;
							case 2:
								N = this.productions_[w[1]][1];
								x.$ = i[i.length - N];
								x._$ = {
									first_line: s[s.length - (N || 1)].first_line,
									last_line: s[s.length - 1].last_line,
									first_column: s[s.length - (N || 1)].first_column,
									last_column: s[s.length - 1].last_column
								};
								if (d) {
									x._$.range = [s[s.length - (N || 1)].range[0], s[s.length - 1].range[1]];
								}
								S = this.performAction.call(x, u, f, a, this.yy, w[1], i, s);
								if (typeof S !== "undefined") {
									return S;
								}
								if (N) {
									r = r.slice(0, -1 * N * 2);
									i = i.slice(0, -1 * N);
									s = s.slice(0, -1 * N);
								}
								r.push(this.productions_[w[1]][0]);
								i.push(x.$);
								s.push(x._$);
								C = o[r[r.length - 2]][r[r.length - 1]];
								r.push(C);
								break;
							case 3:
								return true;
						}
					}
					return true;
				}
			};
			var n = function () {
				var e = {
					EOF: 1,
					parseError: function (t, n) {
						if (this.yy.parser) {
							this.yy.parser.parseError(t, n);
						} else {
							throw new Error(t);
						}
					},
					setInput: function (e) {
						this._input = e;
						this._more = this._less = this.done = false;
						this.yylineno = this.yyleng = 0;
						this.yytext = this.matched = this.match = "";
						this.conditionStack = ["INITIAL"];
						this.yylloc = {first_line: 1, first_column: 0, last_line: 1, last_column: 0};
						if (this.options.ranges) this.yylloc.range = [0, 0];
						this.offset = 0;
						return this;
					},
					input: function () {
						var e = this._input[0];
						this.yytext += e;
						this.yyleng++;
						this.offset++;
						this.match += e;
						this.matched += e;
						var t = e.match(/(?:\r\n?|\n).*/g);
						if (t) {
							this.yylineno++;
							this.yylloc.last_line++;
						} else {
							this.yylloc.last_column++;
						}
						if (this.options.ranges) this.yylloc.range[1]++;
						this._input = this._input.slice(1);
						return e;
					},
					unput: function (e) {
						var t = e.length;
						var n = e.split(/(?:\r\n?|\n)/g);
						this._input = e + this._input;
						this.yytext = this.yytext.substr(0, this.yytext.length - t - 1);
						this.offset -= t;
						var r = this.match.split(/(?:\r\n?|\n)/g);
						this.match = this.match.substr(0, this.match.length - 1);
						this.matched = this.matched.substr(0, this.matched.length - 1);
						if (n.length - 1) this.yylineno -= n.length - 1;
						var i = this.yylloc.range;
						this.yylloc = {
							first_line: this.yylloc.first_line,
							last_line: this.yylineno + 1,
							first_column: this.yylloc.first_column,
							last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - t
						};
						if (this.options.ranges) {
							this.yylloc.range = [i[0], i[0] + this.yyleng - t];
						}
						return this;
					},
					more: function () {
						this._more = true;
						return this;
					},
					less: function (e) {this.unput(this.match.slice(e));},
					pastInput: function () {
						var e = this.matched.substr(0, this.matched.length - this.match.length);
						return (e.length > 20 ? "..." : "") + e.substr(-20).replace(/\n/g, "");
					},
					upcomingInput: function () {
						var e = this.match;
						if (e.length < 20) {
							e += this._input.substr(0, 20 - e.length);
						}
						return (e.substr(0, 20) + (e.length > 20 ? "..." : "")).replace(/\n/g, "");
					},
					showPosition: function () {
						var e = this.pastInput();
						var t = (new Array(e.length + 1)).join("-");
						return e + this.upcomingInput() + "\n" + t + "^";
					},
					next: function () {
						if (this.done) {
							return this.EOF;
						}
						if (!this._input) this.done = true;
						var e, t, n, r, i, s;
						if (!this._more) {
							this.yytext = "";
							this.match = "";
						}
						var o = this._currentRules();
						for (var u = 0; u < o.length; u++) {
							n = this._input.match(this.rules[o[u]]);
							if (n && (!t || n[0].length > t[0].length)) {
								t = n;
								r = u;
								if (!this.options.flex) break;
							}
						}
						if (t) {
							s = t[0].match(/(?:\r\n?|\n).*/g);
							if (s) this.yylineno += s.length;
							this.yylloc = {
								first_line: this.yylloc.last_line,
								last_line: this.yylineno + 1,
								first_column: this.yylloc.last_column,
								last_column: s ? s[s.length - 1].length - s[s.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
							};
							this.yytext += t[0];
							this.match += t[0];
							this.matches = t;
							this.yyleng = this.yytext.length;
							if (this.options.ranges) {
								this.yylloc.range = [this.offset, this.offset += this.yyleng];
							}
							this._more = false;
							this._input = this._input.slice(t[0].length);
							this.matched += t[0];
							e = this.performAction.call(this, this.yy, this, o[r], this.conditionStack[this.conditionStack.length - 1]);
							if (this.done && this._input) this.done = false;
							if (e) return e; else return;
						}
						if (this._input === "") {
							return this.EOF;
						} else {
							return this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
								text: "",
								token: null,
								line: this.yylineno
							});
						}
					},
					lex: function () {
						var t = this.next();
						if (typeof t !== "undefined") {
							return t;
						} else {
							return this.lex();
						}
					},
					begin: function (t) {this.conditionStack.push(t);},
					popState: function () {return this.conditionStack.pop();},
					_currentRules: function () {return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;},
					topState: function () {return this.conditionStack[this.conditionStack.length - 2];},
					pushState: function (t) {this.begin(t);}
				};
				e.options = {};
				e.performAction = function (t, n, r, i) {
					function s(e, t) {return n.yytext = n.yytext.substr(e, n.yyleng - t);}

					var o = i;
					switch (r) {
						case 0:
							if (n.yytext.slice(-2) === "\\\\") {
								s(0, 1);
								this.begin("mu");
							} else if (n.yytext.slice(-1) === "\\") {
								s(0, 1);
								this.begin("emu");
							} else {
								this.begin("mu");
							}
							if (n.yytext) return 14;
							break;
						case 1:
							return 14;
							break;
						case 2:
							this.popState();
							return 14;
							break;
						case 3:
							s(0, 4);
							this.popState();
							return 15;
							break;
						case 4:
							return 35;
							break;
						case 5:
							return 36;
							break;
						case 6:
							return 25;
							break;
						case 7:
							return 16;
							break;
						case 8:
							return 20;
							break;
						case 9:
							return 19;
							break;
						case 10:
							return 19;
							break;
						case 11:
							return 23;
							break;
						case 12:
							return 22;
							break;
						case 13:
							this.popState();
							this.begin("com");
							break;
						case 14:
							s(3, 5);
							this.popState();
							return 15;
							break;
						case 15:
							return 22;
							break;
						case 16:
							return 41;
							break;
						case 17:
							return 40;
							break;
						case 18:
							return 40;
							break;
						case 19:
							return 44;
							break;
						case 20:
							break;
						case 21:
							this.popState();
							return 24;
							break;
						case 22:
							this.popState();
							return 18;
							break;
						case 23:
							n.yytext = s(1, 2).replace(/\\"/g, '"');
							return 32;
							break;
						case 24:
							n.yytext = s(1, 2).replace(/\\'/g, "'");
							return 32;
							break;
						case 25:
							return 42;
							break;
						case 26:
							return 34;
							break;
						case 27:
							return 34;
							break;
						case 28:
							return 33;
							break;
						case 29:
							return 40;
							break;
						case 30:
							n.yytext = s(1, 2);
							return 40;
							break;
						case 31:
							return "INVALID";
							break;
						case 32:
							return 5;
							break;
					}
				};
				e.rules = [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:[\s\S]*?--\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{!--)/, /^(?:\{\{![\s\S]*?\}\})/, /^(?:\{\{(~)?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:-?[0-9]+(?=([~}\s)])))/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)]))))/, /^(?:\[[^\]]*\])/, /^(?:.)/, /^(?:$)/];
				e.conditions = {
					mu: {
						rules: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32],
						inclusive: false
					},
					emu: {rules: [2], inclusive: false},
					com: {rules: [3], inclusive: false},
					INITIAL: {rules: [0, 1, 32], inclusive: true}
				};
				return e;
			}();
			e.lexer = n;
			r.prototype = e;
			e.Parser = r;
			return new r;
		}();
		e = t;
		return e;
	}();
	var a = function (e, t) {
		"use strict";

		function s(e) {
			if (e.constructor === i.ProgramNode) {
				return e;
			}
			r.yy = i;
			return r.parse(e);
		}

		var n = {};
		var r = e;
		var i = t;
		n.parser = r;
		n.parse = s;
		return n;
	}(u, o);
	var f = function (e) {
		"use strict";

		function r() {}

		function i(e, t, r) {
			if (e == null || typeof e !== "string" && e.constructor !== r.AST.ProgramNode) {
				throw new n("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + e);
			}
			t = t || {};
			if (!("data" in t)) {
				t.data = true;
			}
			var i = r.parse(e);
			var s = (new r.Compiler).compile(i, t);
			return (new r.JavaScriptCompiler).compile(s, t);
		}

		function s(e, t, r) {
			function s() {
				var n = r.parse(e);
				var i = (new r.Compiler).compile(n, t);
				var s = (new r.JavaScriptCompiler).compile(i, t, undefined, true);
				return r.template(s);
			}

			if (e == null || typeof e !== "string" && e.constructor !== r.AST.ProgramNode) {
				throw new n("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + e);
			}
			t = t || {};
			if (!("data" in t)) {
				t.data = true;
			}
			var i;
			return function (e, t) {
				if (!i) {
					i = s();
				}
				return i.call(this, e, t);
			};
		}

		var t = {};
		var n = e;
		t.Compiler = r;
		r.prototype = {
			compiler: r,
			disassemble: function () {
				var e = this.opcodes, t, n = [], r, i;
				for (var s = 0, o = e.length; s < o; s++) {
					t = e[s];
					if (t.opcode === "DECLARE") {
						n.push("DECLARE " + t.name + "=" + t.value);
					} else {
						r = [];
						for (var u = 0; u < t.args.length; u++) {
							i = t.args[u];
							if (typeof i === "string") {
								i = '"' + i.replace("\n", "\\n") + '"';
							}
							r.push(i);
						}
						n.push(t.opcode + " " + r.join(" "));
					}
				}
				return n.join("\n");
			},
			equals: function (e) {
				var t = this.opcodes.length;
				if (e.opcodes.length !== t) {
					return false;
				}
				for (var n = 0; n < t; n++) {
					var r = this.opcodes[n], i = e.opcodes[n];
					if (r.opcode !== i.opcode || r.args.length !== i.args.length) {
						return false;
					}
					for (var s = 0; s < r.args.length; s++) {
						if (r.args[s] !== i.args[s]) {
							return false;
						}
					}
				}
				t = this.children.length;
				if (e.children.length !== t) {
					return false;
				}
				for (n = 0; n < t; n++) {
					if (!this.children[n].equals(e.children[n])) {
						return false;
					}
				}
				return true;
			},
			guid: 0,
			compile: function (e, t) {
				this.opcodes = [];
				this.children = [];
				this.depths = {list: []};
				this.options = t;
				var n = this.options.knownHelpers;
				this.options.knownHelpers = {
					helperMissing: true,
					blockHelperMissing: true,
					each: true,
					"if": true,
					unless: true,
					"with": true,
					log: true
				};
				if (n) {
					for (var r in n) {
						this.options.knownHelpers[r] = n[r];
					}
				}
				return this.accept(e);
			},
			accept: function (e) {
				var t = e.strip || {}, n;
				if (t.left) {
					this.opcode("strip");
				}
				n = this[e.type](e);
				if (t.right) {
					this.opcode("strip");
				}
				return n;
			},
			program: function (e) {
				var t = e.statements;
				for (var n = 0, r = t.length; n < r; n++) {
					this.accept(t[n]);
				}
				this.isSimple = r === 1;
				this.depths.list = this.depths.list.sort(function (e, t) {return e - t;});
				return this;
			},
			compileProgram: function (e) {
				var t = (new this.compiler).compile(e, this.options);
				var n = this.guid++, r;
				this.usePartial = this.usePartial || t.usePartial;
				this.children[n] = t;
				for (var i = 0, s = t.depths.list.length; i < s; i++) {
					r = t.depths.list[i];
					if (r < 2) {
						continue;
					} else {
						this.addDepth(r - 1);
					}
				}
				return n;
			},
			block: function (e) {
				var t = e.mustache, n = e.program, r = e.inverse;
				if (n) {
					n = this.compileProgram(n);
				}
				if (r) {
					r = this.compileProgram(r);
				}
				var i = t.sexpr;
				var s = this.classifySexpr(i);
				if (s === "helper") {
					this.helperSexpr(i, n, r);
				} else if (s === "simple") {
					this.simpleSexpr(i);
					this.opcode("pushProgram", n);
					this.opcode("pushProgram", r);
					this.opcode("emptyHash");
					this.opcode("blockValue");
				} else {
					this.ambiguousSexpr(i, n, r);
					this.opcode("pushProgram", n);
					this.opcode("pushProgram", r);
					this.opcode("emptyHash");
					this.opcode("ambiguousBlockValue");
				}
				this.opcode("append");
			},
			hash: function (e) {
				var t = e.pairs, n, r;
				this.opcode("pushHash");
				for (var i = 0, s = t.length; i < s; i++) {
					n = t[i];
					r = n[1];
					if (this.options.stringParams) {
						if (r.depth) {
							this.addDepth(r.depth);
						}
						this.opcode("getContext", r.depth || 0);
						this.opcode("pushStringParam", r.stringModeValue, r.type);
						if (r.type === "sexpr") {
							this.sexpr(r);
						}
					} else {
						this.accept(r);
					}
					this.opcode("assignToHash", n[0]);
				}
				this.opcode("popHash");
			},
			partial: function (e) {
				var t = e.partialName;
				this.usePartial = true;
				if (e.context) {
					this.ID(e.context);
				} else {
					this.opcode("push", "depth0");
				}
				this.opcode("invokePartial", t.name);
				this.opcode("append");
			},
			content: function (e) {this.opcode("appendContent", e.string);},
			mustache: function (e) {
				this.sexpr(e.sexpr);
				if (e.escaped && !this.options.noEscape) {
					this.opcode("appendEscaped");
				} else {
					this.opcode("append");
				}
			},
			ambiguousSexpr: function (e, t, n) {
				var r = e.id, i = r.parts[0], s = t != null || n != null;
				this.opcode("getContext", r.depth);
				this.opcode("pushProgram", t);
				this.opcode("pushProgram", n);
				this.opcode("invokeAmbiguous", i, s);
			},
			simpleSexpr: function (e) {
				var t = e.id;
				if (t.type === "DATA") {
					this.DATA(t);
				} else if (t.parts.length) {
					this.ID(t);
				} else {
					this.addDepth(t.depth);
					this.opcode("getContext", t.depth);
					this.opcode("pushContext");
				}
				this.opcode("resolvePossibleLambda");
			},
			helperSexpr: function (e, t, r) {
				var i = this.setupFullMustacheParams(e, t, r), s = e.id.parts[0];
				if (this.options.knownHelpers[s]) {
					this.opcode("invokeKnownHelper", i.length, s);
				} else if (this.options.knownHelpersOnly) {
					throw new n("You specified knownHelpersOnly, but used the unknown helper " + s, e);
				} else {
					this.opcode("invokeHelper", i.length, s, e.isRoot);
				}
			},
			sexpr: function (e) {
				var t = this.classifySexpr(e);
				if (t === "simple") {
					this.simpleSexpr(e);
				} else if (t === "helper") {
					this.helperSexpr(e);
				} else {
					this.ambiguousSexpr(e);
				}
			},
			ID: function (e) {
				this.addDepth(e.depth);
				this.opcode("getContext", e.depth);
				var t = e.parts[0];
				if (!t) {
					this.opcode("pushContext");
				} else {
					this.opcode("lookupOnContext", e.parts[0]);
				}
				for (var n = 1, r = e.parts.length; n < r; n++) {
					this.opcode("lookup", e.parts[n]);
				}
			},
			DATA: function (e) {
				this.options.data = true;
				if (e.id.isScoped || e.id.depth) {
					throw new n("Scoped data references are not supported: " + e.original, e);
				}
				this.opcode("lookupData");
				var t = e.id.parts;
				for (var r = 0, i = t.length; r < i; r++) {
					this.opcode("lookup", t[r]);
				}
			},
			STRING: function (e) {this.opcode("pushString", e.string);},
			INTEGER: function (e) {this.opcode("pushLiteral", e.integer);},
			BOOLEAN: function (e) {this.opcode("pushLiteral", e.bool);},
			comment: function () {},
			opcode: function (e) {this.opcodes.push({opcode: e, args: [].slice.call(arguments, 1)});},
			declare: function (e, t) {this.opcodes.push({opcode: "DECLARE", name: e, value: t});},
			addDepth: function (e) {
				if (e === 0) {
					return;
				}
				if (!this.depths[e]) {
					this.depths[e] = true;
					this.depths.list.push(e);
				}
			},
			classifySexpr: function (e) {
				var t = e.isHelper;
				var n = e.eligibleHelper;
				var r = this.options;
				if (n && !t) {
					var i = e.id.parts[0];
					if (r.knownHelpers[i]) {
						t = true;
					} else if (r.knownHelpersOnly) {
						n = false;
					}
				}
				if (t) {
					return "helper";
				} else if (n) {
					return "ambiguous";
				} else {
					return "simple";
				}
			},
			pushParams: function (e) {
				var t = e.length, n;
				while (t--) {
					n = e[t];
					if (this.options.stringParams) {
						if (n.depth) {
							this.addDepth(n.depth);
						}
						this.opcode("getContext", n.depth || 0);
						this.opcode("pushStringParam", n.stringModeValue, n.type);
						if (n.type === "sexpr") {
							this.sexpr(n);
						}
					} else {
						this[n.type](n);
					}
				}
			},
			setupFullMustacheParams: function (e, t, n) {
				var r = e.params;
				this.pushParams(r);
				this.opcode("pushProgram", t);
				this.opcode("pushProgram", n);
				if (e.hash) {
					this.hash(e.hash);
				} else {
					this.opcode("emptyHash");
				}
				return r;
			}
		};
		t.precompile = i;
		t.compile = s;
		return t;
	}(n);
	var l = function (e, t) {
		"use strict";

		function u(e) {this.value = e;}

		function a() {}

		var n;
		var r = e.COMPILER_REVISION;
		var i = e.REVISION_CHANGES;
		var s = e.log;
		var o = t;
		a.prototype = {
			nameLookup: function (e, t) {
				var n, r;
				if (e.indexOf("depth") === 0) {
					n = true;
				}
				if (/^[0-9]+$/.test(t)) {
					r = e + "[" + t + "]";
				} else if (a.isValidJavaScriptVariableName(t)) {
					r = e + "." + t;
				} else {
					r = e + "['" + t + "']";
				}
				if (n) {
					return "(" + e + " && " + r + ")";
				} else {
					return r;
				}
			},
			compilerInfo: function () {
				var e = r, t = i[e];
				return "this.compilerInfo = [" + e + ",'" + t + "'];\n";
			},
			appendToBuffer: function (e) {
				if (this.environment.isSimple) {
					return "return " + e + ";";
				} else {
					return {appendToBuffer: true, content: e, toString: function () {return "buffer += " + e + ";";}};
				}
			},
			initializeBuffer: function () {return this.quotedString("");},
			namespace: "Handlebars",
			compile: function (e, t, n, r) {
				this.environment = e;
				this.options = t || {};
				s("debug", this.environment.disassemble() + "\n\n");
				this.name = this.environment.name;
				this.isChild = !!n;
				this.context = n || {programs: [], environments: [], aliases: {}};
				this.preamble();
				this.stackSlot = 0;
				this.stackVars = [];
				this.registers = {list: []};
				this.hashes = [];
				this.compileStack = [];
				this.inlineStack = [];
				this.compileChildren(e, t);
				var i = e.opcodes, u;
				this.i = 0;
				for (var a = i.length; this.i < a; this.i++) {
					u = i[this.i];
					if (u.opcode === "DECLARE") {
						this[u.name] = u.value;
					} else {
						this[u.opcode].apply(this, u.args);
					}
					if (u.opcode !== this.stripNext) {
						this.stripNext = false;
					}
				}
				this.pushSource("");
				if (this.stackSlot || this.inlineStack.length || this.compileStack.length) {
					throw new o("Compile completed with content left on stack");
				}
				return this.createFunctionContext(r);
			},
			preamble: function () {
				var e = [];
				if (!this.isChild) {
					var t = this.namespace;
					var n = "helpers = this.merge(helpers, " + t + ".helpers);";
					if (this.environment.usePartial) {
						n = n + " partials = this.merge(partials, " + t + ".partials);";
					}
					if (this.options.data) {
						n = n + " data = data || {};";
					}
					e.push(n);
				} else {
					e.push("");
				}
				if (!this.environment.isSimple) {
					e.push(", buffer = " + this.initializeBuffer());
				} else {
					e.push("");
				}
				this.lastContext = 0;
				this.source = e;
			},
			createFunctionContext: function (e) {
				var t = this.stackVars.concat(this.registers.list);
				if (t.length > 0) {
					this.source[1] = this.source[1] + ", " + t.join(", ");
				}
				if (!this.isChild) {
					for (var n in this.context.aliases) {
						if (this.context.aliases.hasOwnProperty(n)) {
							this.source[1] = this.source[1] + ", " + n + "=" + this.context.aliases[n];
						}
					}
				}
				if (this.source[1]) {
					this.source[1] = "var " + this.source[1].substring(2) + ";";
				}
				if (!this.isChild) {
					this.source[1] += "\n" + this.context.programs.join("\n") + "\n";
				}
				if (!this.environment.isSimple) {
					this.pushSource("return buffer;");
				}
				var r = this.isChild ? ["depth0", "data"] : ["Handlebars", "depth0", "helpers", "partials", "data"];
				for (var i = 0, o = this.environment.depths.list.length; i < o; i++) {
					r.push("depth" + this.environment.depths.list[i]);
				}
				var u = this.mergeSource();
				if (!this.isChild) {
					u = this.compilerInfo() + u;
				}
				if (e) {
					r.push(u);
					return Function.apply(this, r);
				} else {
					var a = "function " + (this.name || "") + "(" + r.join(",") + ") {\n  " + u + "}";
					s("debug", a + "\n\n");
					return a;
				}
			},
			mergeSource: function () {
				var e = "", t;
				for (var n = 0, r = this.source.length; n < r; n++) {
					var i = this.source[n];
					if (i.appendToBuffer) {
						if (t) {
							t = t + "\n    + " + i.content;
						} else {
							t = i.content;
						}
					} else {
						if (t) {
							e += "buffer += " + t + ";\n  ";
							t = undefined;
						}
						e += i + "\n  ";
					}
				}
				return e;
			},
			blockValue: function () {
				this.context.aliases.blockHelperMissing = "helpers.blockHelperMissing";
				var e = ["depth0"];
				this.setupParams(0, e);
				this.replaceStack(function (t) {
					e.splice(1, 0, t);
					return "blockHelperMissing.call(" + e.join(", ") + ")";
				});
			},
			ambiguousBlockValue: function () {
				this.context.aliases.blockHelperMissing = "helpers.blockHelperMissing";
				var e = ["depth0"];
				this.setupParams(0, e);
				var t = this.topStack();
				e.splice(1, 0, t);
				this.pushSource("if (!" + this.lastHelper + ") { " + t + " = blockHelperMissing.call(" + e.join(", ") + "); }");
			},
			appendContent: function (e) {
				if (this.pendingContent) {
					e = this.pendingContent + e;
				}
				if (this.stripNext) {
					e = e.replace(/^\s+/, "");
				}
				this.pendingContent = e;
			},
			strip: function () {
				if (this.pendingContent) {
					this.pendingContent = this.pendingContent.replace(/\s+$/, "");
				}
				this.stripNext = "strip";
			},
			append: function () {
				this.flushInline();
				var e = this.popStack();
				this.pushSource("if(" + e + " || " + e + " === 0) { " + this.appendToBuffer(e) + " }");
				if (this.environment.isSimple) {
					this.pushSource("else { " + this.appendToBuffer("''") + " }");
				}
			},
			appendEscaped: function () {
				this.context.aliases.escapeExpression = "this.escapeExpression";
				this.pushSource(this.appendToBuffer("escapeExpression(" + this.popStack() + ")"));
			},
			getContext: function (e) {
				if (this.lastContext !== e) {
					this.lastContext = e;
				}
			},
			lookupOnContext: function (e) {this.push(this.nameLookup("depth" + this.lastContext, e, "context"));},
			pushContext: function () {this.pushStackLiteral("depth" + this.lastContext);},
			resolvePossibleLambda: function () {
				this.context.aliases.functionType = '"function"';
				this.replaceStack(function (e) {return "typeof " + e + " === functionType ? " + e + ".apply(depth0) : " + e;});
			},
			lookup: function (e) {this.replaceStack(function (t) {return t + " == null || " + t + " === false ? " + t + " : " + this.nameLookup(t, e, "context");});},
			lookupData: function () {this.pushStackLiteral("data");},
			pushStringParam: function (e, t) {
				this.pushStackLiteral("depth" + this.lastContext);
				this.pushString(t);
				if (t !== "sexpr") {
					if (typeof e === "string") {
						this.pushString(e);
					} else {
						this.pushStackLiteral(e);
					}
				}
			},
			emptyHash: function () {
				this.pushStackLiteral("{}");
				if (this.options.stringParams) {
					this.push("{}");
					this.push("{}");
				}
			},
			pushHash: function () {
				if (this.hash) {
					this.hashes.push(this.hash);
				}
				this.hash = {values: [], types: [], contexts: []};
			},
			popHash: function () {
				var e = this.hash;
				this.hash = this.hashes.pop();
				if (this.options.stringParams) {
					this.push("{" + e.contexts.join(",") + "}");
					this.push("{" + e.types.join(",") + "}");
				}
				this.push("{\n    " + e.values.join(",\n    ") + "\n  }");
			},
			pushString: function (e) {this.pushStackLiteral(this.quotedString(e));},
			push: function (e) {
				this.inlineStack.push(e);
				return e;
			},
			pushLiteral: function (e) {this.pushStackLiteral(e);},
			pushProgram: function (e) {
				if (e != null) {
					this.pushStackLiteral(this.programExpression(e));
				} else {
					this.pushStackLiteral(null);
				}
			},
			invokeHelper: function (e, t, n) {
				this.context.aliases.helperMissing = "helpers.helperMissing";
				this.useRegister("helper");
				var r = this.lastHelper = this.setupHelper(e, t, true);
				var i = this.nameLookup("depth" + this.lastContext, t, "context");
				var s = "helper = " + r.name + " || " + i;
				if (r.paramsInit) {
					s += "," + r.paramsInit;
				}
				this.push("(" + s + ",helper " + "? helper.call(" + r.callParams + ") " + ": helperMissing.call(" + r.helperMissingParams + "))");
				if (!n) {
					this.flushInline();
				}
			},
			invokeKnownHelper: function (e, t) {
				var n = this.setupHelper(e, t);
				this.push(n.name + ".call(" + n.callParams + ")");
			},
			invokeAmbiguous: function (e, t) {
				this.context.aliases.functionType = '"function"';
				this.useRegister("helper");
				this.emptyHash();
				var n = this.setupHelper(0, e, t);
				var r = this.lastHelper = this.nameLookup("helpers", e, "helper");
				var i = this.nameLookup("depth" + this.lastContext, e, "context");
				var s = this.nextStack();
				if (n.paramsInit) {
					this.pushSource(n.paramsInit);
				}
				this.pushSource("if (helper = " + r + ") { " + s + " = helper.call(" + n.callParams + "); }");
				this.pushSource("else { helper = " + i + "; " + s + " = typeof helper === functionType ? helper.call(" + n.callParams + ") : helper; }");
			},
			invokePartial: function (e) {
				var t = [this.nameLookup("partials", e, "partial"), "'" + e + "'", this.popStack(), "helpers", "partials"];
				if (this.options.data) {
					t.push("data");
				}
				this.context.aliases.self = "this";
				this.push("self.invokePartial(" + t.join(", ") + ")");
			},
			assignToHash: function (e) {
				var t = this.popStack(), n, r;
				if (this.options.stringParams) {
					r = this.popStack();
					n = this.popStack();
				}
				var i = this.hash;
				if (n) {
					i.contexts.push("'" + e + "': " + n);
				}
				if (r) {
					i.types.push("'" + e + "': " + r);
				}
				i.values.push("'" + e + "': (" + t + ")");
			},
			compiler: a,
			compileChildren: function (e, t) {
				var n = e.children, r, i;
				for (var s = 0, o = n.length; s < o; s++) {
					r = n[s];
					i = new this.compiler;
					var u = this.matchExistingProgram(r);
					if (u == null) {
						this.context.programs.push("");
						u = this.context.programs.length;
						r.index = u;
						r.name = "program" + u;
						this.context.programs[u] = i.compile(r, t, this.context);
						this.context.environments[u] = r;
					} else {
						r.index = u;
						r.name = "program" + u;
					}
				}
			},
			matchExistingProgram: function (e) {
				for (var t = 0, n = this.context.environments.length; t < n; t++) {
					var r = this.context.environments[t];
					if (r && r.equals(e)) {
						return t;
					}
				}
			},
			programExpression: function (e) {
				this.context.aliases.self = "this";
				if (e == null) {
					return "self.noop";
				}
				var t = this.environment.children[e], n = t.depths.list, r;
				var i = [t.index, t.name, "data"];
				for (var s = 0, o = n.length; s < o; s++) {
					r = n[s];
					if (r === 1) {
						i.push("depth0");
					} else {
						i.push("depth" + (r - 1));
					}
				}
				return (n.length === 0 ? "self.program(" : "self.programWithDepth(") + i.join(", ") + ")";
			},
			register: function (e, t) {
				this.useRegister(e);
				this.pushSource(e + " = " + t + ";");
			},
			useRegister: function (e) {
				if (!this.registers[e]) {
					this.registers[e] = true;
					this.registers.list.push(e);
				}
			},
			pushStackLiteral: function (e) {return this.push(new u(e));},
			pushSource: function (e) {
				if (this.pendingContent) {
					this.source.push(this.appendToBuffer(this.quotedString(this.pendingContent)));
					this.pendingContent = undefined;
				}
				if (e) {
					this.source.push(e);
				}
			},
			pushStack: function (e) {
				this.flushInline();
				var t = this.incrStack();
				if (e) {
					this.pushSource(t + " = " + e + ";");
				}
				this.compileStack.push(t);
				return t;
			},
			replaceStack: function (e) {
				var t = "", n = this.isInline(), r, i, s;
				if (n) {
					var o = this.popStack(true);
					if (o instanceof u) {
						r = o.value;
						s = true;
					} else {
						i = !this.stackSlot;
						var a = !i ? this.topStackName() : this.incrStack();
						t = "(" + this.push(a) + " = " + o + "),";
						r = this.topStack();
					}
				} else {
					r = this.topStack();
				}
				var f = e.call(this, r);
				if (n) {
					if (!s) {
						this.popStack();
					}
					if (i) {
						this.stackSlot--;
					}
					this.push("(" + t + f + ")");
				} else {
					if (!/^stack/.test(r)) {
						r = this.nextStack();
					}
					this.pushSource(r + " = (" + t + f + ");");
				}
				return r;
			},
			nextStack: function () {return this.pushStack();},
			incrStack: function () {
				this.stackSlot++;
				if (this.stackSlot > this.stackVars.length) {
					this.stackVars.push("stack" + this.stackSlot);
				}
				return this.topStackName();
			},
			topStackName: function () {return "stack" + this.stackSlot;},
			flushInline: function () {
				var e = this.inlineStack;
				if (e.length) {
					this.inlineStack = [];
					for (var t = 0, n = e.length; t < n; t++) {
						var r = e[t];
						if (r instanceof u) {
							this.compileStack.push(r);
						} else {
							this.pushStack(r);
						}
					}
				}
			},
			isInline: function () {return this.inlineStack.length;},
			popStack: function (e) {
				var t = this.isInline(), n = (t ? this.inlineStack : this.compileStack).pop();
				if (!e && n instanceof u) {
					return n.value;
				} else {
					if (!t) {
						if (!this.stackSlot) {
							throw new o("Invalid stack pop");
						}
						this.stackSlot--;
					}
					return n;
				}
			},
			topStack: function (e) {
				var t = this.isInline() ? this.inlineStack : this.compileStack, n = t[t.length - 1];
				if (!e && n instanceof u) {
					return n.value;
				} else {
					return n;
				}
			},
			quotedString: function (e) {return '"' + e.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029") + '"';},
			setupHelper: function (e, t, n) {
				var r = [], i = this.setupParams(e, r, n);
				var s = this.nameLookup("helpers", t, "helper");
				return {
					params: r,
					paramsInit: i,
					name: s,
					callParams: ["depth0"].concat(r).join(", "),
					helperMissingParams: n && ["depth0", this.quotedString(t)].concat(r).join(", ")
				};
			},
			setupOptions: function (e, t) {
				var n = [], r = [], i = [], s, o, u;
				n.push("hash:" + this.popStack());
				if (this.options.stringParams) {
					n.push("hashTypes:" + this.popStack());
					n.push("hashContexts:" + this.popStack());
				}
				o = this.popStack();
				u = this.popStack();
				if (u || o) {
					if (!u) {
						this.context.aliases.self = "this";
						u = "self.noop";
					}
					if (!o) {
						this.context.aliases.self = "this";
						o = "self.noop";
					}
					n.push("inverse:" + o);
					n.push("fn:" + u);
				}
				for (var a = 0; a < e; a++) {
					s = this.popStack();
					t.push(s);
					if (this.options.stringParams) {
						i.push(this.popStack());
						r.push(this.popStack());
					}
				}
				if (this.options.stringParams) {
					n.push("contexts:[" + r.join(",") + "]");
					n.push("types:[" + i.join(",") + "]");
				}
				if (this.options.data) {
					n.push("data:data");
				}
				return n;
			},
			setupParams: function (e, t, n) {
				var r = "{" + this.setupOptions(e, t).join(",") + "}";
				if (n) {
					this.useRegister("options");
					t.push("options");
					return "options=" + r;
				} else {
					t.push(r);
					return "";
				}
			}
		};
		var f = ("break else new var" + " case finally return void" + " catch for switch while" + " continue function this with" + " default if throw" + " delete in try" + " do instanceof typeof" + " abstract enum int short" + " boolean export interface static" + " byte extends long super" + " char final native synchronized" + " class float package throws" + " const goto private transient" + " debugger implements protected volatile" + " double import public let yield").split(" ");
		var l = a.RESERVED_WORDS = {};
		for (var c = 0, h = f.length; c < h; c++) {
			l[f[c]] = true;
		}
		a.isValidJavaScriptVariableName = function (e) {
			if (!a.RESERVED_WORDS[e] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(e)) {
				return true;
			}
			return false;
		};
		n = a;
		return n;
	}(r, n);
	var c = function (e, t, n, r, i) {
		"use strict";
		var s;
		var o = e;
		var u = t;
		var a = n.parser;
		var f = n.parse;
		var l = r.Compiler;
		var c = r.compile;
		var h = r.precompile;
		var p = i;
		var d = o.create;
		var v = function () {
			var e = d();
			e.compile = function (t, n) {return c(t, n, e);};
			e.precompile = function (t, n) {return h(t, n, e);};
			e.AST = u;
			e.Compiler = l;
			e.JavaScriptCompiler = p;
			e.Parser = a;
			e.parse = f;
			return e;
		};
		o = v();
		o.create = v;
		s = o;
		return s;
	}(s, o, a, f, l);
	return c;
}();
/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if (typeof ShopifyAPI === 'undefined') {
	ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
	if (typeof attribute !== 'string') {
		attribute += '';
		if (attribute === 'undefined') {
			attribute = '';
		}
	}
	return jQuery.trim(attribute);
}

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function () {
	 alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function (note, callback) {
	var params = {
		type: 'POST',
		url: '/cart/update.js',
		data: 'note=' + attributeToString(note),
		dataType: 'json',
		success: function (cart) {
			if (typeof callback === 'function') {
				callback(cart);
			} else {
				ShopifyAPI.onCartUpdate(cart);
			}
		},
		error: function (XMLHttpRequest, textStatus) {
			ShopifyAPI.onError(XMLHttpRequest, textStatus);
		}
	};
	jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest) {
	var data = eval('(' + XMLHttpRequest.responseText + ')');
	if (data.message) {
		alert(data.message + '(' + data.status + '): ' + data.description);
	}
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
	var formData = new FormData(form);
	var params = {
		type: 'POST',
		url: '/cart/add.js',
		data: formData,
		processData: false,
		contentType: false,
		dataType: 'json',
		success: function (line_item) {
			if (typeof callback === 'function') {
				callback(line_item, form);
			} else {
				ShopifyAPI.onItemAdded(line_item, form);
			}
		},
		error: function (XMLHttpRequest, textStatus) {
			if (typeof errorCallback === 'function') {
				errorCallback(XMLHttpRequest, textStatus);
			} else {
				ShopifyAPI.onError(XMLHttpRequest, textStatus);
			}
		}
	};
	jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
	jQuery.getJSON('/cart.js', function (cart) {
		if (typeof callback === 'function') {
			callback(cart);
		} else {
			ShopifyAPI.onCartUpdate(cart);
		}
	});
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
	var params = {
		type: 'POST',
		url: '/cart/change.js',
		data: 'quantity=' + quantity + '&line=' + line,
		dataType: 'json',
		success: function (cart) {
			if (typeof callback === 'function') {
				callback(cart);
			} else {
				ShopifyAPI.onCartUpdate(cart);
			}
		},
		error: function (XMLHttpRequest, textStatus) {
			ShopifyAPI.onError(XMLHttpRequest, textStatus);
		}
	};
	jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {
	'use strict';

	// Public functions
	var init, loadCart;

	// Private general variables
	var settings, isUpdating, $body;

	// Private plugin variables
	var $formContainer,
		$addToCart,
		$cartCountSelector,
		$cartCostSelector,
		$cartContainer;

	// Private functions
	var updateCountPrice,
		formOverride,
		itemAddedCallback,
		itemErrorCallback,
		cartUpdateCallback,
		buildCart,
		cartCallback,
		adjustCart,
		adjustCartCallback,
		qtySelectors,
		validateQty;

	/*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
	init = function (options) {
		// Default settings
		settings = {
			formSelector: '[data-product-form]',
			cartContainer: '#CartContainer',
			addToCartSelector: 'input[type="submit"]',
			cartCountSelector: null,
			cartCostSelector: null,
			moneyFormat: '$',
			disableAjaxCart: false,
			enableQtySelectors: true
		};

		// Override defaults with arguments
		$.extend(settings, options);

		// Select DOM elements
		$formContainer = $(settings.formSelector);
		$cartContainer = $(settings.cartContainer);
		$addToCart = $formContainer.find(settings.addToCartSelector);
		$cartCountSelector = $(settings.cartCountSelector);
		$cartCostSelector = $(settings.cartCostSelector);

		// General Selectors
		$body = $('body');

		// Track cart activity status
		isUpdating = false;

		// Setup ajax quantity selectors on the any template if enableQtySelectors is true
		if (settings.enableQtySelectors) {
			qtySelectors();
		}

		// Take over the add to cart form submit action if ajax enabled
		if (!settings.disableAjaxCart && $addToCart.length) {
			formOverride();
		}

		// Run this function in case we're using the quantity selector outside of the cart
		adjustCart();
	};

	loadCart = function () {
		$body.addClass('drawer--is-loading');
		ShopifyAPI.getCart(cartUpdateCallback);
	};

	updateCountPrice = function (cart) {
		if ($cartCountSelector) {
			$cartCountSelector.html(cart.item_count).removeClass('hidden-count');

			if (cart.item_count === 0) {
				$cartCountSelector.addClass('hidden-count');
			}
		}
		if ($cartCostSelector) {
			$cartCostSelector.html(
				theme.Currency.formatMoney(cart.total_price, settings.moneyFormat)
			);
		}
	};

	formOverride = function () {
		$formContainer.on('submit', function (evt) {
			evt.preventDefault();

			// Add class to be styled if desired
			$addToCart.removeClass('is-added').addClass('is-adding');

			// Remove any previous quantity errors
			$('.qty-error').remove();

			ShopifyAPI.addItemFromForm(
				evt.target,
				itemAddedCallback,
				itemErrorCallback
			);
		});
	};

	itemAddedCallback = function () {
		$addToCart.removeClass('is-adding').addClass('is-added');
		//ShopifyAPI.getCart(cartUpdateCallback);
	};

	itemErrorCallback = function (XMLHttpRequest) {
		var data = eval('(' + XMLHttpRequest.responseText + ')');
		$addToCart.removeClass('is-adding is-added');
		
		if (data.message) {
			if (data.status === 422) {
				// $formContainer.after(
				// 	'<div class="errors qty-error">' + data.description + '</div>'
				// );

				let $_mainClass = "bgDark white";
				let $type = "Error";
				$('#cosPopUpMessage' + $type).find('p').html(data.description);

				$.magnificPopup.open({
					mainClass: $_mainClass,
					items: {
						src: '#cosPopUpMessage' + $type
					},
					type: 'inline',
					callbacks: {
						close: function () {
							$('#cosPopUpMessage' + $type).find('p').html('');
						}
					}
				});
			}
		}
	};

	cartUpdateCallback = function (cart) {
		// Update quantity and price
		updateCountPrice(cart);
		buildCart(cart);
	};

	buildCart = function (cart) {
		// Start with a fresh cart div
		$cartContainer.empty();

		// Show empty cart
		if (cart.item_count === 0) {
			$cartContainer.append(
				'<p class="cart--empty-message">' +
				theme.strings.cartEmpty +
				'</p>\n' +
				'<p class="cookie-message">' +
				theme.strings.cartCookies +
				'</p>'
			);
			cartCallback(cart);
			return;
		}

		// Handlebars.js cart layout
		var items = [],
			item = {},
			data = {},
			source = $('#CartTemplate').html(),
			template = Handlebars.compile(source);

		// Add each item to our handlebars.js data
		$.each(cart.items, function (index, cartItem) {
			/* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
			var prodImg;
			var unitPrice = null;
			if (cartItem.image !== null) {
				prodImg = cartItem.image
					.replace(/(\.[^.]*)$/, '_small$1')
					.replace('http:', '');
			} else {
				prodImg =
					'//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
			}

			if (cartItem.properties !== null) {
				$.each(cartItem.properties, function (key, value) {
					if (key.charAt(0) === '_' || !value) {
						delete cartItem.properties[key];
					}
				});
			}

			if (cartItem.properties !== null) {
				$.each(cartItem.properties, function (key, value) {
					if (key.charAt(0) === '_' || !value) {
						delete cartItem.properties[key];
					}
				});
			}

			if (cartItem.line_level_discount_allocations.length !== 0) {
				for (var discount in cartItem.line_level_discount_allocations) {
					var amount =
						cartItem.line_level_discount_allocations[discount].amount;

					cartItem.line_level_discount_allocations[
						discount
						].formattedAmount = theme.Currency.formatMoney(
						amount,
						settings.moneyFormat
					);
				}
			}

			if (cart.cart_level_discount_applications.length !== 0) {
				for (var cartDiscount in cart.cart_level_discount_applications) {
					var cartAmount =
						cart.cart_level_discount_applications[cartDiscount]
							.total_allocated_amount;

					cart.cart_level_discount_applications[
						cartDiscount
						].formattedAmount = theme.Currency.formatMoney(
						cartAmount,
						settings.moneyFormat
					);
				}
			}

			if (cartItem.unit_price_measurement) {
				unitPrice = {
					addRefererenceValue:
						cartItem.unit_price_measurement.reference_value !== 1,
					price: theme.Currency.formatMoney(
						cartItem.unit_price,
						settings.moneyFormat
					),
					reference_value: cartItem.unit_price_measurement.reference_value,
					reference_unit: cartItem.unit_price_measurement.reference_unit
				};
			}

			// Create item's data object and add to 'items' array
			item = {
				key: cartItem.key,
				line: index + 1, // Shopify uses a 1+ index in the API
				url: cartItem.url,
				img: prodImg,
				name: cartItem.product_title,
				variation: cartItem.variant_title,
				properties: cartItem.properties,
				itemAdd: cartItem.quantity + 1,
				itemMinus: cartItem.quantity - 1,
				itemQty: cartItem.quantity,
				price: theme.Currency.formatMoney(
					cartItem.original_line_price,
					settings.moneyFormat
				),
				discountedPrice: theme.Currency.formatMoney(
					cartItem.final_line_price,
					settings.moneyFormat
				),
				discounts: cartItem.line_level_discount_allocations,
				discountsApplied:
					cartItem.line_level_discount_allocations.length === 0 ? false : true,
				vendor: cartItem.vendor,
				unitPrice: unitPrice
			};

			items.push(item);
		});

		// Gather all cart data and add to DOM
		data = {
			items: items,
			note: cart.note,
			totalPrice: theme.Currency.formatMoney(
				cart.total_price,
				settings.moneyFormat
			),
			cartDiscounts: cart.cart_level_discount_applications,
			cartDiscountsApplied:
				cart.cart_level_discount_applications.length === 0 ? false : true
		};

		$cartContainer.append(template(data));

		cartCallback(cart);
	};

	cartCallback = function (cart) {
		$body.removeClass('drawer--is-loading');
		$body.trigger('ajaxCart.afterCartLoad', cart);

		if (window.Shopify && Shopify.StorefrontExpressButtons) {
			Shopify.StorefrontExpressButtons.initialize();
		}
	};

	adjustCart = function () {
		// Delegate all events because elements reload with the cart

		// Add or remove from the quantity
		$body.on('click', '.ajaxcart__qty-adjust', function () {
			if (isUpdating) {
				return;
			}
			var $el = $(this),
				line = $el.data('line'),
				$qtySelector = $el.siblings('.ajaxcart__qty-num'),
				qty = parseInt($qtySelector.val().replace(/\D/g, ''));

			qty = validateQty(qty);

			// Add or subtract from the current quantity
			if ($el.hasClass('ajaxcart__qty--plus')) {
				qty += 1;
			} else {
				qty -= 1;
				if (qty <= 0) qty = 0;
			}

			// If it has a data-line, update the cart.
			// Otherwise, just update the input's number
			if (line) {
				updateQuantity(line, qty);
			} else {
				$qtySelector.val(qty);
			}
		});

		// Update quantity based on input on change
		$body.on('change', '.ajaxcart__qty-num', function () {
			if (isUpdating) {
				return;
			}
			var $el = $(this),
				line = $el.data('line'),
				qty = parseInt($el.val().replace(/\D/g, ''));

			qty = validateQty(qty);

			// If it has a data-line, update the cart
			if (line) {
				updateQuantity(line, qty);
			}
		});

		// Prevent cart from being submitted while quantities are changing
		$body.on('submit', 'form.ajaxcart', function (evt) {
			if (isUpdating) {
				evt.preventDefault();
			}
		});

		// Highlight the text when focused
		$body.on('focus', '.ajaxcart__qty-adjust', function () {
			var $el = $(this);
			setTimeout(function () {
				$el.select();
			}, 50);
		});

		function updateQuantity(line, qty) {
			isUpdating = true;

			// Add activity classes when changing cart quantities
			var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass(
				'is-loading'
			);

			if (qty === 0) {
				$row.parent().addClass('is-removed');
			}

			// Slight delay to make sure removed animation is done
			setTimeout(function () {
				ShopifyAPI.changeItem(line, qty, adjustCartCallback);
			}, 250);
		}

		// Save note anytime it's changed
		$body.on('change', 'textarea[name="note"]', function () {
			var newNote = $(this).val();

			// Update the cart note in case they don't click update/checkout
			ShopifyAPI.updateCartNote(newNote, function () {});
		});
	};

	adjustCartCallback = function (cart) {
		// Update quantity and price
		updateCountPrice(cart);

		// Reprint cart on short timeout so you don't see the content being removed
		setTimeout(function () {
			ShopifyAPI.getCart(buildCart);
			isUpdating = false;
		}, 150);
	};

	qtySelectors = function () {
		// Change number inputs to JS ones, similar to ajax cart but without API integration.
		// Make sure to add the existing name and id to the new input element
		var $numInputs = $('input[type="number"]');

		if ($numInputs.length) {
			$numInputs.each(function () {
				var $el = $(this),
					currentQty = $el.val(),
					inputName = $el.attr('name'),
					inputId = $el.attr('id');

				var itemAdd = currentQty + 1,
					itemMinus = currentQty - 1,
					itemQty = currentQty;

				var source = $('#JsQty').html(),
					template = Handlebars.compile(source),
					data = {
						key: $el.data('id'),
						itemQty: itemQty,
						itemAdd: itemAdd,
						itemMinus: itemMinus,
						inputName: inputName,
						inputId: inputId
					};

				// Append new quantity selector then remove original
				$el.after(template(data)).remove();
			});

			// Setup listeners to add/subtract from the input
			$('.js-qty__adjust').on('click', function () {
				var $el = $(this),
					$qtySelector = $el.siblings('.js-qty__num'),
					qty = parseInt($qtySelector.val().replace(/\D/g, ''));

				qty = validateQty(qty);

				// Add or subtract from the current quantity
				if ($el.hasClass('js-qty__adjust--plus')) {
					qty += 1;
				} else {
					qty -= 1;
					if (qty <= 1) qty = 1;
				}

				// Update the input's number
				$qtySelector.val(qty);
			});
		}
	};

	validateQty = function (qty) {
		if (parseFloat(qty) === parseInt(qty) && !isNaN(qty)) {
			// We have a valid number!
		} else {
			// Not a number. Default to 1.
			qty = 1;
		}
		return qty;
	};

	module = {
		init: init,
		load: loadCart
	};

	return module;
})(ajaxCart || {}, jQuery);


/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
window.timber = window.timber || {};
window.theme = window.theme || {};

timber.initCache = function () {
	timber.cache = {
		// General
		$html: $('html'),
		$body: $('body'),
		$window: $(window),

		// Navigation
		$navigation: $('#AccessibleNav'),

		// Product Page
		$optionSelector: $('.single-option-selector'),

		// Customer Pages
		$recoverPasswordLink: $('#RecoverPassword'),
		$hideRecoverPasswordLink: $('#HideRecoverPasswordLink'),
		$recoverPasswordForm: $('#RecoverPasswordForm'),
		$customerLoginForm: $('#CustomerLoginForm'),
		$passwordResetSuccess: $('#ResetSuccess')
	};
};

timber.init = function () {
	timber.initCache();
	timber.accessibleNav();
	timber.drawersInit();
	timber.responsiveVideos();
	timber.loginForms();
};

timber.accessibleNav = function () {
	var classes = {
		active: 'nav-hover',
		focus: 'nav-focus',
		outside: 'nav-outside',
		hasDropdown: 'site-nav--has-dropdown',
		link: 'site-nav__link'
	};
	var selectors = {
		active: '.' + classes.active,
		hasDropdown: '.' + classes.hasDropdown,
		dropdown: '[data-meganav-dropdown]',
		link: 'a',
		nextLink: '> a',
		parentLink: '[data-meganav-type="parent"]',
		childLink: '[data-meganav-type="child"]'
	};

	var $nav = timber.cache.$navigation,
		$allLinks = $nav.find(selectors.link),
		$parents = $nav.find(selectors.hasDropdown),
		$childLinks = $nav.find(selectors.childLink),
		$topLevel = $parents.find(selectors.nextLink),
		$dropdowns = $nav.find(selectors.dropdown),
		$subMenuLinks = $dropdowns.find(selectors.link);

	// Mouseenter
	$parents.on('mouseenter touchstart', function (evt) {
		var $el = $(this);
		var evtType = evt.type;
		var $dropdowns = $nav.find(selectors.active);

		if (!$el.hasClass(classes.active)) {
			// force stop the click from happening
			evt.preventDefault();
			evt.stopImmediatePropagation();
		}

		// Make sure we close any opened same level dropdown before opening a new one
		if (evtType === 'touchstart' && $dropdowns.length > 0) {
			hideDropdown($el);
		}

		showDropdown($el);
	});

	$childLinks.on('touchstart', function (evt) {
		evt.stopImmediatePropagation();
	});

	$parents.on('mouseleave', function () {
		hideDropdown($(this));
	});

	$allLinks.on('focus', function () {
		handleFocus($(this));
	});

	$allLinks.on('blur', function () {
		removeFocus($topLevel);
	});

	// accessibleNav private methods
	function handleFocus($el) {
		var $newFocus = null,
			$previousItem = $el.parent().prev();

		// Always put tabindex -1 on previous element just in case the user is going backward.
		// In that case, we want to focus on the previous parent and not the previous parent childs

		$allLinks.attr('tabindex', '');

		if ($previousItem.hasClass(classes.hasDropdown)) {
			$previousItem.find(selectors.dropdown + ' a').attr('tabindex', -1);
		}

		$newFocus = $el.parents(selectors.hasDropdown).find('> a');
		addFocus($newFocus);
	}

	function showDropdown($el) {
		var $toplevel = $el.find(selectors.nextLink);

		$toplevel.attr('aria-expanded', true);

		$el.addClass(classes.active);

		setTimeout(function () {
			timber.cache.$body.on('touchstart.MegaNav', function () {
				hideDropdowns();
			});
		}, 250);
	}

	function hideDropdown($el) {
		var $dropdowns = $el.parent().find(selectors.active);
		var $parentLink = $dropdowns.find(selectors.nextLink);

		$parentLink.attr('aria-expanded', false);

		$dropdowns.removeClass(classes.active);

		timber.cache.$body.off('touchstart.MegaNav');
	}

	function hideDropdowns() {
		var $dropdowns = $nav.find(selectors.active);
		$.each($dropdowns, function () {
			hideDropdown($(this));
		});
	}

	function addFocus($el) {
		$el.addClass(classes.focus);

		if ($el.attr('aria-expanded') !== undefined) {
			$el.attr('aria-expanded', true);
		}
	}

	function removeFocus($el) {
		$el.removeClass(classes.focus);

		$subMenuLinks.attr('tabindex', -1);

		if ($el.attr('aria-expanded') !== undefined) {
			$el.attr('aria-expanded', false);
		}
	}

	// Check if dropdown is outside of viewport
	function handleDropdownOffset($dropdowns) {
		var viewportSize = $(window).width();
		$dropdowns.removeClass(classes.outside);

		$.each($dropdowns, function () {
			var $dropdown = $(this);
			var dropdownOffset = $dropdown.offset().left + $dropdown.width();
			if (dropdownOffset > viewportSize) {
				$dropdown.addClass(classes.outside);
			}
		});
	}

	timber.cache.$window.load(function () {
		handleDropdownOffset($dropdowns);
	});

	timber.cache.$window.resize(function () {
		afterResize(function () {
			handleDropdownOffset($dropdowns);
		}, 250);
	});
};

timber.drawersInit = function () {
	timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
	if (theme.settings.cartType === 'drawer') {
		timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
			onDrawerOpen: ajaxCart.load
		});
	}
};

timber.getHash = function () {
	return window.location.hash;
};

timber.responsiveVideos = function () {
	var $iframeVideo = $(
		'iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'
	);
	var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

	$iframeVideo.each(function () {
		// Add wrapper to make video responsive
		if (!$(this).parents('.video-wrapper').length) {
			$(this).wrap('<div class="video-wrapper"></div>');
		}
	});

	$iframeReset.each(function () {
		// Re-set the src attribute on each iframe after page load
		// for Chrome's 'incorrect iFrame content on 'back'' bug.
		// https://code.google.com/p/chromium/issues/detail?id=395791
		// Need to specifically target video and admin bar
		this.src = this.src;
	});
};

timber.loginForms = function () {
	function showRecoverPasswordForm() {
		timber.cache.$recoverPasswordForm.show();
		timber.cache.$customerLoginForm.hide();
	}

	function hideRecoverPasswordForm() {
		timber.cache.$recoverPasswordForm.hide();
		timber.cache.$customerLoginForm.show();
	}

	timber.cache.$recoverPasswordLink.on('click', function (evt) {
		evt.preventDefault();
		showRecoverPasswordForm();
	});

	timber.cache.$hideRecoverPasswordLink.on('click', function (evt) {
		evt.preventDefault();
		hideRecoverPasswordForm();
	});

	// Allow deep linking to recover password form
	if (timber.getHash() === '#recover') {
		showRecoverPasswordForm();
	}
};

timber.resetPasswordSuccess = function () {
	timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
	var Drawer = function (id, position, options) {
		var defaults = {
			close: '.js-drawer-close',
			open: '.js-drawer-open-button-' + position,
			openButtonLeftClass: 'js-drawer-open-button-left',
			drawerLeftClass: 'drawer--left',
			drawerRightClass: 'drawer--right',
			openClass: 'js-drawer-open',
			dirOpenClass: 'js-drawer-open-' + position
		};

		this.nodes = {
			$parent: $('body, html'),
			$page: $('#PageContainer'),
			$moved: $('.page-container')
		};

		this.config = $.extend(defaults, options);
		this.position = position;

		this.$drawer = $('#' + id);

		if (!this.$drawer.length) {
			return false;
		}

		this.drawerIsOpen = false;
		this.init();
	};

	Drawer.prototype.init = function () {
		var $openBtn = $(this.config.open);

		// Add aria controls
		$openBtn.attr('aria-expanded', 'false');

		$openBtn.on('click', $.proxy(this.open, this));
		this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
	};

	Drawer.prototype.open = function (evt) {
		// Keep track if drawer was opened from a click, or called by another function
		var externalCall = false;

		// Other drawers that might be open (will be closed later)
		var $otherDrawers = $('.drawer').not(this.$drawer);

		// don't open an opened drawer
		if (this.drawerIsOpen) {
			if (evt) {
				evt.preventDefault();
			}
			return;
		}

		// Close other drawers if they are open
		var self = this;
		$otherDrawers.each(function () {
			if (!$(this).hasClass(self.config.openClass)) {
				return;
			}

			if ($(this).hasClass(self.config.drawerLeftClass)) {
				timber.LeftDrawer.close();
			}

			if ($(this).hasClass(self.config.drawerRightClass)) {
				timber.RightDrawer.close();
			}
		});

		// Prevent following href if link is clicked
		if (evt) {
			evt.preventDefault();
		} else {
			externalCall = true;
		}

		// Without this, the drawer opens, the click event bubbles up to $nodes.page
		// which closes the drawer.
		if (evt && evt.stopPropagation) {
			evt.stopPropagation();
			// save the source of the click, we'll focus to this on close
			this.$activeSource = $(evt.currentTarget);
		}

		if (this.drawerIsOpen && !externalCall) {
			return this.close();
		}

		// Add is-transitioning class to moved elements on open so drawer can have
		// transition for close animation
		this.nodes.$moved.addClass('is-transitioning');
		this.$drawer.prepareTransition();

		this.nodes.$parent.addClass(
			this.config.openClass + ' ' + this.config.dirOpenClass
		);
		this.$drawer.addClass(this.config.openClass);

		this.drawerIsOpen = true;

		// Set focus on drawer
		Drawer.prototype.trapFocus({
			$container: this.$drawer,
			namespace: 'drawer_focus'
		});

		// Run function when drawer opens if set
		if (
			this.config.onDrawerOpen &&
			typeof this.config.onDrawerOpen === 'function'
		) {
			if (!externalCall) {
				this.config.onDrawerOpen();
			}
		}

		if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
			this.$activeSource.attr('aria-expanded', 'true');
		}

		this.bindEvents();
	};

	Drawer.prototype.close = function (evt) {
		// don't close a closed drawer
		if (!this.drawerIsOpen) {
			return;
		}

		if (evt.keyCode !== 27) {
			evt.preventDefault();
		}
		// deselect any focused form elements
		$(document.activeElement).trigger('blur');

		// Ensure closing transition is applied to moved elements, like the nav
		this.nodes.$moved.prepareTransition({disableExisting: true});
		this.$drawer.prepareTransition({disableExisting: true});

		this.nodes.$parent.removeClass(
			this.config.dirOpenClass + ' ' + this.config.openClass
		);
		this.$drawer.removeClass(this.config.openClass);

		this.drawerIsOpen = false;

		// Remove focus on drawer
		Drawer.prototype.removeTrapFocus({
			$container: this.$drawer,
			namespace: 'drawer_focus'
		});

		if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
			this.$activeSource.attr('aria-expanded', 'false');
		}

		this.unbindEvents();
	};

	/**
	 * Traps the focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {jQuery} options.$container - Container to trap focus within
	 * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
	 * @param {string} options.namespace - Namespace used for new focus event handler
	 */
	Drawer.prototype.trapFocus = function (options) {
		var eventName = options.namespace
			? 'focusin.' + options.namespace
			: 'focusin';

		if (!options.$elementToFocus) {
			options.$elementToFocus = options.$container;
			options.$container.attr('tabindex', '-1');
		}

		options.$elementToFocus.focus();

		$(document).on(eventName, function (evt) {
			if (
				options.$container[0] !== evt.target &&
				!options.$container.has(evt.target).length
			) {
				options.$container.focus();
			}
		});
	};

	/**
	 * Removes the trap of focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {jQuery} options.$container - Container to trap focus within
	 * @param {string} options.namespace - Namespace used for new focus event handler
	 */
	Drawer.prototype.removeTrapFocus = function (options) {
		var eventName = options.namespace
			? 'focusin.' + options.namespace
			: 'focusin';

		if (options.$container && options.$container.length) {
			options.$container.removeAttr('tabindex');
		}

		$(document).off(eventName);
	};

	Drawer.prototype.bindEvents = function () {
		// Lock scrolling on mobile
		this.nodes.$page.on('touchmove.drawer', function () {
			return false;
		});

		this.$drawer.on('click.drawer', function (event) {
			if ($(this).hasClass('drawer--left')) {
				event.stopPropagation();
			}
		});

		$('.page-container, .drawer__header-container').on(
			'click.drawer',
			this.close.bind(this)
		);

		// Pressing escape closes drawer
		this.nodes.$parent.on(
			'keyup.drawer',
			$.proxy(function (evt) {
				// The hamburger 'open' button changes to a 'close' button when the drawer
				// is open. Clicking on it will close the drawer.
				if (this.$activeSource !== undefined) {
					this.$activeSource.on(
						'click.drawer',
						$.proxy(function () {
							if (
								!this.$activeSource.hasClass(this.config.openButtonLeftClass)
							) {
								return;
							}
							this.close();
						}, this)
					);
				}
				if (evt.keyCode === 27) {
					this.close(evt);
				}
			}, this)
		);
	};

	Drawer.prototype.unbindEvents = function () {
		if (this.$activeSource !== undefined) {
			this.$activeSource.off('.drawer');
		}
		this.nodes.$page.off('.drawer');
		this.nodes.$parent.off('.drawer');
	};

	return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);

/*
 * Shopify JS for customizing Slick.js
 *   http://kenwheeler.github.io/slick/
 *   Untouched JS in assets/slick.min.js
 */

theme.Slideshow = (function () {
	'use strict';

	var selectors = {
		activeSlide: '.slick-active',
		heroAdaptTextWrap: '[data-hero-adapt-text-wrap]',
		heroDotsWrapper: '[data-hero-dots-wrapper]',
		heroImage: '[data-hero-image]',
		heroTextContent: '[data-hero-text-content]',
		pagination: '[data-slide-pagination]',
		pause: '[data-pause]',
		slickList: '.slick-list',
		slidePrevious: '[data-slide-previous]',
		slideNext: '[data-slide-next]',
		slides: '.slick-slide'
	};

	var classes = {
		heroSlideHidden: 'hero__slide--hidden',
		isPaused: 'is-paused'
	};

	function Slideshow($slider) {
		var $sliderWrapper = $slider.closest('[data-section-id]');
		var loadSlideA11yString = (this.loadSlideA11yString = $slider.data(
			'slide-nav-a11y'
		));
		var activeSlideA11yString = (this.activeSlideA11yString = $slider.data(
			'slide-nav-active-a11y'
		));

		this.$slider = $slider;

		// Default settings
		this.settings = {
			$element: $slider,
			accessibility: true,
			adaptHeight: $slider.data('adapt'),
			arrows: true,
			dots: true,
			slide: '[data-hero-slide]',
			/* eslint-disable shopify/jquery-dollar-sign-reference */
			prevArrow: $slider.find(selectors.slidePrevious),
			nextArrow: $slider.find(selectors.slideNext),
			appendDots: $slider.find(selectors.heroDotsWrapper),
			/* eslint-enable shopify/jquery-dollar-sign-reference */
			adaptiveHeight: true,
			draggable: false,
			fade: true,
			onInit: this.onInit.bind(this),
			onBeforeChange: this.beforeChange.bind(this),
			onAfterChange: this.afterChange.bind(this),
			focusOnChange: true,
			isTouch: Modernizr.touch ? true : false,
			autoplay: $slider.data('autoplay'),
			autoplaySpeed: $slider.data('autoplayspeed'),
			customPaging: function (slick, index) {
				var labelString =
					index === 0 ? activeSlideA11yString : loadSlideA11yString;
				return (
					'<a href="' +
					$slider.attr('id') +
					'" aria-label="' +
					labelString.replace('[slide_number]', index + 1) +
					'" data-slide-number="' +
					index +
					'" data-slide-pagination aria-controls="SlickSlide' +
					(index + 1) +
					'"></a>'
				);
			}
		};

		this.cache = {
			$window: $(window),
			$heroImage: $slider.find(selectors.heroImage),
			$heroText: $slider.find(selectors.heroTextContent),
			$pauseButton: $slider.find(selectors.pause),
			$textWrapperMobile: $sliderWrapper.find(selectors.heroAdaptTextWrap)
		};

		this.currentActiveSlide = 0;

		/*
     * Init slick slider
     *   - Add any additional option changes here
     *   - https://github.com/kenwheeler/slick/#options
     */
		this.$slider.slick(this.settings);
	}

	Slideshow.prototype = _.assignIn({}, Slideshow.prototype, {
		onInit: function (obj) {
			//console.log('INIT SLIDE SHOW HOME PAGE')
			this.$allSlides = obj.$slides;
			this.$activeSlide = obj.$slider.find(
				selectors.slides + selectors.activeSlide
			);



			if (resolution_IsMobile()) {
			//	obj.$slider.find('.desktop').remove();
			//	obj.$slider.find('.mobile').css({'display':'block'});
			} else {
			//	obj.$slider.find('.mobile').remove();
			//	obj.$slider.find('.desktop').css({'display':'block'});

			}

			this.$pagination = obj.$slider.find(selectors.pagination);

			if (!this.settings.isTouch) {
				obj.$slides.addClass(classes.heroSlideHidden);
				this.$activeSlide.removeClass(classes.heroSlideHidden);
			}

			if (this.settings.autoplay) {
				this.cache.$pauseButton.on('click', this.togglePause.bind(this));

				$(document).scroll(
					theme.debounce(
						function () {
							var slideshowOffsetY =
								obj.$slider.offset().top + obj.$slider.outerHeight();

							if (slideshowOffsetY < window.pageYOffset) {
								this.togglePauseAttributes(this.cache.$pauseButton, false);
								obj.$slider.slickPause();
							} else if (!this.cache.$pauseButton.hasClass(classes.isPaused)) {
								this.togglePauseAttributes(this.cache.$pauseButton, true);
								obj.$slider.slickPlay();
							}
						}.bind(this),
						250
					)
				);
			}

			// Prevent default slick behaviour of autoplaying on mouseleave
			obj.$slider.find(selectors.slickList).off('mouseleave.slick');

			if (this.settings.adaptHeight) {
				this.showMobileText(0);
			}

			this.slideshowA11ySetup(obj.$slider);
			this.applySlideColor(0, 1);
		},

		beforeChange: function (obj, currentSlide, nextSlide) {
			obj.$slider.attr('data-slide-index', nextSlide);

			if (!this.settings.isTouch) {
				obj.$slides.removeClass(classes.heroSlideHidden);
			}

			if (this.settings.adaptHeight) {
				this.showMobileText(nextSlide);
			}

			this.applySlideColor(nextSlide, currentSlide);

			this.$pagination.each(
				function (index, element) {
					var labelString =
						index === nextSlide
							? this.activeSlideA11yString
							: this.loadSlideA11yString;

					labelString = labelString.replace('[slide_number]', index + 1);

					$(element).attr('aria-label', labelString);
				}.bind(this)
			);

			// Set upcoming slide as index
			this.currentActiveSlide = nextSlide;
		},

		afterChange: function (obj) {
			if (this.settings.isTouch) {
				return;
			}

			this.$activeSlide = this.$slider.find(
				selectors.slides + selectors.activeSlide
			);

			obj.$slides.addClass(classes.heroSlideHidden).attr('aria-hidden', true);

			this.$activeSlide
				.removeClass(classes.heroSlideHidden)
				.attr('aria-hidden', false);
		},

		keyboardNavigation: function (evt) {
			if (evt.keyCode === 37) {
				this.$slider.slickPrev();
			}
			if (evt.keyCode === 39) {
				this.$slider.slickNext();
			}
		},

		togglePause: function (evt) {
			var $pauseButton = $(evt.currentTarget);
			var isPaused = $pauseButton.hasClass(classes.isPaused);

			this.togglePauseAttributes($pauseButton, isPaused);

			if (this.settings.autoplay) {
				if (isPaused) {
					this.$slider.slickPlay();
				} else {
					this.$slider.slickPause();
				}
			}
		},

		togglePauseAttributes: function ($pauseButton, isPaused) {
			if (this.settings.autoplay) {
				$pauseButton
					.toggleClass(classes.isPaused, !isPaused)
					.attr(
						'aria-label',
						isPaused
							? $pauseButton.data('label-pause')
							: $pauseButton.data('label-play')
					);
			}
		},

		showMobileText: function (slideIndex) {
			var $allTextContent = this.cache.$textWrapperMobile.find(
				selectors.heroTextContent
			);
			var $currentTextContent = this.cache.$textWrapperMobile.find(
				'[data-index="' + slideIndex + '"]'
			);

			if (!$currentTextContent.length && this.$allSlides.length === 1) {
				this.cache.$textWrapperMobile.hide();
			} else {
				this.cache.$textWrapperMobile.show();
			}

			$allTextContent.hide();
			$currentTextContent.show();
		},

		// Apply when slideshow is in first position
		applySlideColor: function (nextSlideIndex, previousSlideIndex) {
			var prefixClassName = 'hero--color-';

			this.$slider
				.removeClass(prefixClassName + previousSlideIndex)
				.addClass(prefixClassName + nextSlideIndex);
		},

		slideshowA11ySetup: function ($slider) {
			var $list = $slider.find(selectors.slickList);

			// When an element in the slider is focused
			// pause slideshow and set aria-live.
			$slider
				.on(
					'focusin mouseenter',

					function (evt) {
						if (
							!$slider.has(evt.target).length ||
							$list.attr('aria-live') === 'polite'
						) {
							return;
						}

						$list.attr('aria-live', 'polite');
						if (this.settings.autoplay) {
							$slider.slickPause();
						}
					}.bind(this)
				)
				.on(
					'focusout mouseleave',

					function (evt) {
						if ($slider.has(evt.relatedTarget).length) {
							return;
						}

						$list.removeAttr('aria-live');
						if (this.settings.autoplay) {
							// Only resume playing if the user hasn't paused using the pause
							// button
							if (!this.cache.$pauseButton.hasClass(classes.isPaused)) {
								$slider.slickPlay();
							}
						}
					}.bind(this)
				)
				.on('keyup', this.keyboardNavigation.bind(this));

			$list.removeAttr('tabindex');

			this.$allSlides.each(function (index) {
				$(this)
					.attr('id', 'SlickSlide' + (index + 1))
					.attr('aria-hidden', true);
			});

			this.$activeSlide.attr('aria-hidden', false);

			if (this.$allSlides.length > 1) {
				this.$pagination.each(function () {
					$(this).on('click keyup', function (evt) {
						if (evt.type === 'keyup' && evt.which !== 13) return;

						evt.preventDefault();

						if (evt.type === 'keyup') {
							$slider.focus();
						}
					});
				});
			}
		}
	});

	return Slideshow;
})();


/* ================ Sections ================ */
window.theme = window.theme || {};

theme.Product = (function () {
	function Product(container) {
		var $window = $(window);

		this.settings = {
			productPageLoad: false,
			preloadImage: false,
			enableHistoryState: true,
			namespace: '.productSection'
		};

		this.selectors = {
			productImageWrapper: '.product-single__photo-wrapper',
			productImages: '.product-single__photos',
			productImagePhoto: '.product-single__photo',
			productImagePhotoFlexWrapper: '.product-single__photo--flex-wrapper',
			productThumbnail: '.product-single__thumbnail',
			productImagePhotoContainer: '.product-single__photo--container',
			productFullDetails: '.product-single__full-details',
			productForm: '.add-to-cart__form',
			addToCart: '.btn--add-to-cart',
			addToCartText: '.btn__text',
			goToCartText: '.btn__text_gotocart',
			priceContainer: '[data-price-container]',
			productPrice: '#ProductPrice',
			SKU: '.variant-sku',
			priceA11y: '#PriceA11y',
			comparePrice: '#ComparePrice',
			comparePriceA11y: '#ComparePriceA11y',
			comparePriceWrapper: '.product-single__price--wrapper',
			quantityElements: '.js-quantity-selector, label + .js-qty',
			originalSelectorId: '#ProductSelect',
			singleOptionSelector: '.single-option-selector__radio',
			radioWrapper: '.radio-wrapper',
			meta: '.product-single__meta_container',
			metaInner: '.product-single__meta',
			productWrapper: '.product-single',
			shopifyPaymentButton: '.shopify-payment-button',
			unitPrice: '[data-unit-price]',
			unitPriceBaseUnit: '[data-unit-price-base-unit]'
		};

		this.classes = {
			priceContainerUnitAvailable: 'price-container--unit-available'
		};

		var $container = (this.$container = $(container));
		var sectionId = $container.attr('data-section-id');

		if (!$('#ProductJson-' + sectionId).html()) {
			return;
		}

		this.productSingleObject = JSON.parse(
			document.getElementById('ProductJson-' + sectionId).innerHTML
		);
		this.zoomType = $container.data('image-zoom-type');

		this.initBreakpoints();
		this.stringOverrides();
		this.initProductVariant();
		this.initStickyProductMeta();
		this.productThumbnailSwitch();

		if (this.zoomType) {
			this.productImageZoom();
		}

		if (theme.settings.cartType === 'drawer') {
			ajaxCart.init({
				formSelector: '#AddToCartForm--' + sectionId,
				cartContainer: '#CartContainer',
				addToCartSelector: '#AddToCart--' + sectionId,
				enableQtySelectors: true,
				moneyFormat: theme.strings.moneyFormat
			});
		}

		$formContainer = $(this.selectors.productForm, this.$container);
		$btnAddToCart = $(this.selectors.addToCart, this.$container);
		// console.log('$formContainer', $formContainer)
		//
		$formContainer.on('submit', function (evt) {
		//	console.log('$formContainer', "SUBMIT");
			evt.preventDefault();

			// Add class to be styled if desired
			//$btnAddToCart.addClass('btn--loading');

			// Remove any previous quantity errors
			$('.qty-error').remove();

			ShopifyAPI.addItemFromForm(
				evt.target,
				cos_itemAddedCallback,
				cos_itemErrorCallback
			);
		});

		var cos_itemAddedCallback = function (datas, itm) {
			//$btnAddToCart.removeClass('btn--loading');

			jQuery.getJSON('/cart.js', function(cart) {
				if (cart.item_count>0) {
					$('#menuTopCartTotElement').html(cart.item_count);
				} else {
					$('#menuTopCartTotElement').html('');
				}
			});
			if (typeof window.cosProductTemplate !== "undefined") {
				window.cosProductTemplate.showItemAdded(datas, itm);
			}
		};

		var cos_itemErrorCallback = function (XMLHttpRequest) {
			var data = eval('(' + XMLHttpRequest.responseText + ')');
			//$btnAddToCart.removeClass('btn--loading');
			// if (data.message) {
			// 	if (data.status === 422) {
			// 		$formContainer.after(
			// 			'<div class="errors qty-error">' + data.description + '</div>'
			// 		);
			// 	}
			// }

		};

		$window
			.on('load' + this.settings.namespace, theme.initStickyProductMeta)
			.on(
				'resize' + this.settings.namespace,
				theme.debounce(this.initStickyProductMeta, 150).bind(this)
			);
	}

	Product.prototype = _.assignIn({}, Product.prototype, {
		initProductVariant: function () {
			var options = {
				$container: this.$container,
				enableHistoryState:
					this.$container.data('enable-history-state') || false,
				singleOptionSelector: this.selectors.singleOptionSelector,
				originalSelectorId: this.selectors.originalSelectorId,
				product: this.productSingleObject
			};

			this.variants = new slate.Variants(options);
			this.$container.on(
				'variantChange' + this.settings.namespace,
				this.productPage.bind(this)
			);
			this.$container.on(
				'variantImageChange' + this.settings.namespace,
				this.showVariantImage.bind(this)
			);
		},

		initBreakpoints: function () {
			var self = this;
			var $container = self.$container;
			self.zoomType = $container.data('image-zoom-type');

			enquire.register(theme.variables.mediaQuerySmall, {
				match: function () {
					self.createImageCarousel();
					if (self.zoomType) {
						if ($(self.selectors.productImagePhoto).length) {
							// remove event handlers for product zoom on mobile
							$(self.selectors.productImagePhoto).off();
						}
					}
				},
				unmatch: function () {
					self.destroyImageCarousel();
					self.reorderImages();
					if (self.zoomType) {
						// reinit product zoom
						self.productImageZoom();
					}
				}
			});
		},

		stringOverrides: function () {
			// Override defaults in theme.strings with potential
			// template overrides

			theme.productStrings = theme.productStrings || {};
			$.extend(theme.strings, theme.productStrings);
		},

		resizeElements: function () {
			$(this.selectors.productGridImages, this.$container).imagesLoaded(
				function () {
					$(this.selectors.productGridImages, this.$container)
						.css('height', 'auto')
						.equalHeights();
				}
			);
		},

		showVariantImage: function (evt) {
			var variant = evt.variant;
			var $newImage = $(
				'.product-single__photo[data-image-id="' +
				variant.featured_image.id +
				'"]'
			);
			var imageIndex;

			if (variant && variant.featured_image) {
				this.setActiveThumbnail(variant.featured_image.id);
			}

			if (theme.variables.bpSmall) {
				// Switch carousel slide, unless it's the first photo on load
				imageIndex = $newImage.closest('.slick-slide').attr('index');
				// Navigate to slide unless it's the first photo on load
				// If there is no index, slider is not initalized.
				if (_.isUndefined(imageIndex)) {
					return;
				}

				if (imageIndex !== 0 || theme.variables.productPageLoad) {
					$(this.selectors.productImages, this.$container).slickGoTo(
						imageIndex
					);
				}
				// Switch image variant on thumbnail layout for desktop view;
				// When a image variant is updated on mobile view, update the
				// desktop view also.
				if (!this.$container.data('scroll-to-image')) {
					this.switchImage(variant.featured_image.id);
				}
			} else {
				if (this.$container.data('scroll-to-image')) {
					imageIndex = $newImage.closest('.slick-slide').index();
					// Scroll to/reorder image unless it's the first photo on load
					if (imageIndex !== 0 || theme.variables.productPageLoad) {
						if (theme.variables.productPageSticky) {
							// Scroll to variant image
							$('html, body').animate(
								{
									scrollTop: $newImage.offset().top
								},
								250
							);
						} else {
							// Move selected variant image to top, preventing scrolling
							var currentScroll = $(document).scrollTop();
							$newImage
								.closest(
									$(
										this.selectors.productImagePhotoFlexWrapper,
										this.$container
									)
								)
								.prependTo($(this.selectors.productImages, this.$container));
							$(document).scrollTop(currentScroll);
						}
					}
				} else {
					// Thumbnail layout
					// Move selected variant image to top
					$newImage
						.closest(
							$(this.selectors.productImagePhotoFlexWrapper, this.$container)
						)
						.prependTo($(this.selectors.productImages, this.$container));
					// Switch image variant for thumnail layout
					this.switchImage(variant.featured_image.id);
				}
			}

			if (!theme.variables.productPageLoad) {
				theme.variables.productPageLoad = true;
			}
		},

		switchImage: function (imageId) {
			$(this.selectors.productImagePhotoContainer, this.$container).addClass(
				'hide'
			);
			$(this.selectors.productImagePhotoContainer, this.$container)
				.filter('#ProductImageWrapper-' + imageId)
				.removeClass('hide');
		},

		reorderImages: function () {
			if (this.$container.data('scroll-to-image')) return;
			var $newImage = $(
				this.selectors.productImagePhotoContainer,
				this.$container
			).not('.hide');
			$newImage
				.closest(
					$(this.selectors.productImagePhotoFlexWrapper, this.$container)
				)
				.prependTo($(this.selectors.productImages, this.$container));
		},

		productThumbnailSwitch: function () {
			var self = this;
			var $productThumbnails = $('#ProductThumbs', this.$container).find(
				this.selectors.productThumbnail
			);

			if ($productThumbnails.length) {
				// Switch the main image with one of the thumbnails
				// Note: this does not change the variant selected, just the image
				$productThumbnails.on('click', function (evt) {
					evt.preventDefault();
					var newImageId = $(this).attr('data-image-id');
					var $newImage = $(
						'.product-single__photo[data-image-id="' + newImageId + '"]'
					);

					self.switchImage(newImageId);
					self.setActiveThumbnail(newImageId);

					// Thumbnail layout
					// Move selected featured image to top
					$newImage
						.closest(
							$(self.selectors.productImagePhotoFlexWrapper, self.$container)
						)
						.prependTo($(self.selectors.productImages, self.$container));
				});
			}
		},

		setActiveThumbnail: function (imageId) {
			var $productThumbnails = $('#ProductThumbs', this.$container).find(
				this.selectors.productThumbnail
			);

			if ($productThumbnails.length) {
				var activeClass = 'active-thumb';
				var $thumbnail = $(
					this.selectors.productThumbnail + "[data-image-id='" + imageId + "']",
					this.$container
				);

				$productThumbnails.removeClass(activeClass);
				$thumbnail.addClass(activeClass);
			}
		},

		productImageZoom: function () {
			if (
				!$(this.selectors.productImagePhoto, this.$container).length ||
				theme.variables.bpSmall
			) {
				return;
			}

			$(this.selectors.productImagePhoto, this.$container).magnificPopup({
				type: 'image',
				mainClass: 'mfp-fade',
				closeOnBgClick: true,
				closeBtnInside: false,
				closeOnContentClick: true,
				tClose: theme.strings.zoomClose,
				removalDelay: 500,
				gallery: {
					enabled: true,
					navigateByImgClick: false,
					arrowMarkup:
						'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
					tPrev: theme.strings.zoomPrev,
					tNext: theme.strings.zoomNext
				}
			});
		},

		createImageCarousel: function () {
			var self = this;

			if (
				!$(this.selectors.productImages, this.$container).length ||
				$(this.selectors.productImagePhoto, this.$container).length < 2
			) {
				return;
			}

			$(this.selectors.productImages, this.$container).slick({
				arrows: false,
				dots: true,
				adaptiveHeight: true,
				onAfterChange: function () {
					// Let's do this after changing slides
					// Update featured image and active thumbnail on desktop
					// when changing slides
					self.setFeaturedImage();
				}
			});
		},

		setFeaturedImage: function () {
			// Thumbnail layout only
			if (this.$container.data('scroll-to-image')) return;
			var imageId = $(this.selectors.productImages, this.$container)
				.find('.slick-slide.slick-active .product-single__photo')
				.attr('data-image-id');

			this.switchImage(imageId);
			this.setActiveThumbnail(imageId);
		},

		destroyImageCarousel: function () {
			if (!$(this.selectors.productImages, this.$container).length) {
				return;
			}
			$(this.selectors.productImages, this.$container).unslick();
		},

		productPage: function (evt) {
			var moneyFormat = theme.strings.moneyFormat;
			var variant = evt.variant;
			var translations = theme.strings;

			if (variant) {
				// Display variant image on featured product
				if (!$('body').hasClass('template-product')) {
					if (variant.featured_image) {
						var $newImage = $(
							this.selectors.productImageWrapper +
							'[data-image-id="' +
							variant.featured_image.id +
							'"]',
							this.$container
						);
						var $otherImages = $(
							this.selectors.productImageWrapper +
							':not([data-image-id="' +
							variant.featured_image.id +
							'"])',
							this.$container
						);

						$newImage.removeClass('hide');
						$otherImages.addClass('hide');
					}
				}

				$(this.selectors.priceContainer, this.$container).removeClass(
					'visibility-hidden ' + this.classes.priceContainerUnitAvailable
				);
				$(this.selectors.productPrice, this.$container).attr(
					'aria-hidden',
					'false'
				);
				$(this.selectors.priceA11y, this.$container).attr(
					'aria-hidden',
					'false'
				);

				// Select a valid variant if available
				if (variant.available) {
					// Available, enable the submit button, change text, show quantity elements
					$(this.selectors.addToCart, this.$container)
						.removeClass('disabled')
						.prop('disabled', false);
					$(this.selectors.addToCartText, this.$container).html(
						translations.addToCart
					);
					$(this.selectors.goToCartText, this.$container).html(
						translations.goToCart
					);
					
					$(this.selectors.quantityElements, this.$container).show();
					$(this.selectors.shopifyPaymentButton, this.$container).show();

					// Update the full details link
					var $link = $(this.selectors.productFullDetails, this.$container);
					if ($link.length) {
						$link.attr(
							'href',
							this.updateUrlParameter($link.attr('href'), 'variant', variant.id)
						);
					}
				} else {
					// Sold out, disable the submit button, change text, hide quantity elements
					$(this.selectors.addToCart, this.$container)
						.addClass('disabled')
						.prop('disabled', true);
					$(this.selectors.addToCartText, this.$container).html(
						translations.soldOut
					);
					$(this.selectors.quantityElements, this.$container).hide();
					$(this.selectors.shopifyPaymentButton, this.$container).hide();
				}

				$(this.selectors.productPrice, this.$container)
					.html(theme.Currency.formatMoney(variant.price, moneyFormat))
					.show();

				// Also update and show the product's compare price if necessary
				if (variant.compare_at_price > variant.price) {
					$(this.selectors.comparePrice, this.$container).html(
						theme.Currency.formatMoney(variant.compare_at_price, moneyFormat)
					);
					$(this.selectors.comparePriceWrapper, this.$container).removeClass(
						'hide'
					);
					$(this.selectors.productPrice, this.$container).addClass('on-sale');
					$(this.selectors.comparePriceWrapper, this.$container).attr(
						'aria-hidden',
						'false'
					);
					$(this.selectors.comparePriceA11y, this.$container).attr(
						'aria-hidden',
						'false'
					);
				} else {
					$(this.selectors.comparePriceWrapper, this.$container)
						.addClass('hide')
						.attr('aria-hidden', 'true');
					$(this.selectors.productPrice, this.$container).removeClass(
						'on-sale'
					);
					$(this.selectors.comparePrice, this.$container).html('');
					$(this.selectors.comparePriceA11y, this.$container).attr(
						'aria-hidden',
						'true'
					);
				}

				if (variant.unit_price) {
					var $unitPrice = $(this.selectors.unitPrice, this.$container);
					var $unitPriceBaseUnit = $(
						this.selectors.unitPriceBaseUnit,
						this.$container
					);

					$unitPrice.html(
						theme.Currency.formatMoney(variant.unit_price, moneyFormat)
					);
					$unitPriceBaseUnit.html(this.getBaseUnit(variant));

					$(this.selectors.priceContainer, this.$container).addClass(
						this.classes.priceContainerUnitAvailable
					);
				}

				// Also Show SKU
				$(this.selectors.SKU).html(variant.sku);
			} else {
				// The variant doesn't exist, disable submit button.
				// This may be an error or notice that a specific variant is not available.
				// To only show available variants, implement linked product options:
				//   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
				$(this.selectors.addToCart, this.$container)
					.addClass('disabled')
					.prop('disabled', true);
				$(this.selectors.addToCartText, this.$container).html(
					translations.unavailable
				);
				$(this.selectors.quantityElements, this.$container).hide();
				$(this.selectors.shopifyPaymentButton, this.$container).hide();

				$(this.selectors.priceContainer, this.$container).addClass(
					'visibility-hidden'
				);
				$(this.selectors.productPrice, this.$container).attr(
					'aria-hidden',
					'true'
				);
				$(this.selectors.priceA11y, this.$container).attr(
					'aria-hidden',
					'true'
				);
				$(this.selectors.comparePriceWrapper, this.$container).attr(
					'aria-hidden',
					'true'
				);
				$(this.selectors.comparePriceA11y, this.$container).attr(
					'aria-hidden',
					'true'
				);
			}
		},

		updateUrlParameter: function (url, key, value) {
			var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
			var separator = url.indexOf('?') === -1 ? '?' : '&';

			if (url.match(re)) {
				return url.replace(re, '$1' + key + '=' + value + '$2');
			} else {
				return url + separator + key + '=' + value;
			}
		},

		initStickyProductMeta: function () {
			//console.log('initStickyProductMeta');
			var $meta = $(this.selectors.meta, this.$container);
			var $metaInner = $(this.selectors.metaInner, this.$container);
			
			let topMetaBlock=($(window).height() - $('.header-container').outerHeight() - $('.product-single__meta_container').outerHeight())/2;
			
			//$('.product-single__meta_container').css('margin-top',topMetaBlock);
			/**
			 *
			 * COS Hack
			 * Set height for product meta block
			 */
			if (!resolution_IsMobile()) {
				//$meta.height($(window).height() - $('.header-container').outerHeight() + 10);
			}

			var $wrapper = $(this.selectors.productWrapper, this.$container);

			if ($meta.find('#shopify-product-reviews').length) {
				//console.log('YES shopify-product-reviews ');
				theme.variables.productPageSticky = false;
				return;
			}

			if (
				!$meta.length ||
				$(this.selectors.productImagePhoto, this.$container).length < 2
			) {
				//console.log('RETURN ');
				return;
			}

			// Force detatch if already detached. Prevent layout issues.
			//$meta.css('margin-top', $(window).height() - )
			
			
			$meta.trigger('detach.ScrollToFixed');

			// Detach and stop if on mobile breakpoint
			if (theme.variables.bpSmall) {
				console.log('bpSmall ');
				return;
			}

			var productCopyHeight = $meta.outerHeight();
			var productImagesHeight = $(
				this.selectors.productImages,
				this.$container
			).height();

			/*============================================================================
				Calculate when to detach fixed element to avoid content overlap.
				Subtract product copy height from the limit because plugin uses offset().top
			==============================================================================*/
			var calcLimit = $wrapper.offset().top + $wrapper.height();
			calcLimit -= productCopyHeight;

			/**
			 *
			 * COS Hack
			 * Set height for product meta block
			 */
			calcLimit += (($meta.height() - $metaInner.height()) /2);

			//console.log('productCopyHeight',productCopyHeight,'productImagesHeight',productImagesHeight,$(window).height());
			// Init sticky if desc shorter than images and fits in viewport
			if (
				productCopyHeight < productImagesHeight &&
				productCopyHeight < $(window).height()
			) {

				
				//console.log( 'HEADER OUTER HEIGHT - ', $('.header-container').outerHeight() );

				theme.variables.productPageSticky = true;

				
				//let marginTopScrollToFixed=$('.header-container').outerHeight() + 10; //scroll and Fix to header
				//let marginTopScrollToFixed=$('.header-container').outerHeight()+$('.product-single__meta').outerHeight() + 10;
				let marginTopScrollToFixed= $('.header-container').outerHeight()+(($('.product-single__photos').position().top + $('.product-single__photos').outerHeight())/2) - ($('.product-single__meta').outerHeight() /2) - 9 - $('#cosBreadcrumb').outerHeight();
				if (productImagesHeight > $(window).height()) {
					marginTopScrollToFixed= $('.header-container').outerHeight() + (($(window).height() - $('.product-single__meta').outerHeight()) / 2)-$('#cosBreadcrumb').outerHeight() - 9;
				}
				
				//console.log( 'CALCLIMIT - ',productImagesHeight,  $(window).height());
				$meta.scrollToFixed({
					marginTop: marginTopScrollToFixed,
					limit: calcLimit
				});

				// QUI $(".product-single__meta_container").addClass("scroll-to-fixed-fixed");

			} else {
			//	console.log('No sticky productCopyHeight');
				theme.variables.productPageSticky = false;
			}

		},

		onUnload: function () {
			this.$container.off(this.settings.namespace);
			this.destroyImageCarousel();
		},

		getBaseUnit: function (variant) {
			return variant.unit_price_measurement.reference_value === 1
				? variant.unit_price_measurement.reference_unit
				: variant.unit_price_measurement.reference_value +
				variant.unit_price_measurement.reference_unit;
		}
	});

	return Product;
})();

window.theme = window.theme || {};

theme.Collection = (function () {
	function Collection(container) {
		this.selectors = {
			productGridImages: '.grid-uniform .grid-product__image-wrapper',
			$productGridRows: $('.collage-grid__row'),
			productGridPhotosLarge: '.grid__item--large .grid-product__image-link',
			$collectionImage: $('.collection-hero__image'),
			filterDropdowns: '.filter-dropdown',
			filterSelect: '.filter-dropdown__select',
			filterLabel: '.filter-dropdown__label',
			sortDropdown: '#sortBy'
		};

		var $container = (this.$container = $(container));
		this.gridType = $container.data('grid-type');

		this.selectors.$collectionImage.addClass('is-init');

		// Enable parallax effect if 3d transforms are supported
		if (!Modernizr.csstransforms3d) {
			return;
		}

		theme.cache.$window.on('scroll', function () {
			var scrolled = theme.cache.$window.scrollTop();
			theme.cache.$collectionImage.css({
				transform: 'translate3d(0, ' + scrolled / 4.5 + 'px, 0)'
			});
		});

		this.init();
	}

	Collection.prototype = _.assignIn({}, Collection.prototype, {
		init: function () {
			this.cacheSelectors();
			this.setQueryParams();

			this.cache.$sortDropdown.on('change', this.sortCollection.bind(this));

			if (this.gridType === 'collage') {
				this.initCollageGrid();
			} else if (this.gridType === 'grid') {
				theme.equalHeights.call(this);
			}
		},

		updateFilterLabel: function (evt, element) {
			var $select = evt ? $(evt.target) : $(element);
			var $label = $select
				.prev('.filter-dropdown__label')
				.find('.filter-dropdown__label--active');
			var selectedVariant = $select.find('option:selected').text();

			$label.html(' ' + selectedVariant);
			this.cache.$filterDropdowns.addClass('loaded');
		},

		cacheSelectors: function () {
			this.cache = {
				$html: $('html'),
				$window: $(window),
				$productGridImages: $(this.selectors.productGridImages),
				$productGridRows: $(this.selectors.productGridRows),
				$productGridPhotosLarge: $(this.selectors.productGridPhotosLarge),
				$filterDropdowns: $(this.selectors.filterDropdowns),
				$filterSelect: $(this.selectors.filterSelect),
				$filterLabel: $(this.selectors.filterLabel),
				$sortDropdown: $(this.selectors.sortDropdown)
			};
		},

		setQueryParams: function () {
			//don't execute if sort dropdown is not present.
			if (!this.cache.$sortDropdown.length) {
				return;
			}

			Shopify.queryParams = this.parseQueryString();
		},

		parseQueryString: function () {
			if (!location.search.length) {
				return {};
			}

			var params = {};

			for (
				var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&');
				i < aCouples.length;
				i++
			) {
				aKeyValue = aCouples[i].split('=');
				if (aKeyValue.length > 1) {
					params[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(
						aKeyValue[1]
					);
				}
			}
			return params;
		},

		initCollageGrid: function () {
			if (!this.cache.$productGridRows.length) {
				return;
			}

			this.collageGridHeights();

			theme.cache.$window.on(
				'resize',
				theme.debounce(this.collageGridHeights, 500)
			);
		},

		collageGridHeights: function () {
			if (theme.variables.bpSmall || !this.cache.$productGridRows.length) {
				return;
			}

			// calculate image heights for each row of grid images
			for (var i = this.cache.$productGridRows.length - 1; i >= 0; i--) {
				var $currentRow = $(this.cache.$productGridRows[i]);
				var $smallImages = $currentRow.find(
					'.grid__item--small .grid-product__image-wrapper'
				);
				var $largeImageWrapper = $currentRow.find(
					'.grid__item--large .grid-product__image-wrapper'
				);
				var $largeImage = $largeImageWrapper.find('.grid-product__image-link');

				// calculate the bottom edge of the small image
				var smallImageOffset =
					$smallImages[1].offsetTop + $smallImages[1].offsetHeight;

				// calculate the bottom edge of the large image for the row
				var largeImageOffset =
					$largeImageWrapper[0].offsetTop + $largeImageWrapper[0].offsetHeight;

				var largeImageHeight = 0;

				// Depending on which image is lower, increase or decrease the large
				// image size
				if (smallImageOffset > largeImageOffset) {
					largeImageHeight =
						$largeImage.height() + (smallImageOffset - largeImageOffset);
				} else {
					largeImageHeight =
						$largeImage.height() - (largeImageOffset - smallImageOffset);
				}

				$largeImage.css('height', largeImageHeight);
			}
		},

		clearCollageGridHeights: function () {
			if (!this.cache.$productGridRows.length) {
				return;
			}

			this.cache.$productGridPhotosLarge.removeAttr('style');
		},

		collectionSorting: function () {
			if (!this.cache.$tagList.length) {
				return;
			}

			this.cache.$tagList.on('change', function () {
				window.location.href = $(this).val();
			});
		},

		sortCollection: function () {
			if (!this.cache.$sortDropdown.length) {
				return;
			}

			if (Shopify.queryParams.page) {
				delete Shopify.queryParams.page;
			}
			Shopify.queryParams.sort_by = this.cache.$sortDropdown.val();
			location.search = decodeURIComponent(jQuery.param(Shopify.queryParams));
		}
	});

	return Collection;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function () {
	var classes = {
		headerWrapperTransparent: 'header-wrapper--transparent'
	};

	function Header(container) {
		timber.drawersInit();
		theme.initCache();
		theme.fitNav();
		theme.resizeLogo();
		theme.searchModal();

		var $container = (this.$container = $(container));
		this.template = $container.attr('data-template');
		this.$headerWrapper = theme.cache.$siteHeader.closest(
			'[data-header-wrapper]'
		);

		// ajaxCart.init will run from Product.prototype when on the product page
		if (
			theme.settings.cartType === 'drawer' &&
			this.template.indexOf('product') === -1
		) {
			ajaxCart.init({
				formSelector: '.add-to-cart__form',
				cartContainer: '#CartContainer',
				addToCartSelector: '.add-to-cart',
				enableQtySelectors: true,
				moneyFormat: theme.strings.moneyFormat
			});
		}

		theme.cache.$window.on('load', theme.resizeLogo);
		theme.cache.$window.on('resize', theme.debounce(theme.resizeLogo, 150));

		this.initSideBarDropDowns();
		this.updateHeaderTransparency();

		// Reorder & load events for all section
		// Only trigger when sections list contain slideshow
		$(document).on(
			'shopify:section:reorder shopify:section:load',
			this.updateHeaderTransparency.bind(this)
		);

		// setTimeout is added since we want to see the newest DOM structure
		// unLoad is triggered before the removal of the DOM
		$(document).on(
			'shopify:section:unload',
			function () {
				setTimeout(this.updateHeaderTransparency.bind(this));
			}.bind(this)
		);
	}

	Header.prototype = _.assignIn({}, Header.prototype, {
		onSelect: function () {
			this.handleDrawerOpenInEditor(event);
		},

		onDeselect: function () {
			timber.LeftDrawer.close(event);
		},

		handleDrawerOpenInEditor: function (event) {
			if (
				theme.cache.$siteNav.hasClass('site-nav--compress') ||
				theme.variables.bpSmall
			) {
				setTimeout(function () {
					timber.LeftDrawer.drawerIsOpen = false;
					timber.LeftDrawer.open();
				}, 500);
			} else if (!theme.cache.$siteNav.hasClass('site-nav--compress')) {
				timber.LeftDrawer.drawerIsOpen = true;
				timber.LeftDrawer.close(event);
			}
		},

		initSideBarDropDowns: function () {
			var $toggleBtns = $('.mobile-nav__toggle-btn');
			// Setup aria attributes
			$toggleBtns.attr('aria-expanded', 'false');

			$toggleBtns.each(function () {
				var $button = $(this);
				$button.attr('aria-controls', $button.attr('data-aria-controls'));
			});

			$toggleBtns.on('click', function () {
				var $button = $(this);
				var currentlyExpanded = $button.attr('aria-expanded');
				var toggleState = false;
				// Updated aria-expanded value based on state pre-click
				if (currentlyExpanded === 'true') {
					$button.attr('aria-expanded', 'false');
				} else {
					$button.attr('aria-expanded', 'true');
					toggleState = true;
				}

				// Toggle that expands/collapses sublist
				$button
					.closest('.mobile-nav__has-sublist')
					.toggleClass('mobile-nav--expanded', toggleState)
					.next()
					.slideToggle();
			});
		},

		/**
		 * Check whether the first section is slideshow
		 * and enable transparency setting (header) is enabled
		 */
		updateHeaderTransparency: function () {
			var $sectionsWrapper = theme.cache.$body.find('[data-sections-wrapper]');
			var $firstSection = $sectionsWrapper.find('[data-section-type]').first();

		/*	this.$headerWrapper.removeClass(classes.headerWrapperTransparent);

			if (
				$firstSection.data('section-type') === 'slideshow-section' &&
				theme.cache.$siteHeader.data('transparent-header') === true
			) {
				this.$headerWrapper.addClass(classes.headerWrapperTransparent);
			}

		 */
		}
	});

	return Header;
})();

window.theme = window.theme || {};

theme.FeaturedContentSection = (function () {
	function FeaturedContent() {
		theme.styleTextLinks();
	}

	return FeaturedContent;
})();

window.theme = window.theme || {};

theme.NewsletterSection = (function () {
	function Newsletter() {
		theme.styleTextLinks();
	}

	return Newsletter;
})();

theme.slideshows = {};

theme.SlideshowSection = (function () {
	var classes = {
		headerWrapperTransparent: 'header-wrapper--transparent',
		isPaused: 'is-paused'
	};

	var selectors = {
		pause: '[data-pause]',
		headerWrapper: '[data-header-wrapper]'
	};

	function SlideshowSection(container) {
		theme.initCache();

		var $container = $(container);
		var sectionId = $container.attr('data-section-id');
		var slideshow = '#Hero-' + sectionId;
		this.$slideshow = $(slideshow);
		this.autoplay = this.$slideshow.data('autoplay');
		this.$headerWrapper = theme.cache.$siteHeader.closest(
			selectors.headerWrapper
		);

		theme.slideshows[slideshow] = new theme.Slideshow(this.$slideshow);

		// remove header absolute display if slideshow is empty
		if (!this.$slideshow.hasClass('hero')) {
			this.$headerWrapper.removeClass(classes.headerWrapperTransparent);
		}

		if (Shopify.designMode) {
			// Fix the slideshow height in the iOS theme editor
			this.setSlideshowHeight(this.$slideshow);
		}
	}

	SlideshowSection.prototype = _.assignIn({}, SlideshowSection.prototype, {
		onUnload: function () {
			this.$slideshow.unslick();
		},

		onBlockSelect: function (evt) {
			var $slide = $('.slide--' + evt.detail.blockId);
			var slideIndex = $slide.attr('index');

			// Go to selected slide, pause autoplay
			this.$slideshow.slickGoTo(slideIndex);

			if (this.autoplay) {
				this.$slideshow.slickPause();
			}
		},

		onBlockDeselect: function () {
			var $pauseButton = this.$slideshow.find(selectors.pause);

			if (this.autoplay && $pauseButton.hasClass(classes.isPaused)) {
				this.$slideshow.slickPlay();
			}
		},

		setSlideshowHeight: function ($slideshow) {
			enquire.register(theme.variables.mediaQuerySmall, {
				match: function () {
					$slideshow.css('height', $(window.parent.document).height());
				},
				unmatch: function () {
					$slideshow.removeAttr('height');
				}
			});
		}
	});

	return SlideshowSection;
})();

window.theme = window.theme || {};

theme.PasswordHeader = (function () {
	function PasswordHeader() {
		this.init();
	}

	PasswordHeader.prototype = _.assignIn({}, PasswordHeader.prototype, {
		init: function () {
			$('.js-toggle-login-modal').magnificPopup({
				type: 'inline',
				mainClass: 'mfp-fade',
				closeOnBgClick: false,
				closeBtnInside: false,
				closeOnContentClick: false,
				tClose: password.strings.pageClose,
				removalDelay: 500,
				callbacks: {
					open: function () {
						window.setTimeout(function () {
							document.getElementById('password').focus();
						}, 50);
					},
					close: function () {
						window.setTimeout(function () {
							document.getElementById('email').focus();
						}, 50);
					}
				}
			});
			if ($('.storefront-password-form .errors').size()) {
				$('.js-toggle-login-modal').click();
			}
		}
	});

	return PasswordHeader;
})();

window.theme = window.theme || {};

theme.PasswordContent = (function () {
	function PasswordContent() {
		theme.styleTextLinks();
	}

	return PasswordContent;
})();

window.theme = window.theme || {};

theme.ProductRecommendations = (function () {
	function ProductRecommendations(container) {
		//console.log('=============================');
		//console.log('ProductRecommendations')
		//console.log('      ******************** ');
		//console.log('      CONTAINER ',container);
		this.$container = $(container);

		var self = this;
		var baseUrl = this.$container.data('baseUrl');
		var productId = this.$container.data('productId');
		var recommendationsSectionUrl =
			baseUrl +
			'?section_id=product-recommendations&product_id=' +
			productId +
			'&limit=4';

		$.get(recommendationsSectionUrl).then(function (section) {
			var recommendationsMarkup = $(section).html();
			if (recommendationsMarkup.trim() !== '') {
				self.$container.html(recommendationsMarkup);
			}
		});
	}

	return ProductRecommendations;
})();

theme.CosProductRecommendations = (function () {
	function CosProductRecommendations(container) {
		this.$container = $(container);

		var self = this;
		var baseUrl = this.$container.data('baseUrl');
		var productId = this.$container.data('productId');
		var recommendationsSectionUrl =
			baseUrl +
			'?section_id=product-recommendations&product_id=' +
			productId +
			'&limit=15';

		$.get(recommendationsSectionUrl).then(function (section) {
			var recommendationsMarkup = $(section).html();
			if (recommendationsMarkup.trim() !== '') {
				self.$container.html(recommendationsMarkup);
				if (typeof window.productRecommendationsCarouselController !== "undefined") {
					window.productRecommendationsCarouselController.init($('#cosProductRecommendationsWrapper'));
				}
			}
		}, function (section) {
			/**
			 * Hide Tab Raccomandati
			 */
			$('#product_recommendations_recent_wrapper').css({'display':'none'});
			if (typeof window.productRecommendationsCarouselController !== "undefined"){
				window.productRecommendationsCarouselController.init($('#cosProductRecommendationsWrapper'));
			}
		});
	}

	return CosProductRecommendations;
})();

theme.Maps = (function () {
	var config = {
		zoom: 14
	};
	var apiStatus = null;
	var mapsToLoad = [];

	var errors = {
		addressNoResults: theme.strings.addressNoResults,
		addressQueryLimit: theme.strings.addressQueryLimit,
		addressError: theme.strings.addressError,
		authError: theme.strings.authError
	};

	var selectors = {
		section: '[data-section-type="map"]',
		map: '[data-map]',
		mapOverlay: '[data-map-overlay]'
	};

	var classes = {
		mapError: 'map-section--load-error',
		errorMsg: 'map-section__error errors text-center'
	};

	// Global function called by Google on auth errors.
	// Show an auto error message on all map instances.
	// eslint-disable-next-line camelcase, no-unused-vars
	window.gm_authFailure = function () {
		if (!Shopify.designMode) return;

		if (Shopify.designMode) {
			$(selectors.section).addClass(classes.mapError);
			$(selectors.map).remove();
			$(selectors.mapOverlay).after(
				'<div class="' +
				classes.errorMsg +
				'">' +
				theme.strings.authError +
				'</div>'
			);
		}
	};

	function Map(container) {
		this.$container = $(container);
		this.$map = this.$container.find(selectors.map);
		this.key = this.$map.data('api-key');

		if (typeof this.key !== 'string' || this.key === '') {
			return;
		}

		if (apiStatus === 'loaded') {
			var self = this;

			// Check if the script has previously been loaded with this key
			var $script = $('script[src*="' + this.key + '&"]');
			if ($script.length === 0) {
				$.getScript(
					'https://maps.googleapis.com/maps/api/js?key=' + this.key
				).then(function () {
					apiStatus = 'loaded';
					self.createMap();
				});
			} else {
				this.createMap();
			}
		} else {
			mapsToLoad.push(this);

			if (apiStatus !== 'loading') {
				apiStatus = 'loading';
				if (typeof window.google === 'undefined') {
					$.getScript(
						'https://maps.googleapis.com/maps/api/js?key=' + this.key
					).then(function () {
						apiStatus = 'loaded';
						initAllMaps();
					});
				}
			}
		}
	}

	function initAllMaps() {
		// API has loaded, load all Map instances in queue
		$.each(mapsToLoad, function (index, instance) {
			instance.createMap();
		});
	}

	function geolocate($map) {
		var deferred = $.Deferred();
		var geocoder = new google.maps.Geocoder();
		var address = $map.data('address-setting');

		geocoder.geocode({address: address}, function (results, status) {
			if (status !== google.maps.GeocoderStatus.OK) {
				deferred.reject(status);
			}

			deferred.resolve(results);
		});

		return deferred;
	}

	Map.prototype = _.assignIn({}, Map.prototype, {
		createMap: function () {
			var $map = this.$map;

			return geolocate($map)
				.then(
					function (results) {
						var mapOptions = {
							zoom: config.zoom,
							center: results[0].geometry.location,
							draggable: false,
							clickableIcons: false,
							scrollwheel: false,
							disableDoubleClickZoom: true,
							disableDefaultUI: true
						};

						var map = (this.map = new google.maps.Map($map[0], mapOptions));
						var center = (this.center = map.getCenter());

						//eslint-disable-next-line no-unused-vars
						var marker = new google.maps.Marker({
							map: map,
							position: map.getCenter()
						});

						google.maps.event.addDomListener(window, 'resize', function () {
							google.maps.event.trigger(map, 'resize');
							map.setCenter(center);
							$map.removeAttr('style');
						});
					}.bind(this)
				)
				.fail(function () {
					var errorMessage;

					switch (status) {
						case 'ZERO_RESULTS':
							errorMessage = errors.addressNoResults;
							break;
						case 'OVER_QUERY_LIMIT':
							errorMessage = errors.addressQueryLimit;
							break;
						case 'REQUEST_DENIED':
							errorMessage = errors.authError;
							break;
						default:
							errorMessage = errors.addressError;
							break;
					}

					// Show errors only to merchant in the editor.
					if (Shopify.designMode) {
						$map
							.parent()
							.addClass(classes.mapError)
							.html(
								'<div class="' +
								classes.errorMsg +
								'">' +
								errorMessage +
								'</div>'
							);
					}
				});
		},

		onUnload: function () {
			if (this.$map.length === 0) {
				return;
			}
			google.maps.event.clearListeners(this.map, 'resize');
		}
	});

	return Map;
})();

window.theme = window.theme || {};

theme.Search = (function () {
	function Search() {
		theme.equalHeights();
	}

	return Search;
})();


theme.variables = {
	productPageLoad: false,
	productPageSticky: true,

	// Breakpoints from src/stylesheets/global/variables.scss.liquid
	mediaQuerySmall: 'screen and (max-width: 590px)',
	mediaQueryMedium: 'screen and (min-width: 591px) and (max-width: 1024px)',
	mediaQueryMediumUp: 'screen and (min-width: 591px)',
	mediaQueryLarge: 'screen and (min-width: 1025px) and (max-width: 1920px)',
	mediaQueryXlarge: 'screen and (min-width: 1921px)',
	bpSmall: false,  //MOBILE
	bpIbrid: false, //IBRIDO
	bpDesktop: false, //DESKTOP
	bpLarge: false //Large

};

theme.initCache = function () {
	theme.cache = {
		$window: $(window),
		$html: $('html'),
		$body: $('body'),
		$drawerRight: $('.drawer--right'),

		$hero: $('#Hero'),
		$customSelect: $('.js-selector'),

		$collectionImage: $('.collection-hero__image'),

		$siteHeader: $('.site-header'),
		$siteNav: $('.site-nav'),
		$siteNavOpen: $('.site-nav--open'),
		$cartBuggle: $('.cart-link__bubble'),
		$logoWrapper: $('.site-header__logo'),
		$logo: $('.site-header__logo img'),
		$toggleSearchModal: $('.js-toggle-search-modal'),
		$searchBox: $('.site-nav--search__bar'),

		$productImages: $('.product-single__photos'),
		$productImagePhoto: $('.product-single__photo'),

		$indentedRteImages: $('.rte--indented-images'),

		$productGridRows: $('.collage-grid__row'),
		$productGridPhotosLarge: $('.grid__item--large .grid-product__image-link'),

		// Equal height elements
		$productGridImages: $('.grid-uniform .grid-product__image-wrapper'),

		$returnLink: $('.return-link')
	};
};

theme.init = function () {
	theme.initCache();
	theme.setBreakpoints();
	theme.fitNav();
	theme.cartInit();
	theme.afterCartLoad();
	theme.checkoutIndicator();
	theme.returnLink();
	theme.styleTextLinks();
	theme.searchModal();
	theme.productCardImageLoadingAnimation();

	// Functions to run on load so image sizes can be calculated
	theme.cache.$window.on('load', theme.resizeLogo);
	theme.cache.$window.on('load', theme.articleImages);

	// Functions to re-run on resize
	theme.cache.$window.on('resize', theme.debounce(theme.resizeLogo, 150));
};

theme.returnLink = function () {
	if (!document.referrer || !theme.cache.$returnLink.length || !window.history.length) {
		return;
	}

	theme.cache.$returnLink.on('click', theme.backButton);
};

theme.backButton = function () {
	var referrerDomain = urlDomain(document.referrer);
	var shopDomain = urlDomain(document.url);

	if (shopDomain === referrerDomain) {
		history.back();
		return false;
	}

	function urlDomain(url) {
		var a = document.createElement('a');
		a.href = url;
		return a.hostname;
	}
};

theme.setBreakpoints = function () {
	enquire.register(theme.variables.mediaQuerySmall, {
		match: function () {
			if (theme.settings.gridType === 'collage') {
				theme.clearCollageGridHeights();
			}

			theme.variables.bpSmall = true;
			theme.variables.bpIbrid = false;
			theme.variables.bpDesktop = false;
			theme.variables.bpLarge = false;

		},
		unmatch: function () {
			theme.variables.bpSmall = false;
		}
	});

	/**
	 * COS Fix
	 * Gestione delle altre risuluzioni per il JS utili nei componenti creati
	 */
  enquire.register(theme.variables.mediaQueryMedium, {
		match: function () {
			theme.variables.bpSmall = false;
			theme.variables.bpIbrid = true;
			theme.variables.bpDesktop = false;
			theme.variables.bpLarge = false;

		},
		unmatch: function () {
			theme.variables.bpIbrid = false;
		}
	});

	enquire.register(theme.variables.mediaQueryLarge, {
		match: function () {
			theme.variables.bpSmall = false;
			theme.variables.bpIbrid = false;
			theme.variables.bpDesktop = true;
			theme.variables.bpLarge = false;

		},
		unmatch: function () {
			theme.variables.bpDesktop = false;
		}
	});

	enquire.register(theme.variables.mediaQueryXlarge, {
		match: function () {
			theme.variables.bpSmall = false;
			theme.variables.bpIbrid = false;
			theme.variables.bpDesktop = false;
			theme.variables.bpLarge = true;

		},
		unmatch: function () {
			theme.variables.bpLarge = false;
		}
	});

};

theme.fitNav = function () {
	// Measure children of site nav on load and resize.
	// If wider than parent, switch to mobile nav.
	controlNav();
	theme.cache.$window.on('load', controlNav);
	theme.cache.$window.on('resize', theme.debounce(controlNav, 150));

	function controlNav() {
		// Subtract 20 from width to account for inline-block spacing
		var navWidth = theme.cache.$siteNav.parent().outerWidth() - 20;
		var navItemWidth = 0;
		theme.cache.$siteNav.find('> li').each(function () {
			var $el = $(this);
			// Round up to be safe
			navItemWidth += Math.ceil($(this).width());
		});

		if (navItemWidth > navWidth) {
			theme.cache.$siteNav.addClass('site-nav--compress');
			// theme.cache.$siteNav.parent().removeClass('large--two-thirds').addClass('large--one-sixth');
			theme.cache.$siteNavOpen.addClass('site-nav--open__display');
			theme.cache.$siteNavOpen.parent().removeClass('large--hide');
			// theme.cache.$logoWrapper.parent().removeClass('large--one-third').addClass('large--two-thirds');
			// theme.cache.$logoWrapper.removeClass('large--left').addClass('text-center');
			// theme.cache.$searchBox.hide();
		} else {
			theme.cache.$siteNav.removeClass('site-nav--compress');
			theme.cache.$siteNavOpen.removeClass('site-nav--open__display');
			theme.cache.$siteNavOpen.parent().addClass('large--hide');
			// theme.cache.$searchBox.show();
		}

		theme.cache.$siteNav.addClass('site-nav--init');
		theme.cache.$siteNavOpen.addClass('site-nav--init');
	}
};

theme.resizeLogo = function () {
	// Using .each() as there can be a reversed logo too
	theme.cache.$logo.each(function () {
		var $el = $(this),
			logoWidthOnScreen = $el.width(),
			containerWidth = $el.closest('.grid__item').width();
		// If image exceeds container, let's make it smaller
		if (logoWidthOnScreen > containerWidth) {
			$el.css('maxWidth', containerWidth);
		} else {
			$el.removeAttr('style');
		}
	});
};

theme.sizeCartDrawerFooter = function () {
	// Stop if our drawer doesn't have a fixed footer
	if (!theme.cache.$drawerRight.hasClass('drawer--has-fixed-footer')) {
		return;
	}

	// Elements are reprinted regularly so selectors are not cached
	var $cartFooter = $('.ajaxcart__footer').removeAttr('style');
	var $cartInner = $('.ajaxcart__inner').removeAttr('style');
	var cartFooterHeight = $cartFooter.outerHeight();
	var cartDrawerTitleHeight = $('.drawer--right .drawer__header').outerHeight();
	var $cartDrawerInner = $('.drawer--right .drawer__inner');

	if (cartDrawerTitleHeight != 80) {
		$cartDrawerInner.css('top', cartDrawerTitleHeight);
	}

	$cartInner.css('bottom', cartFooterHeight);
	$cartFooter.css('height', cartFooterHeight);
};

theme.afterCartLoad = function () {
	theme.cache.$body.on('ajaxCart.afterCartLoad', function (evt, cart) {
		// Open cart drawer
		timber.RightDrawer.open();

		// Size the cart's fixed footer
		theme.sizeCartDrawerFooter();

		// Show cart bubble in nav if items exist
		if (cart.items.length > 0) {
			theme.cache.$cartBuggle.addClass('cart-link__bubble--visible');
		} else {
			theme.cache.$cartBuggle.removeClass('cart-link__bubble--visible');
		}
	});
};

theme.checkoutIndicator = function () {
	// Add a loading indicator on the cart checkout button (/cart and drawer)
	theme.cache.$body.on('click', '.cart__checkout', function () {
		// $(this).addClass('btn--loading');
	});
};

theme.searchModal = function () {
	if (!theme.cache.$toggleSearchModal.length) {
		return;
	}

	theme.cache.$toggleSearchModal.magnificPopup({
		type: 'inline',
		mainClass: 'mfp-fade',
		closeOnBgClick: true,
		closeBtnInside: false,
		closeOnContentClick: false,
		tClose: theme.strings.zoomClose,
		alignTop: true,
		removalDelay: 500,
		focus: '.search-bar > input'
	});
};

theme.clearCollageGridHeights = function () {
	if (!theme.cache.$productGridRows.length) {
		return;
	}
	;

	theme.cache.$productGridPhotosLarge.removeAttr('style');
};

theme.articleImages = function () {
	if (!theme.cache.$indentedRteImages.length) {
		return;
	}

	theme.cache.$indentedRteImages.find('img').each(function () {
		var $el = $(this);
		var attr = $el.attr('style');

		// Check if undefined or float: none
		if (!attr || attr == 'float: none;') {
			// Remove grid-breaking styles if image isn't wider than parent
			if ($el.width() < theme.cache.$indentedRteImages.width()) {
				$el.addClass('rte__no-indent');
			}
		}
	});
};

theme.styleTextLinks = function () {
	$('.rte').find('a:not(:has(img))').addClass('text-link');
};

theme.equalHeights = function () {
	var self = this;
	theme.cache.$window.on('load', resizeElements());

	theme.cache.$window.on(
		'resize',
		afterResize(
			function () {
				resizeElements();
			},
			250,
			'equal-heights'
		)
	);

	function resizeElements() {
		self.cache.$productGridImages.css('height', 'auto').equalHeights();
	}
};

theme.cartInit = function () {
	if (!theme.cookiesEnabled()) {
		theme.cache.$body.addClass('cart--no-cookies');
	}
};

theme.cookiesEnabled = function () {
	var cookieEnabled = navigator.cookieEnabled;

	if (!cookieEnabled) {
		document.cookie = 'testcookie';
		cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
	}
	return cookieEnabled;
};

theme.productCardImageLoadingAnimation = function () {
	var selectors = {
		image: '[data-image]',
		imageLink: '[data-image-link]',
	};

	var classes = {
		loadingAnimation: 'grid-product__image-link--loading',
		lazyloaded: '.lazyloaded'
	};

	$(document).on('lazyloaded', function (e) {
		var $target = $(e.target);

		if (!$target.is(selectors.image)) {
			return;
		}

		$target
			.closest(selectors.imageLink)
			.removeClass(classes.loadingAnimation);
	});


	// When the theme loads, lazysizes might load images before the "lazyloaded"
	// event listener has been attached. When this happens, the following function
	// hides the loading placeholders.
	$(selectors.image + classes.lazyloaded)
		.closest(selectors.imageLink)
		.removeClass(classes.loadingAnimation);
};

$(document).ready(function () {


	if (window.shop_locale  == 'it') {
		/*
		 * Translated default messages for the jQuery validation plugin.
		 * Locale: IT (Italian; Italiano)
		 */
		$.extend($.validator.messages, {
			required: "Campo obbligatorio",
			remote: "Controlla questo campo",
			email: "Inserisci un indirizzo email valido",
			url: "Inserisci un indirizzo web valido",
			date: "Inserisci una data valida",
			dateISO: "Inserisci una data valida (ISO)",
			number: "Inserisci un numero valido",
			digits: "Inserisci solo numeri",
			creditcard: "Inserisci un numero di carta di credito valido",
			equalTo: "Il valore non corrisponde",
			extension: "Inserisci un valore con un&apos;estensione valida",
			maxlength: $.validator.format("Non inserire pi&ugrave; di {0} caratteri"),
			minlength: $.validator.format("Inserisci almeno {0} caratteri"),
			rangelength: $.validator.format("Inserisci un valore compreso tra {0} e {1} caratteri"),
			range: $.validator.format("Inserisci un valore compreso tra {0} e {1}"),
			max: $.validator.format("Inserisci un valore minore o uguale a {0}"),
			min: $.validator.format("Inserisci un valore maggiore o uguale a {0}"),
			nifES: "Inserisci un NIF valido",
			nieES: "Inserisci un NIE valido",
			cifES: "Inserisci un CIF valido",
			currency: "Inserisci una valuta valida"
		});
	}



	theme.init();
	var sections = new theme.Sections();

	sections.register('product-template', theme.Product);
	sections.register('collection-template', theme.Collection);
	sections.register('header-section', theme.HeaderSection);
	sections.register('featured-content-section', theme.FeaturedContentSection);
	sections.register('newsletter-section', theme.NewsletterSection);
	sections.register('slideshow-section', theme.SlideshowSection);
	sections.register('password-header', theme.PasswordHeader);
	sections.register('password-content', theme.PasswordContent);
	sections.register('product-recommendations', theme.ProductRecommendations);
	sections.register('cos-product-recommendations', theme.CosProductRecommendations);
	sections.register('map', theme.Maps);
	sections.register('search', theme.Search);


});

/*
 * Run function after window resize
 * http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed
 */
var afterResize = (function () {
	var t = {};
	return function (callback, ms, uniqueId) {
		if (!uniqueId) {
			uniqueId = "Don't call this twice without a uniqueId";
		}
		if (t[uniqueId]) {
			clearTimeout(t[uniqueId]);
		}
		t[uniqueId] = setTimeout(callback, ms);
	};
})();
